{
  "accept.action.button": "Accepter",
  "accessDenied.message": "Vous n'avez pas accès à ce module, veuillez contacter votre administrateur système",
  "accessDenied.okButton": "D'ACCORD",
  "accessDenied.title": "Accès refusé",
  "accession.entry": "Saisie du numéro de laboratoire",
  "activityReportByPanel": "Rapport d'activités par panel",
  "activityReportByTest": "Rapport d'activité par test",
  "activityReportByTestSection": "Rapport d'activités par section de test",
  "add.age.range": "Ajouter une autre tranche d'âge +",
  "add.aliquot": "Ajouter un Aliquote",
  "add.new.dictionary.menu": "Ajouter un nouveau menu de dictionnaire",
  "adjustment.button": "Ajuster la quantité",
  "adjustment.newQuantity": "Nouvelle quantité",
  "adjustment.notes": "Remarques",
  "adjustment.notes.placeholder": "Veuillez fournir des détails concernant cet ajustement.",
  "adjustment.reason": "Raison de l'ajustement",
  "adjustment.reason.select": "Sélectionnez la raison",
  "adjustment.success": "Quantité de lot ajustée avec succès",
  "adjustment.title": "Ajuster la quantité de lot",
  "admin.dashboard.subtitle": "Choisissez une zone d’administration pour configurer OpenELIS.",
  "admin.dashboard.title": "Tableau de bord d’administration ",
  "admin.formEntryConfig": "Configurations générales",
  "admin.config.logo.error.fileTooLarge": "L’image est trop volumineuse. Taille maximale : 2 Mo.",
  "admin.config.logo.formats": "Formats : JPG, PNG, GIF (max 2 Mo)",
  "admin.label": "Administrateur",
  "admin.legacy": "Administration héritée",
  "admin.page.configuration.formEntryConfigMenu.button.add": "Ajouter",
  "admin.page.configuration.formEntryConfigMenu.button.deactivate": "Désactiver",
  "admin.page.configuration.formEntryConfigMenu.button.exit": "Quitter",
  "admin.page.configuration.formEntryConfigMenu.button.modify": "Modifier",
  "admin.page.configuration.formEntryConfigMenu.button.save": "Enregistrer",
  "admin.page.configuration.formEntryConfigMenu.description": "Description",
  "admin.page.configuration.formEntryConfigMenu.editRecord": "Modifier l'enregistrement",
  "admin.page.configuration.formEntryConfigMenu.name": "Nom",
  "admin.page.configuration.formEntryConfigMenu.select": "Sélectionner",
  "admin.page.configuration.formEntryConfigMenu.value": "Valeur",
  "admin.labelPresets.title": "Label Presets",
  "admin.labelPresets.addButton": "Add Preset",
  "admin.labelPresets.search.placeholder": "Search presets...",
  "admin.labelPresets.col.name": "Name",
  "admin.labelPresets.col.barcodeType": "Barcode Type",
  "admin.labelPresets.col.dimensions": "Dimensions",
  "admin.labelPresets.col.scope": "Scope",
  "admin.labelPresets.col.status": "Status",
  "admin.labelPresets.col.actions": "Actions",
  "admin.labelPresets.systemTag": "System",
  "admin.labelPresets.status.active": "Active",
  "admin.labelPresets.status.inactive": "Inactive",
  "admin.labelPresets.scope.order": "Order",
  "admin.labelPresets.scope.sample": "Sample",
  "admin.labelPresets.action.edit": "Edit",
  "admin.labelPresets.action.duplicate": "Duplicate",
  "admin.labelPresets.action.activate": "Activate",
  "admin.labelPresets.action.deactivate": "Deactivate",
  "admin.labelPresets.duplicateName": "Copy of {name}",
  "admin.labelPresets.duplicated": "Preset duplicated",
  "admin.labelPresets.duplicateFailed": "Duplicate failed",
  "admin.labelPresets.activated": "Preset activated",
  "admin.labelPresets.deactivated": "Preset deactivated",
  "admin.labelPresets.toggleFailed": "Status change failed",
  "admin.labelPresets.saveFailed": "Save failed",
  "admin.labelPresets.editor.titleAdd": "Add Label Preset",
  "admin.labelPresets.editor.titleEdit": "Edit Label Preset",
  "admin.labelPresets.editor.section.basicInfo": "Basic Info",
  "admin.labelPresets.editor.section.dimensions": "Dimensions (mm)",
  "admin.labelPresets.editor.section.barcodeSettings": "Barcode Settings",
  "admin.labelPresets.editor.section.printScope": "Print Scope & Quantities",
  "admin.labelPresets.field.name": "Preset Name",
  "admin.labelPresets.field.isActive": "Active",
  "admin.labelPresets.field.heightMm": "Height (mm)",
  "admin.labelPresets.field.widthMm": "Width (mm)",
  "admin.labelPresets.field.barcodeType": "Barcode Type",
  "admin.labelPresets.field.defaultPerOrder": "Default per Order",
  "admin.labelPresets.field.maxPerOrder": "Max per Order",
  "admin.labelPresets.field.defaultPerSample": "Default per Sample",
  "admin.labelPresets.field.maxPerSample": "Max per Sample",
  "admin.labelPresets.validation.name.required": "Name is required",
  "admin.labelPresets.validation.name.toolong": "Name must not exceed 120 characters",
  "admin.labelPresets.validation.dimension.range": "Dimension must be between 5 and 200 mm",
  "admin.labelPresets.validation.barcodeType.required": "Barcode type is required",
  "admin.labelPresets.validation.scope.required": "At least one print scope (Order or Sample) must be selected",
  "admin.labelPresets.validation.max.lte": "Max must be greater than or equal to default",
  "advanced.search": "Lancer la recherche",
  "alert.expired.title": "Elément expiré",
  "alert.expiring.title": "Bientôt Expiration",
  "alert.lowStock.title": "Alerte de stock faible",
  "alerts.acknowledge.button": "Acquitter",
  "alerts.acknowledge.comment": "Commentaire de résolution",
  "alerts.acknowledge.comment.placeholder": "Décrivez comment cette alerte a été traitée...",
  "alerts.acknowledge.comment.required": "Le commentaire de résolution est requis pour les alertes critiques",
  "alerts.acknowledge.error": "Échec de l'acquittement de l'alerte",
  "alerts.acknowledge.success": "Alerte acquittée avec succès",
  "alerts.acknowledge.title": "Acquitter l'alerte",
  "alerts.autoRefresh": "Actualisation automatique toutes les 60 secondes",
  "alerts.dashboard.title": "Tableau de bord des alertes",
  "alerts.empty": "Aucune alerte à afficher",
  "alerts.eqaDeadlineSummary.critical": "Critique",
  "alerts.eqaDeadlineSummary.deadlineCount": "{count} échéances à venir",
  "alerts.eqaDeadlineSummary.subtitle": "Échéances de soumission EEQ à venir regroupées par prestataire",
  "alerts.eqaDeadlineSummary.title": "Résumé des échéances EQA",
  "alerts.eqaDeadlineSummary.viewAll": "Voir tout",
  "alerts.filter.myAlerts": "Mes alertes",
  "alerts.filter.search": "Rechercher des alertes...",
  "alerts.filter.severity": "Sévérité",
  "alerts.filter.status": "Statut",
  "alerts.filter.type": "Type d'alerte",
  "alerts.severity.critical": "Critique",
  "alerts.severity.warning": "Avertissement",
  "alerts.status.acknowledged": "Acquitté",
  "alerts.status.open": "Ouvert",
  "alerts.status.resolved": "Résolu",
  "alerts.summary.critical": "Alertes critiques",
  "alerts.summary.eqaDeadlines": "Échéances EQA",
  "alerts.summary.sampleExpiration": "Échantillons expirant",
  "alerts.summary.statOverdue": "Commandes STAT en retard",
  "alerts.summary.totalOpen": "Total ouvertes",
  "alerts.table.actions": "Actions",
  "alerts.table.created": "Créé",
  "alerts.table.message": "Message",
  "alerts.table.severity": "Sévérité",
  "alerts.table.status": "Statut",
  "alerts.table.type": "Type",
  "alerts.type.critical_unacknowledged": "Critique non acquitté",
  "alerts.type.eqa_deadline": "Échéance EQA",
  "alerts.type.sample_expiration": "Expiration d'échantillon",
  "alerts.type.stat_overdue": "STAT en retard",
  "alerts.type.stat_upcoming": "STAT à venir",
  "aliquot": "Aliquote",
  "aliquot.analyses.count": "Analyses: {count}",
  "aliquot.id": "Identifiant de l'aliquote",
  "aliquot.quantity": "Quantité d'aliquote",
  "aliquot.quantity.not.balanced": "Quantité non équilibrée pour le type d'échantillon",
  "aliquot.save.error": "Erreur lors de l'enregistrement des données d'aliquotage.",
  "aliquot.save.success": "Les données aliquotes ont été enregistrées avec succès.",
  "aliquot.tests.not.assigned": "Tests non attribués pour le type d'échantillon",
  "aliquot.validation.errors": "Erreurs de validation",
  "aliquoting": "Aliquotage",
  "aliquoting.section": "Section d'aliquotage",
  "all.label": "Tous",
  "all.tests.assigned": "Tous les tests attribués",
  "allocated.to.aliquots": "Alloué à Aliquots",
  "analysis.count": "Nombre d'analyses",
  "analysis.details": "Détails de l'analyse",
  "analyzer.action.add": "Ajouter un Automate",
  "analyzer.action.copyMappings": "Copier les correspondances",
  "analyzer.action.delete": "Supprimer",
  "analyzer.action.edit": "Modifier",
  "analyzer.action.fieldMappings": "Correspondances de champs",
  "analyzer.action.qcRules": "Règles CQ",
  "analyzer.action.testConnection": "Texte de connexion",
  "analyzer.combinationName.notification": "Notification de combinaison de nom d'automate",
  "analyzer.copyMappings.confirmation.message": "Etes vous sûr de vouloir copier  {count} correspondances ? Les correspondances existantes seront écrasées.",
  "analyzer.copyMappings.confirmation.title": "Confirmer la copie des correspondances",
  "analyzer.copyMappings.copy": "Copier les correspondances",
  "analyzer.copyMappings.error": "Erreur lors de la copie des correspondances",
  "analyzer.copyMappings.error.noSourceMappings": "L'automate source n'a aucune correspondance active à copier. ",
  "analyzer.copyMappings.loading": "Copier les correspondances ...",
  "analyzer.copyMappings.source": "Automate d'origine",
  "analyzer.copyMappings.source.name": "Nom",
  "analyzer.copyMappings.source.type": "Type",
  "analyzer.copyMappings.subtitle": "Copier les mappages de champs de {source} vers {target}",
  "analyzer.copyMappings.success": "Successfully copied {count} mappings",
  "analyzer.copyMappings.success.viewTarget": "View Target Analyzer",
  "analyzer.copyMappings.summary": "Mapping Summary",
  "analyzer.copyMappings.summary.breakdown": "Field mappings: {fieldCount}, Unit conversions: {unitCount}, Qualitative mappings: {qualCount}",
  "analyzer.copyMappings.summary.count": "{count} mappings will be copied",
  "analyzer.copyMappings.target": "Analyseur cible",
  "analyzer.copyMappings.target.placeholder": "Sélectionner l'analyseur cible",
  "analyzer.copyMappings.target.required": "Target Analyzer *",
  "analyzer.copyMappings.title": "Copier les mappages de champs",
  "analyzer.copyMappings.warning": "Cela copiera tous les mappages de champs, y compris les conversions d'unités et les mappages de valeurs qualitatives. Les mappages existants seront écrasés.",
  "analyzer.delete.cancel": "Annuler",
  "analyzer.delete.delete": "Supprimer",
  "analyzer.delete.error": "Error",
  "analyzer.delete.error.noId": "Analyzer ID is required",
  "analyzer.delete.error.unknown": "An unknown error occurred while deleting the analyzer",
  "analyzer.delete.message": "Êtes-vous sûr de vouloir supprimer {name}? Cette action ne peut pas être annulée et supprimera toutes les données associées.",
  "analyzer.delete.success": "Analyseur supprimé",
  "analyzer.delete.title": "Supprimer l'analyseur",
  "analyzer.delete.unknown": "Unknown Analyzer",
  "analyzer.errorDashboard.acknowledgeAll": "Tout reconnaître",
  "analyzer.errorDashboard.action.acknowledge": "Reconnaître",
  "analyzer.errorDashboard.action.menu": "Error actions",
  "analyzer.errorDashboard.action.viewDetails": "Voir les détails",
  "analyzer.errorDashboard.errorType.connection": "Connexion",
  "analyzer.errorDashboard.errorType.mapping": "Mappage",
  "analyzer.errorDashboard.errorType.protocol": "Protocole",
  "analyzer.errorDashboard.errorType.timeout": "Délai d'attente",
  "analyzer.errorDashboard.errorType.validation": "Validation",
  "analyzer.errorDashboard.filter.analyzer": "Analyseur",
  "analyzer.errorDashboard.filter.analyzer.all": "Tous",
  "analyzer.errorDashboard.filter.search": "Rechercher des erreurs...",
  "analyzer.errorDashboard.filter.severity": "Gravité",
  "analyzer.errorDashboard.filter.severity.all": "Toutes les gravités",
  "analyzer.errorDashboard.filter.type": "Type d'erreur",
  "analyzer.errorDashboard.filter.type.all": "Tous les types",
  "analyzer.errorDashboard.severity.critical": "Critique",
  "analyzer.errorDashboard.severity.error": "Erreur",
  "analyzer.errorDashboard.severity.warning": "Avertissement",
  "analyzer.errorDashboard.stats.critical": "Critiques",
  "analyzer.errorDashboard.stats.last24Hours": "24 dernières heures",
  "analyzer.errorDashboard.stats.total": "Total des erreurs",
  "analyzer.errorDashboard.stats.unacknowledged": "Non reconnues",
  "analyzer.errorDashboard.status.acknowledged": "Reconnue",
  "analyzer.errorDashboard.status.unacknowledged": "Non reconnue",
  "analyzer.errorDashboard.subtitle": "View and manage analyzer errors and alerts",
  "analyzer.errorDashboard.table.analyzer": "Analyseur",
  "analyzer.errorDashboard.table.message": "Message",
  "analyzer.errorDashboard.table.severity": "Gravité",
  "analyzer.errorDashboard.table.status": "Statut",
  "analyzer.errorDashboard.table.timestamp": "Horodatage",
  "analyzer.errorDashboard.table.type": "Type",
  "analyzer.errorDashboard.title": "Tableau de bord des erreurs",
  "analyzer.errorDetails.acknowledged": "Reconnue",
  "analyzer.errorDetails.acknowledgedBy": "Par {user} le {date}",
  "analyzer.errorDetails.analyzer": "Analyseur",
  "analyzer.errorDetails.analyzerId": "ID de l'analyseur",
  "analyzer.errorDetails.close": "Fermer",
  "analyzer.errorDetails.copy": "Copier",
  "analyzer.errorDetails.createMapping": "Créer un mappage",
  "analyzer.errorDetails.download": "Télécharger",
  "analyzer.errorDetails.errorId": "ID de l'erreur",
  "analyzer.errorDetails.errorMessage": "Message d'erreur",
  "analyzer.errorDetails.errorType": "Type d'erreur",
  "analyzer.errorDetails.logs": "Journaux de l'analyseur ({count} entrées)",
  "analyzer.errorDetails.recommendedActions": "Actions recommandées",
  "analyzer.errorDetails.recommendedActions.checkConfiguration": "Check IP address and port configuration in analyzer settings",
  "analyzer.errorDetails.recommendedActions.createMapping": "Create a mapping for the unmapped field to resolve this error",
  "analyzer.errorDetails.recommendedActions.testConnection": "Test connection using the 'Test Connection' feature",
  "analyzer.errorDetails.recommendedActions.verifyConnection": "Verify analyzer is powered on and network cable is connected",
  "analyzer.errorDetails.severity": "Gravité",
  "analyzer.errorDetails.subtitle": "Informations détaillées et journaux de l'analyseur pour l'erreur {id}",
  "analyzer.errorDetails.timestamp": "Horodatage",
  "analyzer.errorDetails.title": "Détails de l'erreur",
  "analyzer.fhirImport.error.importFailed": "Échec de l'import du bundle FHIR",
  "analyzer.fhirImport.error.invalidBundleType": "Le type de bundle doit être 'transaction' ou 'batch', reçu : {bundleType}",
  "analyzer.fhirImport.error.noObservations": "Le bundle ne contient aucune ressource Observation avec résultats",
  "analyzer.fieldCreation.acceptedUnits.label": "Unités acceptées",
  "analyzer.fieldCreation.acceptedUnits.placeholder": "Sélectionnez les unités acceptées",
  "analyzer.fieldCreation.cancel": "Annuler",
  "analyzer.fieldCreation.confirmation": "Je comprends que ce champ sera disponible pour le mappage immédiatement après sa création",
  "analyzer.fieldCreation.create": "Créer le champ",
  "analyzer.fieldCreation.createNew": "Créer un nouveau champ",
  "analyzer.fieldCreation.description.label": "Description (Optionnel)",
  "analyzer.fieldCreation.description.placeholder": "Entrez la description du champ",
  "analyzer.fieldCreation.entityType.label": "Type d'entité",
  "analyzer.fieldCreation.entityType.placeholder": "Sélectionnez le type d'entité",
  "analyzer.fieldCreation.error.generic": "Échec de la création du champ",
  "analyzer.fieldCreation.error.title": "Erreur lors de la création du champ",
  "analyzer.fieldCreation.fieldName.label": "Nom du champ",
  "analyzer.fieldCreation.fieldName.placeholder": "Entrez le nom du champ",
  "analyzer.fieldCreation.fieldType.label": "Type de champ",
  "analyzer.fieldCreation.fieldType.placeholder": "Sélectionnez le type de champ",
  "analyzer.fieldCreation.loincCode.label": "Code LOINC (Optionnel)",
  "analyzer.fieldCreation.loincCode.placeholder": "Entrez le code LOINC",
  "analyzer.fieldCreation.modal.subtitle": "Créer un nouveau champ qui sera disponible pour le mappage immédiatement",
  "analyzer.fieldCreation.modal.title": "Créer un nouveau champ OpenELIS",
  "analyzer.fieldCreation.success.message": "Le champ est maintenant disponible pour le mappage",
  "analyzer.fieldCreation.success.title": "Champ créé avec succès",
  "analyzer.fieldCreation.validation.entityType.required": "Le type d'entité est requis",
  "analyzer.fieldCreation.validation.fieldName.required": "Le nom du champ est requis",
  "analyzer.fieldCreation.validation.unique": "Un champ avec ce nom existe déjà",
  "analyzer.fieldCreation.validation.units.required": "Les unités acceptées sont requises pour les champs numériques",
  "analyzer.fieldMapping.activationModal.activate": "Activer les modifications",
  "analyzer.fieldMapping.activationModal.cancel": "Annuler",
  "analyzer.fieldMapping.activationModal.confirmCheckbox": "Je comprends que ces modifications s'appliqueront uniquement aux nouveaux messages",
  "analyzer.fieldMapping.activationModal.errorConcurrentEdit": "Mapping changes detected. Another user has modified mappings for this analyzer. Please reload the page to see latest changes.",
  "analyzer.fieldMapping.activationModal.errorMissingRequired": "Cannot activate: Required mappings missing",
  "analyzer.fieldMapping.activationModal.errorMissingRequired.detail": "Missing required fields: {fields}",
  "analyzer.fieldMapping.activationModal.reloadPage": "Reload Page",
  "analyzer.fieldMapping.activationModal.subtitle": "Confirmer l'activation des modifications de mappage pour l'analyseur '{name}'",
  "analyzer.fieldMapping.activationModal.title": "Activer les modifications de mappage",
  "analyzer.fieldMapping.activationModal.viewPendingMessages": "View Pending Messages",
  "analyzer.fieldMapping.activationModal.warning": "Vous êtes sur le point d'activer les modifications de mappage pour l'analyseur '{name}'. Ces modifications s'appliqueront à tous les nouveaux messages reçus après l'activation. Les résultats existants ne seront pas affectés.",
  "analyzer.fieldMapping.activationModal.warningActive": "Cet analyseur est actuellement actif. L'activation des modifications peut affecter les résultats entrants.",
  "analyzer.fieldMapping.activationModal.warningPendingMessages": "This analyzer has {count} pending messages in the error queue. Activating mapping changes may affect how these messages are reprocessed. Consider resolving errors first.",
  "analyzer.fieldMapping.back": "Retour",
  "analyzer.fieldMapping.fieldType.controlTest": "Test de contrôle",
  "analyzer.fieldMapping.fieldType.custom": "Personnalisé",
  "analyzer.fieldMapping.fieldType.dateTime": "Date/Heure",
  "analyzer.fieldMapping.fieldType.meltingPoint": "Point de fusion",
  "analyzer.fieldMapping.fieldType.numeric": "Numérique",
  "analyzer.fieldMapping.fieldType.qualitative": "Qualitatif",
  "analyzer.fieldMapping.fieldType.text": "Texte",
  "analyzer.fieldMapping.page.subtitle": "Configure field mappings between analyzer and OpenELIS",
  "analyzer.fieldMapping.page.title": "Mappages de champs",
  "analyzer.fieldMapping.panel.mapping.active": "Active",
  "analyzer.fieldMapping.panel.mapping.retired": "Retired",
  "analyzer.fieldMapping.panel.retire": "Retire Mapping",
  "analyzer.fieldMapping.panel.retire.disabled.tooltip": "Cannot retire: {reason}",
  "analyzer.fieldMapping.panel.source.fieldsAvailable": "{count} fields available",
  "analyzer.fieldMapping.panel.source.search": "Search fields...",
  "analyzer.fieldMapping.panel.source.title": "Analyzer Fields ({type})",
  "analyzer.fieldMapping.panel.status.mapped": "Mapped",
  "analyzer.fieldMapping.panel.status.unmapped": "Unmapped",
  "analyzer.fieldMapping.panel.statusFilter.active": "Active Only",
  "analyzer.fieldMapping.panel.statusFilter.all": "All Fields",
  "analyzer.fieldMapping.panel.statusFilter.draft": "Draft Only",
  "analyzer.fieldMapping.panel.statusFilter.label": "Filter by Status",
  "analyzer.fieldMapping.panel.statusFilter.mapped": "Mapped Only",
  "analyzer.fieldMapping.panel.statusFilter.unmapped": "Unmapped Only",
  "analyzer.fieldMapping.panel.target.cancel": "Cancel",
  "analyzer.fieldMapping.panel.target.edit": "Edit",
  "analyzer.fieldMapping.panel.target.remove": "Remove",
  "analyzer.fieldMapping.panel.target.saveActivate": "Save and Activate",
  "analyzer.fieldMapping.panel.target.saveDraft": "Save as Draft",
  "analyzer.fieldMapping.panel.target.selectField": "Select a field from the left panel to view or create mappings.",
  "analyzer.fieldMapping.panel.target.summary": "Mappings Summary",
  "analyzer.fieldMapping.panel.unmappedField.tooltip": "Unmapped Field - This field has no mapping configured",
  "analyzer.fieldMapping.pendingCodes.actions": "Actions",
  "analyzer.fieldMapping.pendingCodes.code": "Analyzer Code",
  "analyzer.fieldMapping.pendingCodes.empty": "No pending unmapped analyzer codes.",
  "analyzer.fieldMapping.pendingCodes.ignore": "Ignore",
  "analyzer.fieldMapping.pendingCodes.markMapped": "Mark Mapped",
  "analyzer.fieldMapping.pendingCodes.seenCount": "Seen",
  "analyzer.fieldMapping.pendingCodes.status": "Status",
  "analyzer.fieldMapping.pendingCodes.subtitle": "Review and resolve unmapped analyzer test codes.",
  "analyzer.fieldMapping.pendingCodes.title": "Pending Unmapped Codes",
  "analyzer.fieldMapping.pluginConfig.title": "Plugin Configuration Snapshot",
  "analyzer.fieldMapping.queryAnalyzer": "Query Analyzer",
  "analyzer.fieldMapping.retirementModal.cancel": "Cancel",
  "analyzer.fieldMapping.retirementModal.confirmation": "Are you sure you want to retire this mapping? Historical messages will still reference it for audit purposes.",
  "analyzer.fieldMapping.retirementModal.errorPendingMessages": "Cannot retire: {count} pending messages use this mapping",
  "analyzer.fieldMapping.retirementModal.reasonLabel": "Retirement Reason (Optional)",
  "analyzer.fieldMapping.retirementModal.reasonPlaceholder": "Optional: Reason for retiring this mapping",
  "analyzer.fieldMapping.retirementModal.retire": "Retire Mapping",
  "analyzer.fieldMapping.retirementModal.subtitle": "Confirm retirement of field mapping",
  "analyzer.fieldMapping.retirementModal.title": "Retire Mapping",
  "analyzer.fieldMapping.save": "Save Mappings",
  "analyzer.fieldMapping.stats.pendingCodes": "Pending Codes",
  "analyzer.fieldMapping.stats.required": "Required Mappings",
  "analyzer.fieldMapping.stats.total": "Total Mappings",
  "analyzer.fieldMapping.stats.unmapped": "Unmapped Fields",
  "analyzer.fieldMapping.status.active": "Active",
  "analyzer.fieldMapping.status.draft": "Draft",
  "analyzer.fieldMapping.status.retired": "Retired",
  "analyzer.fieldMapping.status.unmapped": "Unmapped",
  "analyzer.fieldMapping.testMapping": "Test Mapping",
  "analyzer.fieldMapping.warning.missingRequired": "Required mappings are missing",
  "analyzer.fieldMapping.warning.missingRequired.detail": "Some required fields are not mapped. Please map all required fields before activating.",
  "analyzer.filter.lifecycleStage.all": "All Lifecycle Stages",
  "analyzer.filter.lifecycleStage.label": "Lifecycle Stage",
  "analyzer.filter.status": "Status",
  "analyzer.filter.status.all": "All Statuses",
  "analyzer.filter.status.label": "Status",
  "analyzer.filter.testUnit": "Test Unit",
  "analyzer.filter.type": "Analyzer Type",
  "analyzer.form.activeStatus": "Active Status",
  "analyzer.form.activeStatus.description": "Enable this analyzer for data collection",
  "analyzer.form.addTitle": "Add New Analyzer",
  "analyzer.form.cancel": "Cancel",
  "analyzer.form.communicationMode": "Mode de communication",
  "analyzer.form.communicationMode.analyzerInitiated": "Analyseur \u2192 SIL (l'analyseur se connecte \u00e0 OpenELIS)",
  "analyzer.form.communicationMode.both": "Bidirectionnel (les deux directions)",
  "analyzer.form.communicationMode.help": "Qui initie la connexion. La plupart des analyseurs utilisent Analyseur \u2192 SIL.",
  "analyzer.form.communicationMode.lisInitiated": "SIL \u2192 Analyseur (OpenELIS se connecte \u00e0 l'analyseur)",
  "analyzer.form.createdBy": "Created By",
  "analyzer.form.createdDate": "Created Date/Time",
  "analyzer.form.defaults.error": "Failed to load default configuration",
  "analyzer.form.defaults.loaded": "Default configuration loaded",
  "analyzer.form.defaults.loaded.subtitle": "Template for {name} has been loaded. Customize as needed before saving.",
  "analyzer.form.editTitle": "Edit Analyzer",
  "analyzer.form.error.invalidCommunicationMode": "Mode de communication invalide : {value}. Valeurs valides : {validValues}",
  "analyzer.form.error.invalidProtocolVersion": "Version de protocole invalide : {value}. Valeurs valides : {validValues}",
  "analyzer.form.error.save": "Failed to save analyzer",
  "analyzer.form.error.unknown": "An unknown error occurred",
  "analyzer.form.fileProtocol.description": "This analyzer imports results from files. File import settings will be configured after saving.",
  "analyzer.form.fileProtocol.title": "File Import Protocol",
  "analyzer.form.identifierPattern": "Identifier Pattern",
  "analyzer.form.identifierPattern.helperText": "Regex pattern to match incoming message identifiers for routing",
  "analyzer.form.identifierPattern.placeholder": "e.g., ^ABX\\\\^PENTRA.*",
  "analyzer.form.ipAddress": "Adresse IP",
  "analyzer.form.ipAddress.placeholder": "192.168.1.10",
  "analyzer.form.lastModified": "Date/Heure de dernière modification",
  "analyzer.form.loadDefaultConfig": "Charger la configuration par défaut",
  "analyzer.form.loadDefaultConfig.helperText": "Configuration rapide à l'aide de modèles préconfigurés pour les plugins GenericASTM et GenericHL7",
  "analyzer.form.loadDefaultConfig.placeholder": "Sélectionner un modèle d'analyseur préconfiguré",
  "analyzer.form.name": "Nom de l'analyseur",
  "analyzer.form.name.placeholder": "ex: Analyseur d'hématologie 1",
  "analyzer.form.pluginType": "Type de plugin",
  "analyzer.form.pluginType.helperText": "Le plugin analyseur qui traitera les messages entrants",
  "analyzer.form.pluginType.placeholder": "Sélectionner le type de plugin...",
  "analyzer.form.port": "Numéro de port",
  "analyzer.form.port.placeholder": "5000",
  "analyzer.form.protocolVersion": "Version du protocole",
  "analyzer.form.save": "Enregistrer",
  "analyzer.form.status": "Statut",
  "analyzer.form.status.helperText": "Le statut change automatiquement selon l'état de l'analyseur. Remplacement manuel vers INACTIF, CONFIGURATION ou VALIDATION uniquement.",
  "analyzer.form.subtitle": "Configurer les paramètres de connexion et les unités de test de l'analyseur",
  "analyzer.form.success.save": "Analyseur enregistré avec succès",
  "analyzer.form.testConnection": "Tester la connexion",
  "analyzer.form.testConnection.error": "\u00c9chec de la connexion",
  "analyzer.form.testUnits": "Affectation des unités de test",
  "analyzer.form.testUnits.helper": "Sélectionner une ou plusieurs unités de test pour cet analyseur",
  "analyzer.form.testUnits.placeholder": "Sélectionner les unités de test...",
  "analyzer.form.type": "Type d'analyseur",
  "analyzer.form.type.other": "Autre",
  "analyzer.form.type.placeholder": "Sélectionner le type d'analyseur",
  "analyzer.form.validation.ipAddress.invalid": "Invalid IP address format",
  "analyzer.form.validation.name.required": "Analyzer name is required",
  "analyzer.form.validation.type.required": "Analyzer type is required",
  "analyzer.hl7.insertError": "Erreur d'insertion HL7",
  "analyzer.hl7.parseError": "Erreur d'analyse HL7",
  "analyzer.hl7.unknownAnalyzer": "Impossible d'identifier l'analyseur à partir du MSH HL7 (application/établissement émetteur)",
  "analyzer.list.subtitle": "Manage laboratory analyzers and field mappings",
  "analyzer.list.title": "Analyzers",
  "analyzer.navigation.analyzerTypes": "Analyzer Types",
  "analyzer.navigation.analyzers": "Analyzers",
  "analyzer.navigation.analyzersList": "Analyzers List",
  "analyzer.navigation.errorDashboard": "Error Dashboard",
  "analyzer.navigation.fieldMappings": "Field Mappings",
  "analyzer.navigation.qc": "Quality Control",
  "analyzer.navigation.qcDashboard": "Tableau de bord CQ",
  "analyzer.navigation.qcAlerts": "QC Alerts & Violations",
  "analyzer.navigation.qcCorrectiveActions": "Corrective Actions",
  "analyzerType.page.title": "Analyzer Types",
  "analyzerType.column.name": "Name",
  "analyzerType.column.description": "Description",
  "analyzerType.column.protocol": "Protocol",
  "analyzerType.column.pluginClass": "Plugin Class",
  "analyzerType.column.genericPlugin": "Generic Plugin",
  "analyzerType.column.identifierPattern": "Identifier Pattern",
  "analyzerType.column.pluginLoaded": "Plugin Loaded",
  "analyzerType.column.instances": "Instances",
  "analyzerType.column.status": "Status",
  "analyzerType.search.placeholder": "Search analyzer types...",
  "analyzerType.button.create": "Create New Analyzer Type",
  "analyzerType.button.creating": "Creating...",
  "analyzerType.button.cancel": "Cancel",
  "analyzerType.modal.createTitle": "Create New Analyzer Type",
  "analyzerType.field.name": "Name",
  "analyzerType.field.description": "Description",
  "analyzerType.field.protocol": "Protocol",
  "analyzerType.field.selectProtocol": "Select protocol",
  "analyzerType.field.pluginClassName": "Plugin Class Name",
  "analyzerType.field.identifierPattern": "Identifier Pattern",
  "analyzerType.field.identifierPatternHelper": "Regex pattern for matching sample identifiers (e.g. ^[A-Z]{2}\\\\d{6}$)",
  "analyzerType.field.isGenericPlugin": "Generic Plugin",
  "analyzerType.field.isActive": "Active",
  "analyzerType.error.nameRequired": "Name is required",
  "analyzerType.notification.createSuccess": "Analyzer type created successfully",
  "analyzerType.notification.createError": "Failed to create analyzer type",
  "analyzer.navigation.qcControlLots": "Lots de contrôle",
  "analyzer.navigation.qcRuleConfig": "Configuration des règles",
  "analyzer.page.addButton": "Add Analyzer",
  "analyzer.page.hierarchy.list": "Analyzer List",
  "analyzer.page.hierarchy.mappings": "Field Mappings",
  "analyzer.page.hierarchy.root": "Analyzers",
  "analyzer.page.title": "Analyseurs",
  "analyzer.plugin.missing": "Plugin Missing",
  "analyzer.qc.alerts.message": "Les fonctionnalités d'alertes et de violations arrivent bientôt.",
  "analyzer.qc.alerts.title": "Alertes et violations CQ",
  "analyzer.qc.corrective.message": "Les fonctionnalités d'actions correctives arrivent bientôt.",
  "analyzer.qc.corrective.title": "Actions correctives",
  "analyzer.qc.placeholder.message": "Les fonctionnalités de contrôle de qualité arrivent bientôt.",
  "analyzer.qc.placeholder.title": "Contrôle de qualité",
  "analyzer.qualitativeMapping.isDefault": "Default",
  "analyzer.qualitativeMapping.mappings": "Value Mappings",
  "analyzer.qualitativeMapping.noValues": "No analyzer values available for mapping",
  "analyzer.qualitativeMapping.openelisCode.placeholder": "Select OpenELIS code",
  "analyzer.qualitativeMapping.subtitle": "Map qualitative values for {fieldName}",
  "analyzer.qualitativeMapping.title": "Qualitative Value Mapping",
  "analyzer.qualitativeMapping.validation.error": "Validation Error",
  "analyzer.qualitativeMapping.validation.error.subtitle": "Please correct the errors below",
  "analyzer.qualitativeMapping.validation.noDefault": "No Default Value",
  "analyzer.qualitativeMapping.validation.noDefault.subtitle": "At least one mapping should be marked as default",
  "analyzer.qualitativeMapping.validation.openelisCode.required": "OpenELIS code is required",
  "analyzer.query.button": "Interroger l'analyseur",
  "analyzer.query.cancel": "Annuler",
  "analyzer.query.modal.logs": "Journaux de connexion",
  "analyzer.query.modal.noLogs": "Aucun journal pour le moment.",
  "analyzer.query.modal.progress": "Progression",
  "analyzer.query.modal.state": "État",
  "analyzer.query.modal.subtitle": "Récupérer les champs disponibles depuis l'analyseur",
  "analyzer.query.modal.title": "Interroger l'analyseur",
  "analyzer.query.progress": "{percent}% terminé",
  "analyzer.search.label": "Recherche",
  "analyzer.search.placeholder": "Rechercher des analyseurs...",
  "analyzer.stat.active": "Actif",
  "analyzer.stat.inactive": "Inactif",
  "analyzer.stat.pluginWarnings": "Plugin Warnings",
  "analyzer.stat.total": "Analyseurs au total",
  "analyzer.stats.active": "Analyseurs actifs",
  "analyzer.stats.inactive": "Analyseurs inactifs",
  "analyzer.stats.total": "Total des analyseurs",
  "analyzer.status.active": "Actif",
  "analyzer.status.deleted": "Supprimé",
  "analyzer.status.error_pending": "Erreur en attente",
  "analyzer.status.inactive": "Inactif",
  "analyzer.status.offline": "Hors ligne",
  "analyzer.status.pending_registration": "En attente d’inscription",
  "analyzer.status.setup": "Configuration",
  "analyzer.status.validation": "Validation",
  "analyzer.success.save": "Analyseur enregistré avec succès",
  "analyzer.table.actions": "Actions",
  "analyzer.table.connection": "Connexion",
  "analyzer.table.header.connection": "Connexion",
  "analyzer.table.header.lastModified": "Dernière modification",
  "analyzer.table.header.name": "Nom",
  "analyzer.table.header.status": "Statut",
  "analyzer.table.header.testUnits": "Unités de test",
  "analyzer.table.header.type": "Type",
  "analyzer.table.lastModified": "Dernière modification",
  "analyzer.table.name": "Nom",
  "analyzer.table.status": "Statut",
  "analyzer.table.testUnits": "Unités de test",
  "analyzer.table.type": "Type",
  "analyzer.testConnection.bridge.healthCheckFailed": "Impossible de joindre l'endpoint de santé du bridge à {url} : {detail}",
  "analyzer.testConnection.bridge.httpStatus": "Le bridge a retourné HTTP {status}",
  "analyzer.testConnection.bridge.notConfigured": "Le bridge n'est pas configuré",
  "analyzer.testConnection.bridge.unparseableResponse": "Le bridge a retourné une réponse non analysable",
  "analyzer.testConnection.bridge.unreachable": "Impossible de joindre le bridge : {detail}",
  "analyzer.testConnection.close": "Fermer",
  "analyzer.testConnection.logs": "Journaux de connexion",
  "analyzer.testConnection.requestBuildFailed": "Échec de la construction de la requête : {detail}",
  "analyzer.testConnection.success": "Connexion réussie",
  "analyzer.testConnection.tcp.bridgeNotConfigured": "Le bridge n'est pas configuré, la joignabilité de l'analyseur ne peut pas être testée",
  "analyzer.testConnection.testAgain": "Tester à nouveau",
  "analyzer.testConnection.testing": "Test de la connexion...",
  "analyzer.testConnection.title": "Test de connexion",
  "analyzer.testMapping.activeMappings": "{count} active mappings",
  "analyzer.testMapping.analyzerInfo": "Analyzer Information",
  "analyzer.testMapping.analyzerName": "Analyzer Name",
  "analyzer.testMapping.analyzerType": "Analyzer Type",
  "analyzer.testMapping.appliedMappings": "Applied Mappings",
  "analyzer.testMapping.entityPreview": "OpenELIS Entity Preview",
  "analyzer.testMapping.errors": "Errors",
  "analyzer.testMapping.loading": "Processing preview...",
  "analyzer.testMapping.messageInput": "Sample ASTM Message",
  "analyzer.testMapping.messageInput.counter": "{current} / {max} characters",
  "analyzer.testMapping.messageInput.helper": "Enter a sample ASTM message to preview how it will be interpreted",
  "analyzer.testMapping.messageInput.placeholder": "H|\\\\^&|||PSM^Micro^2.0|...",
  "analyzer.testMapping.messageInput.required": "Sample ASTM Message *",
  "analyzer.testMapping.noResults": "No preview results yet. Enter a sample ASTM message and click Preview Mapping.",
  "analyzer.testMapping.parsedFields": "Parsed Fields",
  "analyzer.testMapping.parsedFields.astmRef": "ASTM Ref",
  "analyzer.testMapping.parsedFields.fieldName": "Field Name",
  "analyzer.testMapping.parsedFields.interpretation": "Interpretation",
  "analyzer.testMapping.parsedFields.mappedTo": "Mapped To",
  "analyzer.testMapping.parsedFields.rawValue": "Raw Value",
  "analyzer.testMapping.pluginConfigSnapshot": "Plugin Config Snapshot",
  "analyzer.testMapping.previewOptions": "Preview Options",
  "analyzer.testMapping.previewOptions.detailedParsing": "Show detailed parsing steps",
  "analyzer.testMapping.previewOptions.validateAll": "Validate all mappings",
  "analyzer.testMapping.results": "Résultats du test",
  "analyzer.testMapping.saveTestCase": "Save as Test Case",
  "analyzer.testMapping.submit": "Soumettre un message d'exemple",
  "analyzer.testMapping.subtitle": "Preview how sample ASTM messages will be interpreted",
  "analyzer.testMapping.testAnother": "Test Another Message",
  "analyzer.testMapping.title": "Tester le mappage",
  "analyzer.testMapping.validation.invalidFormat": "Invalid ASTM message format",
  "analyzer.testMapping.validation.messageRequired": "ASTM message is required",
  "analyzer.testMapping.validation.messageTooLarge": "ASTM message exceeds maximum size of 10KB",
  "analyzer.testMapping.warnings": "Warnings",
  "analyzer.unitMapping.analyzerUnit": "Source Unit (Analyzer)",
  "analyzer.unitMapping.analyzerUnit.helper": "Unit reported by the analyzer",
  "analyzer.unitMapping.conversionFactor": "Conversion Factor",
  "analyzer.unitMapping.conversionFactor.helper": "Factor to convert from {from} to {to} (e.g., 0.0555 for mg/dL to mmol/L)",
  "analyzer.unitMapping.openelisUnit": "Target Unit (OpenELIS)",
  "analyzer.unitMapping.openelisUnit.helper": "Canonical unit used in OpenELIS",
  "analyzer.unitMapping.openelisUnit.placeholder": "Select target unit",
  "analyzer.unitMapping.rejectIfMismatch": "Reject if Units Don't Match",
  "analyzer.unitMapping.rejectIfMismatch.helper": "Reject messages if units don't match and no conversion factor is provided",
  "analyzer.unitMapping.subtitle": "Configure unit mapping for {fieldName}",
  "analyzer.unitMapping.title": "Unit Mapping",
  "analyzer.unitMapping.validation.analyzerUnit.required": "Source unit is required",
  "analyzer.unitMapping.validation.conversionFactor.invalid": "Conversion factor must be a positive number",
  "analyzer.unitMapping.validation.conversionFactor.required": "Conversion factor is required when units differ",
  "analyzer.unitMapping.validation.error": "Validation Error",
  "analyzer.unitMapping.validation.error.subtitle": "Please correct the errors below",
  "analyzer.unitMapping.validation.openelisUnit.required": "Target unit is required",
  "analyzer.qcRules.modal.title": "Règles d'identification des échantillons CQ — {analyzerName}",
  "analyzer.qcRules.orSemantics": "Les règles utilisent une logique OU : un échantillon est marqué comme CQ si au moins une règle active correspond.",
  "analyzer.qcRules.addRule": "Ajouter une règle",
  "analyzer.qcRules.deleteRule": "Supprimer la règle",
  "analyzer.qcRules.noRules": "Aucune règle CQ configurée. Ajoutez au moins une règle avant d'activer cet analyseur.",
  "analyzer.qcRules.ruleType": "Type de règle",
  "analyzer.qcRules.targetField": "Référence du champ",
  "analyzer.qcRules.targetField.placeholder": "ex. : O.12, QC_TASK",
  "analyzer.qcRules.operand": "Valeur à rechercher",
  "analyzer.qcRules.operand.placeholder": "ex. : Q, CNEG, ^(CNEG|CPOS).*",
  "analyzer.qcRules.error.loadFailed": "Échec du chargement des règles CQ",
  "analyzer.qcRules.error.saveFailed": "Échec de l'enregistrement de la règle CQ",
  "analyzer.qcRules.error.deleteFailed": "Échec de la suppression de la règle CQ",
  "analyzerTestName.header.analyzerName": "Analyseur – Nom du test dans l'analyseur",
  "analyzerTestName.modal.add.heading": "Ajouter un nom de test dans l'analyseur",
  "analyzerTestName.modal.update.heading": "Ajouter un nom de test dans l'analyseur",
  "assigned.cytopathologist.label": "Cytopathologiste attribué",
  "assigned.pathologist.label": "Pathologiste affecté",
  "assigned.technician.label": "Technicien affecté",
  "audittrail.table.heading.action": "Action",
  "audittrail.table.heading.identifier": "Identifiant",
  "audittrail.table.heading.item": "Élément",
  "audittrail.table.heading.newvalue": "Nouvelle Valeur",
  "audittrail.table.heading.oldvalue": "Ancienne Valeur",
  "audittrail.table.heading.time": "Temps",
  "audittrail.table.heading.user": "Utilisateur",
  "audittrail.table.title.patientResults": "Résultats du Patient",
  "availabletests.title": "Tests disponibles",
  "back.action.button": "Retour",
  "banner.menu.administration": "Administration",
  "banner.menu.alerts": "Alertes",
  "banner.menu.alerts.tooltip": "Tableau de bord des alertes et de l’assurance qualité",
  "banner.menu.aliquot": "Aliquote",
  "banner.menu.aliquot.tooltip": "Échantillon Aliquoté",
  "banner.menu.billing": "Facturation",
  "banner.menu.billing.tooltip": "Facturation",
  "banner.menu.createDouble": "Double entrée",
  "banner.menu.createInitial": "Entrée initiale",
  "banner.menu.eorders": "Ordonnances externes",
  "banner.menu.eqa": "EEQ",
  "banner.menu.eqa.distribution": "Distributions d’EEQ",
  "banner.menu.eqa.distribution.tooltip": "Créer et gérer les distributions d'EEQ",
  "banner.menu.eqa.management": "Programmes EEQ",
  "banner.menu.eqa.management.tooltip": "Créer et gérer les programmes d'EEQ",
  "banner.menu.eqa.mgmt": "Gestion EQE",
  "banner.menu.eqa.mgmt.distributions": "Distributions",
  "banner.menu.eqa.mgmt.distributions.tooltip": "Créer et gérer les distributions EQE",
  "banner.menu.eqa.mgmt.participants": "Participants",
  "banner.menu.eqa.mgmt.participants.tooltip": "Gérer l'inscription des organisations aux programmes EQE",
  "banner.menu.eqa.mgmt.programs": "Programmes",
  "banner.menu.eqa.mgmt.programs.tooltip": "Créer et gérer les programmes EQE",
  "banner.menu.eqa.mgmt.results": "Résultats et analyse",
  "banner.menu.eqa.mgmt.results.tooltip": "Collecte de résultats et analyse statistique EQE",
  "banner.menu.eqa.mgmt.tooltip": "Gérer les programmes EQE, participants et distributions",
  "banner.menu.eqa.tests": "Tests EQE",
  "banner.menu.eqa.tests.myPrograms": "Mes programmes",
  "banner.menu.eqa.tests.myPrograms.tooltip": "Gérer l'inscription aux programmes EQE externes",
  "banner.menu.eqa.tests.orders": "Commandes",
  "banner.menu.eqa.tests.orders.tooltip": "Voir et gérer les commandes de tests EQE",
  "banner.menu.eqa.tests.tooltip": "Commandes de tests EQE et inscription aux programmes",
  "banner.menu.eqa.tooltip": "Évaluation Externe de la Qualité",
  "banner.menu.generic.sample": "Échantillon générique",
  "banner.menu.generic.sample.edit": "Modifier l'échantillon",
  "banner.menu.generic.sample.import": "Importer  échantillons",
  "banner.menu.generic.sample.order": "Recevoir un échantillon",
  "banner.menu.generic.sample.results": "Saisir les résultats",
  "banner.menu.help": "Aide",
  "banner.menu.help.about": "Tutoriels vidéo",
  "banner.menu.help.contact": "Notes de version",
  "banner.menu.help.documents": "Documentation des processus",
  "banner.menu.help.formDBS": "Formulaire DBS",
  "banner.menu.help.formVL": "Formulaire VL",
  "banner.menu.help.usermanual": "Manuel de l'utilisateur",
  "banner.menu.home": "Accueil",
  "banner.menu.inventory": "Inventaire",
  "banner.menu.inventory.catalog": "Gérer le catalogue",
  "banner.menu.inventory.dashboard": "Tableau de bord",
  "banner.menu.inventory.list": "Éléments d’inventaire",
  "banner.menu.inventory.reports": "Rapports",
  "banner.menu.nonconformity": "Non Conforme",
  "banner.menu.nonconformity.correctiveActions": "Actions Correctives",
  "banner.menu.nonconformity.dashboard": "Toutes les non-conformités",
  "banner.menu.nonconformity.report": "Signaler un Événement Non Conforme",
  "banner.menu.nonconformity.view": "Voir les Nouveaux Événements Non Conformes",
  "banner.menu.patient": "Patient",
  "banner.menu.patient.Create": "Étude",
  "banner.menu.patient.addOrEdit": "Ajouter/Modifier un Patient",
  "banner.menu.patient.merge": "Fusionner Patient",
  "banner.menu.patient.merge.tooltip": "Fusionner les enregistrements de patients en doublon",
  "banner.menu.patientConsult": "Afficher",
  "banner.menu.patientEdit": "Modifier",
  "banner.menu.patienthistory": "Historique du Patient",
  "banner.menu.printBarcode": "Code-barres",
  "banner.menu.referredOut": "Referred Out",
  "banner.menu.report.validation.backlog": "Compte de tests en attente de validation",
  "banner.menu.reports": "Rapports",
  "banner.menu.reports.routine": "Routine",
  "banner.menu.reports.study": "Etude",
  "banner.menu.results": "Résultats",
  "banner.menu.results.CobasIntegra400": "Biochimie: Cobas Integra 400+",
  "banner.menu.results.FacsCalibur": "Immunologie: FacsCalibur",
  "banner.menu.results.FacsCantoII": "Immunologie: FacsCantoII",
  "banner.menu.results.FacsPrestoanalyzer": "Immunologie: FacsPresto",
  "banner.menu.results.Fullyanalyzer": "Biochimie: Fully",
  "banner.menu.results.GeneXpertAnalyzer": "GeneXpert",
  "banner.menu.results.GeneXpertanalyzer": "GeneXpertFileAnalyzer",
  "banner.menu.results.PocH100iAnalyzer": "PocH100iAnalyze",
  "banner.menu.results.SysmeXT": "Hematologie: SysmeXT 2000i",
  "banner.menu.results.SysmexXNLAnalyzer": "SysmexXNL",
  "banner.menu.results.SysmexXNLanalyzer": "Automate Sysmex XNL",
  "banner.menu.results.SysmexXPAnalyzer": "SysmexXP",
  "banner.menu.results.SysmexXPanalyzer": "Analyseur Sysmex XP",
  "banner.menu.results.accession": "Recherche par ordonnance",
  "banner.menu.results.analyzer": "Automate",
  "banner.menu.results.cobasc111analyzer": "Biochimie: Cobas C111",
  "banner.menu.results.genexpertanalyzer": "GeneXpert",
  "banner.menu.results.logbook": "Par Unité",
  "banner.menu.results.mindrayanalyzer": "Mindray",
  "banner.menu.results.order.programmes": "Planification des demandes",
  "banner.menu.results.patient": "Par Patient",
  "banner.menu.results.quantstudio3analyzer": "QuantStudio 3",
  "banner.menu.results.status": "Par Test, Date ou Statut",
  "banner.menu.results.sysmexanalyzer": "Hématologie: Sysmex XT 2000i",
  "banner.menu.results.sysmexxtanalyzer": "Hematologie: Sysmex XT 4000i",
  "banner.menu.results.taqman48dbsanalyzer": "Virologie: Cobas TaqMan48 DNA PCR",
  "banner.menu.results.testdate": "Par Date de Test",
  "banner.menu.results.weber": "La Weber 4000",
  "banner.menu.resultvalidation": "Validation",
  "banner.menu.resultvalidation.bacteria": "Bactérie",
  "banner.menu.resultvalidation.bench": "Par palier",
  "banner.menu.resultvalidation.biochemistry": "Biochimie",
  "banner.menu.resultvalidation.cytobacteriology": "Cytobacteriologie",
  "banner.menu.resultvalidation.dnapcr": "DNA PCR",
  "banner.menu.resultvalidation.ecbu": "ECBU",
  "banner.menu.resultvalidation.endocrinologie": "Endocrinologie",
  "banner.menu.resultvalidation.genotyping": "Génotypage",
  "banner.menu.resultvalidation.hemato-immunology": "Hémato-Immunologie",
  "banner.menu.resultvalidation.hematology": "Hématologie",
  "banner.menu.resultvalidation.immunology": "Immunologie",
  "banner.menu.resultvalidation.immunology.Haiti": "Immuno-Virologie",
  "banner.menu.resultvalidation.immunologyHematology": "Immunologie - Hématologie",
  "banner.menu.resultvalidation.liquidBio": "Liquide biologique",
  "banner.menu.resultvalidation.malaria": "Paludisme",
  "banner.menu.resultvalidation.molecularBio": "Biologie Moleculaire",
  "banner.menu.resultvalidation.mycobacteriology": "Mycobactériologie",
  "banner.menu.resultvalidation.mycology": "Mycologie",
  "banner.menu.resultvalidation.parasitology": "Parasitologie",
  "banner.menu.resultvalidation.serology": "Sérologie",
  "banner.menu.resultvalidation.serology-immunology": "Sérologie-Immunologie",
  "banner.menu.resultvalidation.viralload": "Charge Virale",
  "banner.menu.resultvalidation.virology": "Virologie",
  "banner.menu.resultvalidation_routine": "Routine",
  "banner.menu.resultvalidation_study": "Etude",
  "banner.menu.sample": "Ordonnance",
  "banner.menu.sample.shipment": "Expédition des échantillons",
  "banner.menu.sampleAdd": "Ajouter une ordonnance",
  "banner.menu.sampleBatchEntry": "Saisie d'ordonnances en lot",
  "banner.menu.sampleConsult": "Consulter",
  "banner.menu.sampleCreate": "Etude",
  "banner.menu.sampleEdit": "Modifier une ordonnance",
  "banner.menu.sampleManagement": "Gestion des échantillons",
  "banner.menu.sampleManagement.tooltip": "Menu de gestion des échantillons",
  "banner.menu.storage": "Stockage",
  "banner.menu.storage.tooltip": "Gestion du stockage des échantillons",
  "banner.menu.study.eorders": "Statistiques journalières. ",
  "banner.menu.workplan": "Plan de Travail",
  "banner.menu.workplan.bench": "Par Unité",
  "banner.menu.workplan.panel": "Par Panel",
  "banner.menu.workplan.priority": "Par priorité",
  "banner.menu.workplan.test": "Par test",
  "banner.menu.workplan.unit": "Par Unité",
  "barcode.additionalInvalidLevels.message": "Le code-barre contient des niveaux au-delà de la partie valide. Seuls les niveaux valides sont préremplis.",
  "barcode.additionalInvalidLevels.warning": "Niveaux non valides supplémentaires détectés",
  "barcode.autoOpenForm": "Formulaire d'ouverture de l'emplacement avec hiérarchie valide",
  "barcode.debounce.warning": "Veuillez patienter avant de scanner un autre code-barre",
  "barcode.error": "Code-barres invalide",
  "barcode.firstMissingLevel": "Premier niveau manquant : {level}",
  "barcode.format": "Format du code-barres",
  "barcode.header": "En-tête du code-barres",
  "barcode.invalidFormat": "Format de code-barres invalide. Format attendu : CHAMBRE-APPAREIL ou CHAMBRE-APPAREIL-ÉTAGÈRE-RACK-POSITION",
  "barcode.label.block": "Étiquette de bloc",
  "barcode.label.freezer": "Étiquette de congélateur ",
  "barcode.label.helper.text": "Saisissez les valeurs en : mm",
  "barcode.label.order": "Étiquette de demande d’examen ",
  "barcode.label.slide": "Étiquette de lame",
  "barcode.label.specimen": "Étiquette d’échantillon",
  "barcode.label.info.blockCaseNumber": "Numéro de bloc de dossier",
  "barcode.label.info.blockId": "ID du bloc",
  "barcode.label.info.blockNumber": "Numéro de bloc",
  "barcode.label.info.boxid": "Identifiant de la boîte",
  "barcode.label.info.caseNumber": "Numéro de dossier",
  "barcode.label.info.collectedBy": "Collecté Par",
  "barcode.label.info.collectionDate": "Date de Prélèvement",
  "barcode.label.info.collectionDateTime": "Date et Heure de Prélèvement",
  "barcode.label.info.created": "Créé",
  "barcode.label.info.destination": "Destination",
  "barcode.label.info.expiryDate": "Date d'Expiration",
  "barcode.label.info.labNumber": "Numéro d'Accession",
  "barcode.label.info.patientDobFull": "Date de Naissance du Patient",
  "barcode.label.info.patientId": "Identifiant du Patient",
  "barcode.label.info.patientName": "Nom du Patient",
  "barcode.label.info.patientSexFull": "Sexe du Patient",
  "barcode.label.info.samplecount": "Échantillons",
  "barcode.label.info.siteId": "ID du Site",
  "barcode.label.info.slideId": "ID de la lame",
  "barcode.label.info.slideNumber": "Numéro de lame",
  "barcode.label.info.specimenType": "Type d'échantillon",
  "barcode.label.info.stainType": "Type de coloration",
  "barcode.label.info.storageLocation": "Emplacement de stockage",
  "barcode.label.info.temperature": "Température",
  "barcode.label.info.tests": "Tests",
  "barcode.labels.order.row": "Étiquettes de commande",
  "barcode.labels.running.total": "Total cumulé",
  "barcode.labels.sample.row": "Étiquettes d'échantillon {sampleNumber}",
  "barcode.labels.section.title": "Quantités d'étiquettes",
  "barcode.locationNotFound": "Emplacement introuvable",
  "barcode.notification.save": "Les configurations de code-barres ont été enregistrées.",
  "barcode.partialMatch": "Correspondance partielle - certains composants sont valides",
  "barcode.print.button": "Imprimer",
  "barcode.print.dialog.quantityFor": "Quantity to print for {label}",
  "barcode.print.dialog.title": "Imprimer les étiquettes",
  "barcode.print.done": "Terminer",
  "barcode.print.individual.button": "Bouton d'impression individuelle",
  "barcode.print.later": "Skip — Print Later",
  "barcode.print.preprint": "Impression anticipée du code-barres",
  "barcode.print.preprint.button": "Bouton de pré-impression",
  "barcode.print.preprint.note": "Note de pré-impression",
  "barcode.print.reprint.dialog": "Réimprimer les étiquettes",
  "barcode.print.section.set": "Section de configuration de l'impression",
  "barcode.print.set.button": "Bouton de configuration de l'impression",
  "barcode.print.set.instruction": "Instruction de configuration de l'impression",
  "barcode.print.skip": "Passer",
  "barcode.print.title": "Titre de l'impression du code-barres",
  "barcode.ready": "Prêt à scanner",
  "barcode.scan": "Scanner le code-barres",
  "barcode.scan.error": "Demande d'examens non trouvée",
  "barcode.scan.placeholder": "Scanner le code-barre ou saisir le numéro labo ...",
  "barcode.scan.success": "Demande d'examens chargée avec succès",
  "barcode.scanning": "Scan en cours…",
  "barcode.scanOrType": "Scannez le code-barres ou saisissez l'emplacement",
  "barcode.success": "Emplacement trouvé",
  "barcode.validHierarchyPrefilled": "Niveaux hiérarchiques valides préremplis",
  "barcode.validation.altPrefix": "La saisie doit être alphanumérique et comporter au maximum 4 caractères.",
  "barcode.validationFailed": "La validation du code-barres a échoué",
  "barcodeconfiguration.browse.title": "Configuration du code-barres",
  "breadcrumb.home": "Accueil",
  "breadcrums.admin.managment": "Gestion de l'administration",
  "calendar.management.title": "Gestion du calendrier",
  "calendar.management.description": "Gérer les jours fériés et la configuration des week-ends pour le calcul des délais de traitement",
  "calendar.management.addHoliday": "Ajouter jour férié",
  "calendar.management.editHoliday": "Modifier jour férié",
  "calendar.management.deleteConfirm": "Êtes-vous sûr de vouloir supprimer ce jour férié ?",
  "calendar.management.holidayName": "Nom du jour férié",
  "calendar.management.date": "Date",
  "calendar.management.recurring": "Récurrent",
  "calendar.management.annual": "Annuel",
  "calendar.management.oneTime": "Ponctuel",
  "calendar.management.active": "Actif",
  "calendar.management.inactive": "Inactif",
  "calendar.management.weekend": "Week-end",
  "calendar.management.weekendDays": "Jours de week-end (exclus du temps de travail)",
  "calendar.management.weekendSaved": "Configuration du week-end enregistrée",
  "calendar.management.importCsv": "Importer un fichier CSV",
  "calendar.management.exportCsv": "Exporter un fichier CSV",
  "calendar.management.importPreview": "Aperçu de l’importation",
  "calendar.management.year": "Année",
  "calendar.management.noHolidays": "Aucun jour férié configuré pour {year}. Cliquez sur “Ajouter un jour férié” pour commencer.",
  "calendar.management.duplicateDate": "Un jour férié existe déjà pour cette date",
  "calendar.management.imported": "{count} jours fériés importés",
  "calendar.management.skipped": "{count} jours fériés ignorés",
  "calendar.management.holidayCount": "{count} jours fériés configurés pour {year}",
  "calendar.management.saveError": "Erreur lors de l’enregistrement du jour férié",
  "calendar.management.loadError": "Erreur lors du chargement des jours fériés",
  "calendar.management.save": "Enregistrer",
  "calendar.management.cancel": "Annuler",
  "calendar.management.actions": "Actions",
  "calendar.management.status": "Statuts",
  "calendar.management.column.date": "Date",
  "calendar.management.column.holidayName": "Nom du jour férié",
  "calendar.management.column.recurring": "Récurrent",
  "calendar.management.column.status": "Statuts",
  "calendar.management.column.actions": "Actions",
  "calendar.management.day.sun": "Dim",
  "calendar.management.day.mon": "Lun",
  "calendar.management.day.tue": "Mar",
  "calendar.management.day.wed": "Mer",
  "calendar.management.day.thu": "Jeu",
  "calendar.management.day.fri": "Ven",
  "calendar.management.day.sat": "Sam",
  "calendar.management.chooseFile": "Choisir un fichier CSV",
  "calendar.management.csvColumns": "Colonnes : date, nom, récurrent (Vrai/Faux)",
  "calendar.management.rowsFound": "{count} lignes trouvées",
  "calendar.management.column.csvDate": "Date",
  "calendar.management.column.csvName": "Nom",
  "calendar.management.column.csvRecurring": "Récurrent",
  "calendar.management.importing": "Importation en cours ...",
  "reports.tat.title": "Rapport sur le délai de traitement",
  "reports.tat.description": "Analyser les délais de traitement du laboratoire à travers les différentes étapes du processus",
  "reports.tat.generateReport": "Générer un rapport",
  "reports.tat.clearFilters": "Effacer les filtres",
  "reports.tat.segment.orderToCollection": "De la prescription au prélèvement",
  "reports.tat.segment.collectionToReceipt": "Prélèvement à la réception",
  "reports.tat.segment.receiptToTesting": "Réception au début de l’analyse",
  "reports.tat.segment.receiptToResult": "Réception à la saisie des résultats",
  "reports.tat.segment.receiptToValidation": "Réception à la validation",
  "reports.tat.segment.resultToValidation": "Saisie des résultats à la validation",
  "reports.tat.segment.overall": "Délai de traitement global",
  "reports.tat.calendarTime": "Temps calendaire",
  "reports.tat.workingTime": "Temps de travail",
  "reports.tat.workingTimeInfo": "Mode temps de travail : exclusion des {weekendDays} et de {holidayCount} jours fériés dans la période sélectionnée",
  "reports.tat.configuredWeekends": "week-ends configurés",
  "reports.tat.noHolidaysWarning": " Aucun jour férié configuré. Configurez les jours fériés dans Admin > Gestion du calendrier.",
  "reports.tat.manageCalendar": "Gestion du calendrier",
  "reports.tat.totalResults": "Résultats totaux",
  "reports.tat.meanTat": "Délai moyen de traitement",
  "reports.tat.medianTat": "Délai médian de traitemen",
  "reports.tat.percentile90": "90e percentile",
  "reports.tat.minTat": "Délai minimum de traitement",
  "reports.tat.maxTat": "Délai maximum de traitement",
  "reports.tat.stdDeviation": "Écart-type",
  "reports.tat.distribution": "Distribution des délais de traitement",
  "reports.tat.breakdownBy": "Répartition par",
  "reports.tat.clickRowHint": "Cliquez sur une ligne pour voir les résultats individuels",
  "reports.tat.summary": "Résumé",
  "reports.tat.detailList": "Liste détaillée",
  "reports.tat.trends": "Tendances",
  "reports.tat.noResults": "Aucun résultat trouvé pour les filtres sélectionnés. Essayez d’ajuster la période ou les critères de filtrage.",
  "reports.tat.insufficientData": "Données insuffisantes",
  "reports.tat.loadError": "Erreur lors du chargement des données du rapport",
  "reports.tat.dateRange": "Plage de date",
  "reports.tat.labUnit": "Unité de laboratoire",
  "reports.tat.testPanel": "Test / Panel",
  "reports.tat.priority.all": "Tous",
  "reports.tat.priority.routine": "Routine",
  "reports.tat.priority.stat": "Urgent",
  "reports.tat.priority.asap": "Dès que possible",
  "reports.tat.sampleType": "Type d'échantillon",
  "reports.tat.orderingSite": "Site demandeur",
  "reports.tat.priority": "Priorité",
  "reports.tat.includeCancelled": "Inclure les analyses annulées/rejetées",
  "reports.tat.export": "Exporter",
  "reports.tat.exportCsv": "Exporter fichier CSV",
  "reports.tat.exportPdf": "Exporter fichier PDF",
  "reports.tat.labNumber": "Numéro Laboratoire",
  "reports.tat.patient": "Patient",
  "reports.tat.test": "Test",
  "reports.tat.orderCreated": "Demande d'examens créée",
  "reports.tat.collected": "Prélevé",
  "reports.tat.received": "Reçu",
  "reports.tat.testingStarted": "Analyse commencée",
  "reports.tat.resultEntered": "Résultat saisi",
  "reports.tat.validated": "Validé",
  "reports.tat.selectedTat": "Délai de traitement sélectionné",
  "reports.tat.overallTat": "Délai global de traitement",
  "reports.tat.columns": "Colonnes",
  "reports.tat.rowsPerPage": "Lignes par page",
  "reports.tat.showing": "Affichage de {from} à {to} sur {total} résultats",
  "reports.tat.trend": "Tendance",
  "reports.tat.aggregation": "Agrégation",
  "reports.tat.daily": "Journalier",
  "reports.tat.weekly": "Hebdomadaire",
  "reports.tat.monthly": "Mensuel",
  "reports.tat.compareBy": "Comparer par",
  "reports.tat.showVolume": "Afficher le volume des demandes",
  "reports.tat.mean": "Moyen",
  "reports.tat.median": "Médian",
  "reports.tat.notApplicable": "N/A",
  "reports.tat.dateRangeFrom": "Plage de Date (De)",
  "reports.tat.dateRangeTo": "Plage de Date (à)",
  "reports.tat.tatSegment": "Segment de Délai de traitement",
  "reports.tat.metrics": "Indicateurs",
  "reports.tat.compareNone": "Aucun",
  "reports.tat.comparePriority": "Priorité",
  "reports.tat.column.labNumber": "Numéro Laboratoire",
  "reports.tat.column.test": "Test",
  "reports.tat.column.labUnit": "Unité de laboratoire",
  "reports.tat.column.priority": "Priorité",
  "reports.tat.column.ordered": "Prescrit",
  "reports.tat.column.collected": "Prélevé",
  "reports.tat.column.received": "Reçu",
  "reports.tat.column.started": "Démarré",
  "reports.tat.column.resulted": "Résultat disponible",
  "reports.tat.column.validated": "Validé",
  "reports.tat.column.selectedTat": "Délai de traitement sélectionné",
  "reports.tat.column.overallTat": "Délai de traitement global",
  "reports.tat.column.name": "Nom",
  "reports.tat.column.count": "Nombre",
  "reports.tat.column.mean": "Moyen",
  "reports.tat.column.median": "Médian",
  "reports.tat.column.p90": "90e percentile",
  "reports.tat.column.max": "Maximum",
  "reports.tat.home": "Accueil",
  "reports.tat.all": "Tous",
  "reports.tat.preset.today": "Aujourd'hui",
  "reports.tat.preset.7days": "7 derniers jours",
  "reports.tat.preset.30days": "30 derniers jours ",
  "reports.tat.preset.90days": "90 derniers jours ",
  "reports.tat.preset.thisMonth": "Ce mois",
  "reports.tat.preset.lastMonth": "Dernier mois",
  "reports.tat.preset.thisQuarter": "Ce trimestre",
  "button.cancel": "Annuler",
  "button.activate": "Activer",
  "button.adjust": "Ajuster",
  "button.deactivate": "Désactiver",
  "button.dispose": "Disposer",
  "button.edit": "Modifier",
  "button.generate": "Générer",
  "button.label.genarateReport": "Générer un rapport",
  "button.label.loadnext": "Charger le lot suivant",
  "button.label.loadprevious": "Charger le lot précédent",
  "button.label.showHidePram": "Afficher/Masquer les paramètres du rapport",
  "button.record": "Enregistrer",
  "button.save": "Sauvegarder",
  "button.save.draft": "Enregistrer le brouillon",
  "button.save.next": "Enregistrer et suivant",
  "button.save.stay": "Enregistrer",
  "button.send": "Envoyer",
  "calculatedTests": "Calculated Tests",
  "catalog.item.activate.success": "L'élément du catalogue a été activé avec succès.",
  "catalog.item.category": "Catégorie",
  "catalog.item.compatibleAnalyzers": "Automates compatibles",
  "catalog.item.deactivate.confirm.button": "Désactiver",
  "catalog.item.deactivate.confirm.message": "Êtes-vous sûr de vouloir désactiver {itemName} ?",
  "catalog.item.deactivate.confirm.title": "Confirmer la désactivation",
  "catalog.item.deactivate.implications.1": "Cet élément n'apparaîtra plus dans les listes d'articles actifs.",
  "catalog.item.deactivate.implications.2": "Les lots existants pour cet article resteront accessibles.",
  "catalog.item.deactivate.implications.3": "Vous pouvez réactiver cet élément ultérieurement si nécessaire.",
  "catalog.item.deactivate.implications.title": "Implications :",
  "catalog.item.deactivate.label": "Désactiver l'élément",
  "catalog.item.deactivate.success": "Elément désactivé avec succès",
  "catalog.item.form.title.add": "Ajouter de nouveaux éléments au catalogue",
  "catalog.item.form.title.edit": "Modifier un élément du catalogue",
  "catalog.item.lowStockThreshold": "Seuil de stock bas",
  "catalog.item.manufacturer": "Fabricante",
  "catalog.item.minimumStock": "Niveau de stock minimum",
  "catalog.item.name": "Nom de l'élément ",
  "catalog.item.reorderLevel": "Niveau de réapprovisionnement",
  "catalog.item.reorderQuantity": "Quantité de commande",
  "catalog.item.save.error": "Erreur lors de l'enregistrement de l'élément de catalogue",
  "catalog.item.save.success": "L'élément du catalogue a été enregistré avec succès.",
  "catalog.item.stabilityAfterOpening": "Stabilité après ouverture (jours)",
  "catalog.item.status": "Statut",
  "catalog.item.storageRequirements": "Exigences de stockage",
  "catalog.item.testTypes": "Types de tests",
  "catalog.item.testsPerCartridge": "Tests par cartouche",
  "catalog.item.testsPerKit": "Tests par kit",
  "catalog.item.type": "Type d'élément ",
  "catalog.item.units": "Unités",
  "catalog.search.placeholder": "Rechercher par nom d'élément",
  "choose.availablepanel": "Choisir le panneau disponible",
  "coldStorage.action.createSuccess": "Corrective action created successfully",
  "coldStorage.action.retractSuccess": "Corrective action retracted successfully",
  "coldStorage.action.updateSuccess": "Corrective action updated successfully",
  "coldStorage.actions": "Actions",
  "coldStorage.activated": "activated",
  "coldStorage.addDevicesMessage": "Please add devices in Device Management to configure temperature thresholds.",
  "coldStorage.addNewDevice": "Add New Device",
  "coldStorage.alert.equipment": "Equipment Failure",
  "coldStorage.alert.equipment.description": "Alerts for equipment malfunctions or connectivity issues",
  "coldStorage.alert.inventory": "Inventory Alerts",
  "coldStorage.alert.inventory.description": "Alerts for low inventory or stock management",
  "coldStorage.alert.saveFailed": "Failed to save notification preferences: ",
  "coldStorage.alert.saveSuccess": "Notification preferences saved successfully. Each alert type will use its configured notification methods.",
  "coldStorage.alert.temperature": "Temperature Alerts",
  "coldStorage.alert.temperature.description": "Alerts triggered when freezer temperature exceeds defined thresholds",
  "coldStorage.alert.type": "Alert Type",
  "coldStorage.alertConfiguration": "Alert Configuration",
  "coldStorage.autoEscalate": "Automatically escalate unresolved alerts",
  "coldStorage.bacnetUdpPort": "BACnet UDP Port",
  "coldStorage.button.delete": "Delete",
  "coldStorage.config.saveSuccess": "System configuration saved successfully",
  "coldStorage.configMoved": "Configuration Moved to Admin Panel",
  "coldStorage.configMovedDesc": "System-wide settings should be managed in the Admin UI where all global configurations are centralized. This page is read-only and will be removed in a future release.",
  "coldStorage.configuredDevices": "Configured Devices",
  "coldStorage.criticalThreshold": "Critical Threshold (°C)",
  "coldStorage.databaseVersion": "Database Version",
  "coldStorage.deactivated": "deactivated",
  "coldStorage.description": "Description",
  "coldStorage.device.activate": "Activate device",
  "coldStorage.device.activateMessage": "Activating this device will enable monitoring and data collection.",
  "coldStorage.device.changeStatus": "Change Device Status",
  "coldStorage.device.changeStatusOf": "Change the status of {name}:",
  "coldStorage.device.created": "Device created successfully",
  "coldStorage.device.createdSuccess": "Device \\",
  "coldStorage.device.deactivate": "Deactivate device",
  "coldStorage.device.deactivateMessage": "Deactivating this device will stop monitoring and data collection. Historical data will be preserved.",
  "coldStorage.device.delete": "Delete Device",
  "coldStorage.device.deleteConfirm": "Are you sure you want to delete {name}?",
  "coldStorage.device.deleteWarning": "This will mark the device as inactive and remove it from active monitoring. Historical data will be preserved.",
  "coldStorage.device.deleted": "Device \\",
  "coldStorage.device.deviceStatus": "Device Status",
  "coldStorage.device.edit": "Edit device",
  "coldStorage.device.id": "Device ID",
  "coldStorage.device.ipAddress": "IP Address",
  "coldStorage.device.port": "Port",
  "coldStorage.device.protocol": "Protocol",
  "coldStorage.device.roomFacility": "Room/Facility",
  "coldStorage.device.statusChanged": "Device \\",
  "coldStorage.device.type": "Type",
  "coldStorage.device.updated": "Device updated successfully",
  "coldStorage.email": "Email",
  "coldStorage.emailSmsNotifications": "Email Notifications & SMS Notifications",
  "coldStorage.error.createAction": "Failed to create corrective action. Please try again.",
  "coldStorage.error.createDevice": "Failed to create device: ",
  "coldStorage.error.createRoom": "Failed to create room: ",
  "coldStorage.error.deleteDevice": "Failed to delete device: ",
  "coldStorage.error.loadActions": "Failed to load corrective actions. Please try again.",
  "coldStorage.error.loadConfig": "Failed to load system configuration: ",
  "coldStorage.error.loadDevices": "Failed to load devices: ",
  "coldStorage.error.loadLocations": "Failed to load locations: ",
  "coldStorage.error.loadUsers": "Failed to load user list. Please try again later.",
  "coldStorage.error.retractAction": "Failed to retract corrective action. Please try again.",
  "coldStorage.error.saveConfig": "Failed to save system configuration: ",
  "coldStorage.error.saveThreshold": "Failed to save threshold configuration: ",
  "coldStorage.error.toggleStatus": "Failed to toggle device status: ",
  "coldStorage.error.updateAction": "Failed to update corrective action. Please try again.",
  "coldStorage.error.updateDevice": "Failed to update device: ",
  "coldStorage.escalationDelay": "Escalation Delay (minutes)",
  "coldStorage.escalationDelayHelper": "Time to wait before escalating an unresolved alert",
  "coldStorage.escalationRules": "Escalation Rules",
  "coldStorage.filter.activeOnly": "Active Only",
  "coldStorage.filter.all": "All Devices",
  "coldStorage.filter.inactiveOnly": "Inactive Only",
  "coldStorage.granularNotificationControl": "Granular Notification Control",
  "coldStorage.granularNotificationControlDesc": "Configure email and SMS notifications for each alert type independently. Enable the notification methods you want for each specific alert category.",
  "coldStorage.howNotificationsWork": "How Notifications Work",
  "coldStorage.howNotificationsWorkDesc": "When an alert is triggered (temperature threshold violation, equipment failure, etc.), the system will:",
  "coldStorage.lastUpdate": "Last Update",
  "coldStorage.loadingConfig": "Loading system configuration...",
  "coldStorage.loadingDevices": "Loading devices...",
  "coldStorage.loadingPrefs": "Loading notification preferences...",
  "coldStorage.modbusTcpPort": "Modbus TCP Port",
  "coldStorage.name": "Name",
  "coldStorage.noConfigFound": "No Configuration Found",
  "coldStorage.noDevicesConfigured": "No Devices Configured",
  "coldStorage.notification.createRecord": "Create an alert record in the system (visible in Dashboard)",
  "coldStorage.notification.logAttempt": "Log the notification attempt for audit trail purposes",
  "coldStorage.notification.sendEmail": "Send EMAIL notifications if enabled (to configured recipients)",
  "coldStorage.notification.sendSms": "Send SMS notifications if enabled (to configured phone numbers)",
  "coldStorage.pollInterval": "Poll Interval (seconds)",
  "coldStorage.protocolConfiguration": "Protocol Configuration",
  "coldStorage.readOnlyMode": "Read-Only Mode",
  "coldStorage.readOnlyModeDesc": "To modify these settings, please navigate to Admin → System Configuration",
  "coldStorage.room.addNew": "Add New Room",
  "coldStorage.room.create": "Create Room",
  "coldStorage.room.created": "Room created successfully",
  "coldStorage.room.description": "Description",
  "coldStorage.room.descriptionPlaceholder": "Enter room description (optional)",
  "coldStorage.room.name": "Room Name *",
  "coldStorage.room.namePlaceholder": "Enter room name (e.g., Lab Storage Room A)",
  "coldStorage.saveNotificationPrefs": "Save Notification Preferences",
  "coldStorage.saveThresholdConfig": "Save Threshold Configuration",
  "coldStorage.saving": "Saving...",
  "coldStorage.search.placeholder": "Search by Device ID or Name",
  "coldStorage.securitySettings": "Security Settings",
  "coldStorage.sessionTimeout": "Session Timeout",
  "coldStorage.sms": "SMS",
  "coldStorage.status": "Status",
  "coldStorage.status.active": "ACTIVE",
  "coldStorage.status.inactive": "INACTIVE",
  "coldStorage.supervisorEmail": "Supervisor Email",
  "coldStorage.supervisorEmailHelper": "Email address to send escalated alerts",
  "coldStorage.supervisorEmailPlaceholder": "supervisor@lab.com",
  "coldStorage.systemConfiguration": "System Configuration",
  "coldStorage.systemInformation": "System Information",
  "coldStorage.systemVersion": "System Version",
  "coldStorage.targetTemperature": "Target Temperature (°C)",
  "coldStorage.threshold.saveSuccess": "Threshold configuration saved successfully",
  "coldStorage.thresholdConfiguration": "Temperature Threshold Configuration",
  "coldStorage.twoFactorAuth": "Two-Factor Authentication",
  "coldStorage.uptime": "Uptime",
  "coldStorage.usingDefaults": "Using default notification settings. Save to create configuration.",
  "coldStorage.validation.error": "Validation Error",
  "coldStorage.validation.retractionReason": "Please provide a reason for retraction",
  "coldStorage.validation.selectActionType": "Please select an action type",
  "coldStorage.validation.selectDevice": "Please select a device",
  "coldStorage.validation.selectRoom": "Please select a room/location for the device",
  "coldStorage.warningThreshold": "Warning Threshold (°C)",
  "collect.addSample.button": "Ajouter un échantillon",
  "collect.assign.addToSample": "Ajouter à un échantillon existant",
  "collect.assign.button": "Assigner des tests",
  "collect.assign.description": "Assigner les tests demandés aux tubes d’échantillons",
  "collect.assign.newSample": "Créer un nouvel échantillon",
  "collect.assign.newSampleHelp": "Sélectionner le type d’échantillon pour le nouveau tube",
  "collect.assign.noExisting": "Aucun échantillon existant disponible",
  "collect.assign.title": "Attribution des tests",
  "collect.multiSampleExample.description": "Lorsque plusieurs types d’échantillons sont nécessaires",
  "collect.multiSampleExample.result": "Crée des tubes séparés pour chaque type",
  "collect.multiSampleExample.title": "Exemple de collecte multi-échantillons ",
  "collect.noSampleYet": "Aucun échantillon collecté pour le moment",
  "collect.noTestsOrdered": "Aucune analyse n’a été prescrite",
  "collect.noTestsWarning.subtitle": "Ajoutez des échantillons avec des analyses à l’étape 1 avant de continuer",
  "collect.noTestsWarning.title": "Aucune analyse à prélever",
  "collect.printMoreLabels.button": "Imprimer plus d’étiquettes",
  "collect.printMoreLabels.helper": " Imprimer des étiquettes supplémentaires pour cet échantillon",
  "collect.requestedTests.info": "Analyses demandées pour cette prescription",
  "collect.requestedTests.title": "Analyses demandées",
  "collect.sample.assignedTests": "Tests assignés",
  "collect.sample.collectionConditions": "Conditions de prélèvement",
  "collect.sample.collectionConditions.placeholder": "Notez toute condition particulière…",
  "collect.sample.collectionDate": "Date de prélèvement",
  "collect.sample.collectionDate.helper": "Date à laquelle l’échantillon a été prélevé",
  "collect.sample.collectionTime": "Heure de prélèvement",
  "collect.sample.collector": "Préleveur",
  "collect.sample.header": "Échantillon {number}",
  "collect.sample.nce.link": "Signaler un événement non conforme",
  "collect.sample.noTests": "Aucune analyse assignée à cet échantillon",
  "collect.sample.printLabels": "Imprimer des étiquettes",
  "collect.sample.quantity": "Quantité",
  "collect.sample.receivedAtLab": "Reçu au laboratoire",
  "collect.sample.receivedAtLab.helper": " Vérifier si l’échantillon a été reçu au laboratoire",
  "collect.sample.receivedDate": "Date de réception ",
  "collect.sample.receivedTime": "Heure de réception",
  "collect.sample.remove": "Supprimer l’échantillon",
  "collect.samples.title": "Échantillons",
  "collect.table.compatibleTypes": "Types d’échantillons compatibles",
  "collect.table.sampleAssignments": "Attribution des échantillons",
  "collect.table.testPanel": "Test / Panel",
  "heading.informedConsent.sectionTitle": "Consentement éclairé",
  "heading.informedConsent.auditRecord": "Historique du consentement",
  "label.informedConsent.consentGiven": "Le patient a fourni un consentement signé",
  "label.informedConsent.formReference": "Numéro de référence du formulaire de consentement",
  "label.informedConsent.recordedBy": "Enregistré par",
  "label.informedConsent.recordedAt": "Enregistré le",
  "label.informedConsent.statusTag": "Consentement enregistré",
  "label.informedConsent.notRecorded": "Non enregistré",
  "placeholder.informedConsent.formReference": "ex. CF-2026-00123",
  "placeholder.informedConsent.recordedBy": "ex. Dr Smith",
  "error.informedConsent.formReferenceMaxLength": "La référence du formulaire de consentement doit contenir 100 caractères ou moins",
  "error.informedConsent.formReferenceInvalidChars": "Seules les lettres, chiffres, tirets et espaces sont autorisés",
  "coldstorage.label.dashboard": "Tableau de bord du stockage frigorifique",
  "collection.date": "Date de collecte",
  "collector": "Agent de collecte",
  "collector.label": "Collectionneuse",
  "column.actions": "Actions",
  "column.name.accept": "Accepter",
  "column.name.analyzerResult": "Résultat de l'automate",
  "column.name.currentResult": "Résultat actuel",
  "column.name.ignore": "Ignorer",
  "column.name.normalRange": "Intervalle de référence",
  "column.name.notes": "Notes",
  "column.name.pastNotes": "Notes antérieures",
  "column.name.reject": "Rejeter",
  "column.name.result": "Résultat",
  "column.name.retest": "Retester",
  "column.name.sampleInfo": "Informations sur l'échantillon",
  "column.name.save": "Sauvegarder",
  "column.name.testDate": "Date du test",
  "column.name.testId": "Id du Test",
  "column.name.testName": "Nom de Test",
  "common.properties.title": "Propriétés communes",
  "configuration.batch.test.reassignment": "Réaffectation et annulation des tests par lot",
  "configuration.method": "Gérer les méthodes",
  "configuration.method.create": "Créer une nouvelle méthode",
  "configuration.method.explain": "Utilisez pour créer une nouvelle méthode, activer ou désactiver une méthode",
  "configuration.method.rename": "Renommer les noms de méthode existants",
  "configuration.method.rename.explain": "Utilisez pour corriger le nom des méthodes existantes",
  "configuration.panel.assign": "Affectation des tests",
  "configuration.panel.assign.explain": "Sélectionnez les tests à réaffecter à un autre panneau en cliquant sur le nom du test ; ils sont affichés sous leur panneau actuellement attribué.",
  "configuration.panel.confirmation.explain": "Ce panneau ne sera pas actif tant qu'au moins un test ne lui aura pas été attribué.",
  "configuration.panel.create": "Créer un nouveau panel",
  "configuration.panel.create.duplicate": "Un type de panel existant avec le même nom a été trouvé. Veuillez annuler ou utiliser un nom différent.",
  "configuration.panel.manage": "Gérer les panels",
  "configuration.panel.manage.explain": "Utilisez pour créer, définir l'ordre d'affichage ou attribuer des tests aux panels",
  "configuration.panel.order": "Définir l'ordre des panels",
  "configuration.panel.order.explain": "Triez les panels en cliquant sur un type et en le faisant glisser dans le bon ordre.",
  "configuration.panel.order.explain.limits": "Seuls les panels avec tests assignés peuvent être sélectionnés. Pour les nouveaux panels, veuillez assigner des tests avant de sélectionner.",
  "configuration.panel.rename": "Renommer les panels existants",
  "configuration.panel.rename.explain": "Utilisez pour corriger le nom des panels existants.",
  "configuration.sampleType.assign.explain": "Sélectionnez les tests à réaffecter à un type d'échantillon différent en cliquant sur le nom du test ; ils sont affichés sous leur type d'échantillon actuellement attribué.",
  "configuration.sampleType.assign.new.type": "Assigner à un type d'échantillon",
  "configuration.sampleType.confirmation.explain": "Ce type d'échantillon ne sera pas actif tant qu'au moins un test ne lui aura pas été attribué.",
  "configuration.sampleType.create": "Créer un nouveau type d'échantillon",
  "configuration.sampleType.create.duplicate": "Un type d'échantillon de test existant portant le même nom a été trouvé. Veuillez annuler ou utiliser un autre nom.",
  "configuration.sampleType.manage": "Gérer les types d'échantillons",
  "configuration.sampleType.manage.explain": "Utilisez pour créer, définir l'ordre d'affichage ou attribuer des tests aux types d'échantillons",
  "configuration.sampleType.order": "Définir l'ordre des types d'échantillons",
  "configuration.sampleType.order.explain": "Triez les types d'échantillons en cliquant sur un type et en le faisant glisser dans le bon ordre.",
  "configuration.sampleType.order.explain.limits": "Seuls les échantillons avec tests attribués peuvent être sélectionnés. Pour les nouveaux échantillons, veuillez attribuer des tests avant de sélectionner.",
  "configuration.selectList.add": "Ajouter une liste de sélection des résultats",
  "configuration.selectList.add.alert": "Pour modifier l'orthographe des entrées de la liste de résultats actuelles, utilisez Renommer les options de liste de résultats existantes",
  "configuration.selectList.add.explain": "Utilisez pour créer une liste de sélection des résultats pour les résultats de test",
  "configuration.selectList.assign.description": "La nouvelle entrée peut être affectée aux tests ou être enregistrée sans affectation. Sélectionnez un ou plusieurs tests pour l’affectation, puis ajustez l’ordre d’affichage. Si la nouvelle entrée doit être la valeur normale du test sélectionné, cochez la case intitulée « Normal ». Si vous souhaitez que le technicien saisisse du texte avec la sélection du résultat pour qualifier davantage les résultats, cochez la case intitulée « Qualifiable ». Par exemple, si les options correspondent à une liste d’organismes et que la dernière option est « Autre », l’utilisateur pourra saisir un organisme qui ne figure pas dans la liste.",
  "configuration.selectList.assign.header": "Affecter la nouvelle sélection de résultat au test",
  "configuration.selectList.assign.new": "Nouvelle option de liste de sélection",
  "configuration.selectList.confirmChange": "La valeur normale sera modifiée de %oldvalue% à %newvalue%. Voulez-vous vraiment continuer ?",
  "configuration.selectList.description": "Entrez en anglais et en français pour la nouvelle option de sélection. Si vous ne connaissez pas la traduction, le terme saisi sera utilisé pour les deux langues.",
  "configuration.selectList.header": "Créer une nouvelle option de sélection de résultat",
  "configuration.selectList.rename": "Renommer les options de liste de résultats existantes",
  "configuration.selectList.rename.explain": "Renommer les options de liste de résultats existantes",
  "configuration.test.activate": "Activer/Désactiver les tests",
  "configuration.test.activate.explain": "Utilisez pour activer ou désactiver un test existant.",
  "configuration.test.add": "Ajouter de nouveaux tests",
  "configuration.test.add.explain": "Utilisez pour ajouter de nouveaux tests au système. La modification des tests existants doit se faire via les autres liens de gestion des tests",
  "configuration.test.catalog": "Voir le catalogue des tests",
  "configuration.test.catalog.explain": "Voir le catalogue des tests actuel",
  "configuration.test.management.ocl": "Importation du concept OCL",
  "configuration.test.management.organization": "Organisation des tests",
  "configuration.test.management.spelling": "Corrections orthographiques",
  "configuration.test.modify": "Modifier les tests",
  "configuration.test.modify.explain": "Utilisez pour modifier les tests existants dans le système.",
  "configuration.test.modify.tab.configuration": "Configuration",
  "configuration.test.modify.tab.compliance": "Compliance Thresholds",
  "configuration.test.modify.filter.instruction": "Sélectionnez un type d'échantillon ou une section de test pour afficher les tests.",
  "configuration.test.modify.filter.noTestsFound": "Aucun test ne correspond aux critères sélectionnés.",
  "configuration.test.modify.filter.selectToBegin": "Veuillez sélectionner un type d'échantillon ou une section de test pour commencer à consulter les tests.",
  "configuration.test.orderable": "Activer/désactiver la commandabilité des tests",
  "configuration.test.orderable.explain": "Les tests commandables peuvent être commandés à l'admission. S'ils ne sont pas commandables, ils ne peuvent être commandés qu'en tant que résultat d'un réflexe",
  "configuration.test.rename": "Renommer les noms de test existants",
  "configuration.test.rename.explain": "Utilisez pour renommer les tests existants. Cela ne changera pas le test, seulement la façon dont l'utilisateur les voit dans OpenELIS et sur les rapports",
  "configuration.testSection.rename": "Unités de services",
  "configuration.testSection.rename.explain": "Utilisez pour corriger le nom des unités de test existants.",
  "configuration.testUnit.assign.new.unit": "Assigner à une section de tests",
  "configuration.testUnit.confirmation.explain": "Cette unité de test ne sera pas active tant qu'au moins un test ne lui aura pas été attribué.",
  "configuration.testUnit.create": "Créer une nouvelle unité de test",
  "configuration.testUnit.create.duplicate": "Une unité portant le même nom a été trouvée. Veuillez annuler ou utiliser un autre nom.",
  "configuration.testUnit.manage": "Gérer les unités de test",
  "configuration.testUnit.manage.explain": "Utilisez pour créer, définir l'ordre d'affichage ou attribuer des tests aux unités de test",
  "configuration.testUnit.order": "Définir l'ordre des unités de test",
  "configuration.testUnit.order.explain": "Triez les unités de laboratoire en cliquant sur une unité et en la faisant glisser dans le bon ordre.",
  "configuration.testUnit.order.explain.limits": "Seules les unités comportant des tests assignés peuvent être sélectionnés. Pour les nouvelles sections, veuillez assigner des tests avant de sélectionner.",
  "configuration.type.rename": "Renommer les types d'échantillons existants",
  "configuration.type.rename.explain": "Utilisez pour corriger le nom des panels existants.",
  "configuration.uom.create": "Créer de nouvelles unités de mesure",
  "configuration.uom.manage": "Gérer les unités de mesure",
  "configuration.uom.manage.explain": "Utilisez pour créer des unités de mesure",
  "configuration.uom.rename": "Renommer les entrées d'unité de mesure existantes",
  "configuration.uom.rename.explain": "Utilisez pour corriger le nom des entrées d'unité de mesure existantes.",
  "configure.labNumber.title": "Gestion des Numéro de Laboratoire",
  "confirmation.rename": "Confirmez les modifications ci-dessus que vous avez apportées.",
  "currentests.title": "Essais en cours",
  "cytology.label.cellabnomality": "Anomalie des Cellules Épithéliales",
  "cytology.label.confirmSelect": "Si vous sélectionnez cette option, toutes les informations de diagnostic actuelles seront supprimées",
  "cytology.label.dashboard": "Tableau de bord en cytologie",
  "cytology.label.glandular": "Glandulaire",
  "cytology.label.negative": "Négatif Pour Lésion ou Malignité Intraépithéliale",
  "cytology.label.neoplastic": "Variations Cellulaires Non Néoplasiques",
  "cytology.label.organisms": "Organismes",
  "cytology.label.other": "Autres Néoplasmes Malins",
  "cytology.label.otherResult": "Autre Résultat de Diagnostic",
  "cytology.label.reactive": "Modifications Cellulaires Réactives",
  "cytology.label.review": "En attente de révision cytopathologique",
  "cytology.label.specimen": "Aptitude de l'Échantillon",
  "cytology.label.squamous": "Épidermoïde",
  "cytology.label.title": "Cytologie",
  "dashboard.avg.turn.around.label": "Temps de traitement moyen",
  "dashboard.avg.turn.around.reception.to.result.label": "Délai moyen de réception à résultat",
  "dashboard.avg.turn.around.reception.to.validation.label": "Délai moyen de réception à validation",
  "dashboard.avg.turn.around.result.to.validation.label": "Délai moyen de résultat à validation",
  "dashboard.avg.turn.around.subtitle.label": "Délai moyen de réception à validation",
  "dashboard.complete.orders.label": "Demandes d'examens terminées aujourd'hui",
  "dashboard.in.progress.label": "En cours",
  "dashboard.in.progress.subtitle.label": "En attente de saisie des résultats",
  "dashboard.partially.completed.label": "Partiellement complété aujourd'hui",
  "dashboard.partially.completed.subtitle.label": "En attente des analyses restantes",
  "dashboard.rejected.orders": "Ordonnances rejetées",
  "dashboard.turn.around.label": "Délai d'exécution retardé",
  "dashboard.turn.around.subtitle.label": "Dépassement de 96 heures",
  "dashboard.unprints.results.label": "Résultats non imprimés",
  "dashboard.user.orders.label": "Ordonnances saisies par l'utilisateur",
  "dashboard.user.orders.today.label": "Ordonnances saisies par l'utilisateur aujourd'hui",
  "dashboard.validation.ready.label": "Prêt pour la validation",
  "dashboard.validation.ready.subtitle.label": "En attente de validation",
  "dataexport.status.actions": "Actions",
  "dataexport.status.attempt.duration": "Duration",
  "dataexport.status.attempt.endTime": "End Time",
  "dataexport.status.attempt.startTime": "Start Time",
  "dataexport.status.attempt.status": "Status",
  "dataexport.status.duration.ms": "{value} ms",
  "dataexport.status.duration.s": "{value} s",
  "dataexport.status.empty": "No FHIR subscribers are configured. Set org.openelisglobal.fhir.subscriber in common.properties and restart the server to register one.",
  "dataexport.status.endpoint": "Endpoint",
  "dataexport.status.failed24h": "Failed / Total (24h)",
  "dataexport.status.failed24hValue": "{failed} / {total}",
  "dataexport.status.intervalMin": "Retry Interval",
  "dataexport.status.intervalValue": "{value} min",
  "dataexport.status.lastAttempt": "Last Attempt",
  "dataexport.status.lastRefreshed": "Last refreshed",
  "dataexport.status.lastStatus": "Last Status",
  "dataexport.status.lastSuccess": "Last Success",
  "dataexport.status.loadingAttempts": "Loading attempt history…",
  "dataexport.status.never": "Never",
  "dataexport.status.noAttempts": "No attempts yet",
  "dataexport.status.placeholderDash": "—",
  "dataexport.status.refresh": "Refresh",
  "dataexport.status.retry": "Retry now",
  "dataexport.status.retryInFlight": "Triggering…",
  "dataexport.status.title": "FHIR Data Export Status",
  "datasubmission.siteid": "ID du Site",
  "database.clean": "Nettoyage de la base de données",
  "database.clean.button": "Nettoyer la base de données",
  "database.clean.confirm.message": "Êtes-vous sûr de vouloir nettoyer la base de données ? Cela supprimera toutes les données des patients et des analyses.",
  "database.clean.confirm.title": "Confirmer le nettoyage de la base de données",
  "database.clean.confirm.warning": " Cette action est irréversible !",
  "database.clean.error": "Échec du nettoyage de la base de données.",
  "database.clean.not.training": "Le nettoyage de la base de données est uniquement disponible sur les environnements de formation. ",
  "database.clean.success": " Base de données nettoyée avec succès.",
  "database.clean.warning": "Cela supprimera définitivement toutes les données des patients, des échantillons et des résultats de la base de données.",
  "date.created": "Date de création",
  "delete.error.msg": "Erreur lors de la suppression de l'élément",
  "delete.success.msg": "Supprimé avec succès",
  "description.active": "Si le test est actif, il peut être commandé sur le formulaire de commande ou dans le cadre d'un algorithme de test. S'il n'est pas actif, il ne peut pas être commandé ni faire partie d'un algorithme de test.",
  "description.ageRange": "Si la tranche d'âge (en mois) importe pour les valeurs données, elle sera spécifiée ici.",
  "description.name": "Le nom du test tel qu'il apparaîtra dans openELIS. Les versions anglaise et française sont affichées.",
  "description.normalRange": "Tout résultat numérique dans cette plage est ce qui est attendu chez une personne en bonne santé.",
  "description.note": "n/a signifie non disponible. La valeur n'est pas spécifiée.",
  "description.orderable": "Si un test est actif et commandable, il peut être commandé sur un formulaire de commande. S'il est actif mais non commandable, il ne sera effectué que s'il est recommandé par un autre test.",
  "description.panel": "Si ce test fait partie d'un panel de tests, le panel sera nommé ici.",
  "description.referenceValue": "La valeur d'une sélection pour une personne en bonne santé. Donnée uniquement pour les résultats de liste de sélection.",
  "description.reportName": "Le nom du test tel qu'il apparaîtra dans les rapports. Les versions anglaise et française sont affichées.",
  "description.resultLimits": "Les limites des résultats normaux et valides pour les tests numériques. Les valeurs peuvent dépendre à la fois de l'âge et du sexe du patient.",
  "description.resultType": "Le type de résultat pour ce test :",
  "description.resultType.alphanumeric": "A - Alphanumérique :",
  "description.resultType.alphanumericDesc": "Accepte des résultats numériques ou textuels dans une zone de texte. Ils ne seront pas évalués pour être normaux ou valides.",
  "description.resultType.cascadingMultiSelectList": "C - Liste de sélection multiple en cascade :",
  "description.resultType.cascadingMultiSelectListDesc": "Similaire à la sélection multiple mais l'utilisateur pourra sélectionner plusieurs groupes dans la liste déroulante.",
  "description.resultType.kind": "Le type de résultat pour ce test :",
  "description.resultType.multiSelectList": "M - Liste de sélection multiple :",
  "description.resultType.multiSelectListDesc": "L'utilisateur pourra sélectionner une ou plusieurs valeurs dans une liste déroulante. Aucune valeur de référence ne sera spécifiée.",
  "description.resultType.numeric": "N - Numérique :",
  "description.resultType.numericDesc": "Accepte uniquement des résultats numériques dans une zone de texte. Les résultats peuvent être évalués comme étant dans une plage normale ou valide.",
  "description.resultType.selectList": "D - Liste de sélection :",
  "description.resultType.selectListDesc": "L'utilisateur pourra sélectionner dans une liste déroulante. La valeur normale sera spécifiée comme valeur de référence.",
  "description.resultType.textArea": " :",
  "description.resultType.textAreaDesc": "Accepte jusqu'à 200 caractères dans une zone de texte. Ils ne seront pas évalués pour être normaux ou valides.",
  "description.sampleType": "Le type d'échantillon sur lequel le test peut être effectué. Si le technicien d'accueil peut sélectionner le type d'échantillon après avoir commandé le test, il sera marqué comme utilisateur pour indiquer que l'utilisateur sélectionnera le type.",
  "description.selectValues": "Spécifié uniquement pour les résultats de sélection, de sélection multiple ou de sélection multiple en cascade. Ce sont les sélections disponibles affichées à l'utilisateur. Si la sélection est marquée comme 'qualifiable', lorsque l'utilisateur sélectionne cette valeur, il pourra saisir des informations supplémentaires dans une zone de texte.",
  "description.sex": "Si le sexe du patient importe pour les valeurs données, il sera spécifié ici.",
  "description.significantDigits": "Le nombre de chiffres significatifs pour les résultats numériques. Les résultats saisis seront arrondis ou complétés au nombre correct de chiffres. La plage normale sera également affichée avec le nombre correct de chiffres significatifs.",
  "description.testUnit": "L'unité du laboratoire qui effectue le test. Elle est également connue sous le nom de section de test.",
  "description.uom": "Unité de mesure pour le test. Cela s'applique généralement aux types de résultats numériques ou alphanumériques.",
  "description.validRange": "Tout résultat numérique hors de cette plage indique que le test peut ne pas avoir été effectué correctement.",
  "dictionary.category.isActive": "La catégorie est active",
  "dictionary.category.label": "Catégorie du dictionnaire",
  "dictionary.category.localAbbreviation": "Abréviation locale de la catégorie",
  "dictionary.category.name": "Nom de la catégorie du dictionnaire",
  "dictionary.dictEntry": "Entrée du dictionnaire",
  "dictionary.label.modify": "Modifier le dictionnaire",
  "dictionary.loincCode": "Code LOINC",
  "dictionary.loincCode.help": "Saisir un identifiant LOINC Standard",
  "dictionary.loincCode.helpText": "Identifiant standard d'observation de laboratoire",
  "dictionary.loincCode.invalid": "Format incorrect de code LOINC ( attendu:12345-6 ou LP12345-6)",
  "dictionary.loincCode.placeholder": "exemple: 12345-6",
  "dictionary.menu.deactivate.fail": "Impossible de désactiver le menu du dictionnaire",
  "dictionary.menu.deactivate.success": "Menu de dictionnaire désactivé avec succès",
  "dictionary.modal.add.heading": "Ajouter au dictionnaire ",
  "dictionary.modal.edit.heading": "Modifier le dictionnaire ",
  "dictionary.number.label": "Numéro du dictionnaire",
  "disposal.button": "Disposer des lots ",
  "disposal.notes": "Notes relatives à l'élimination",
  "disposal.notes.placeholder": "Fournir des détails sur l'élimination (méthode d'élimination, témoin, etc.)",
  "disposal.reason": "Motif de mise au rebut",
  "disposal.reason.select": "Sélectionnez une raison",
  "disposal.success": "Lot éliminé avec succès",
  "disposal.title": "Disposer des lots ",
  "disposal.warning.message": "Cette action ne peut pas être annulée. Le lot sera considéré comme éliminé et retiré de l’inventaire actif.",
  "disposal.warning.title": "Avertissement",
  "edit.add.program.title": "Ajouter/Modifier un programme",
  "emergencyContactInfo.title": "Informations de contact d'urgence",
  "english.current": "ANGLAIS actuel",
  "english.label": "Anglais",
  "enterText.label": "Entrez le reste du texte",
  "eorder.allInfo": "Toutes les infos",
  "eorder.button.editOrder": "Modifier l'ordonnance",
  "eorder.button.enterOrder": "Saisir l'ordonnance",
  "eorder.buttons": " ",
  "eorder.date.end": "Date de fin",
  "eorder.date.start": "Date de début",
  "eorder.facility.requesting": "Établissement Référent",
  "eorder.header": "Voir les Demandes Electroniques",
  "eorder.id.national": "Identité nationale",
  "eorder.id.subjectNumber": "Numéro Patient",
  "eorder.instructions.enter1": "Recherche de correspondance des demandes de test - Dans le menu de ",
  "eorder.instructions.enter2": " ajoutez un numéro de laboratoire et sélectionnez ",
  "eorder.instructions.enter3": " pour accepter l'ordonnance telle quelle, ou sélectionnez ",
  "eorder.instructions.enter4": " pour apporter des modifications ",
  "eorder.labNumber": "Numéro de Laboratoire",
  "eorder.labnumber.referring": "Numéro du Laboratoire Référent",
  "eorder.name.first": "Prénom",
  "eorder.name.last": "Nom de famille",
  "eorder.passport.number": "Numéro de passeport",
  "eorder.priority": "Priorité",
  "eorder.requestDate": "Date de la Demande",
  "eorder.search.noresults": "Pas de Demandes Électronique",
  "eorder.search1.text": "Recherche par nom de famille, numéro de carte d'identité nationale, numéro de laboratoire du laboratoire référent ou numéro de passeport",
  "eorder.search2.text": "Recherche par date et statut Saisissez la plage de dates pour les demandes de test. Cela permettra d'effectuer une recherche en fonction de la date de renvoi ou de la date de commande de la demande électronique",
  "eorder.searchValue": "Rechercher par",
  "eorder.status": "Statut",
  "eorder.test.name": "Nom du Test",
  "eqa.action.deactivate": "Désactiver",
  "eqa.action.edit": "Modifier",
  "eqa.action.enterResults": "Saisir les résultats",
  "eqa.action.enterViewResults": "Saisir / consulter les résultats ",
  "eqa.action.reactivate": "Réactiver",
  "eqa.action.viewOrder": "Voir la commande",
  "eqa.action.viewResults": "Voir les résultats",
  "eqa.admin.addProgram": "Ajouter un programme",
  "eqa.admin.col.actions": "Actions",
  "eqa.admin.col.category": "Catégorie",
  "eqa.admin.col.frequency": "Fréquence",
  "eqa.admin.col.participants": "Participants inscrits",
  "eqa.admin.col.programName": "Nom du programme",
  "eqa.admin.col.provider": "Prestataire",
  "eqa.admin.delete": "Supprimer",
  "eqa.admin.form.addHeading": "Ajouter un nouveau programme EQA",
  "eqa.admin.form.category.placeholder": "Sélectionner la catégorie",
  "eqa.admin.form.description.placeholder": "Description et objectifs du programme...",
  "eqa.admin.form.editHeading": "Modifier le programme EQA",
  "eqa.admin.form.frequency.placeholder": "Sélectionner la fréquence",
  "eqa.admin.form.name.placeholder": "ex. : Culture et sensibilité TB",
  "eqa.admin.form.provider.placeholder": "Sélectionner le prestataire",
  "eqa.admin.form.subtitle": "Inscrire à un nouveau programme d'assurance qualité externe",
  "eqa.admin.programs.subtitle": "Gérer les programmes EEQ inscrits et les prestataires",
  "eqa.admin.programs.title": "Programmes EQA",
  "eqa.admin.provider.placeholder": "ex. : OMS, CDC, CAP",
  "eqa.admin.subtitle": "Gérer les programmes EQA, les utilisateurs et les paramètres système",
  "eqa.admin.systemSettings.placeholder": "Paramètres système bientôt disponibles.",
  "eqa.admin.tab.participants": "Participants",
  "eqa.admin.tab.programs": "Programmes EQA",
  "eqa.admin.tab.systemSettings": "Paramètres système",
  "eqa.admin.tab.userManagement": "Gestion des utilisateurs",
  "eqa.admin.tile.acrossAllPrograms": "Dans tous les programmes",
  "eqa.admin.tile.activePrograms": "Programmes actifs",
  "eqa.admin.tile.canManageEqa": "Peuvent gérer l'EQA",
  "eqa.admin.tile.enrolledParticipants": "Participants inscrits",
  "eqa.admin.tile.systemUsers": "Utilisateurs système",
  "eqa.admin.tile.totalParticipants": "Total des participants",
  "eqa.admin.tile.totalPrograms": "{count} programmes au total",
  "eqa.admin.title": "Administration des programmes",
  "eqa.admin.userManagement.placeholder": "Gestion des utilisateurs bientôt disponible.",
  "eqa.column.actions": "Actions",
  "eqa.deadline.label": "Date limite de test",
  "eqa.distribution.action.continue": "Continuer",
  "eqa.distribution.action.ship": "Expédier",
  "eqa.distribution.action.track": "Suivre",
  "eqa.distribution.action.viewReport": "Voir le rapport",
  "eqa.distribution.advance": "Avancer le statut",
  "eqa.distribution.backToDashboard": "Retour aux distributions",
  "eqa.distribution.barcodes": "Générer les codes-barres",
  "eqa.distribution.col.actions": "Actions",
  "eqa.distribution.col.deadline": "Date limite",
  "eqa.distribution.col.participants": "Participants",
  "eqa.distribution.col.program": "Programme",
  "eqa.distribution.col.responses": "Réponses",
  "eqa.distribution.col.round": "Ronde",
  "eqa.distribution.col.samples": "Échantillons",
  "eqa.distribution.col.shipmentId": "ID d'envoi",
  "eqa.distribution.col.status": "Statut",
  "eqa.distribution.create": "Créer une distribution",
  "eqa.distribution.createError": "Échec de la création de la distribution.",
  "eqa.distribution.createShipment": "Créer un nouvel envoi",
  "eqa.distribution.createSuccess": "Distribution créée avec succès.",
  "eqa.distribution.dashboard.subtitle": "Distribuer les échantillons EQA aux laboratoires participants",
  "eqa.distribution.dashboard.title": "Distribution EQA",
  "eqa.distribution.deadline": "Date limite de soumission",
  "eqa.distribution.detail.title": "Détails de la distribution",
  "eqa.distribution.empty": "Aucune distribution trouvée",
  "eqa.distribution.filter.allShipments": "Tous les envois",
  "eqa.distribution.filter.program": "Filtrer par programme",
  "eqa.distribution.filter.status": "Filtrer par statut",
  "eqa.distribution.list.title": "Distributions EQA",
  "eqa.distribution.manageParticipants": "Gérer les participants",
  "eqa.distribution.name": "Nom de la distribution",
  "eqa.distribution.name.placeholder": "ex., Ronde 1 - Chimie 2026",
  "eqa.distribution.network.active": "Participants actifs",
  "eqa.distribution.network.active.sub": "Actuellement inscrits",
  "eqa.distribution.network.responseRate": "Taux de réponse moyen",
  "eqa.distribution.network.responseRate.sub": "4 derniers trimestres",
  "eqa.distribution.network.subtitle": "Aperçu des laboratoires participants inscrits",
  "eqa.distribution.network.title": "Réseau de participants",
  "eqa.distribution.network.total": "Total des participants",
  "eqa.distribution.network.total.sub": "Dans tous les pays",
  "eqa.distribution.participants": "Organisations participantes",
  "eqa.distribution.participants.min": "Au moins 2 organisations participantes sont requises",
  "eqa.distribution.participants.none": "Aucune organisation n’est actuellement inscrite au programme sélectionné. Inscrivez des participants avant de créer une distribution. ",
  "eqa.distribution.participants.select": "Sélectionner les organisations",
  "eqa.distribution.program": "Programme EQA",
  "eqa.distribution.program.select": "Sélectionner un programme",
  "eqa.distribution.responseRate": "taux de réponse",
  "eqa.distribution.shipments.subtitle": "Suivre les échantillons EQA distribués et les réponses des participants",
  "eqa.distribution.shipments.title": "Envois EQA",
  "eqa.distribution.shipped": "Expédié",
  "eqa.distribution.status.completed": "Terminé",
  "eqa.distribution.status.draft": "Brouillon",
  "eqa.distribution.status.prepared": "Préparé",
  "eqa.distribution.status.shipped": "Expédié",
  "eqa.distribution.step.confirmation": "Confirmation",
  "eqa.distribution.step.details": "Programme et détails",
  "eqa.distribution.step.participants": "Participants",
  "eqa.distribution.summary.completed": "Terminés",
  "eqa.distribution.summary.completed.sub": "Toutes les réponses reçues",
  "eqa.distribution.summary.draft": "Envois brouillon",
  "eqa.distribution.summary.draft.sub": "En préparation",
  "eqa.distribution.summary.participants": "Participants",
  "eqa.distribution.summary.participants.sub": "Inscrits",
  "eqa.distribution.summary.shipped": "Expédiés",
  "eqa.distribution.summary.shipped.sub": "En attente de réponses",
  "eqa.enrollment.allStatuses": "Tous les statuts",
  "eqa.enrollment.alreadyEnrolled": "Déjà inscrit",
  "eqa.enrollment.alreadyEnrolledCount": "{count} organisation(s) déjà inscrite(s)",
  "eqa.enrollment.confirmWithdraw": "Confirmer le retrait",
  "eqa.enrollment.created.success": "Inscription au programme créée avec succès",
  "eqa.enrollment.deactivated": "Inscription au programme désactivée",
  "eqa.enrollment.description": "Description",
  "eqa.enrollment.district": "District",
  "eqa.enrollment.editing": "Modification : {name}",
  "eqa.enrollment.empty": "Aucune inscription trouvée pour ce programme",
  "eqa.enrollment.enroll": "Inscrire",
  "eqa.enrollment.enrollParticipant": "Inscrire un participant",
  "eqa.enrollment.enrollSelected": "Inscrire la sélection",
  "eqa.enrollment.enrollmentDate": "Date d'inscription",
  "eqa.enrollment.labUnits": "Unités de laboratoire",
  "eqa.enrollment.new": "Nouvelle inscription au programme EQA",
  "eqa.enrollment.organizationCode": "Code de l'organisation",
  "eqa.enrollment.organizationName": "Nom de l'organisation",
  "eqa.enrollment.panels": "Panels",
  "eqa.enrollment.programName": "Nom du programme",
  "eqa.enrollment.programName.placeholder": "Saisir le nom du programme",
  "eqa.enrollment.provider": "Prestataire",
  "eqa.enrollment.provider.placeholder": "Saisir le nom du prestataire",
  "eqa.enrollment.reactivate": "Réactiver",
  "eqa.enrollment.reactivated": "Inscription au programme réactivée",
  "eqa.enrollment.save": "Enregistrer l'inscription",
  "eqa.enrollment.saveChanges": "Enregistrer les modifications",
  "eqa.enrollment.searchOrgs": "Rechercher des organisations...",
  "eqa.enrollment.searchPlaceholder": "Rechercher par nom ou code d'organisation...",
  "eqa.enrollment.selectLabUnits": "Sélectionner les unités de laboratoire...",
  "eqa.enrollment.selectOrg": "Sélectionner une organisation…",
  "eqa.enrollment.selectOrgsPrompt": "Sélectionnez les organisations à inscrire",
  "eqa.enrollment.selectPanels": "Sélectionner les panels...",
  "eqa.enrollment.selectProgram": "Sélectionner le programme",
  "eqa.enrollment.selectProgramPrompt": "Sélectionnez un programme pour voir les inscriptions",
  "eqa.enrollment.selectTests": "Sélectionner les tests...",
  "eqa.enrollment.selected": "sélectionné(s)",
  "eqa.enrollment.status": "Statut",
  "eqa.enrollment.status.active": "Actif",
  "eqa.enrollment.status.suspended": "Suspendu",
  "eqa.enrollment.status.withdrawn": "Retiré",
  "eqa.enrollment.success": "Inscription réussie",
  "eqa.enrollment.suspend": "Suspendre",
  "eqa.enrollment.tests": "Tests",
  "eqa.enrollment.thisLab": "Ce laboratoire",
  "eqa.enrollment.updated.success": "Inscription au programme mise à jour avec succès",
  "eqa.enrollment.withdraw": "Retirer",
  "eqa.enrollment.withdrawReason": "Raison du retrait",
  "eqa.enrollment.withdrawReasonPlaceholder": "Indiquez la raison du retrait de ce participant...",
  "eqa.filter.allPriorities": "Toutes les priorités",
  "eqa.filter.allPrograms": "Tous les programmes",
  "eqa.filter.allStatuses": "Tous les statuts",
  "eqa.filter.eqaOnly": "Échantillons EQA uniquement",
  "eqa.filter.priority": "Priorité",
  "eqa.filter.program": "Programme",
  "eqa.filter.status": "Statut",
  "eqa.management.action.enterResults": "Saisir les résultats",
  "eqa.management.action.submit": "Soumettre",
  "eqa.management.bulkUpload": "Téléchargement en masse des résultats",
  "eqa.management.col.accession": "N° d'accession",
  "eqa.management.col.actions": "Actions",
  "eqa.management.col.deadline": "Date limite",
  "eqa.management.col.progress": "Progrès",
  "eqa.management.col.provider": "Prestataire/Programme",
  "eqa.management.col.sampleId": "ID d'échantillon",
  "eqa.management.col.status": "Statut",
  "eqa.management.daysLeft": "jours restants",
  "eqa.management.distributions.title": "Distributions",
  "eqa.management.filter.allSamples": "Tous les échantillons",
  "eqa.management.overdue": "En retard",
  "eqa.management.participants.subtitle": "Gérer l'inscription des organisations aux programmes EQE",
  "eqa.management.participants.title": "Participants",
  "eqa.management.performance.onTime": "Soumission à temps",
  "eqa.management.performance.participation": "Taux de participation",
  "eqa.management.performance.participation.sub": "Tous les programmes inscrits",
  "eqa.management.performance.subtitle": "Métriques de performance EQA de votre laboratoire",
  "eqa.management.performance.title": "Résumé de performance",
  "eqa.management.performance.zScore": "Score Z moyen",
  "eqa.management.performance.zScore.sub": "Dans la plage acceptable",
  "eqa.management.programs.subtitle": "Gérer les programmes distribués par ce laboratoire",
  "eqa.management.programs.title": "Programmes EQE",
  "eqa.management.results.title": "Résultats et analyse",
  "eqa.management.samples.empty": "Aucun échantillon EQA trouvé",
  "eqa.management.samples.subtitle": "Gérer les échantillons EQA reçus et soumettre les résultats",
  "eqa.management.samples.title": "Échantillons EQA",
  "eqa.management.status.completed": "Terminé",
  "eqa.management.status.completed.sub": "Prêt à soumettre",
  "eqa.management.status.inProgress": "En cours",
  "eqa.management.status.inProgress.sub": "Tests en cours",
  "eqa.management.status.in_progress": "En cours",
  "eqa.management.status.overdue": "En retard",
  "eqa.management.status.pending": "En attente",
  "eqa.management.status.pending.sub": "Non commencé",
  "eqa.management.status.submitted": "Soumis",
  "eqa.management.status.submitted.sub": "Résultats envoyés",
  "eqa.management.subtitle": "Recevoir et gérer les échantillons EEQ des prestataires externes",
  "eqa.management.title": "Gestion EQA",
  "eqa.management.viewPerformance": "Voir la performance",
  "eqa.myProgram.helperText": "Sélectionner une inscription pré-remplit les tests et panels",
  "eqa.myProgram.label": "Mon inscription au programme",
  "eqa.myProgram.prePopulated.subtitle": "{tests} tests et {panels} panels pré-sélectionnés à partir de l'inscription",
  "eqa.myProgram.prePopulated.title": "Tests/panels pré-remplis",
  "eqa.myProgram.select": "Sélectionner une inscription pour pré-remplir les tests...",
  "eqa.myPrograms.action.deactivate": "Désactiver",
  "eqa.myPrograms.action.edit": "Modifier",
  "eqa.myPrograms.action.reactivate": "Réactiver",
  "eqa.myPrograms.description": "Description",
  "eqa.myPrograms.enrollButton": "S'inscrire à un programme",
  "eqa.myPrograms.enrollInProgram": "S'inscrire à un programme",
  "eqa.myPrograms.labUnits": "Unité(s) de laboratoire",
  "eqa.myPrograms.panels": "Panels",
  "eqa.myPrograms.programName": "Nom du programme",
  "eqa.myPrograms.provider": "Prestataire",
  "eqa.myPrograms.search.placeholder": "Rechercher des programmes...",
  "eqa.myPrograms.status": "Statut",
  "eqa.myPrograms.status.active": "Actif",
  "eqa.myPrograms.status.inactive": "Inactif",
  "eqa.myPrograms.subtitle": "Programmes auxquels ce laboratoire participe",
  "eqa.myPrograms.testMapping": "Correspondance des tests (facultatif)",
  "eqa.myPrograms.testMappingHint": "Sélectionnez les tests et panels pour pré-remplir la saisie de commande lorsque ce programme est sélectionné",
  "eqa.myPrograms.tests": "Tests",
  "eqa.myPrograms.title": "Mes programmes EQE",
  "eqa.order.deadline": "Date limite de résultat",
  "eqa.order.form.title": "Informations sur l'échantillon EQA",
  "eqa.order.participantId": "ID du participant",
  "eqa.order.priority": "Priorité EQA",
  "eqa.order.programme": "Programme",
  "eqa.order.provider": "Prestataire",
  "eqa.order.providerSampleId": "ID échantillon prestataire",
  "eqa.orders.completedThisMonth": "Complétés ce mois",
  "eqa.orders.enterNewTest": "Saisir un nouveau test EQA",
  "eqa.orders.inProgress": "En cours",
  "eqa.orders.overdue": "En retard",
  "eqa.orders.pending": "En attente",
  "eqa.orders.search.placeholder": "Rechercher par numéro de laboratoire ou programme...",
  "eqa.participant.id": "ID du participant",
  "eqa.priority.critical": "Critique",
  "eqa.priority.label": "Priorité",
  "eqa.priority.standard": "Standard",
  "eqa.priority.urgent": "Urgent",
  "eqa.program.activate": "Activer",
  "eqa.program.active": "Actif",
  "eqa.program.addProgram": "Ajouter un programme",
  "eqa.program.cancel": "Annuler",
  "eqa.program.create": "Créer un programme",
  "eqa.program.createTitle": "Créer un programme EQE",
  "eqa.program.deactivate": "Désactiver",
  "eqa.program.description": "Description",
  "eqa.program.description.placeholder": "Décrivez le programme EQA...",
  "eqa.program.edit": "Modifier le programme",
  "eqa.program.editTitle": "Modifier le programme EQE",
  "eqa.program.empty": "Aucun programme EQA trouvé",
  "eqa.program.inactive": "Inactif",
  "eqa.program.label": "Programme EQA",
  "eqa.program.management.title": "Gestion des programmes EQA",
  "eqa.program.name": "Nom du programme",
  "eqa.program.name.placeholder": "ex. : Tests de compétence en chimie",
  "eqa.program.name.required": "Le nom du programme est requis",
  "eqa.program.provider.required": "Le prestataire est requis ",
  "eqa.program.participantCount": "Participants inscrits",
  "eqa.program.provider": "Prestataire",
  "eqa.program.required": "Le programme EQA est obligatoire lors de l'enregistrement d'un échantillon EQA",
  "eqa.program.save": "Enregistrer le programme",
  "eqa.program.select": "Sélectionner le programme EQA",
  "eqa.program.status": "Statut",
  "eqa.program.tests": "Tests assignés",
  "eqa.program.tests.assign": "Assigner des tests",
  "eqa.program.tests.select": "Sélectionner les tests à assigner",
  "eqa.provider.label": "Organisation prestataire EEQ",
  "eqa.provider.sampleId": "ID d'échantillon du prestataire",
  "eqa.provider.select": "Sélectionner le prestataire EEQ",
  "eqa.results.acceptable": "Acceptable",
  "eqa.results.batch.import": "Importation par lot",
  "eqa.results.col.deadline": "Date limite",
  "eqa.results.col.labNumber": "Numéro Laboratoire",
  "eqa.results.col.priority": "Priorité",
  "eqa.results.col.programme": "Programme",
  "eqa.results.col.provider": "Prestataire",
  "eqa.results.col.status": "Statuts",
  "eqa.results.import.confirm": "Confirmer l'importation",
  "eqa.results.import.errors": "{count} lignes contiennent des erreurs",
  "eqa.results.import.success": "{count} résultats importés avec succès",
  "eqa.results.import.upload": "Télécharger le fichier CSV",
  "eqa.results.manual.entry": "Saisie manuelle des résultats",
  "eqa.results.mean": "Moyenne",
  "eqa.results.minimum.participants": "Minimum 5 participants requis pour l'analyse statistique",
  "eqa.results.noResults": " Aucun résultat d’EEQ trouvé.",
  "eqa.results.organization": "Organisation",
  "eqa.results.organization.select": "Sélectionner l'organisation",
  "eqa.results.participant.count": "Nombre de participants",
  "eqa.results.performance": "Performance",
  "eqa.results.questionable": "Discutable",
  "eqa.results.report.downloading": "Téléchargement du rapport...",
  "eqa.results.report.generate": "Générer le rapport",
  "eqa.results.search.placeholder": "Rechercher par numéro laboratoire, programme ou prestataire…",
  "eqa.results.standardDeviation": "Écart type",
  "eqa.results.statistics": "Statistiques",
  "eqa.results.submit": "Soumettre le résultat",
  "eqa.results.test": "Test",
  "eqa.results.test.select": "Sélectionner le test",
  "eqa.results.title": "Résultats et analyse de l’EEQ",
  "eqa.results.unacceptable": "Inacceptable",
  "eqa.results.value": "Valeur du résultat",
  "eqa.results.zscore": "Score Z",
  "eqa.sample.badge": "EQA",
  "eqa.sample.checkbox": "Échantillon EQA",
  "eqa.sample.checkbox.helper": "Cochez si c'est un échantillon d'Assurance Qualité Externe",
  "eqa.sample.demographics.disabled": "Données démographiques désactivées pour les échantillons EQA",
  "eqa.sample.patient.readonly.body": "Les champs démographiques du patient sont automatiquement définis sur N/A pour les échantillons EQA et ne peuvent pas être modifiés.",
  "eqa.sample.patient.readonly.title": "Échantillon EQA — Infos patient verrouillées",
  "eqa.section.title": "Détails de l'échantillon EQA",
  "eqa.settings.integration.apiKey": "Clé API",
  "eqa.settings.integration.apiUrl": "URL de base de l'API",
  "eqa.settings.integration.fhir": "Intégration API FHIR",
  "eqa.settings.integration.fhir.desc": "Activer l'API FHIR R4 pour l'échange de données EQA externes",
  "eqa.settings.integration.subtitle": "Configurer les intégrations de systèmes externes",
  "eqa.settings.integration.title": "Paramètres d'intégration",
  "eqa.settings.loading": "Chargement des paramètres...",
  "eqa.settings.notifications.email": "Notifications par e-mail",
  "eqa.settings.notifications.email.desc": "Envoyer des notifications par e-mail pour les alertes critiques et les échéances",
  "eqa.settings.notifications.eqaDeadline": "Alertes d'échéance EQA",
  "eqa.settings.notifications.eqaDeadline.desc": "Recevoir des alertes lorsque les échéances de soumission EQA approchent",
  "eqa.settings.notifications.stat": "Alertes de commandes STAT",
  "eqa.settings.notifications.stat.desc": "Alerter lorsque les commandes STAT sont en retard",
  "eqa.settings.notifications.subtitle": "Configurer les préférences d'alerte et de notification",
  "eqa.settings.notifications.threshold": "Seuil d'alerte (jours avant l'échéance)",
  "eqa.settings.notifications.title": "Paramètres de notification",
  "eqa.settings.performance.autoZScore": "Calcul automatique du score Z",
  "eqa.settings.performance.autoZScore.desc": "Calculer automatiquement les scores Z lors de la soumission des résultats",
  "eqa.settings.performance.generateReports": "Générer des rapports de performance",
  "eqa.settings.performance.generateReports.desc": "Générer automatiquement des rapports de performance après chaque ronde",
  "eqa.settings.performance.subtitle": "Configurer les paramètres d'analyse de performance EQA",
  "eqa.settings.performance.title": "Analyse de performance",
  "eqa.settings.performance.zScoreMax": "Score Z maximum acceptable",
  "eqa.settings.performance.zScoreMin": "Score Z minimum acceptable",
  "eqa.settings.saveError": "Échec de l'enregistrement des paramètres",
  "eqa.settings.saveSuccess": "Paramètres enregistrés avec succès",
  "eqa.settings.saving": "Enregistrement...",
  "eqa.status.active": "Actif",
  "eqa.status.completed": "Complété",
  "eqa.status.inProgress": "En cours",
  "eqa.status.inactive": "Inactif",
  "eqa.status.inprogress": "En cours",
  "eqa.status.overdue": "En retard",
  "eqa.status.pending": "En attente",
  "eqa.submission.audit": "Piste d'audit de soumission",
  "eqa.submission.date": "Date de soumission",
  "eqa.submission.error": "La soumission a échoué",
  "eqa.submission.fhir": "Soumettre via FHIR",
  "eqa.submission.fhir.description": "Soumettre les résultats au prestataire EEQ externe via FHIR R4",
  "eqa.submission.late.approve": "Approuver la soumission tardive",
  "eqa.submission.late.justification": "Justification de la soumission tardive",
  "eqa.submission.late.justification.placeholder": "Indiquez la raison de la soumission tardive...",
  "eqa.submission.late.supervisor": "ID utilisateur du superviseur",
  "eqa.submission.late.warning": "La date limite de soumission est dépassée. L'approbation du superviseur est requise.",
  "eqa.submission.method": "Méthode de soumission",
  "eqa.submission.success": "Résultats soumis avec succès",
  "eqa.submission.title": "Soumission des résultats",
  "eqa.tests.action.enterResults": "Saisir les résultats",
  "eqa.tests.action.viewOrder": "Voir la commande",
  "eqa.tests.action.viewResults": "Voir les résultats",
  "eqa.tests.dateEntered": "Date de saisie",
  "eqa.tests.deadline": "Date limite",
  "eqa.tests.enterNew": "Saisir un nouveau test EQA",
  "eqa.tests.labNumber": "Numéro de laboratoire",
  "eqa.tests.orders.subtitle": "Commandes de tests de compétence pour ce laboratoire",
  "eqa.tests.orders.title": "Commandes EQE",
  "eqa.tests.priority": "Priorité",
  "eqa.tests.program": "Programme EQE",
  "eqa.tests.provider": "Prestataire",
  "eqa.tests.searchPlaceholder": "Rechercher par n° d'accession, programme ou prestataire...",
  "eqa.tests.status": "Statut",
  "eqa.tests.status.completed": "Terminé",
  "eqa.tests.status.inProgress": "En cours",
  "eqa.tests.status.overdue": "En retard",
  "eqa.tests.status.pending": "En attente",
  "eqa.tests.summary.completedThisMonth": "Terminés ce mois-ci",
  "eqa.tests.summary.inProgress": "En cours",
  "eqa.tests.summary.overdue": "En retard",
  "eqa.tests.summary.pending": "En attente",
  "eqa.validation.deadline.required": "La date limite de test est requise",
  "eqa.validation.program.required": "Le programme EQA est requis",
  "eqa.validation.provider.required": "L'organisation prestataire EEQ est requise",
  "error.add.edited.msg": "Erreur lors de la modification/ajout",
  "error.barcode.dimension.positive": "La dimension de l'étiquette doit être un nombre positif",
  "error.barcode.labelcount.default.lte.max": "Le nombre par défaut ne doit pas dépasser le maximum pour ce type d'étiquette",
  "error.delete.msg": "Erreur lors de la suppression",
  "error.duplicate.calculationname": "Nom de calcul en double",
  "error.fetch.boxDetails": "Échec de la récupération des détails de la boîte",
  "error.fetch.boxes": "Échec de la récupération des boîtes en expédition",
  "error.fetch.facilities": "Échec de la récupération des établissements",
  "error.fetch.unassignedSamples": "Échec de la récupération des échantillons non attribués",
  "error.field.required": "This field is required",
  "error.import.patient": "Erreur lors de l'importation du patient",
  "error.invalid.email": "Email invalide",
  "error.invalidcredentials": "L'identifiant ou le mot de passe est incorrect",
  "error.locale.format": "Invalid format. Use: en, fr, es, or en-US, fr-CA, etc.",
  "error.no.patient.data": "Aucune donnée de patient",
  "error.nonconform.report": "Veuillez saisir une valeur",
  "error.report.csv.date": "Veuillez sélectionner le type de date.",
  "error.report.csv.study": "Veuillez sélectionner le type d'étude.",
  "error.report.status": "Erreur lors de la génération du rapport",
  "error.required.destination": "L’établissement de destination est requis",
  "error.save.failed": "Échec de l'enregistrement",
  "error.save.msg": "Erreur lors de l'enregistrement",
  "error.save.order": "Erreur lors de l’enregistrement de la demande d’examen ",
  "error.save.patient": "Erreur lors de l'enregistrement du patient",
  "error.title": "Erreur",
  "errorBoundary.reload": "Recharger",
  "errorBoundary.route.patientResultsViewer.message": "Une erreur est survenue lors de l’affichage des résultats de ce patient. Rechargez pour réessayer",
  "errorBoundary.route.patientResultsViewer.title": "Impossible de charger les résultats du patient",
  "errorBoundary.route.resultsSearch.message": "Une erreur est survenue sur la page des résultats. Rechargez pour réessayer.",
  "errorBoundary.route.resultsSearch.title": "Impossible de charger les résultats",
  "errorBoundary.route.samplePatientEntry.message": "Une erreur est survenue sur la page de saisie des échantillons. Rechargez pour réessayer.",
  "errorBoundary.route.samplePatientEntry.title": "Impossible de charger la saisie des échantillons",
  "errorBoundary.route.storage.message": "Une erreur est survenue sur cette page. Rechargez pour réessayer ou utilisez le menu pour naviguer ailleurs.",
  "errorBoundary.route.storage.title": "Impossible de charger le stockage ",
  "errorBoundary.route.analyzers.message": "Une erreur est survenue lors du chargement de cette page. Rechargez pour réessayer.",
  "errorBoundary.route.analyzers.title": "Impossible de charger le module analyseur",
  "errorBoundary.route.analyzerResults.message": "Une erreur est survenue lors du chargement des résultats. Rechargez pour réessayer.",
  "errorBoundary.route.analyzerResults.title": "Impossible de charger les résultats de l’analyseur",
  "esig.button.certify": "Certifier et continuer",
  "esig.button.reject": "Rejeter",
  "esig.button.saveAndSign": "Sauvegarder",
  "esig.button.sign": "Signer",
  "esig.button.validate": "Valider",
  "esig.certification.acknowledge": "J’ai lu et compris la déclaration ci-dessus",
  "esig.certification.intro": "Avant d’utiliser les signatures électroniques, vous devez certifier que votre signature électronique a la même valeur légale que votre signature manuscrite.",
  "esig.error.disabled": "Les signatures électroniques ne sont pas activées",
  "esig.error.generic": "Une erreur s’est produite",
  "esig.error.invalidCredentials": "Identifiants invalides",
  "esig.error.keycloakNotSupported": "L’authentification Keycloak n’est pas encore prise en charge pour les signatures électroniques",
  "esig.error.loadingStatus": "Échec du chargement du statut de signature",
  "esig.error.mustAcknowledge": "Vous devez accepter la déclaration de certification",
  "esig.error.passwordRequired": "Le mot de passe est requis",
  "esig.error.rejectionReasonRequired": "Le motif de rejet est requis",
  "esig.error.title": "Erreur",
  "esig.error.usernameRequired": "Le nom d’utilisateur est requis",
  "esig.info.fullAuth": "Il s’agit de votre première signature dans cette session. Veuillez saisir votre nom d’utilisateur et votre mot de passe pour vous authentifier.",
  "esig.info.legalBinding": "En saisissant vos identifiants, vous créez une signature électronique ayant une valeur légale conformément à la réglementation 21 CFR Part 11.",
  "esig.info.passwordOnly": "Vous avez une session de signature active. Saisissez votre mot de passe pour continuer.",
  "esig.label.context": "Action:",
  "esig.label.meaning": "Signification de la signature :",
  "esig.label.password": "Mot de passe",
  "esig.label.rejectionReason": "Motif du rejet",
  "esig.label.signingAs": "Signé par : {userName}",
  "esig.label.username": "Nom d'utilisateur",
  "esig.meaning.authored": "Saisi",
  "esig.meaning.rejected": "Rejeté",
  "esig.meaning.validatedAndReleased": "Validé et publié",
  "esig.placeholder.password": "Saisissez votre mot de passe pour confirmer",
  "esig.placeholder.rejectionReason": "Saisissez le motif du rejet",
  "esig.placeholder.username": "Saisissez votre nom d’utilisateur ",
  "esig.title.certification": "Certification de signature électronique",
  "esig.title.signature": "Signature électronique",
  "example": "Exemple",
  "external.id": "Identifiant externe",
  "external.referrals.report": "Rapport de références externes",
  "externalReferredOutTests.title": "Tests référés externes",
  "externalconnections.active": "Actif",
  "externalconnections.add.title": "Ajouter une connexion externe",
  "externalconnections.authtype": "Type d’authentification",
  "externalconnections.authtype.basic.password": "Mot de passe",
  "externalconnections.authtype.basic.username": "Nom d'utilisateur",
  "externalconnections.browse.title": "Connexions externes",
  "externalconnections.deactivate.success": "Connexion(s) externe(s) désactivée(s) avec succès.",
  "externalconnections.description": "Description",
  "externalconnections.edit.title": "Modifier la connexion externe",
  "externalconnections.name": "Saisir le nom de la connexion",
  "externalconnections.name.placeholder": "Saisir le nom de la connexion",
  "externalconnections.programmedconnection": "Type de connexion",
  "externalconnections.save.success": "Connexion externe enregistrée avec succès.",
  "externalconnections.search": "Rechercher des connexions externes",
  "externalconnections.search.placeholder": "Rechercher par nom ou type",
  "externalconnections.select": "Sélectionner",
  "externalconnections.uri": "URI",
  "externalconnections.uri.placeholder": "ex. https://serveur:port",
  "false.label": "Faux",
  "field.active": "Actif/Non actif",
  "field.ageRange": "Tranche d'âge",
  "field.dictionaryValues": "Valeurs du dictionnaire",
  "field.loinc": "LOINC",
  "field.name": "Nom",
  "field.normalRange": "Plage normale",
  "field.note": "Remarque",
  "field.orderable": "Commandable/Non commandable",
  "field.panel": "Panneau",
  "field.referenceValue": "Valeur de référence",
  "field.reportName": "Nom du rapport",
  "field.resultLimits": "Limites des résultats",
  "field.resultType": "Type de résultat",
  "field.sampleType": "Type d'échantillon",
  "field.select.testSection": "Select Test Section",
  "field.selectValues": "Sélectionner des valeurs",
  "field.sex": "Sexe",
  "field.significantDigits": "Chiffres significatifs",
  "field.testSection": "Section des tests",
  "field.testUnit": "Unité de test",
  "field.uom": "Unité de mesure",
  "field.validRange": "Plage valide",
  "file.import.configuration.active": "Actif",
  "file.import.configuration.analyzer": "Analyseur",
  "file.import.configuration.analyzer.emptyState": "No file import plugins installed",
  "file.import.configuration.analyzer.placeholder": "Sélectionner un analyseur",
  "file.import.configuration.cancel": "Annuler",
  "file.import.configuration.columnMappings": "Mappages de colonnes",
  "file.import.configuration.columnMappings.helperText": "Mappage JSON des colonnes CSV vers les champs OpenELIS (ex: {\"Sample_ID\": \"sampleId\", \"Result\": \"result\"})",
  "file.import.configuration.delimiter": "Délimiteur",
  "file.import.configuration.delimiter.helperText": "Caractère délimiteur CSV (par défaut: virgule)",
  "file.import.configuration.error.save": "Échec de l'enregistrement de la configuration d'import de fichier",
  "file.import.configuration.error.unknown": "Une erreur inconnue s'est produite",
  "file.import.configuration.fileFormat": "File Format",
  "file.import.configuration.fileFormat.placeholder": "Select file format",
  "file.import.configuration.filePattern": "Modèle de fichier",
  "file.import.configuration.filePattern.helperText": "Modèle glob pour correspondre aux fichiers (ex: *.csv, results_*.txt)",
  "file.import.configuration.hasHeader": "A une ligne d'en-tête",
  "file.import.configuration.importDirectory": "Répertoire d'import",
  "file.import.configuration.importDirectory.helperText": "Répertoire à surveiller pour les nouveaux fichiers",
  "file.import.configuration.importDirectory.placeholder": "/data/import",
  "file.import.configuration.save": "Enregistrer",
  "file.import.configuration.success.created": "Configuration d'import de fichier créée avec succès",
  "file.import.configuration.success.updated": "Configuration d'import de fichier mise à jour avec succès",
  "file.import.configuration.title.add": "Ajouter une configuration d'import de fichier",
  "file.import.configuration.title.edit": "Modifier la configuration d'import de fichier",
  "file.import.configuration.validation.analyzerId.required": "L'analyseur est requis",
  "file.import.configuration.validation.columnMappings.invalid": "Format JSON invalide pour les mappages de colonnes",
  "file.import.configuration.validation.importDirectory.required": "Le répertoire d'import est requis",
  "fileImport.format.csv": "CSV",
  "fileImport.format.excel": "Excel",
  "fileImport.format.tsv": "TSV",
  "filters.label": "Filtres",
  "freezer.nav.corrective": "Corrective Actions",
  "freezer.nav.corrective.tooltip": "Manage corrective actions",
  "freezer.nav.dashboard": "Dashboard",
  "freezer.nav.dashboard.tooltip": "View cold storage monitoring dashboard",
  "freezer.nav.reports": "Reports",
  "freezer.nav.reports.tooltip": "Generate cold storage reports",
  "freezer.nav.settings": "Settings",
  "freezer.nav.settings.tooltip": "Configure cold storage settings",
  "freezer.nav.trends": "Historical Trends",
  "freezer.nav.trends.tooltip": "View temperature trends over time",
  "french.current": "FRANÇAIS actuel",
  "french.label": "Français",
  "from.title": "De",
  "genericSample.edit.success": "Sample updated successfully",
  "genericSample.edit.title": "Modifier l'échantillon",
  "genericSample.field.by": "Par",
  "genericSample.field.count": "#",
  "genericSample.field.date": "Date",
  "genericSample.field.from": "De",
  "genericSample.field.id": "ID",
  "genericSample.field.labPersonReceived": "Personne de laboratoire reçue",
  "genericSample.field.project": "Projet",
  "genericSample.field.storageLocation": "Congélateur de stockage n° et emplacement",
  "genericSample.field.type": "Type",
  "genericSample.notebook.selection.title": "Sélection du projet (facultatif)",
  "genericSample.order.error.labNoRequired": "Veuillez générer un numéro de laboratoire avant d'enregistrer.",
  "genericSample.order.generateLabNo": "Générer un numéro de laboratoire",
  "genericSample.order.labNo.placeholder": "Cliquez sur « Générer un numéro de laboratoire » pour générer ",
  "genericSample.order.success.details": "Détails de l'échantillon",
  "genericSample.order.success.message": "Sample order created successfully with accession number: {accessionNumber}",
  "genericSample.order.title": "Recevoir un échantillon",
  "gps.accuracy.display": "±{accuracy}m accuracy",
  "gps.accuracy.warning.message": "GPS accuracy is {accuracy}m, which exceeds the required {required}m threshold. Consider capturing the location again in a better position.",
  "gps.accuracy.warning.title": "GPS Accuracy Warning",
  "gps.button.clear": "Clear",
  "gps.button.getting.location": "Getting Location...",
  "gps.button.location.captured": "Location Captured",
  "gps.button.use.my.location": "Use My Location",
  "gps.collapse": "Collapse GPS section",
  "gps.config.accuracy.helper": "Maximum acceptable GPS accuracy in meters. Set to 0 to disable accuracy checking.",
  "gps.config.accuracy.label": "Required Accuracy (meters)",
  "gps.config.enabled.description": "When enabled, GPS coordinate fields will appear in the Order Entry workflow to capture sample collection locations.",
  "gps.config.enabled.label": "Enable GPS Coordinates",
  "gps.config.error.load": "Failed to load GPS configuration",
  "gps.config.save.error": "Failed to save GPS configuration",
  "gps.config.save.success": "GPS configuration saved successfully",
  "gps.config.saving": "Saving...",
  "gps.config.section.general": "GPS Settings",
  "gps.config.timeout.helper": "Maximum time to wait for GPS location in seconds.",
  "gps.config.timeout.label": "Timeout (seconds)",
  "gps.config.title": "GPS Coordinates Configuration",
  "gps.config.unsaved.changes": "You have unsaved changes. Are you sure you want to leave?",
  "gps.config.unsaved.subtitle": "Remember to save your changes before navigating away.",
  "gps.config.unsaved.title": "Unsaved Changes",
  "gps.config.validation.accuracy.negative": "Required accuracy cannot be negative",
  "gps.config.validation.accuracy.too.high": "Required accuracy cannot exceed 10,000 meters",
  "gps.config.validation.timeout.too.high": "Timeout cannot exceed 120 seconds",
  "gps.config.validation.timeout.too.low": "Timeout must be at least 1 second",
  "gps.coordinates.captured.via": "Captured via {method}",
  "gps.coordinates.current": "Current coordinates",
  "gps.error.not.supported": "GPS is not supported by this browser",
  "gps.error.permission.denied": "GPS access was denied. Please enable location permissions and try again.",
  "gps.error.position.unavailable": "GPS position is unavailable. Please check your device's location settings.",
  "gps.error.timeout": "GPS request timed out. Please try again.",
  "gps.error.title": "GPS Error",
  "gps.error.unknown": "An unknown GPS error occurred. Please try again.",
  "gps.info.description": "GPS coordinates record the geographic location where the sample was collected. This supports epidemiological surveillance and disease mapping.",
  "gps.info.title": "GPS Coordinates",
  "gps.latitude.helper": "Degrees North (+) or South (-), between -90 and 90",
  "gps.latitude.invalid": "Latitude must be between -90 and 90 degrees",
  "gps.latitude.label": "Latitude",
  "gps.latitude.placeholder": "e.g., -1.286389",
  "gps.longitude.helper": "Degrees East (+) or West (-), between -180 and 180",
  "gps.longitude.invalid": "Longitude must be between -180 and 180 degrees",
  "gps.longitude.label": "Longitude",
  "gps.longitude.placeholder": "e.g., 36.817223",
  "gps.manual.entry.off": "Off",
  "gps.manual.entry.on": "On",
  "gps.manual.entry.title": "Enter coordinates manually",
  "gps.manual.entry.toggle": "Manual coordinate entry",
  "gps.not.captured": "Not captured",
  "gps.section.description": "Capture the geographic location where this sample was collected for epidemiological tracking",
  "gps.section.title": "Collection Location (GPS)",
  "gps.status.captured": "Captured",
  "gps.status.optional": "Optional",
  "gps.tile.collapse": "Collapse GPS section",
  "gps.tile.expand": "Expand to add GPS coordinates",
  "gps.warning.partial.coordinates": "Both latitude and longitude should be provided for a valid location.",
  "header.ID": "IDENTIFIANT",
  "header.assign": "Attribuer",
  "header.cancel.test": "Annuler le test",
  "header.formname": "Nom du formulaire",
  "header.label.ARV": "ARV-initial",
  "header.label.EID": "Diagnostic pour les enfants avec DBS-PCR",
  "header.label.changeLab": "Changer de laboratoire",
  "header.label.followup": "ARV-suivi",
  "header.label.intialFollowup": "ARV -->Suivi initial-VL",
  "header.label.logout": "Déconnexion",
  "header.label.nonconformityByDate": "Rapport de non-conformité par date",
  "header.label.selectLab": "Sélectionner le laboratoire",
  "header.label.selectlocale": "Sélectionner la Langue",
  "header.label.specialRequest": "Demande spéciale",
  "header.label.study.ciexport": "Exporter un fichier CSV par date",
  "header.label.study.vlloadtrends": "Rapport d'exportation des données de charge virale",
  "header.label.version": "Version:",
  "header.reject": "Rejeter",
  "header.rejection.reason": "Raison du rejet",
  "header.results.recorded": "Résultats enregistrés",
  "hide.aliquoting": "Masquer l'aliquotage",
  "holder.choose.availabletest": "Choisissez le test disponible",
  "home.label": "Accueil",
  "immunohistochemistry.label.addreport": "Ajouter un Rapport",
  "immunohistochemistry.label.averageChrom": "Moyenne des signaux Chromosome 17 par noyau",
  "immunohistochemistry.label.averageHer2": "Moyenne de HER2 par noyau",
  "immunohistochemistry.label.cellIntensity": "d'intensité. Score Allred",
  "immunohistochemistry.label.cellPercent": "% des cellules présentent une coloration nucléaire avec",
  "immunohistochemistry.label.dashboard": "Tableau de bord en immunohistochimie",
  "immunohistochemistry.label.her2Assesment": "L'évaluation de la protéine HER2 est de",
  "immunohistochemistry.label.her2Pattern": "Motif de coloration CerbB2/HER 2",
  "immunohistochemistry.label.her2ScoreOf": "Avec un score de",
  "immunohistochemistry.label.historicalDiagnosis": "Diagnostic histologique",
  "immunohistochemistry.label.ihcRatio": "Ratio des signaux Her2/neu par rapport au Chromosome 17",
  "immunohistochemistry.label.ihcScore": "Score IHC (Cerb2)",
  "immunohistochemistry.label.mibName": "MiB 1 (ki-67) (Indice de prolifération) :",
  "immunohistochemistry.label.molecularType": "Sous-type moléculaire",
  "immunohistochemistry.label.numberOfCancer": "Nombre de noyaux cancéreux",
  "immunohistochemistry.label.outOf8": "sur 8",
  "immunohistochemistry.label.report": "Rapport",
  "immunohistochemistry.label.reports": "Rapports",
  "immunohistochemistry.label.review": "En attente de révision en immunohistochimie",
  "immunohistochemistry.label.title": "Immuno-Histochimie",
  "immunohistochemistry.label.tumorCells": "des cellules tumorales sont positives (couper 20%)",
  "import.autoGenerated": "Auto-generated",
  "import.created": "Created",
  "import.error.failed": "Import failed",
  "import.error.importFile": "Failed to import file",
  "import.error.selectFile": "Please select a file first",
  "import.error.validateFile": "Failed to validate file",
  "import.error.validateFirst": "Please validate the file first and fix any errors",
  "import.error.validationFailed": "Validation failed. Please check the errors below.",
  "import.failed": "Import Failed",
  "import.failedCount": "Failed",
  "import.header.collectionDate": "Collection Date",
  "import.header.errorMessage": "Error Message",
  "import.header.field": "Field",
  "import.header.from": "From",
  "import.header.labNo": "Lab No",
  "import.header.quantity": "Quantity",
  "import.header.row": "Row",
  "import.header.sampleType": "Sample Type",
  "import.header.samplesToCreate": "Samples to Create",
  "import.importing": "Importing...",
  "import.invalidRows": "Invalid Rows",
  "import.selectFile": "Select file",
  "import.status.invalid": "Invalid",
  "import.status.valid": "Valid",
  "import.success": "Import Successful",
  "import.totalRows": "Total Rows",
  "import.totalSamplesToCreate": "Total Samples to Create",
  "import.uploadFile": "Upload File",
  "import.uploadFileDesc": "Upload CSV or Excel file ({types})",
  "import.validRows": "Valid Rows",
  "import.validating": "Validating...",
  "import.validationStatus": "Validation Status",
  "input.error.same.panel.type": "Un panneau existant avec le même nom a été trouvé. Veuillez annuler ou utiliser un nom différent.",
  "input.placeholder.labNo": "Saisir le numéro de laboratoire",
  "input.placeholder.patientFirstName": "Entrez le prénom du patient",
  "input.placeholder.patientId": "Entrez le numéro du patient",
  "input.placeholder.patientLastName": "Entrez le nom de famille du patient",
  "input.placeholder.prevLabNumber": "Entrez le numéro de laboratoire précédent",
  "input.placeholder.providerEmail": "Saisir l'adresse e-mail du prescripteur",
  "input.placeholder.providerFax": "Saisir le numéro de fax du prescripteur",
  "input.placeholder.providerWorkPhone": "Saisir le numéro de téléphone du prescripteur",
  "input.placeholder.provisionalClinicalDiagnosis": "Entrer le diagnostic clinique provisoire",
  "input.placeholder.requesterFirstName": "Saisir le prénom du prescripteur",
  "input.placeholder.requesterLastName": "Saisir le nom de famille du prescripteur",
  "input.placeholder.searchTestName": "Rechercher Nom de test ici",
  "input.placeholder.selectPanel": "Sélectionnez le type de panneau",
  "input.placeholder.selectPriority": "Sélectionnez la priorité",
  "input.placeholder.selectTest": "Sélectionnez le type de test",
  "input.placeholder.selectTestSection": "Sélectionnez le type d'unité",
  "instructions.copy.labnum": "Copier le numéro de laboratoire",
  "instructions.order.entry.eqa.enabled": "Lorsqu'il est activé, une case à cocher apparaît sur l'écran de saisie de commande permettant au personnel de marquer un échantillon comme EQA. Les données démographiques du patient seront automatiquement remplies avec N/A et verrouillées.",
  "instructions.test.activation": "Tests actifs: une case cochée indique un test déjà actif. Pour activer un test, cochez la case; pour désactiver, décochez la case. Tous les types d'échantillons sans test actif existant sont désactivés et apparaissent en bas, sous 'Types d'échantillons inactifs'. Si l'un des tests est activé, le type d'échantillon sera activé.",
  "instructions.test.activation.confirm": "Vérifiez que ces modifications sont celles que vous souhaitez effectuer. Si elles sont correctes, enregistrez-les. Sinon, utilisez le bouton retour pour apporter les corrections nécessaires.",
  "instructions.test.activation.sort": "Ordre d'affichage : Listes des types d'échantillons avec des tests nouvellement activés. Triez les tests pour indiquer comment ils seront affichés dans l'écran de saisie des ordonnances. Le tri peut être effectué en faisant glisser les éléments à la position souhaitée.",
  "instructions.test.order": "Les tests avec des cases cochées sont commandables, ceux sans cases cochées ne le sont pas. Modifiez les cases pour changer le statut. Pour qu’un test puisse être commandé lors de l’admission, il doit être à la fois actif et commandable. Les tests qui sont actifs mais non commandables peuvent être demandés dans le cadre d’un test réflexe.",
  "invalid.json": "JSON n'est pas valide",
  "inventory.add.button": "Ajouter un nouveau lot ",
  "inventory.addItem.button": "Ajouter un élément au catalogue",
  "inventory.dashboard.title": "Tableau de bord d'inventaire",
  "inventory.export.button": "Exporter",
  "inventory.filter.all": "Tous",
  "inventory.filter.status": "Filtrer par statuts",
  "inventory.filter.type": "Filtrer par type",
  "inventory.list.title": "Articles en stock",
  "inventory.metrics.expired": "Expiré",
  "inventory.metrics.expiringSoon": "Expire bientôt",
  "inventory.metrics.lowStock": "Stock faible",
  "inventory.metrics.totalLots": "Nombre total de lots",
  "inventory.search.placeholder": "Recherche par nom d'article ou numéro de lot",
  "inventory.tab.catalog": "Catalogue",
  "inventory.tab.dashboard": "Tableau de Bord",
  "inventory.tab.reports": "Rapports",
  "inventory.title": "Gestion des stocks",
  "label.action": "Action",
  "labNumber.format.current": "Format actuel",
  "labNumber.format.new": "Nouveau format",
  "labNumber.prefix": "Préfixe",
  "labNumber.type": "Type de numéro de laboratoire",
  "labNumber.usePrefix": "Utiliser le préfixe",
  "label.actions": "Actions",
  "label.active": "Activer",
  "label.actualTestName": "Nom du test réel",
  "label.add": "Ajouter",
  "label.add.notification": "Ajouter une notification contextuelle à l'utilisateur",
  "label.all": "Tout",
  "label.analysisNotStarted": "Analyse non commencée",
  "label.any": "N'importe lequel",
  "label.audittrail": "laboratoire non",
  "label.audittrail.Reports": "Rapports de piste d'audit",
  "label.audittrail.labNo.invalidaccessionnumber": "Numéro d'accès invalide",
  "label.audittrail.labNo.missing": "Le numéro de laboratoire est requis !",
  "label.audittrailreport.nextvisitdate": "Date de la prochaine visite",
  "label.audittrailreport.priority": "Priorité",
  "label.audittrailreport.program": "Programme",
  "label.audittrailreport.receiveddate": "Date de réception",
  "label.audittrailreport.requestdate": "Date de demande",
  "label.audittrailreport.requester": "Prescripteur",
  "label.audittrailreport.requester.firstname": "Prénom du prescripteur",
  "label.audittrailreport.requester.lastname": "Nom de famille du prescripteur",
  "label.audittrailreport.sitename": "Nom du site",
  "label.autoFilledFromServer": "Rempli automatiquement depuis le serveur",
  "label.barcode": "code-barre",
  "label.barcode.labelsets": "Nombre d'ensembles d'étiquettes",
  "label.barcode.orderlabel": "Nombre d'étiquettes d'ordonnance par ensemble",
  "label.barcode.specimenlabel": "Nombre d'étiquettes d'échantillon par ensemble",
  "label.barcode.totallabel": "Nombre total d'étiquettes à imprimer",
  "label.button.add": "Ajouter",
  "label.button.add.question": "Ajouter une nouvelle question",
  "label.button.cancel": "Annuler",
  "label.button.close": "Close",
  "label.button.changepassword": "Changer Mot de Passe",
  "label.button.clear": "Effacer",
  "label.button.confirm": "Confirmer",
  "label.button.confirmAction": "Confirmer l'action",
  "label.button.confirmDelete": "Confirmation de la suppression",
  "label.button.confirmTitle": "Es-tu sûr ?",
  "label.button.delete": "Supprimer",
  "label.button.descritpion": "Description",
  "label.button.edit": "Modifier",
  "label.button.exit": "Sortie",
  "label.button.externalsearch": "Recherche externe",
  "label.button.field": "Champ",
  "label.button.finish": "Terminer",
  "label.button.finished": "Terminé",
  "label.button.generatePrintableVersion": "Générer une version à imprimer",
  "label.button.import": "Importer",
  "label.button.login": "Se Connecter",
  "label.button.login.sso": "L'authentification unique",
  "label.button.newEntry": "Nouvelle saisie",
  "label.button.ok": "D'accord",
  "label.button.previous": "Précédent",
  "label.button.range": "Plage",
  "label.button.remove": "Supprimer",
  "label.button.remove.block": "Supprimer le Bloc",
  "label.button.remove.report": "Supprimer le Rapport",
  "label.button.remove.slide": "Supprimer la Diapositive",
  "label.button.reset": "Reset",
  "label.button.sample": "Échantillon",
  "label.button.save": "Enregistrer",
  "label.button.search": "Chercher",
  "label.button.select": "Sélectionner",
  "label.button.select.pathologist": "Sélectionner le pathologiste",
  "label.button.select.status": "Sélectionner l'état",
  "label.button.select.technician": "Sélectionner le technicien",
  "label.button.select.test": "Sélectionner le test",
  "label.button.start": "Commencer",
  "label.button.submit": "Terminer",
  "label.button.update": "Mettre à jour",
  "label.button.uploadfile": "Télécharger le Fichier",
  "label.button.validate": "Valider",
  "label.button.viewReport": "Voir le rapport",
  "label.cancel": "Cancel",
  "label.cancel.test.no.replace": "Annuler le test pour les numéros de laboratoire sélectionnés, ne pas assigner un nouveau test",
  "label.checkedWillBeModified": "Les numéros de laboratoire cochés seront modifiés",
  "label.clear": "Effacer les filtres",
  "label.content": "Contenu de l’étiquette",
  "label.confirm": "Confirmer",
  "label.created.samples": "Échantillons créés",
  "label.critical.range": "Plage critique",
  "label.currentTest": "Test actuel",
  "label.days": "jours",
  "label.default.result": "Résultat par défaut",
  "label.delete": "Delete",
  "label.description": "Description",
  "label.edit": "Edit",
  "label.electronic.orders": "Statistiques journalières. ",
  "label.equals": "équivaut à",
  "label.error": "Erreur",
  "label.existing.methods": "Méthodes existantes",
  "label.existing.test.sets": "Ensembles de tests existants",
  "label.filters.mycases": "Mes cas",
  "label.filters.status": "Statut",
  "label.field.required": "Ce champ est requis",
  "label.form.searchby": "Rechercher par",
  "label.id": "ID",
  "label.import.errors": "Erreurs d'importation",
  "label.inactive": "Inactif",
  "label.inactive.methods": "Méthodes inactives. Assignez des tests pour activer.",
  "label.includeInactiveTests": "Inclure les tests inactifs",
  "label.inside.normalrange": "est dans la plage normale",
  "label.lastPrinted": "Dernière impression : {date} {heure} par {utilisateur}",
  "label.loading": "Chargement...",
  "label.loinc": "LOINC",
  "label.management.title": "Gestion des étiquettes",
  "label.no": "No",
  "label.no.options.available": "Aucune option disponible",
  "label.none": "Aucun (pas de filtre)",
  "label.notValidated": "Non validé",
  "label.notequals": "n'est pas égal",
  "label.order.scan.text": "Scanner OU Saisir manuellement OU",
  "label.orderable": "Commandable",
  "label.outside.normalrange": "est en dehors de la plage normale",
  "label.page.patientHistory": "Historique du patient",
  "label.preview.data": "Aperçu des données",
  "label.print": "Imprimer l'étiquette",
  "label.print.error": "Erreur lors de la génération de l'étiquette. Veuillez réessayer.",
  "label.print.error.popupBlocked": "Fenêtre contextuelle bloquée. Veuillez autoriser les fenêtres contextuelles pour que ce site puisse imprimer les étiquettes.",
  "label.print.generating": "Génération en cours…",
  "label.print.success": "Étiquette imprimée avec succès",
  "label.print.description": "Imprimer les étiquettes pour les demandes d'examens et les échantillons",
  "label.print.helper": "Sélectionner le type et la quantité d’étiquettes à imprimer",
  "label.print.success.count": "{count} étiquettes imprimées avec succès",
  "label.print.title": "Imprimer les étiquettes",
  "label.printAll": "Imprimer toutes les étiquettes",
  "label.printAll.success": "Toutes les étiquettes ont été imprimées avec succès",
  "label.printConfirmation.message": "Imprimer l'étiquette pour {nom}{code} ?",
  "label.printConfirmation.title": "Imprimer l'étiquette",
  "label.printHistory": "Historique d'impression",
  "label.printHistory.byUser": "Par {utilisateur}",
  "label.printHistory.count": "{count} libellés",
  "label.printHistory.loading": "Chargement de l’historique d’impression…",
  "label.printHistory.never": "Jamais imprimé",
  "label.printHistory.unknownUser": "Inconnu",
  "label.printHistory.viewAll": "Afficher l'historique",
  "label.printLabel": "Imprimer l'étiquette",
  "label.program": "programme",
  "label.qualifiers": "Qualificateurs",
  "label.quantity": "Quantité",
  "label.readonly": "Lecture seule",
  "label.reference.value": "Valeur de référence",
  "label.refertest.referencelab": "Référer le test à un laboratoire de référence",
  "label.rejectedByBiologist": "Rejeté par le biologiste",
  "label.rejectedByTechnician": "Rejeté par le technicien",
  "label.remove": "Retirer",
  "label.replaceWith": "Remplacer par",
  "label.report.byNationalId": "Numéro d'Identification Nationale / Identifiant Santé Unique",
  "label.reporting.range": "Plage de rapport",
  "label.result.order": "Ordre des résultats",
  "label.resultSelectList": "Liste de sélection des résultats",
  "label.routine.Reports": "Rapports routiniers",
  "label.sample.types.activate": "Les types d'échantillons suivants seront activés :",
  "label.sample.types.deactivate": "Les types d'échantillons suivants seront désactivés car ils ne contiennent aucun test :",
  "label.save": "Save",
  "label.saving": "Enregistrement en cours ...",
  "label.search.available.targetest": "Rechercher les tests disponibles",
  "label.search.availablepanel": "Panneau de recherche disponible",
  "label.search.labno.family": "Recherche par numéro de laboratoire ou nom de famille",
  "label.search.patient": "Rechercher un patient",
  "label.select": "Sélectionner",
  "label.select.dateRange": "Sélectionnez la plage de dates pour laquelle vous souhaitez le rapport",
  "label.select.list.options": "Options de la liste de sélection",
  "label.selectTestSectionCatalog": "Sélectionnez la section de test pour voir le catalogue de cette section",
  "label.sex.dependent": "Dépendant du sexe",
  "label.shortCode": "Code court",
  "label.shortCode.error.invalidChars": "Un code court ne peut contenir que des lettres, des chiffres, des tirets et des traits de soulignement.",
  "label.shortCode.error.maxLength": "Le code court doit comporter 10 caractères ou moins.",
  "label.shortCode.error.network": "Impossible de vérifier l'unicité. Veuillez vérifier manuellement.",
  "label.shortCode.error.save": "Erreur lors de l'enregistrement du code court : {error}",
  "label.shortCode.error.startChar": "Le code court doit commencer par une lettre ou un chiffre.",
  "label.shortCode.helper": "10 caractères maximum, alphanumériques, tiret, trait de soulignement",
  "label.shortCode.optional.helper": "Facultatif (un code sera utilisé si la longueur est inférieure ou égale à 10 caractères). Maximum 10 caractères, alphanumériques avec tirets et traits de soulignement.",
  "label.shortCode.required.helper": "Obligatoire lorsque le code dépasse 10 caractères. Maximum 10 caractères, alphanumériques avec tirets et traits de soulignement.",
  "label.shortCode.update.success": "Code court mis à jour avec succès",
  "label.shortCodeRequired": "Un code court est requis pour l'impression des étiquettes. Veuillez le renseigner au préalable dans le formulaire de modification.",
  "label.shortCodeWarning": "Modifier le code court invalidera les étiquettes existantes",
  "label.showChildren": "Afficher les éléments enfants",
  "label.study.Reports": "Rapports d'étude",
  "label.test.activate": "Les tests suivants seront activés :",
  "label.test.add": "Ajouter un test",
  "label.test.batch.cancel.finish": "Cette action est irréversible.",
  "label.test.batch.cancel.start": "Vous avez choisi d'annuler le test",
  "label.test.batch.no.change.finish": "ne seront pas modifiés.",
  "label.test.batch.replace.start": "Les tests suivants",
  "label.test.deactivate": "Les tests suivants seront désactivés :",
  "label.test.display.order": "Ordre d'affichage du test",
  "label.test.order.confirm": "Vérification : Activer/désactiver l'ordonnabilité des tests",
  "label.test.orderable": "Les tests suivants seront disponibles pour la commande depuis le formulaire de commande.",
  "label.test.results": "Résultats des tests",
  "label.test.resultsData": "Données des résultats des tests",
  "label.test.unorderable": "Les tests suivants ne seront pas disponibles à la commande sur le formulaire de commande. Ils ne pourront être commandés qu'en tant que tests réflexes.",
  "label.testActivate": "Activation des tests",
  "label.testName": "Noms des tests",
  "label.text.generate": "générer",
  "label.total.tests": "Analyse au total",
  "label.type": "Type d’étiquette",
  "label.type.order": "Étiquette de demande d'examen",
  "label.type.sample": "Étiquette d'échantillon",
  "label.unit": "Unité",
  "label.user.notestsection": "L'utilisateur actuel n'a pas d'unité de laboratoire assassinée. Veuillez contacter l'administrateur",
  "label.validation.errors": "Erreurs de validation",
  "label.validation.results": "Validation des résultats",
  "label.view": "Visualiser",
  "label.viewtestCatalog": "Catalogue de tests",
  "label.warning": "Avertissement",
  "label.yes": "Yes",
  "labno.alt.prefix.instruction": "Préfixe pour les étiquettes de code-barres pré-imprimées (4 caractères) :",
  "labno.alt.prefix.note": "REMARQUE : Si ce préfixe a déjà été utilisé, la numérotation continuera à partir du dernier numéro généré.",
  "labno.alt.prefix.use": "Utilisez le même format de numéro d'accès et le même pool de numéros disponibles que la génération de commande.",
  "language.select.label": "Français",
  "legend.search.availabletests": "Rechercher parmi les tests disponibles",
  "loading": "Chargement ...",
  "loading.boxes": "Chargement des boîtes...",
  "loading.description": "Chargement...",
  "location.collection.title": "Lieu de prélèvement ",
  "location.environmentalConditions": "Conditions environnementales",
  "location.environmentalConditions.placeholder": "ex. 25°C, temps clair",
  "location.gps.error": "Impossible d’obtenir la localisation",
  "location.gps.getCurrent": "Obtenir la position actuelle",
  "location.gps.getting": "Obtention de la position…",
  "location.gps.latitude": "Latitude GPS",
  "location.gps.longitude": "Longitude GPS",
  "location.gps.notSupported": "La géolocalisation n’est pas prise en charge par votre navigateur",
  "location.gps.permissionDenied": "Autorisation de localisation refusée",
  "location.gps.timeout": "Délai de demande de localisation dépassé",
  "location.gps.unavailable": "Informations de localisation indisponibles",
  "location.helper": "La hiérarchie des localisations (Région / District / Ville-Village) utilise la structure existante du système de localisation. Les profils de workflow environnemental permettent de laisser certaines lignes sans libellé afin de simplifier ou raccourcir les ensembles de lignes selon les besoins de configuration.",
  "location.requesterReference": "Référence du prescripteur",
  "location.requesterReference.placeholder": "ex. Méthode EPA 524.2",
  "location.select.placeholder": "Sélectionner {levelName}…",
  "location.siteDescription": "Description du site de prélèvement ",
  "location.siteDescription.placeholder": "ex. Point de captage d’approvisionnement municipal en eau",
  "locale.active": "Active",
  "locale.add": "Add Language",
  "locale.add.title": "Add Language",
  "locale.code": "Locale Code",
  "locale.code.helper": "e.g., en, fr, es, pt",
  "locale.create.success": "Language created successfully",
  "locale.delete.confirm.message": "Are you sure you want to delete this language? This action cannot be undone.",
  "locale.delete.confirm.title": "Delete Language",
  "locale.delete.error": "Failed to delete language",
  "locale.delete.fallback.error": "Cannot delete the fallback language. Set another language as fallback first.",
  "locale.delete.success": "Language deleted successfully",
  "locale.displayName": "Display Name",
  "locale.displayName.helper": "e.g., English, Français, Español",
  "locale.edit.title": "Edit Language",
  "locale.fallback": "Fallback",
  "locale.fallback.error": "Failed to set fallback language",
  "locale.fallback.success": "Fallback language updated",
  "locale.management.description": "Manage supported languages for metadata translations.",
  "locale.management.title": "Language Management",
  "locale.setFallback": "Set as Fallback",
  "locale.sortOrder": "Sort Order",
  "locale.status": "Status",
  "locale.update.success": "Language updated successfully",
  "log.submitting.aliquot.data": "Soumission des données aliquotes :",
  "log.submitting.aliquot.data2": "Soumission des données aliquotes (JSON) :",
  "logging.management.apply": "Appliquer le niveau de journalisation",
  "logging.management.description": "Modifier le niveau de journalisation du backend à l’exécution. Ceci est utile pour le débogage sans redémarrer le serveur. Les changements prennent effet immédiatement mais ne persistent pas après un redémarrage du serveur.",
  "logging.management.label": "Configuration des journaux",
  "logging.management.level": "Niveau de journalisation",
  "logging.management.logger": "Nom du logger",
  "logging.management.logger.helper": "ex. org.openelisglobal, root",
  "logging.management.success": "Niveau de log défini à {level} pour {logger}",
  "login.account.disabled": "Compte désactivé",
  "login.account.locked": "Compte verrouillé",
  "login.complexity.message": "Le mot de passe doit répondre aux critères suivants :",
  "login.complexity.message.1": "Être d'au moins 7 caractères",
  "login.complexity.message.2": "Doit contenir des lettres majuscules et minuscules ou des chiffres",
  "login.complexity.message.3": "Doit contenir au moins un des caractères suivants : *, $, #, !",
  "login.complexity.message.4": "Ne doit contenir aucun autre caractère",
  "login.complexity.new.message": "Le nouveau mot de passe doit : ",
  "login.complexity.new.message.1": "Ne doit pas être le même que le mot de passe actuel",
  "login.login.": "Répéter le mot de passe",
  "login.login.current.password": "Mot de passe actuel",
  "login.login.first": "Prénom",
  "login.login.last": "Nom",
  "login.login.name": "Nom d'utilisateur",
  "login.login.new.password": "Nouveau mot de passe",
  "login.login.password": "Mot de passe",
  "login.login.repeat.password": "Répéter le mot de passe",
  "login.msg.password": "Mot de passe",
  "login.msg.password.missing": "Votre mot de passe requis",
  "login.msg.username": "Nom d'utilisateur",
  "login.msg.username.missing": "Votre nom d'utilisateur requis",
  "login.notice.message": "Avis : L’accès à ce service est réservé au personnel autorisé. Si vous n’avez pas l’autorisation expresse de l’administrateur, vous devez quitter immédiatement. Cette organisation interdit tout accès non autorisé, divulgation, duplication, modification, détournement, destruction, perte, utilisation abusive ou vol de ses informations.",
  "login.password.expired.date": "Date d'expiration du mot de passe",
  "login.password.expired.date.placeholder": "jj/mm/aaaa",
  "login.redirecting.sso": "Redirection vers l'authentification unique",
  "login.subtitle": "Identifiant",
  "login.timeout": "Délai d'inactivité de l'utilisateur (minutes)",
  "login.timeout.placeholder": "Entrer en minutes",
  "login.title": "Identifiant",
  "lot.barcode": "Code à barres",
  "lot.calculatedExpiry": "Expiration calculée",
  "lot.currentQuantity": "Quantité actuelle",
  "lot.dateOpened": "Date d'ouverture",
  "lot.details.no.transactions": "Aucune transaction enregistrée pour ce lot",
  "lot.details.no.usage": "Aucun historique d'utilisation pour ce lot",
  "lot.details.section.basic": "Informations de base",
  "lot.details.section.dates": "Dates importantes",
  "lot.details.section.quantities": "Quantité",
  "lot.details.section.storage": "Lieu de Rangement",
  "lot.details.section.transactions": "Historique des transactions",
  "lot.details.section.usage": "Historique d'utilisation",
  "lot.details.tab.info": "Information",
  "lot.details.tab.transactions": "Transactions",
  "lot.details.tab.usage": "Historique d'utilisation",
  "lot.details.title": "Détails du lot",
  "lot.details.view": "Voir Détails",
  "lot.expirationDate": "Date d'expiration",
  "lot.form.title.add": "Réception d'un nouveau lot d'inventaire",
  "lot.form.title.edit": "Modifier le lot d'inventaire",
  "lot.initialQuantity": "Quantité initiale",
  "lot.number": "Numéro par lots",
  "lot.qcStatus": "Statuts  QC",
  "lot.receiptDate": "Date de réception",
  "lot.save.error": "Erreur de sauvegarde par Lot ",
  "lot.save.success": "Lot de sauvegardé avec succès",
  "lot.selectItem": "Sélectionner un élément du catalogue",
  "lot.selectLocation": "Sélectionner l'emplacement de stockage",
  "lot.status": "Statuts",
  "lot.storageLocation": "Emplacement de stockage",
  "manage.testing.algorithms.add.reflex.tests": "Gérer les algorithmes de test et les tests réflexes",
  "master.lists.page": "Page des listes principales",
  "master.lists.page.analyzer": "Page de l'automate",
  "master.lists.page.barcode": "Page des codes-barres",
  "master.lists.page.batchtest": "Page des tests par lot",
  "master.lists.page.external.connections": "Page des connexions externes",
  "master.lists.page.field": "Page des champs",
  "master.lists.page.list": "Page de la liste",
  "master.lists.page.menu": "Configuration du menu",
  "master.lists.page.notification": "Page des notifications",
  "master.lists.page.order.entry": "Page de saisie de commande",
  "master.lists.page.org": "Page de l'organisation",
  "master.lists.page.patient": "Page du patient",
  "master.lists.page.printed": "Page des impressions",
  "master.lists.page.provider": "Page du prestataire",
  "master.lists.page.report.result": "Page du rapport de résultats",
  "master.lists.page.result": "Page des résultats",
  "master.lists.page.site": "Page du site",
  "master.lists.page.test.management": "Page de gestion des tests",
  "master.lists.page.user": "Page de l'utilisateur",
  "master.lists.page.work.plan": "Page du plan de travail",
  "menu.accession.validation": "Recherche par ordonnance",
  "menu.accession.validation.range": "Recherche gamme par ordonnance",
  "menu.billing.active": "Menu de facturation Actif",
  "menu.billing.address": "Adresse de facturation",
  "menu.billing.title": "Gestion du menu de facturation",
  "menu.genericSample": "Échantillon générique",
  "menu.genericSample.edit": "Modifier l'échantillon",
  "menu.genericSample.import": "Importer",
  "menu.genericSample.order": "Recevoir un échantillon",
  "menu.global.title": "Titre global",
  "menu.label.filter": "Filtres : ",
  "menu.label.filter.active": "Uniquement actifs",
  "menu.label.filter.admin": "Uniquement administrateurs",
  "menu.label.filter.role": "Par rôles des unités de laboratoire",
  "menu.nonconform.active": "Menu des non-conformités actif",
  "menu.nonconform.title": "Gestion du menu des non-conformités",
  "menu.patient.active": "Menu des patients actif",
  "menu.patient.title": "Gestion du menu des patients",
  "menu.results.range": "Recherche gamme par ordonnance",
  "menu.sidenav.active": "Menu actif",
  "menu.study.active": "Menu d'étude actif",
  "menu.study.title": "Configuration du menu d'étude",
  "menu.validation.date": "Rechercher par date de test",
  "message.method.activation": "Cette méthode ne sera pas active tant qu'au moins un test ne lui aura pas été assigné.",
  "message.noPluginFound": "Aucun plugin trouvé",
  "message.propertiesupdate.success": "Properties updated successfully",
  "method.browse.title": "Section de méthode",
  "method.methodName": "Nom de la méthode",
  "method.modal.add.heading": "Ajouter une nouvelle méthode",
  "modal.add.method": "Ajouter une nouvelle méthode",
  "move.back": "Revenir en arrière",
  "move.to.aliquot": "Déplacement vers Aliquote",
  "new.patient.label": "Nouveau patient",
  "new.program.label": "Nouveau programme",
  "next.action.button": "Suivante",
  "nextLabel.action.button": "Suivant",
  "no.aliquots": "Pas d'aliquotes disponibles",
  "no.analysis.found": "Aucune analyse trouvée",
  "no.data.found": "Aucune donnée trouvée",
  "no.option": "Non",
  "noTestsFound.matching": "Aucun test trouvé correspondant",
  "nonconform.add.new.date": "Ajouter une Nouvelle Date",
  "nonconform.corrective.action": "Action corrective planifiée ou recommandée :",
  "nonconform.corrective.actionType": "Type d'action",
  "nonconform.corrective.comment": "Commentaires",
  "nonconform.corrective.control": "Action préventive corrective planifiée ou recommandée ou contrôles simultanés :",
  "nonconform.corrective.title": "Action Corrective pour Événements Non Conformes",
  "nonconform.date.completed": "Date d'Achèvement",
  "nonconform.date.discussion.nce": "Date de Discussion avec le Personnel ENC",
  "nonconform.date.event": "Date de l'événement",
  "nonconform.description.nce": "Description de l'ENC",
  "nonconform.field.date": "Date ENC",
  "nonconform.field.reporting.data": "Date de Signalement",
  "nonconform.goToNceForm": "Accéder au formulaire de signalement NCE",
  "nonconform.lab.componenet.nce": "Composant du Laboratoire où l'ENC a eu lieu",
  "nonconform.label.highseverity": "9 = gravité très élevée - une action immédiate est requise",
  "nonconform.label.lowseverity": "1 = gravité très faible - aucune action immédiate n'est requise",
  "nonconform.label.prescibernamesite": "Nom du prescripteur et site",
  "nonconform.label.proposed.action": "Action proposée",
  "nonconform.label.reportingunit": "Unité de rapport",
  "nonconform.label.suspected.cause.nce": "Cause suspectée de l'ENC",
  "nonconform.nce.concurrent.control.action": "action de contrôle concurrent",
  "nonconform.nce.number": "Numéro d'ENC",
  "nonconform.nce.preventive.action": "action préventive",
  "nonconform.nce.resolution": "Résolution ENC",
  "nonconform.nce.resolution.description": "Les actions correctives et les contrôles préventifs/concurrents étaient-ils efficaces pour résoudre l'événement non conforme et empêcher sa récurrence?",
  "nonconform.nce.turnaround.time": "Délai d'Exécution",
  "nonconform.order.save.fail": "Échec de l'enregistrement",
  "nonconform.order.save.success": "Enregistrement réussi",
  "nonconform.person.reporting.different": "Nom de la personne signalant l'ENC (si différent)",
  "nonconform.person.responsible": "Personne Responsable",
  "nonconform.report": "Rapport d'événement non conforme (ENC)",
  "nonconform.report.field.date": "Date de rapport",
  "nonconform.severity.score": "Score de Gravité",
  "nonconform.view.comments": "Commentaires",
  "nonconform.view.corrective.action.description": "Description de l'action corrective à entreprendre",
  "nonconform.view.event.date": "Date de l'Événement",
  "nonconform.view.event.description": "Description de l'Événement",
  "nonconform.view.lab.component": "Composant de Laboratoire",
  "nonconform.view.nce.category": "Catégorie d'ÉCN",
  "nonconform.view.nce.likely.occur": "Quelle est la probabilité que l'ÉCN se reproduise ?",
  "nonconform.view.nce.severity": "Gravité",
  "nonconform.view.nce.type": "Type d'ÉCN",
  "nonconform.view.preventive.description": "Le cas échéant, description de l'action préventive ou de contrôle concomitante",
  "nonconform.view.report": "Voir le Nouvel Événement Non Conforme",
  "nonconform.view.reporting.person": "Personne Responsable du Rapport",
  "nonconform.view.severe.consequences": "Quelle est la gravité des conséquences ou de l'impact de l'ÉCN ?",
  "nonconform.view.specimen": "Spécimen(s)",
  "nce.attachment.dropzone": "Glissez-déposez les fichiers ici ou cliquez pour téléverser",
  "nce.attachment.error.maxFiles": " Maximum {maxFiles} fichiers autorisés",
  "nce.attachment.error.size": "La taille du fichier dépasse le maximum de {maxSize}",
  "nce.attachment.error.type": "Type de fichier non autorisé. Types acceptés : {types}",
  "nce.attachment.error.upload": " Erreur lors du téléversement du fichier",
  "nce.attachment.files": "fichiers",
  "nce.attachment.hint": "(Optionnel – max {maxFiles} fichiers, 10 Mo chacun)",
  "nce.attachment.uploading": "Téléversement en cours…",
  "nce.category.administrative": "Administratif",
  "nce.category.analytical": "Analytique",
  "nce.category.postanalytical": "Post-analytique",
  "nce.category.preanalytical": "Pré-analytique",
  "nce.field.attachments": "Pièces jointes",
  "nce.field.notes": "Notes",
  "nce.field.description.placeholder": "Décrivez ce qui s’est passé, quand cela a été détecté et tout contexte pertinent…",
  "nce.field.immediateAction": "Action immédiate entreprise",
  "nce.field.immediateAction.placeholder": "Quelles mesures correctives ont été prises immédiatement…",
  "nce.field.linkedItems": "Échantillons/Résultats associés",
  "nce.field.severity": "Gravité",
  "nce.field.title": "Titre",
  "nce.field.title.placeholder": "Brève description de l’événement… ",
  "nce.severity.critical": "Critique",
  "nce.severity.critical.description": "Risque pour la sécurité des patients, violation réglementaire",
  "nce.severity.major": "Majeur",
  "nce.severity.major.description": "Impact significatif sur la qualité ou les opérations",
  "nce.severity.minor": "Mineur",
  "nce.severity.minor.description": "Impact limité, facilement corrigé",
  "nce.severity.low": "Faible",
  "nce.severity.low.description": "Impact minimal, aucune action corrective requise",
  "nce.status.open": "Ouvert",
  "nce.status.underInvestigation": "En cours d’investigation",
  "nce.status.correctiveAction": "Action corrective",
  "nce.status.closed": "Fermé",
  "nce.tree.empty": "Aucune demande d'examen trouvée. Recherchez par numéro laboratoire pour commencer.",
  "nce.tree.loading": "Chargement des demandes d'examen… ",
  "nce.tree.order": "Demande d'examen",
  "nce.tree.search": "Filtrer par test ou échantillon…",
  "nce.tree.selected": "{sampleCount} échantillons, {resultCount} résultats sélectionnés ",
  "nce.trigger.order_cancellation": " L’annulation de la demande d'examen peut nécessiter une documentation de la non-conformité ",
  "nce.trigger.partial_sample_rejection": "Le rejet partiel d’échantillon nécessite une documentation de la non-conformité",
  "nce.trigger.pathology_rejection": "Le rejet de cas en pathologie peut nécessiter une documentation  de non-conformité",
  "nce.trigger.premature_disposal": "L’élimination prématurée peut nécessiter une documentation de conformité",
  "nce.trigger.qc_invalidation": "L’invalidation du contrôle qualité nécessite une documentation de non-conformité",
  "nce.trigger.referral_rejection": "Le rejet de référencement nécessite une documentation de non-conformité",
  "nce.trigger.result_rejection_no_retest": "Le rejet de résultat sans nouveau test nécessite une documentation de non-conformité",
  "nce.trigger.result_rejection_retest": "Le rejet de résultat avec nouveau test peut nécessiter une documentation de non-conformité",
  "nce.trigger.sample_rejection": " Le rejet d’échantillon nécessite une documentation de non-conformité",
  "nce.trigger.test_cancel_no_results": "L’annulation d’analyse peut nécessiter une documentation de non-conformité ",
  "nce.trigger.test_cancel_with_results": "L’annulation d’analyse avec résultats nécessite une documentation de non-conformité",
  "nce.type.calibration_failure": "Échec de la calibration ",
  "nce.type.communication_failure": "Echec de la communication",
  "nce.type.contamination": "Contamination",
  "nce.type.documentation_error": "Erreur de documentation",
  "nce.type.equipment_malfunction": "Dysfonctionnement de l’équipement",
  "nce.type.labeling_error": "Erreur d’étiquetage",
  "nce.type.patient_id_mismatch": "Discordance d’identifiant patient",
  "nce.type.policy_violation": "Violation de procédure",
  "nce.type.procedure_deviation": "Écart de procédure",
  "nce.type.qc_failure": "Échec du contrôle qualité",
  "nce.type.reagent_issue": "Problème de réactif ",
  "nce.type.report_delay": "Retard de rapport",
  "nce.type.report_distribution_error": "Erreur de distribution du rapport",
  "nce.type.requisition_incomplete": "Demande incomplète",
  "nce.type.resource_shortage": "Manque de ressources",
  "nce.type.result_interpretation_error": "Erreur d’interprétation des résultats",
  "nce.type.sample_collection_error": "Erreur de prélèvement de l'échantillon",
  "nce.type.staff_competency_issue": " Problème de compétence du personnel ",
  "nce.type.storage_error": "Erreur de stockage",
  "nce.type.system_error": "Erreur système",
  "nce.type.training_gap": "Manque de formation",
  "nce.type.transcription_error": "Erreur de transcription",
  "nce.type.transport_issue": "Problème de transport",
  "nce.type.request_form_error": "Erreur sur le formulaire de demande",
  "nce.type.equipment_failure": "Défaillance de l’équipement",
  "nce.type.procedure_error": "Erreur de procédure",
  "nce.type.calibration_error": "Erreur de calibration",
  "nce.type.cross_contamination": "Contamination croisée",
  "nce.type.result_transcription_error": "Erreur de transcription des résultats",
  "nce.type.report_delivery_error": "Erreur de livraison du rapport",
  "nce.type.critical_value_not_reported": "Valeur critique non signalée",
  "nce.type.delayed_result": "Résultat retardé",
  "nce.type.result_amendment": "Modification du résultat",
  "nce.type.training_issue": "Problème de formation",
  "nce.button.createNce": "Créer une non-conformité",
  "nce.button.skip": "Ignorer",
  "nce.creating": "Création de la non-conformité",
  "nce.description.placeholder": "Décrivez la non-conformité",
  "nce.error.create.failed": "Échec de la création de la non-conformité",
  "nce.error.severity.required": "La gravité est requise",
  "nce.trigger.mandatory.message": "Vous devez créer un NCE avant de poursuivre cette action.",
  "nce.trigger.mandatory.title": "La non-conformité est requise",
  "nce.trigger.order_cancellation.message": "L’annulation de la prescription peut nécessiter la documentation d’un événement non conforme.",
  "nce.trigger.order_cancellation.title": "Annulation de la prescription – Non-Conformité",
  "nce.trigger.partial_sample_rejection.message": "Le rejet partiel d’échantillon nécessite la documentation d’un événement non conforme.",
  "nce.trigger.partial_sample_rejection.title": "Rejet partiel d’échantillon – Non-Conformité requis ",
  "nce.trigger.pathology_rejection.message": "Le rejet de cas en pathologie peut nécessiter la documentation d’un événement non conforme.",
  "nce.trigger.pathology_rejection.title": "Rejet en pathologie – Non-Conformité",
  "nce.trigger.premature_disposal.message": "L’élimination prématurée peut nécessiter la documentation d’un événement non conforme.",
  "nce.trigger.premature_disposal.title": "Élimination prématurée – Non-Conformité",
  "nce.trigger.qc_invalidation.message": " L’invalidation du contrôle qualité nécessite la documentation d’un événement non conforme.",
  "nce.trigger.qc_invalidation.title": "Invalidation Contrôle Qualité – Non-Conformité requise",
  "nce.trigger.referral_rejection.message": "Le rejet de référencement nécessite la documentation d’un événement non conforme.",
  "nce.trigger.referral_rejection.title": "Rejet de référencement – Non-Conformité requise",
  "nce.trigger.result_rejection_no_retest.message": "Le rejet de résultat sans nouveau test nécessite la documentation d’un événement non conforme.",
  "nce.trigger.result_rejection_no_retest.title": "Rejet de résultat – Non-Conformité requise",
  "nce.trigger.result_rejection_retest.message": "Le rejet de résultat avec nouveau test peut nécessiter la documentation d’un événement non conforme. ",
  "nce.trigger.result_rejection_retest.title": "Rejet de résultat – Non-Conformité",
  "nce.trigger.sample_rejection.message": "Le rejet d’échantillon nécessite la documentation d’un événement non conforme.",
  "nce.trigger.sample_rejection.title": "Rejet d’échantillon – Non-Conformité requise",
  "nce.trigger.test_cancel_no_results.message": " L’annulation d’analyse peut nécessiter la documentation d’un événement non conforme.",
  "nce.trigger.test_cancel_no_results.title": "Annulation d’analyse – Non-conformité",
  "nce.trigger.test_cancel_with_results.message": "L’annulation d’analyse avec résultats existants nécessite la documentation d’une non-conformité.",
  "nce.trigger.test_cancel_with_results.title": "Annulation d’analyse – Non-conformité requise",
  "nce.admin.trigger.config.title": "Configuration des déclencheurs de non-conformité ",
  "nce.admin.trigger.config.description": "Configurer les cas où les non-conformités sont créées automatiquement ou demandées.",
  "nce.admin.trigger.behaviors.title": "Comportements de déclenchement",
  "nce.admin.rejection.mappings.title": "Mappage des motifs de rejet ",
  "nce.admin.rejection.mappings.description": "Associer les motifs de rejet aux catégories de non-conformité pour un remplissage automatique.",
  "nce.trigger.behavior.mandatory": "Obligatoire",
  "nce.trigger.behavior.prompted": "Avec invite",
  "nce.trigger.behavior.disabled": "Désactivé",
  "nce.trigger.column.type": "Type de déclencheur ",
  "nce.trigger.column.description": "Description",
  "nce.trigger.column.behavior": "Comportement",
  "nce.trigger.column.active": "Actif",
  "nce.trigger.type.sampleRejection": "Rejet d'échantillon",
  "nce.trigger.type.resultRejection": "Rejet de résultat",
  "nce.trigger.type.qaEvent": "Événement Assurance Qualité",
  "nce.trigger.type.manual": "Manuel",
  "nce.trigger.update.success": "Configuration des déclencheurs mise à jour",
  "nce.trigger.update.error": "Échec de la mise à jour de la configuration des déclencheurs",
  "nce.mapping.add": "Ajouter un mappage",
  "nce.mapping.edit": "Modifier le mappage",
  "nce.mapping.column.rejectionReason": " Motif de rejet ",
  "nce.mapping.column.category": "Catégorie de non-conformité",
  "nce.mapping.column.type": "Type de non-conformité ",
  "nce.mapping.column.severity": "Gravité par défaut ",
  "nce.mapping.column.active": "Actif",
  "nce.mapping.noData": "Pas de mapping de rejet configuré",
  "nce.mapping.validation.error": "Le motif de rejet et la catégorie sont requis",
  "nce.mapping.save.success": "Mappage enregistré avec succès",
  "nce.mapping.active": "Actif",
  "nce.field.category": "Catégorie",
  "nce.field.type": "Type",
  "nce.select.category": "Choisir une catégorie",
  "nce.select.type": "Sélectionner un type",
  "nce.error.dateOfEvent.required": "La date de l’événement est requise",
  "nce.error.reportingUnit.required": "L’unité de déclaration est requise",
  "nce.error.description.required": "La description est requise",
  "nce.error.suspectedCauses.required": " Les causes suspectées sont requises",
  "nce.error.proposedAction.required": "L’action proposée est requise",
  "nce.error.category.required": "La catégorie est requise ",
  "nce.attachment.saveFirst": "Enregistrez la non-conformité pour activer les pièces jointes ",
  "nce.attachment.error.noEvent": "Veuillez d’abord enregistrer la non-conformité avant de téléverser des pièces jointes ",
  "nce.attachment.download": "Télécharger",
  "nce.attachment.delete": "Supprimer",
  "sidenav.label.admin.nceTriggerConfig": "Configuration des déclencheurs",
  "sidenav.label.admin.nceCategoryType": "Catégories et types ",
  "sidenav.label.admin.nceConfig": "Configuration des non-conformités",
  "nce.admin.categorytype.title": "Configuration des catégories et types de non-conformités ",
  "nce.admin.categorytype.description": "Gérer les catégories et types disponibles pour les non-conformités",
  "nce.admin.tab.categories": "Catégories",
  "nce.admin.tab.types": "Types",
  "nce.admin.category.add": "Ajouter une catégorie ",
  "nce.admin.category.edit": "Modifier la catégorie ",
  "nce.admin.category.name.required": "Le nom de la catégorie est requis",
  "nce.admin.category.save.success": "Catégorie enregistrée avec succès ",
  "nce.admin.category.save.error": "Échec de l’enregistrement de la catégorie",
  "nce.admin.type.add": "Ajouter un type",
  "nce.admin.type.edit": "Modifier le type",
  "nce.admin.type.validation.error": "Le nom du type et la catégorie sont requis",
  "nce.admin.type.save.success": "Type enregistré avec succès",
  "nce.admin.type.save.error": "Échec de l’enregistrement du type",
  "nce.admin.column.name": "Nom",
  "nce.admin.column.displayKey": "Clé d’affichage",
  "nce.admin.column.typesCount": "Nombre de types",
  "nce.admin.column.category": "Catégorie",
  "nce.admin.column.actions": "Actions",
  "nce.admin.field.name": "Nom",
  "nce.admin.field.displayKey": " Clé d’affichage (pour i18n)",
  "nce.admin.field.displayKey.helper": "Optionnel. Utilisé pour les traductions.",
  "nce.admin.field.category": "Catégorie",
  "nce.admin.delete.confirm.title": " Confirmer la suppression",
  "nce.admin.delete.confirm.message": "Êtes-vous sûr de vouloir supprimer « {name} » ? Cette action est irréversible.",
  "nce.admin.delete.success": "Supprimé avec succès",
  "nce.inline.title": "Signaler une non-conformité",
  "nce.inline.context": "CONTEXTE (rempli automatiquement)",
  "nce.dashboard.title": "Toutes les non-conformités ",
  "nce.dashboard.subtitle": "Toutes les non-conformités ouvertes du laboratoire",
  "nce.button.reportNce": "Signaler une non-conformité",
  "nce.search.placeholder": "Rechercher des non-conformités… ",
  "nce.filter.allStatus": "Tous les statuts",
  "nce.filter.allCategories": "Toutes les catégories",
  "nce.filter.allSeverities": "Toutes les gravités",
  "nce.filter.clearAll": "Tout effacer",
  "nce.summary.critical": "Critique",
  "nce.summary.major": "Majeur",
  "nce.summary.minor": "Mineur",
  "nce.summary.overdue": "En retard ",
  "nce.tag.overdue": "En retard ",
  "nce.tab.eventDetails": "Détails de l’événement ",
  "nce.tab.investigation": "Investigation",
  "nce.tab.capa": "Actions correctives et préventives",
  "nce.tab.history": "Historique",
  "nce.field.suspectedCauses": " Causes suspectées",
  "nce.field.proposedAction": "Action proposée",
  "nce.field.trigger": "Déclencheur",
  "nce.capa.noItems": "Aucune action corrective/préventive enregistrée pour le moment.",
  "nce.history.noItems": "Aucun historique disponible.",
  "nce.history.system": "Système",
  "nce.action.acknowledge": "Accuser réception ",
  "nce.action.assignTo": "Assigner à",
  "nce.action.addNote": "Ajouter une note",
  "nce.link.duplicate.warning": "Ces échantillons sont déjà liés à cette non-conformité",
  "nce.list.empty": "Aucune non-conformité ne correspond à vos critères.",
  "nce.modal.addNote": "Ajouter une note",
  "nce.modal.addNoteDescription": "Ajouter une note à la non-conformité {nceNumber} ",
  "nce.modal.notePlaceholder": "Saisissez votre note…",
  "nce.modal.assign": "Assigner la non-conformité",
  "nce.modal.assignDescription": "Assigner la non-conformité {nceNumber} à un utilisateur",
  "nce.modal.selectUser": "Sélectionner un utilisateur",
  "nce.modal.searchUser": "Rechercher un utilisateur…",
  "nce.assign.selectUser": "Veuillez sélectionner un utilisateur à assigner ",
  "nce.assign.success": "Non-conformité assignée avec succès",
  "nce.assign.error": " Échec de l’assignation de la non-conformité",
  "nce.acknowledge.success": "Non-conformité accusée réception avec succès",
  "nce.acknowledge.error": "Échec de l’accusé de réception de la non-conformité ",
  "nce.note.empty": "Veuillez saisir une note",
  "nce.note.success": "Note ajoutée avec succès",
  "nce.note.error": " Échec de l’ajout de la note",
  "nce.attachment.downloadError": "Échec du téléchargement de la pièce jointe",
  "nce.attachment.viewError": "Échec de l’affichage de la pièce jointe",
  "not.available": "Pas disponible",
  "not.specified": "Non spécifié",
  "notAuthenticated": "Non authentifié",
  "notebook.attachments.title": "Pièces jointes",
  "notebook.attachments.uploadPrompt": "Cliquez pour télécharger des fichiers",
  "notebook.auditTrail.action.archived": "Archivé",
  "notebook.auditTrail.action.created": "Créé",
  "notebook.auditTrail.action.finalized": "Finalisé",
  "notebook.auditTrail.action.locked": "verouillé",
  "notebook.auditTrail.action.submitted": "Soumis",
  "notebook.auditTrail.action.updated": "Mis à Jour ",
  "notebook.auditTrail.comingSoon": "La fonctionnalité de journalisation des audits sera bientôt disponible.",
  "notebook.auditTrail.none.subtitle": "Aucun enregistrement de suivi n’a été trouvé pour ce cahier.",
  "notebook.auditTrail.none.title": "Aucune piste d'audit disponible",
  "notebook.auditTrail.title": "Formulaire d'Audit",
  "notebook.button.edit": "Modifier",
  "notebook.button.editResults": "Afficher les résultats",
  "notebook.button.enterResults": "Saisie des résultats",
  "notebook.button.newLabNotebook": "Projet",
  "notebook.button.view": "Afficher",
  "notebook.comments.add.button": "Ajouter un commentaire",
  "notebook.comments.add.label": "Ajouter un commentaire",
  "notebook.comments.none.subtitle": "Aucun commentaire n'a encore été ajouté.",
  "notebook.comments.none.title": "Pas de commentaires",
  "notebook.comments.title": "Commentaires",
  "notebook.error.notAssigned": "Vous n’êtes pas affecté à ce projet",
  "notebook.heading.allEntries": "Toutes les saisies",
  "notebook.heading.notebooks": "Les Projets",
  "notebook.icon.edit": "Modifier",
  "notebook.instruments.title": "Instruments",
  "notebook.label.addpage": "Ajouter un page",
  "notebook.label.author": "Auteur",
  "notebook.label.basicinfo": "Informations de base",
  "notebook.label.content": "Contenu principal",
  "notebook.label.dashboard": "Tableau de bord des notes",
  "notebook.label.drafts": "Brouillons",
  "notebook.label.entryFiles": "Fichiers d’entrée",
  "notebook.label.entryTags": "Saisie les étiquettes ",
  "notebook.label.experimentDoc": "Documentation relative à l'expérience",
  "notebook.label.experimentType": "Type d'expérience",
  "notebook.label.filter.types": "les types d'expérience",
  "notebook.label.finalized": "Terminé cette semaine",
  "notebook.label.formEntry": "Saisie du formulaire de note",
  "notebook.label.objective": "Objectif",
  "notebook.label.pages": "Pages des flux de données",
  "notebook.label.pending": "En attente de révision",
  "notebook.label.project": "Projet",
  "notebook.label.project.title": "Nom du Projet",
  "notebook.label.projectFiles": "Fichiers du projet",
  "notebook.label.projectTags": "Libelle du projet ",
  "notebook.label.protocol": "Identifiant du protocole",
  "notebook.label.questionnaire": "Questionnaire",
  "notebook.label.sampleManagement": "Gestion des échantillons",
  "notebook.label.status": "Statut",
  "notebook.label.technician": "Nom du technicien",
  "notebook.label.title": "Saisie le Titre",
  "notebook.label.total": "Total saisie ",
  "notebook.page.completed": "Terminé",
  "notebook.page.content": "Contenu:",
  "notebook.page.instructions": "Instructions",
  "notebook.page.markComplete": "Marquer comme terminé",
  "notebook.page.modal.add.errorRequired": "Le titre et le contenu sont obligatoires.",
  "notebook.page.modal.add.title": "Ajouter une nouvelle page",
  "notebook.page.modal.content.label": "Contenu",
  "notebook.page.modal.edit.title": "Modifier la page",
  "notebook.page.modal.instructions.label": "Instructions",
  "notebook.page.modal.title.label": "Titre",
  "notebook.page.title": "Carnet de notes",
  "notebook.pages.none.subtitle": "Cliquez pour ajouter des pages",
  "notebook.pages.none.title": "Aucune page ajoutée",
  "notebook.project.definition.form.title": "Formulaire pour définir le projet",
  "notebook.project.entry.form.title": "Formulaire de saisie du projet",
  "notebook.results.modal.title": "Résultats par numéro de laboratoire",
  "notebook.results.noAccession": "Pas de numéro de laboratoire disponible pour cet échantillon",
  "notebook.results.none.subtitle": "Aucun résultat trouvé pour le numéro d'accès fourni.",
  "notebook.results.none.title": "Aucun résultat trouvé",
  "notebook.results.title": "Résultats",
  "notebook.sample.result.dateCreated": "Date de création",
  "notebook.samples.available": "Échantillons disponibles",
  "notebook.samples.none.subtitle": "Recherche d'échantillons par patient ou par numéro de laboratoire",
  "notebook.samples.none.subtitle.selected": "Cliquez pour ajouter des échantillons",
  "notebook.samples.none.title": "Aucun échantillon disponible",
  "notebook.samples.none.title.selected": "Aucun échantillon sélectionné",
  "notebook.samples.resultsRecorded": "Résultats enregistrés :",
  "notebook.samples.selected": "Échantillons sélectionnés",
  "notebook.search.byAccession": "Recherche par numéro de laboratoire ",
  "notebook.search.byPatient": "Recherche par Patient",
  "notebook.select.label": "Sélectionnez le bloc-notes",
  "notebook.status.archived": "Saisie des archives",
  "notebook.status.assignment.title": "Statut et affectation",
  "notebook.status.draft": "Enregistrer le brouillon",
  "notebook.status.finalized": "Sauvegarder la saisie ",
  "notebook.status.locked": "verrouiller la saisie ",
  "notebook.status.metadata.title": "Statut et métadonnées",
  "notebook.status.submitted": "Soumis pour revue",
  "notebook.tab.attachments": "Pièces jointes",
  "notebook.tab.auditTrail": "Audit",
  "notebook.tab.comments": "Commentaires",
  "notebook.tab.content": "Contenu",
  "notebook.tab.entryDetails": "Saisie les détails ",
  "notebook.tab.metadata": "Données volumineuses ",
  "notebook.tab.results": "Résultats",
  "notebook.tab.samples": "Échantillons",
  "notebook.tab.workflow": "Plan de travail",
  "notebook.table.header.entries": "Saisies",
  "notebook.tag.placeholder": "Saisir des étiquettes",
  "notebook.tags.add": "Ajouter une balise",
  "notebook.tags.modal.add.errorRequired": "l'étiquette est requise.",
  "notebook.tags.modal.add.label": "Etiquette ",
  "notebook.tags.modal.add.title": "Ajouter une nouvelle étiquette ",
  "notebook.tags.title": "Etiquettes ",
  "notebook.validation.content.required": "Contenu principal obligatoire",
  "notebook.validation.objective.required": "L'objectif est obligatoire",
  "notebook.validation.project.required": "Projet obligatoire",
  "notebook.validation.protocol.required": "Identifiant du protocole obligatoire",
  "notebook.validation.title.required": "Titre obligatoire",
  "notebook.validation.type.required": "Le type d'expérience est requis.",
  "notification.error": "Error",
  "notification.info": "Information",
  "notification.invalid.confirm.password": "Votre mot de passe saisi n'est pas identique au mot de passe ci-dessus.",
  "notification.invalid.loginName": "Veuillez saisir des valeurs alphanumériques sans espaces uniquement.",
  "notification.invalid.name": "Veuillez saisir uniquement des caractères alphanumériques.",
  "notification.invalid.password": "Veuillez entrer le mot de passe selon les instructions.",
  "notification.login.generic.error": "Erreur de connexion générique",
  "notification.login.syntax.error": "Erreur de syntaxe dans le nom d'utilisateur ou le mot de passe",
  "notification.organization.post.delete.success": "L'organisation a été désactivée avec succès.",
  "notification.organization.post.internetAddress": "Entrez une URL d'organisation valide.",
  "notification.organization.post.save.success": "Informations sur l'organisation ajoutées avec succès.",
  "notification.organization.post.success": "Informations sur l'organisation mises à jour avec succès.",
  "notification.password.change.fail": "Échec du changement de mot de passe",
  "notification.password.change.success": "Mot de passe modifié avec succès",
  "notification.response.syntax.error": "Erreur de syntaxe de la réponse",
  "notification.slideover.button.hideread": "Masquer les lus",
  "notification.slideover.button.markallasread": "Marquer tout comme lu",
  "notification.slideover.button.markasread": "Marquer comme lu",
  "notification.slideover.button.reload": "Recharger",
  "notification.slideover.button.showread": "Afficher les lus",
  "notification.slideover.button.subscribe": "S'abonner sur cet appareil",
  "notification.slideover.button.subscribe.fail": "Échec de l'abonnement",
  "notification.slideover.button.subscribe.success": "Abonnement réussi",
  "notification.slideover.button.unsubscribe": "Se désabonner",
  "notification.slideover.button.unsubscribe.fail": "Échec de l'annulation de l'abonnement",
  "notification.slideover.button.unsubscribe.success": "Désabonnement réussi",
  "notification.slideover.empty.header": "Vous êtes à jour",
  "notification.sliderover.empty.message": "Vous n'avez pas de notifications pour le moment.",
  "notification.title": "Message de notification",
  "notification.user.post.delete.success": "Utilisateur désactivé avec succès.",
  "notification.user.post.save.success": "Informations utilisateur ajoutées avec succès.",
  "notify.error": "Utilisateur et message sont requis",
  "notify.main.title": "Notifier l'utilisateur",
  "notify.message": "Message",
  "notify.user.by": "Utilisateur à notifier",
  "notify.user.success.notification": "Notification envoyée avec succès",
  "of": "de",
  "openreports.activity.title": "Rapports d'activité",
  "openreports.aggregate.title": "Rapports agrégés",
  "openreports.all.test.summary.title": "Résumé du rapport de test",
  "openreports.all.tests.aggregate": "Résumé de tous les tests",
  "openreports.hiv.aggregate": "Résumé du Test VIH",
  "openreports.management.title": "Rapports de gestion",
  "openreports.mgt.nonconformity.date": "Rapport des non-conformités par date",
  "openreports.mgt.nonconformity.section": "Rapport de non-conformité par unité et raison",
  "openreports.mgt.rejection": "Rapport de rejet",
  "openreports.patient.EID.version1": "EID Version 1",
  "openreports.patient.EID.version2": "EID Version 2",
  "openreports.patient.VL.version1": "VL Version Nationale",
  "openreports.patientTestStatus": "Rapport d'état du patient",
  "openreports.patientreports.title": "Résultats du patient",
  "openreports.stat.aggregate": "Rapport statistique",
  "order.accept": "Accepter",
  "order.accept.error": "Échec de l’acceptation de la prescription",
  "order.additionalInfo": "Informations complémentaires",
  "order.additionalInfo.helper": "Notes facultatives concernant cette prescription ",
  "order.clinicalInfo": "Informations cliniques",
  "order.continue": "Continuer",
  "order.current.time": "Heure actuelle (hh:mm)",
  "order.dashboard.empty": "Aucune demande d'examen trouvée ",
  "order.dashboard.title": " Tableau de bord des demandes d'examen",
  "order.department.label": "Service/département/unité:",
  "order.diagnosis.placeholder": "Saisir le diagnostic ou les notes cliniques",
  "order.entry.setup": "Configuration de saisie de commande par lot",
  "order.external": "Externe",
  "order.facility": "Établissement",
  "order.filter.priority": "Filtrer par priorité",
  "order.filter.status": "Filtrer par statut",
  "order.fixIssue": "Corriger le problème ",
  "order.form.label": "Formulaire :",
  "order.form.select": "Sélectionner le formulaire",
  "order.generate.barcode": "Générer un code-barres",
  "order.generate.barcode.history": "Historique des codes-barres générés",
  "order.if.other.label": "si Autre préciser:",
  "order.invalid.requester.name.label": "nom du prescripteur invalide",
  "order.invalid.site.name": "Nom de site invalide",
  "order.labNumber": "Numéro laboratoire",
  "order.labNumber.generate": "Générer le numéro laboratoire",
  "order.labNumber.helper": "Identifiant unique pour cette demande d'examen",
  "order.attachment.action.delete": "Supprimer la pièce jointe",
  "order.attachment.action.download": "Télécharger la pièce jointe",
  "order.attachment.action.view": "Voir la pièce jointe",
  "order.attachment.column.actions": "Actions",
  "order.attachment.column.fileName": "Nom du fichier",
  "order.attachment.column.fileSize": "Taille",
  "order.attachment.column.fileType": "Type",
  "order.attachment.column.uploadedAt": "Téléversé le",
  "order.attachment.delete.confirm.body": "Êtes-vous sûr de vouloir supprimer « {fileName} » ? Cette action est irréversible.",
  "order.attachment.delete.confirm.title": "Supprimer la pièce jointe",
  "order.attachment.delete.failed": "Impossible de supprimer la pièce jointe. Veuillez réessayer.",
  "order.attachment.dropzone": "Glissez-déposez les fichiers ici ou cliquez pour parcourir",
  "order.attachment.empty": "Aucune pièce jointe pour le moment",
  "order.attachment.error.maxFiles": "ous pouvez joindre au maximum {maxFiles} fichiers.",
  "order.attachment.error.size": "Chaque fichier doit faire {maxSize} ou moins.",
  "order.attachment.error.type": "Types de fichiers autorisés : {types}",
  "order.attachment.heading": "Pièces jointes",
  "order.attachment.hint": "Optionnel. Jusqu’à {maxFiles} fichiers, 10 Mo chacun. Formats autorisés : PDF, JPG, PNG, TIFF.",
  "order.attachment.upload.failed": "Une ou plusieurs pièces jointes n’ont pas pu être téléversées.",
  "order.labNumber.placeholder": "Saisir ou générer le numéro laboratoire",
  "order.label.add": "Ajouter Bulletin d'analyse",
  "order.label.modify": "Modifier le bulletin d'analyse",
  "order.legend.EDTATube": "Tube EDTA",
  "order.legend.commonFields": "Champs communs",
  "order.legend.configureBarcode": "Configurer la saisie du code-barres",
  "order.legend.dryBloodSpot": "Tache de sang sec",
  "order.legend.dryTube": "Tube sec",
  "order.legend.facility": "Établissement",
  "order.legend.onDemand": "À la demande",
  "order.legend.optionalFields": "Champs optionnels",
  "order.legend.patient": "Patient",
  "order.legend.preDemand": "Demande anticipée",
  "order.legend.sample": "Échantillon",
  "order.legend.selectMethod": "Sélectionner la méthode",
  "order.legend.siteName": "Nom du site",
  "order.legend.specimen.collected": "Spécimen collecté",
  "order.legend.tests": "Tests",
  "order.legend.viralLoadTest": "Test de charge virale",
  "order.lastUpdated": "Dernière mise à jour",
  "order.load.error": "Échec du chargement de la demande d'examen",
  "order.location": "Localisation",
  "order.new": "Nouvelle prescription",
  "order.payment.status.label": "Statut de paiement du patient:",
  "order.paymentStatus": "Statut du paiement",
  "order.previousLabNumber": "Numéro laboratoire précédent",
  "order.previousLabNumber.placeholder": "Saisir le numéro laboratoire précédent si applicable",
  "order.printLabels": "Imprimer les étiquettes ",
  "order.printLabels.info": " Imprimer les codes-barres pour cette demande d'examen ",
  "order.priority": "Priorité",
  "order.progress": "Progrès",
  "order.provisionalDiagnosis": "Diagnostic provisoire",
  "order.received.time": "Heure à laquelle la commande a été reçue",
  "order.reception.time": "Heure de réception (hh:mm) :",
  "order.remember.site.and.requester.label": "Se souvenir du site et du prescripteur",
  "order.readonly.message": "Cette demande d'examen est en mode lecture seule",
  "order.requester": "Prescripteur",
  "order.requester.email.label": "Courriel du prescripteur:",
  "order.requester.fax.label": "Numéro de fax du prescripteur:",
  "order.requester.firstName.label": "Prénom du prescripteur:",
  "order.requester.lastName.label": "Nom du prescripteur:",
  "order.requester.phone.label": "Téléphone du prescripteur:",
  "order.requester.provisionalDiagnosis.label": "Renseignement clinique:",
  "order.result.reporting.heading": "RAPPORT DE RÉSULTATS",
  "order.sampleCategory": "Catégorie d’échantillon ",
  "order.sampleCategory.helper": "Sélectionner la catégorie d’échantillon à prélever ",
  "order.sampling.performed.label": "Échantillonnage effectué pour analyse:",
  "order.search.requester.label": "Prescripteur",
  "order.saveStatus.error": "Échec de l’enregistrement",
  "order.saveStatus.saved": "Enregistré",
  "order.saveStatus.saving": " Enregistrement en cours…",
  "order.saveStatus.unsaved": "Modifications non enregistrées",
  "order.save.incomplete": "Veuillez ajouter un patient (ou un site de prélèvement) et au moins un type d’échantillon avant d’enregistrer. ",
  "order.saved.draft": "Brouillon enregistré ",
  "order.search.placeholder": "Rechercher des demandes d'examen … ",
  "order.search.site.name": "Site de prélèvement",
  "order.send.toAnalyzer": "Send to analyzer",
  "order.send.modal.title": "Send order to analyzer",
  "order.send.modal.confirm": "Send",
  "order.send.modal.cancel": "Cancel",
  "order.send.modal.analyzerLabel": "Target analyzer",
  "order.send.modal.accession": "Order accession: {accession}",
  "order.send.modal.noAnalyzers": "No analyzers are configured for LIS-initiated dispatch.",
  "order.send.success": "Order dispatched",
  "order.send.error": "Failed to dispatch order",
  "order.send.unknownError": "Unknown bridge error",
  "order.send.missingAccession": "Order has no accession number to correlate the result.",
  "order.site.name": "Nom du site:",
  "order.step.collect": "Prélever",
  "order.step.enter": "Saisir la demande d'examen",
  "order.step.label": "Étiqueter et stocker",
  "order.step.patient.info": "Informations sur les patients",
  "order.step.program.selection": "Sélection du programme",
  "order.step.qa": "Revue Assurance Qualité ",
  "order.start.new": "Démarrer une nouvelle demande",
  "order.submit.labNumber": "Soumettre avec numéro laboratoire",
  "order.submit.success": "Demande d’examen soumise avec succès",
  "order.submitted.success.msg": "La demande d’examen a été soumise avec succès",
  "order.summary.accessionNumber": "Numéro d’enregistrement",
  "order.summary.collectionDate": "Date de prélèvement",
  "order.summary.patientName": "Nom du patient",
  "order.summary.sampleType": "Type d’échantillon ",
  "order.summary.title": "Résumé de la prescription",
  "order.test.request.heading": "Requête de test",
  "order.title": "COMMANDE",
  "ordertests.title": "Commander des tests",
  "organization.add.placeholder": "Valeurs alphanumériques",
  "organization.add.placeholder.active": "Oui ou Non",
  "organization.add.placeholder.internetAddress": "https://orgname.com",
  "organization.add.placeholder.parent": "Ajouter un parent de l'organisation",
  "organization.add.title": "Ajouter une organisation",
  "organization.city": "Ville",
  "organization.clia.number": "Numéro de CLIA",
  "organization.edit.title": "Modifier l'organisation",
  "organization.internetaddress": "Adresse Internet",
  "organization.isActive": "Actif",
  "organization.main.title": "Gestion des organisations",
  "organization.next": "Page suivante",
  "organization.organizationName": "Nom de l'organisation",
  "organization.parent": "Organisation parent",
  "organization.previous": "Page précédente",
  "organization.search.byorgname": "Rechercher par nom d'organisation",
  "organization.search.parent.name": "Noms des organisations parentes",
  "organization.search.placeHolder": "Rechercher par nom d'organisation...",
  "organization.select": "Sélectionner",
  "organization.short.CI": "Préfixe de l'organisation",
  "organization.streetAddress": "Adresse",
  "organization.type.CI": "Type d'organisation",
  "organization.type.CI.description": "Description du type d'organisation",
  "organization.type.CI.name": "Nom du type d'organisation",
  "organization.type.CI.select": "Sélectionner le type d'organisation",
  "otherMalignant.placeholder": "Autre malin",
  "page.breadcrumb.separator": " > ",
  "page.title.back": "Back",
  "pagination.backward": "Page précédente",
  "pagination.forward": "Page Suivante",
  "pagination.item": "{min}-{max}",
  "pagination.item-range": "{min}-{max} de {total} entrées",
  "pagination.items-per-page": "Entrées par page",
  "pagination.itemsPerPage": "Items per page:",
  "pagination.nextPage": "Next page",
  "pagination.page": "page {page}",
  "pagination.page-number": "Numéro de page",
  "pagination.page-range": "de {total} {total, plural, one {page} other {pages}}",
  "pagination.previousPage": "Previous page",
  "panel.existing": "Panneaux existants",
  "panel.existing.inactive": "Panneaux inactifs (Attribuer des tests pour activer)",
  "panel.new": "Nouveau panneau",
  "panel.panelName": "Nom du panel",
  "pathology.label.addblock": "Ajouter un Bloc(s)",
  "pathology.label.addslide": "Ajouter une Lame(s)",
  "pathology.label.block": "Bloc",
  "pathology.label.block.add.number": "Ajouter un numéro de bloc",
  "pathology.label.block.number": "Numéro du Bloc",
  "pathology.label.blocks": "Blocs",
  "pathology.label.casesInProgress": "Cas en cours",
  "pathology.label.complete": "Terminé",
  "pathology.label.conclusion": "Conclusion",
  "pathology.label.dashboard": "Tableau de Bord de la Pathologie",
  "pathology.label.grossexam": "Examen Macroscopique",
  "pathology.label.location": "Emplacement",
  "pathology.label.microexam": "Examen Microscopique",
  "pathology.label.printlabel": "Imprimer l'Étiquette",
  "pathology.label.refer": "Référer à l'Immuno-Histochimie",
  "pathology.label.release": "Prêt pour la Publication",
  "pathology.label.report": "Rapport de Pathologie",
  "pathology.label.request": "Demandes",
  "pathology.label.requests": "Demandes pathologiques supplémentaires",
  "pathology.label.review": "En attente de révision pathologique",
  "pathology.label.slide": "Lame",
  "pathology.label.slide.add.number": "Ajouter un numéro de lame",
  "pathology.label.slide.number": "numéro de diapositive",
  "pathology.label.slides": "Lames",
  "pathology.label.stage": "Stade",
  "pathology.label.techniques": "Techniques Utilisées",
  "pathology.label.textconclusion": "Conclusion Textuelle",
  "pathology.label.title": "Pathologie",
  "pathology.label.view": "Voir la fiche",
  "patient.address.camp": "Camp/Commune",
  "patient.address.fokontany": "Fokontany",
  "patient.address.hamletOrLot": "Hameau / Lotissement ",
  "patient.address.healthdistrict": "District",
  "patient.address.healthregion": "Région",
  "patient.address.province": "Province",
  "patient.address.street": "Rue",
  "patient.address.town": "Ville",
  "patient.age.days": "Jours",
  "patient.age.months": "Mois",
  "patient.age.years": "Âge en années",
  "patient.alias": "Alias",
  "patient.dataSourceName": "Nom de la source de données du patient",
  "patient.dob": "Date de naissance",
  "patient.eduction": "Éducation",
  "patient.emergency.additional.camp": "Entrez le camp/commune",
  "patient.emergency.additional.district": "Entrez le district",
  "patient.emergency.additional.education": "Entrez l'éducation",
  "patient.emergency.additional.maritalstatus": "Entrez l'état civil",
  "patient.emergency.additional.nationnality": "Entrez la nationalité",
  "patient.emergency.additional.othernationality": "Entrez une autre nationalité",
  "patient.emergency.additional.region": "Entrez la région",
  "patient.emergency.additional.street": "Entrez la rue",
  "patient.emergency.additional.town": "Entrez la ville",
  "patient.emergency.email": "Entrez l'e-mail du contact d'urgence",
  "patient.emergency.firstname": "Entrez le prénom du contact d'urgence",
  "patient.emergency.lastname": "Entrez le nom de famille du contact d'urgence",
  "patient.emergency.phone": "Entrez le numéro de téléphone du contact d'urgence",
  "patient.externalId": "ID externe",
  "patient.female": "Femelle",
  "patient.first.name": "Prénom",
  "patient.gender": "Genre",
  "patient.gps.latitude": "Latitude GPS ",
  "patient.gps.latitude.placeholder": "ex. -18.879190 (plage -90 à 90)",
  "patient.gps.longitude": "Longitude GPS",
  "patient.gps.longitude.placeholder": "ex. 47.507905 (plage -180 à 180)",
  "patient.id": "Numéro du patient",
  "patient.information.age": "Entrez l'âge",
  "patient.information.days": "Entrez les jours",
  "patient.information.email": "Saisir l’e-mail du patient",
  "patient.information.firstname": "Entrez le prénom du patient",
  "patient.information.healthid": "Entrez l'identifiant santé unique",
  "patient.information.lastname": "Entrez le nom de famille du patient",
  "patient.information.months": "Entrez les mois",
  "patient.information.nationalid": "Entrez le numéro de la carte d'identité",
  "patient.information.primaryphone": "Entrez le numéro de téléphone principal du patient",
  "patient.label": "Patiente",
  "patient.label.additionalInfo": "Informations Complémentaires",
  "patient.label.age": "Âge",
  "patient.label.customNotes": "Notes personnalisées ",
  "patient.label.diseaseProgramme": "Programme de maladie cible",
  "patient.label.occupation": "Profession",
  "patient.label.contactphone": "Téléphone de contact : {PHONE_FORMAT}",
  "patient.label.email": "E-mail",
  "patient.label.info": "Informations sur les patients",
  "patient.label.modify": "Ajouter ou modifier un patient",
  "patient.label.name": "Nom",
  "patient.label.nopatientid": "Aucune information sur le patient disponible",
  "patient.label.primaryphone": "Téléphone principal du patient",
  "patient.label.sex": "Sexe",
  "patient.last.name": "Nom de famille",
  "phone.format.international.label": "International",
  "phone.format.local.label": "Local",
  "patient.male": "Mâle",
  "patient.maritalstatus": "État civil",
  "patient.merge.activeOrders": "Demande d'examens active",
  "patient.merge.address": "Adresse",
  "patient.merge.addressesDiffer": "L'adresse diffère : {primaire} vs {secondaire}",
  "patient.merge.auditEntries": "Écritures d'audit (le patient d'origine sera conservé)",
  "patient.merge.back": "Retour",
  "patient.merge.cancelButton": "Annuler",
  "patient.merge.clinicalSummary": "Résumé clinique",
  "patient.merge.confirmButton": "Confirmer la fusion",
  "patient.merge.confirmCheckbox": "Je comprends que cette action est irréversible et j'ai vérifié que les bons patients sont bien fusionnés.",
  "patient.merge.confirmMerge": "Confirmer la fusion des patients",
  "patient.merge.conflictNote": "(Les données démographiques primaires des patients seront utilisées)",
  "patient.merge.conflictingInfo": "Informations contradictoires détectées",
  "patient.merge.contactInfo": "Coordonnées",
  "patient.merge.county": "Comté/État",
  "patient.merge.dataToConsolidate": "Données à consolider",
  "patient.merge.demographics": "Données démographiques",
  "patient.merge.dob": "DOB",
  "patient.merge.email": "Email",
  "patient.merge.emailsDiffer": "L'adresse électronique diffère : {primaire} vs {secondaire}",
  "patient.merge.error.alreadyMerged": "Le patient a déjà été fusionné.",
  "patient.merge.error.executionFailed": "L'exécution de la fusion a échoué",
  "patient.merge.error.noPermission": "Seuls les administrateurs globaux peuvent fusionner les dossiers des patients.",
  "patient.merge.error.patientNotFound": "Patient introuvable",
  "patient.merge.error.samePatient": "Impossible de fusionner un patient avec lui-même",
  "patient.merge.error.selectBoth": "Veuillez sélectionner les deux patients pour continuer",
  "patient.merge.error.selectPrimary": "Veuillez sélectionner le patient dont le dossier doit être principal.",
  "patient.merge.error.validationFailed": "La validation de la fusion a échoué",
  "patient.merge.externalIds": "ID externes",
  "patient.merge.gender": "Genre",
  "patient.merge.identifiers": "Identifiants",
  "patient.merge.identifiersToPreserve": "Identifiants à préserver (pour les deux patients)",
  "patient.merge.mergeSummary": "Fusionner le résumé",
  "patient.merge.mergingFrom": "Fusionner à partir de",
  "patient.merge.mergingLabel": "Fusion",
  "patient.merge.name": "Nom",
  "patient.merge.nationalId": "Numéro d'Identité",
  "patient.merge.nationalIds": "Numéro de la carte d'Identité",
  "patient.merge.nextStep": "Étape suivante",
  "patient.merge.noIdentifiers": "Aucun identifiant enregistré",
  "patient.merge.noPatientSelected": "Aucun patient sélectionné",
  "patient.merge.notRecorded": "Non enregistré",
  "patient.merge.orders": "Demande d'examens",
  "patient.merge.ordersCount": "{count} ({active} active)",
  "patient.merge.patientId": "ID du patient",
  "patient.merge.patientIds": "ID des patients",
  "patient.merge.patientResults": "Résultats des patients",
  "patient.merge.phone": "Téléphone",
  "patient.merge.phonesDiffer": "Les numéros de téléphone diffèrent : {primaire} vs {secondaire}",
  "patient.merge.postalCode": "Code Postal",
  "patient.merge.primaryLabel": "Primaire",
  "patient.merge.primaryPatient": "Patient principal",
  "patient.merge.reason": "Motif de la fusion (obligatoire)",
  "patient.merge.reasonPlaceholder": "Veuillez indiquer le motif de la fusion de ces dossiers patients...",
  "patient.merge.recordsReassigned": "{count} enregistrements réattribués",
  "patient.merge.samples": "Échantillons",
  "patient.merge.searchDifferent": "Rechercher un autre patient",
  "patient.merge.selectFirstPatient": "Sélectionnez le premier patient",
  "patient.merge.selectPrimaryDescription": "Quel patient devrait faire l'objet du dossier principal ? ",
  "patient.merge.selectPrimaryRecord": "Sélectionner le dossier patient principal",
  "patient.merge.selectSecondPatient": "Sélectionner un deuxième patient",
  "patient.merge.step.compare": "Sélectionnez Primaire",
  "patient.merge.step.confirm": "Confirmer la fusion",
  "patient.merge.step.select": "Sélectionner des patients",
  "patient.merge.streetAddress": "Adresse de la rue",
  "patient.merge.success": "Fusion des patients effectuée avec succès",
  "patient.merge.successMessage": "Le patient {mergedId} a été fusionné avec le patient {primaryId}. ID d'audit : {auditId}",
  "patient.merge.testResults": "Résultats des tests",
  "patient.merge.title": "Fusionner les dossiers des patients",
  "patient.merge.totalContacts": "Contacts",
  "patient.merge.totalRelations": "Rapports",
  "patient.merge.totalResults": "Résultats totaux",
  "patient.merge.totalSamples": "Échantillons",
  "patient.merge.town": "Ville/Ville",
  "patient.merge.tryDifferentSearch": "Essayez de modifier vos critères de recherche ou d'utiliser différents identifiants de patients.",
  "patient.merge.warning.dataLink": "Toutes les données ultérieures seront associées au patient principal. Le patient non sélectionné sera marqué comme fusionné et inactif.",
  "patient.merge.warning.irreversible": "Cette action est irréversible. Toutes les données seront définitivement consolidées.",
  "patient.merge.warning.samePatient": "Même patient sélectionné",
  "patient.merge.warning.samePatientDescription": "Vous avez sélectionné le même patient pour les deux dossiers. Veuillez sélectionner deux patients différents à fusionner.",
  "patient.natioanalid": "Carte d'identité",
  "patient.nationalid": "Numéro d'identification nationale",
  "patient.nationality": "Nationalité",
  "patient.nationality.other": "Précisez Autre nationalité",
  "patient.photo.active.camera": "Cliquer pour activer la caméra",
  "patient.photo.add": "Ajouter une photo",
  "patient.photo.browse": "Cliquez pour parcourir les fichiers",
  "patient.photo.camera.permission.denied": "Autorisation d'accès à la caméra refusée. Veuillez vérifier les paramètres de votre navigateur.",
  "patient.photo.cancel": "Annuler",
  "patient.photo.capture": "Prise de photo",
  "patient.photo.captured": "Photo prise:",
  "patient.photo.change": "Modifier l'image",
  "patient.photo.confirm": "Confirmer",
  "patient.photo.dragndrop": "Copier/Coller une image ici",
  "patient.photo.error.fileTooLarge": "L’image est trop volumineuse. Taille maximale : 2 Mo.",
  "patient.photo.formats": "Formats: JPG, PNG (max 1MB)",
  "patient.photo.import": "Importer",
  "patient.photo.label": "Photo du patient",
  "patient.photo.modal.heading": "Choisir la photo du patient",
  "patient.photo.modal.options": "Options de sélection d'images",
  "patient.photo.preview": "Pré-visualiser",
  "patient.photo.preview.alt": "Pré-visualiser la photo du patient",
  "patient.photo.preview.captured.alt": "Photo du patient capturée",
  "patient.photo.retake": "Reprendre",
  "patient.photo.start.camera": "Démarrer la caméra",
  "patient.photo.take": "Prendre une photo",
  "patient.photo.view": "Voir la photo",
  "patient.idDoc.title": "Documents d’identification",
  "patient.idDoc.addDocument": "Ajouter un document",
  "patient.idDoc.selectImage": "Sélectionner une image",
  "patient.idDoc.documentType": "Type de document",
  "patient.idDoc.description": "Description",
  "patient.idDoc.description.placeholder": "Saisir la description du document",
  "patient.idDoc.category.nationalId": "Carte nationale d’identité",
  "patient.idDoc.category.insuranceCard": "Carte d’assurance",
  "patient.idDoc.category.other": "Autre",
  "patient.idDoc.view": "Visualiser",
  "patient.idDoc.edit": "Modifier",
  "patient.idDoc.delete": "Supprimer",
  "patient.idDoc.remove": "Retirer",
  "patient.idDoc.pending": "Non enregistré",
  "patient.idDoc.empty": "Aucun document d’identification téléversé ",
  "patient.idDoc.viewDocument": "Voir le document",
  "patient.idDoc.editDocument": "Modifier le document",
  "patient.idDoc.confirmDelete": "Supprimer le document",
  "patient.idDoc.deleteWarning": "Êtes-vous sûr de vouloir supprimer ce document ? Cette action est irréversible.",
  "patient.idDoc.upload": "Téléverser",
  "patient.idDoc.dragndrop": "Glissez-déposez un fichier ici",
  "patient.idDoc.browse": "ou cliquez pour parcourir les fichiers",
  "patient.idDoc.formats": "Formats : JPEG, PNG, PDF (max 10 Mo)",
  "patient.idDoc.useCamera": "Utiliser la caméra",
  "patient.idDoc.pdfSelected": "Document PDF sélectionné",
  "patient.idDoc.error.invalidFormat": "Format de fichier invalide. Formats acceptés : JPEG, PNG, PDF. ",
  "patient.idDoc.error.fileTooLarge": "Le fichier est trop volumineux. Taille maximale : 10 Mo.",
  "patient.prev.lab.no": "Numéro de laboratoire précédent",
  "patient.report.associated.name": "Rapports des Patients Associés",
  "patient.report.collection.name": "ARV Rapports des Patients Recueillies",
  "patient.search.nopatient": "Aucun patient trouvé",
  "patient.st.number": "Numéro ST",
  "patient.subject.number": "Identifiant unique du patient",
  "patient.yrs": "ans",
  "patientcontact.person.email": "Email du contact",
  "patientcontact.person.firstname": "Prénom du contact",
  "patientcontact.person.lastname": "Nom de famille du contact",
  "placeholder.accession.number": "Saisissez le N° Labo",
  "plugin.files": "Plugin Files",
  "plugin.name": "Plugin Name",
  "print.barcode": "Imprimer les codes",
  "process.testAdd.pressNext.ageRangeSelectiong": "Appuyez sur le bouton Suivant. L'étape de sélection de la tranche d'âge n'est pas requise !",
  "process.testAdd.pressNext.selectGroupDictionary": "Appuyez sur le bouton Suivant. L'étape de sélection de la liste de dictionnaires de groupe n'est pas requise !",
  "program.name.label": "Nom du programme",
  "program.name.code": "Code du programme",
  "project.ARVFollowupStudy.name": "ARV - Bilan de Suivi",
  "project.ARVStudies.name": "ARV",
  "project.ARVStudy.name": "ARV - Bilan Initial",
  "project.EIDStudy.name": "EID",
  "project.IndeterminateStudy.name": "Indéterminé",
  "project.RTNStudy.name": "RTN",
  "project.Recency.name": "Recency Testing",
  "project.SequencingStudy.name": "Séquençage",
  "project.SpecialRequestStudy.name": "Demande Spéciale",
  "project.VLStudy.name": "VL",
  "project.add.subtitle": "Ajouter Projet",
  "project.add.title": "Ajouter Projet",
  "project.browse.title": "Projet",
  "project.completedDate": "Completed Date",
  "project.desc.short": "Project Descr.",
  "project.description": "Project Description",
  "project.edit.subtitle": "Éditer Projet",
  "project.edit.title": "Éditer Projet",
  "project.external.reference": "External Reference",
  "provider.browse.title": "Gestion des Prestataires",
  "provider.email": "E-mail",
  "provider.fax": "Fax",
  "provider.isActive": "Actif",
  "provider.modal.add.heading": "Ajouter un prestataire",
  "provider.modal.update.heading": "Mettre à jour le Prestataire",
  "provider.providerFirstName": "Prénom du Prestataire",
  "provider.providerLastName": "Nom de Famille du Prestataire",
  "provider.search": "Rechercher un Prestataire",
  "provider.search.placeholder": "Rechercher par Nom de Prestataire...",
  "provider.select": "Sélectionner un Prestataire",
  "provider.telephone": "Téléphone",
  "qa.checklist.incomplete": "La checklist Assurance Qualité est incomplète",
  "qa.checklist.instructions": "Complétez tous les contrôles requis avant de soumettre",
  "qa.checklist.samplingSiteCorrect": "Sampling site information is correct",
  "qa.checklist.title": "Checklist Assurance Qualité",
  "qa.summary.noSamples": "Aucun échantillon à examiner",
  "qa.summary.noTests": "No tests selected",
  "qa.summary.order": "Détails de la demande d’examen",
  "qa.summary.panel": "Panel",
  "qa.summary.patient": " Informations du patient",
  "qa.summary.samples": "Résumé des échantillons",
  "qa.summary.samplingSite": "Sampling Site",
  "qa.summary.siteCode": "Site Code",
  "qa.summary.siteName": "Site Name",
  "qc.comments.add": "Ajouter un commentaire",
  "qc.comments.empty": "Aucun commentaire",
  "qc.comments.placeholder": "Entrer un commentaire CQ...",
  "qc.comments.title": "Commentaires CQ",
  "qc.frequency.compliance": "Métriques de conformité",
  "qc.frequency.config": "Configuration de fréquence CQ",
  "qc.frequency.daily": "Démarrage quotidien",
  "qc.frequency.everyHours": "Toutes les N heures",
  "qc.frequency.everySamples": "Tous les N échantillons",
  "qc.frequency.manual": "Déclenchement manuel uniquement",
  "qc.frequency.notConfigured": "Non configuré",
  "qc.frequency.perShift": "Par quart de travail",
  "qc.frequency.save": "Enregistrer la configuration",
  "qc.frequency.type": "Type de fréquence",
  "qc.frequency.value": "Valeur de fréquence",
  "qc.leveyJennings.mean": "Moyenne",
  "qc.leveyJennings.minus2SD": "-2 ET",
  "qc.leveyJennings.minus3SD": "-3 ET",
  "qc.leveyJennings.noData": "Aucune donnée CQ disponible",
  "qc.leveyJennings.plus2SD": "+2 ET",
  "qc.leveyJennings.plus3SD": "+3 ET",
  "qc.leveyJennings.title": "Graphique de contrôle Levey-Jennings",
  "qc.notes": "Remarques sur le contrôle qualité",
  "qc.notes.placeholder": "Saisir les notes et observations relatives au contrôle qualité",
  "qc.signature.comment": "Commentaire (optionnel)",
  "qc.signature.comment.placeholder": "Ajouter un commentaire...",
  "qc.signature.ipAddress": "Adresse IP",
  "qc.signature.noSignatures": "Aucune signature",
  "qc.signature.sign": "Signer le rapport",
  "qc.signature.signedAt": "Signé le",
  "qc.signature.success": "Rapport signé avec succès",
  "qc.signature.title": "Signatures électroniques",
  "qc.signature.userId": "ID utilisateur",
  "qc.status": "statut QC",
  "qc.status.failed": "Echec",
  "qc.status.notRequired": "Pas obligatoire",
  "qc.status.passed": "Réussi",
  "qc.status.pending": "QC en attente",
  "qc.status.select": "Sélectionnez le statut QC",
  "qc.status.update.button": "Statut QC mis à jour ",
  "qc.status.update.success": "Statut QC mis à jour avec succès",
  "qc.status.update.title": "Statut QC mis à jour ",
  "qc.status.warning.message": "Le fait de marquer ce lot comme Non conforme empêchera son utilisation jusqu'à ce que le statut du contrôle qualité soit mis à jour.",
  "qc.status.warning.title": "Avertissement d’échec du contrôle qualité",
  "qc.westgard.noViolations": "Aucune violation détectée",
  "qc.westgard.rule.disabled": "Désactivée",
  "qc.westgard.rule.enabled": "Activée",
  "qc.westgard.rules": "Règles de Westgard",
  "qc.westgard.rules.description": "Configurer l'évaluation CQ multi-règles de Westgard",
  "qc.westgard.violations": "Violations",
  "quantity": "Quantité",
  "quantity.balanced": "Quantité équilibrée",
  "quantity.not.balanced": "Quantité non équilibrée",
  "quick.entry.accession.number": "N° Labo",
  "referTest.referralLabel": "Référer le test à un laboratoire de référence",
  "referral.button.labSearch": "Rechercher les références par numéro de laboratoire",
  "referral.button.patientSearch": "Recherche de patient",
  "referral.button.unitTestSearch": "Rechercher les références par unité(s) et test(s)",
  "referral.date.end": "Date de fin (jj/mm/aaaa)",
  "referral.date.start": "Date de Début (jj/mm/aaaa)",
  "referral.error": "Aucune référence ne correspond aux critères",
  "referral.input": "Scanner ou Entrer Manuellement",
  "referral.label.institute": "Institut",
  "referral.label.reason": "Raison de référence",
  "referral.label.referredOutTests": "Tests référés à l'extérieur",
  "referral.label.sentdate": "Date envoyée",
  "referral.label.testmethod": "Méthodes",
  "referral.label.testtoperform": "Test à effectuer",
  "referral.main.button": "Rechercher les références par patient",
  "referral.matching.search": "Tests référés correspondant à la recherche",
  "referral.out.head": "Références",
  "referral.out.note": "Notez que si vous recherchez par date de résultat, seuls les tests avec des résultats apparaîtront.",
  "referral.out.request": "Résultats par Date / Test / Type de Date d'Unité :",
  "referral.print.selected.patient.reports": "Imprimer les rapports des patients sélectionnés",
  "referral.print.selected.patient.reports.selectall.button": "Sélectionner tout",
  "referral.print.selected.patient.reports.selectnone.button": "Désélectionner tout",
  "referral.result.labNumber": "Résultats par Numéro de Laboratoire",
  "referral.search": "Rechercher",
  "referral.search.column.analysisId": "Identifiant de l'analyse",
  "referral.search.column.referenceLab": "Laboratoire de référence",
  "referral.search.column.resultDate": "Date de résultat",
  "referral.search.column.sentDate": "Date d'envoi",
  "referral.test": "Test(s)",
  "referral.testresult.pastnote": "Notes passées",
  "referral.units": "Unité(s)",
  "referrer.label": "Référent",
  "reflexTests": "Tests de réflexes",
  "reject.action.button": "Rejeter",
  "reject.order.sample.notification": "Vous rejetez un échantillon.Cet échantillon sera rejeté et n’apparaîtra pas dans les plans de travail une fois enregistré,aucun résultat ne peut être entré pour cette commande.",
  "remaining.quantity": "Quantité restante :",
  "remove.aliquot": "Supprimer l’aliquote",
  "report.enter.labNumber.headline": "Générer un rapport ou une plage de rapports par numéro de numéro de laboratoire",
  "report.enter.patient.headline": "Générer tous les rapports pour un client",
  "report.enter.patient.headline.description": "Recherchez le patient via le numéro de laboratoire précédent, l'ID du patient (qui peut être soit le numéro d'identification unique de la santé, soit l'ID national) ou d'autres champs.",
  "report.enter.site.headline": "Générer des rapports par site",
  "report.labe.byLabNumber": "Rapport par Numéro de Laboratoire",
  "report.labe.byPatient": "Rapport par Patient",
  "report.labe.date": "Rapport par Date",
  "report.labe.site": "Rapport par Site",
  "report.label.site.dateType": "Type de date",
  "report.label.site.onlyResults": "Uniquement les rapports avec des résultats",
  "report.patient.site.description": "Générer des rapports par date de résultat ou par date de commande. La date de résultat montrera uniquement les rapports avec des résultats. Si vous sélectionnez uniquement les rapports avec des résultats, tous les rapports où tous les tests sont en cours ne seront pas générés.",
  "report.select.site": "Sélectionner le site",
  "report.select.studttype": "Sélectionner le type d'étude",
  "reporting.label.testName": "Nom du test dans les rapports",
  "reports.auditTrail": "Examen d'audit",
  "reports.systemAuditTrail": "Journal d’audit du système",
  "reports.button": "Générer le rapport",
  "reports.dateRange": "Intervalle de dates",
  "reports.endDate": "Date de fin",
  "reports.error.dateRangeRequired": "La plage de dates est requise pour ce type de rapport.",
  "reports.error.generationFailed": "Impossible de générer le rapport. Veuillez réessayer.",
  "reports.error.invalidDateRange": "La date de fin doit être postérieure à la date de début.",
  "reports.export": "Exporter les rapports",
  "reports.export.byDate": "Exporter en Fichier CSV",
  "reports.export.byDate_routine": "Exporter Routine en Fichier CSV",
  "reports.export.general": "Exportation générale",
  "reports.export.specific": "Exportation Données Charge Viral",
  "reports.export.valid": "Valide",
  "reports.export.whonet": "WHONET Report",
  "reports.followupRequired.byLocation": "Suivi Requis",
  "reports.format": "Format d'exportation",
  "reports.format.select": "Sélectionner un format",
  "reports.generate.title": "Générer le rapport de stock des éléments",
  "reports.generating": "Génération en cours...",
  "reports.generation.success": "Rapport généré et téléchargé avec succès",
  "reports.groupByLocation": "Regrouper par lieu de stockage",
  "reports.groupByType": "Regrouper par type d'élément",
  "reports.grouping": "Options de regroupement",
  "reports.help.description": "Utilisez ces rapports pour analyser vos données d'inventaire :",
  "reports.help.tip1": "Utilisez des plages de dates pour l'analyse des tendances",
  "reports.help.tip2": "Regroupez par type ou par emplacement pour une meilleure analyse.",
  "reports.help.tip3": "Exporter vers Excel pour une analyse plus approfondie",
  "reports.help.title": "Conseils pour signaler",
  "reports.includeExpired": "Inclure les lots expirés",
  "reports.includeInactive": "Inclure les éléments inactifs",
  "reports.info.message": "Sélectionnez le type de rapport et les options ci-dessous. La génération des rapports peut prendre quelques instants.",
  "reports.info.title": "Génération de rapports",
  "reports.label.cistudyexport": "Rapport général",
  "reports.label.indicator": "Indicateur",
  "reports.label.indicator.performance": "Performances de l'unité",
  "reports.label.referred.out": "Rapport des tests référencés",
  "reports.label.trends": "Tendances",
  "reports.menu.covid": "Covid Report",
  "reports.nonConformity.byDate.report": "Par date",
  "reports.nonConformity.byLabno.report": "Par Labno",
  "reports.nonConformity.bySectionReason.report": "Par unité et raison",
  "reports.nonConformity.bySectionReason.title": "Rapport des non-conformités par unité et raison",
  "reports.nonConformity.menu": "Non-conformités",
  "reports.nonConformity.notification.report": "Non-conformités notification",
  "reports.nonConformity.notification.report.instructions": "Instructions pour le rapport de notification de non-conformité",
  "reports.options": "Options de filtre",
  "reports.patient.ARV.version1": "ARV-Version",
  "reports.patient.ARV.version1 ": "ARV-Version 1",
  "reports.patient.ARVFollowup.version1": "ARV-Bilan de Suivi Version 1",
  "reports.patient.ARVFollowup.version2": "ARV-Bilan de Suivi Version 2",
  "reports.patient.ARVInitial.version1": "ARV-Bilan Initial Version 1",
  "reports.patient.ARVInitial.version2": "ARV-Bilan Initial Version 2",
  "reports.patient.Indeterminate.location": "Indéterminés par le Service",
  "reports.patient.Indeterminate.version1": "Indéterminés Version 1",
  "reports.patient.Indeterminate.version2": "Indéterminés Version 2",
  "reports.startDate": "Date de début",
  "reports.type": "Type du rapport",
  "reports.type.expirationForecast": "Prévision d’expiration",
  "reports.type.expirationForecast.description": "Éléments expirant dans la période indiqué",
  "reports.type.lotTraceability": "Traçabilité des lot",
  "reports.type.lotTraceability.description": "Traçabilité complète des mouvements et de l’utilisation des lots",
  "reports.type.lowStock": "Alerte de stock faible",
  "reports.type.lowStock.description": "Éléments actuellement en dessous du stock minimum",
  "reports.type.select": "Sélectionner type du rapport",
  "reports.type.stockLevels": "Rapport sur les niveaux de stock des éléments",
  "reports.type.stockLevels.description": "Niveaux de stock actuels pour tous les éléments en inventaire",
  "reports.type.transactionHistory": "Historique des transactions",
  "reports.type.transactionHistory.description": "Toutes les transactions comprises dans la plage de dates indiquée",
  "reports.type.usageTrends": "Tendances d’utilisation",
  "reports.type.usageTrends.description": "Évolution des usages et de la consommation au fil du temps",
  "request.samesite.order": "Passer la commande sur le même site",
  "requester.label": "Prescripteur",
  "required.invalidtext": "Ce champ est requis",
  "result.acceptasis.warning": "Avertissement d'acceptation en l'état",
  "result.acceptasis.trigger": "Accept",
  "result.acceptasis.reason.label": "Reason for unconditional acceptance",
  "result.acceptasis.reason.placeholder": "Required — e.g. retested twice with same result, or no result available",
  "result.acceptasis.confirm": "Confirm acceptance",
  "result.acceptasis.cancel": "Cancel",
  "result.acceptasis.committed": "Accepted",
  "result.acceptasis.undo": "Undo",
  "result.entry.error.accessionRequired": "Veuillez saisir un numéro de laboratoire",
  "result.entry.error.title": "Erreur ",
  "result.entry.info.title": "Information",
  "result.entry.label": "Saisie les résultats",
  "result.entry.noResults": "Aucun échantillon trouvé pour le numéro lab{accessionNumber}",
  "result.entry.noTestsFound": "Aucun test avec des résultats en attente n'a été trouvé pour le numéro d'accès {accessionNumber}",
  "result.entry.results.accessionNumber": "Numéro de laboratoire ",
  "result.entry.results.sampleCount": "Echantillons ",
  "result.entry.results.testCount": "Tests",
  "result.entry.results.title": "Résultats des tests en attente",
  "result.entry.saveSuccess": "Résultat enregistré pour {testName}",
  "result.entry.search.accessionLabel": "Numéro de laboratoire",
  "result.entry.search.accessionPlaceholder": "Saisissez le numéro de laboratoire ",
  "result.entry.search.button": "Recherche",
  "result.entry.search.searching": "Recherche en cours…",
  "result.entry.search.title": "Recherche par numéro de laboratoire",
  "result.entry.success.title": "Succès",
  "result.entry.table.action": "Action",
  "result.entry.table.header.sampleId": "ID de l'échantillon",
  "result.entry.table.header.sampleType": "Type d'échantillons ",
  "result.entry.table.header.testCount": "Tests ",
  "result.entry.table.noSamples": "Aucun échantillon testé trouvé",
  "result.entry.table.noTests": "Aucun test n'a été effectué sur cet échantillon.",
  "result.entry.table.result": "Résultat ",
  "result.entry.table.resultPlaceholder": "Saisir le résultat",
  "result.entry.table.save": "Enregistrer",
  "result.entry.table.saving": "Enregistrement...",
  "result.entry.table.status": "Statuts ",
  "result.entry.table.testName": "Nom du test ",
  "result.entry.table.testsTitle": "Tests ({count})",
  "result.entry.title": "Saisie les résultats",
  "result.noTestsFound": "Aucun test approprié trouvé",
  "result.nonconforming.item": "L'échantillon ou l'ordonnance est non conforme OU le test a été rejetée",
  "result.outOfValidRange.msg": "La valeur que vous avez entrée (en champ rouge) est hors de la gamme des valeurs admissible pour ce bilan. Prière de vérifier la valeur.",
  "result.reject.warning": "Avertissement de rejet de résultat",
  "result.report.queue.size": "Taille de la file d'attente :",
  "result.search.noresult": "Aucun résultat trouvé",
  "resultreporting.browse.title": "Configuration de la diffusion des résultats",
  "resultreporting.config.url": "URL du site vers lequel les résultats seront envoyés. Par exemple http://192.168.56.101/someSite",
  "resultreporting.config.url.placeholder": "https://nomdelorganisation.com/someSite",
  "results.label.refer": "Référer le test à un laboratoire de référence",
  "routine.reports": "Rapports de routine",
  "rulebuilder.error.invalidNumeric": "Valeur numérique invalide",
  "rulebuilder.error.invalidTest": "Test invalide",
  "rulebuilder.label.add.externaltrigger": "Ajouter un message externe \\",
  "rulebuilder.label.add.internaltrigger": "Ajouter un message interne \\",
  "rulebuilder.label.addAction": "Ajouter une action",
  "rulebuilder.label.addCondition": "Ajouter une condition",
  "rulebuilder.label.addExternalNote": "Ajouter une note externe",
  "rulebuilder.label.addInternalNote": "Ajouter une note interne",
  "rulebuilder.label.addPopup": "Ajouter une fenêtre contextuelle",
  "rulebuilder.label.addRule": "Ajouter une règle",
  "rulebuilder.label.addRuleConditions": "Ajouter des conditions de règle réflexe",
  "rulebuilder.label.confirmDelete": "Êtes-vous sûr de vouloir supprimer cette règle ?",
  "rulebuilder.label.dictValue": "Sélectionner",
  "rulebuilder.label.noSuggestions": "Aucune suggestion disponible",
  "rulebuilder.label.numericValue": "Valeur numérique",
  "rulebuilder.label.numericValue2": "Valeur numérique 2",
  "rulebuilder.label.overallOptions": "Sur toutes les options",
  "rulebuilder.label.perfomActions": "Effectuer les actions suivantes",
  "rulebuilder.label.relation": "Relation logique",
  "rulebuilder.label.removeAction": "Supprimer l'action",
  "rulebuilder.label.removeCondition": "Supprimer la condition",
  "rulebuilder.label.removeRule": "Désactiver la règle",
  "rulebuilder.label.rule": "Règle",
  "rulebuilder.label.ruleDetails": "View Rule",
  "rulebuilder.label.ruleName": "Nom de la règle",
  "rulebuilder.label.searchTest": "Rechercher un test",
  "rulebuilder.label.selectSample": "Sélectionner un échantillon",
  "rulebuilder.label.textValue": "Valeur de texte",
  "rulebuilder.label.toggleRule": "Basculer la règle",
  "sample.accession.number": "Numéro Laboratoire de l’échantillon",
  "sample.add.action": "Ajouter un échantillon",
  "sample.collection.date": "Date de collecte",
  "sample.collection.method": "Méthode de prélèvement ",
  "sample.collection.method.placeholder": "ex. ponction veineuse, capillaire, tubulure",
  "sample.collection.time": "Heure de collecte",
  "sample.currentDate": "Date actuelle",
  "sample.specimen.origin": "Origine de l’échantillon (laboratoire référent)",
  "sample.specimen.origin.placeholder": "Nom du laboratoire référent",
  "sample.temperature": "Température de l’échantillon ",
  "sample.temperature.placeholder": "ex. température ambiante, sur glace, réfrigéré",
  "sample.entry.available.tests": "Tests disponibles",
  "sample.entry.nextVisit.date": "Date de rendez vous",
  "sample.entry.panels": "Panneaux disponibles",
  "sample.entry.project.patient.and.testName": "Noms et/ou Numéro d'identité National \\n Nom du Test",
  "sample.entry.project.testName": "Nom du Test",
  "sample.entry.search.barcode": "Rechercher un code-barres d'échantillon",
  "sample.id": "ID de l’échantillon",
  "sample.item.info": "Informations sur l’échantillon",
  "sample.items.for.accession": "Échantillons associés au numéro Lab :",
  "sample.label.accessionNumber": "Numéro d’enregistrement",
  "sample.label.collectionDate": "Date de prélèvement",
  "sample.label.dept": "Service/Département/Unité",
  "sample.label.facility": "Établissement Référant",
  "sample.label.labnumber": "Numéro de Laboratoire",
  "sample.label.labnumber.generate": "Générer",
  "sample.label.labnumber.new": "Nouveau numéro de laboratoire",
  "sample.label.noorder": "La commande n'existe pas",
  "sample.label.orderdate": "Date de Commande",
  "sample.label.orderpanel": "Panels de commande",
  "sample.label.requester": "Prescripteur",
  "sample.label.search.Order": "Rechercher une commande",
  "sample.label.search.labnumber": "Rechercher par numéro d'accès",
  "sample.label.search.patient": "Rechercher par patient",
  "sample.label.typeOfSample": "Type d’échantillon",
  "sample.label.types": "Types d’échantillons",
  "sample.management.action.clearSelection": "Effacer la sélection",
  "sample.management.action.createAliquot": "Créer une aliquote",
  "sample.management.action.selectAllAliquots": "Sélectionner toutes les aliquotes",
  "sample.management.action.selectAllParents": "Sélectionner tous les parents",
  "sample.management.addTests.button": "Ajouter des tests",
  "sample.management.addTests.error.addFailed": "Impossible d'ajouter les tests. Veuillez réessayer.",
  "sample.management.addTests.error.loadSampleTypes": "Erreur lors du chargement des types d'échantillons",
  "sample.management.addTests.error.loadTests": "Erreur lors du chargement des tests disponibles",
  "sample.management.addTests.error.noEligibleSamples": "Impossible d'ajouter des tests : tous les échantillons sélectionnés ont été distribués.",
  "sample.management.addTests.error.noTests": "Veuillez sélectionner au moins un test",
  "sample.management.addTests.modal.add": "Ajouter des tests",
  "sample.management.addTests.modal.addCount": "Ajouter {count} test(s)",
  "sample.management.addTests.modal.adding": "Ajout...",
  "sample.management.addTests.modal.aliquotsIncluded": "aliquot(s) inclus",
  "sample.management.addTests.modal.bulkAliquotNote": "Des tests seront ajoutés à tous les échantillons sélectionnés, y compris les aliquotes.",
  "sample.management.addTests.modal.cancel": "Annuler",
  "sample.management.addTests.modal.noEligibleSamples": "Aucun échantillon admissible",
  "sample.management.addTests.modal.noTestsAvailable": "Aucun test n'est disponible pour ce type d'échantillon.",
  "sample.management.addTests.modal.noTestsSelected": "Aucun test sélectionné",
  "sample.management.addTests.modal.panels": "Panels",
  "sample.management.addTests.modal.searchTestsPlaceholder": "Rechercher des tests...",
  "sample.management.addTests.modal.selectSampleType": "Type d'échantillon",
  "sample.management.addTests.modal.selectSampleTypeFirst": "Veuillez sélectionner un type d'échantillon pour afficher les panels et les tests disponibles.",
  "sample.management.addTests.modal.selectSampleTypePlaceholder": "Sélectionnez un type d'échantillon...",
  "sample.management.addTests.modal.selectTests": "Sélectionnez des tests",
  "sample.management.addTests.modal.selectTestsPlaceholder": "Rechercher et sélectionner des tests...",
  "sample.management.addTests.modal.selectedTests": "Tests sélectionnés",
  "sample.management.addTests.modal.subtitle": "Ajouter des tests à {count} échantillons sélectionnés",
  "sample.management.addTests.modal.tests": "Tests",
  "sample.management.addTests.modal.title": "Ajouter des tests à l'échantillon",
  "sample.management.addTests.resultItem": "{sampleId}: {added} ajouté",
  "sample.management.addTests.resultItem.withSkipped": "{sampleId} : {added} ajouté, {skipped} ignoré",
  "sample.management.addTests.success": "{count} test(s) ajoutés avec succès",
  "sample.management.addTests.successDetailed": "{count} test(s) ajoutés à {samples} échantillon(s) : {details}",
  "sample.management.addTests.successDetailedWithSkipped": "{added} test(s) ajoutés à {samples} échantillon(s), {skipped} ignoré: {details}",
  "sample.management.addTests.successWithSkipped": "{added} test(s) ajoutés, {skipped} ignorés (déjà commandés)",
  "sample.management.addTests.title": "Ajouter des tests",
  "sample.management.addTests.warning.dispensedSamples": "{count} échantillon(s) n’ont plus de volume restant et seront ignorés. Les tests seront ajoutés à {eligible} échantillon(s) éligibles.",
  "sample.management.addTests.warning.dispensedSamples.title": "Échantillons distribués exclus",
  "sample.management.aliquot.error.createFailed": "Impossible de créer l'aliquote. Veuillez réessayer.",
  "sample.management.aliquot.error.numberOfAliquotsInvalid": "Le nombre d'aliquotes doit être compris entre 1 et 100.",
  "sample.management.aliquot.error.quantityExceedsRemaining": "La quantité demandée ({requested}) dépasse la quantité restante ({remained})",
  "sample.management.aliquot.error.quantityPerAliquotTooSmall": "La quantité par aliquote ({quantité par aliquot}) serait inférieure au minimum (0,001).",
  "sample.management.aliquot.error.quantityPositive": "La quantité doit être supérieure à 0",
  "sample.management.aliquot.error.quantityRequired": "La quantité est requise",
  "sample.management.aliquot.error.title": "Erreur",
  "sample.management.aliquot.modal.cancel": "Annuler",
  "sample.management.aliquot.modal.create": "Créer une aliquote",
  "sample.management.aliquot.modal.createMultiple": "Créer {count} aliquotes",
  "sample.management.aliquot.modal.creating": "Création en cours…",
  "sample.management.aliquot.modal.notesLabel": "Notes (optionnel)",
  "sample.management.aliquot.modal.notesPlaceholder": "Ajoutez des notes concernant cette aliquote…",
  "sample.management.aliquot.modal.numberOfAliquotsHelper": "Indiquez le nombre d'aliquotes de volume égal à (1-100)",
  "sample.management.aliquot.modal.numberOfAliquotsLabel": "Nombre d’aliquotes",
  "sample.management.aliquot.modal.parentInfo": "Informations sur l’échantillon parent",
  "sample.management.aliquot.modal.preview": "Aperçu",
  "sample.management.aliquot.modal.previewText": "Création de {coumpter} aliquotes avec {Chaque quantité} {unités} chacune",
  "sample.management.aliquot.modal.quantityHelper": "Saisissez la quantité à transférer en {unit}",
  "sample.management.aliquot.modal.quantityLabel": "Quantité à transférer",
  "sample.management.aliquot.modal.quantityPlaceholder": "Saisir la quantité",
  "sample.management.aliquot.modal.subtitle": "Créer une aliquote à partir de l’échantillon {externalId}",
  "sample.management.aliquot.modal.title": "Créer une aliquote",
  "sample.management.aliquot.modal.totalQuantityHelper": "Saisissez la quantité totale à répartir entre toutes les aliquotes en {unit}",
  "sample.management.aliquot.modal.totalQuantityLabel": "Quantité total à transférer",
  "sample.management.aliquot.success": "Aliquot {externalId} créé avec succès. Veuillez effectuer une nouvelle recherche pour afficher les résultats mis à jour.",
  "sample.management.aliquot.successMultiple": "{count} aliquotes créées avec succès ({externalIds}). Veuillez effectuer une nouvelle recherche pour afficher les résultats mis à jour.",
  "sample.management.breadcrumb.title": "Gestion des échantillons",
  "sample.management.cancelTest.error": "Impossible d'annuler le test. Veuillez réessayer.",
  "sample.management.cancelTest.success": "Le test « {testName} » a été annulé avec succès",
  "sample.management.description": "Rechercher et gérer des échantillons, créer des aliquotes et ajouter des tests",
  "sample.management.error.title": "Erreur",
  "sample.management.hierarchy.aliquotOf": "Aliquote de {parent}",
  "sample.management.hierarchy.aliquots": "aliquotes",
  "sample.management.noResults.subtitle": "Aucun échantillon trouvé pour le numéro de laboratoire : {numéro de laboratoire}",
  "sample.management.noResults.title": "Aucun résultat trouvé",
  "sample.management.results.accessionNumber": "Numéro de laboratoire ",
  "sample.management.results.aliquots": "aliquotes",
  "sample.management.results.aliquotsSelected": "aliquotes",
  "sample.management.results.item": "élément",
  "sample.management.results.items": "éléments",
  "sample.management.results.selected": "Choisi",
  "sample.management.results.title": "Éléments d’échantillon",
  "sample.management.results.totalCount": "Total des échantillons",
  "sample.management.search.error.general": "Erreur lors du chargement des résultats d'exemple. Veuillez réessayer.",
  "sample.management.search.label": "Rechercher des échantillons",
  "sample.management.search.loading": "Recherche...",
  "sample.management.search.placeholder": "Saisissez le numéro d'accession pour effectuer une recherche.",
  "sample.management.search.title": "Rechercher des échantillons",
  "sample.management.status.allVolumeDispensed": "Tous les volumes distribués",
  "sample.management.status.available": "Disponible",
  "sample.management.status.consumed": "Consommé",
  "sample.management.status.inUse": "Utilisé",
  "sample.management.status.unknown": "Inconnu",
  "sample.management.success.title": "Succès",
  "sample.management.table.cancelTest": "Annuler le test",
  "sample.management.table.cancelling": "Annulation...",
  "sample.management.table.header.externalId": "ID de l'échantillon",
  "sample.management.table.header.hierarchy": "Hiérarchie",
  "sample.management.table.header.originalQuantity": "Quantité originale",
  "sample.management.table.header.quantity": "Quantité originale",
  "sample.management.table.header.remainingQuantity": "Quantité restante",
  "sample.management.table.header.sampleType": "Type d'échantillon",
  "sample.management.table.header.status": "Statuts",
  "sample.management.table.header.tests": "Tests",
  "sample.management.table.noResults": "Aucun échantillons afficher. Utilisez la fonction de recherche ci-dessus pour trouver des échantillons.",
  "sample.management.table.noTests": "Aucun test commandé pour cet échantillon",
  "sample.management.table.orderedDate": "Ordonnée",
  "sample.management.table.orderedTests": "Tests commandés ({count})",
  "sample.management.title": "Gestion des échantillons",
  "sample.panel.label.text": "Panneau de recherche disponible",
  "sample.panel.placeholder": "Choisissez le panneau Disponible",
  "sample.panel.search.error.msg": "Aucun panneau trouvé correspondant",
  "sample.quantity.label": "Quantité",
  "sample.receivedDate": "Date de réception",
  "sample.reject.label": "Échantillon rejeté",
  "sample.remove.action": "Supprimer l'échantillon",
  "sample.requestDate": "Date de la demande",
  "sample.search.nosample": "Aucun échantillon n'a été trouvé pour le numéro laboratoire fourni.",
  "sample.search.panel.legend.text": "Rechercher parmi les panneaux disponibles",
  "sample.search.scanner.instructions": "Scannez ou saisissez manuellement. Pour un seul rapport, laissez le champ de droite vide",
  "sample.search.scanner.instructions.highaccession": "Scanner le code-barres de l'échantillon pour rechercher les résultats",
  "sample.search.scanner.instructions2": "Scanner le code-barres de l'échantillon pour rechercher les résultats",
  "sample.search.title": "Rechercher un échantillon",
  "sample.select.type": "Sélectionnez le type d'échantillon",
  "sample.type": "Type d'échantillon",
  "sample.type.and.test.sort.order": "Ordre de tri des types d'échantillons et des tests",
  "sample.uom.label": "Unité de mesure de l’échantillon",
  "sample.voided.title": "L’échantillon est annulé",
  "sampleManagement.actions": "Actions",
  "sampleManagement.addTests.button": "Ajouter des tests",
  "sampleManagement.addTests.cancel": "Annuler",
  "sampleManagement.addTests.duplicate": "Test déjà commandé pour {sampleId}",
  "sampleManagement.addTests.error": "Erreur lors de l'ajout des tests",
  "sampleManagement.addTests.incompatible": "Test non compatible avec le type d'échantillon ({sampleType})",
  "sampleManagement.addTests.selectSamples": "Sélectionnez le(s) échantillon(s) auquel ajouter des tests",
  "sampleManagement.addTests.selectTests": "Sélectionnez les test(s) à ajouter",
  "sampleManagement.addTests.skipped": "{count} doublons ignoré(s)",
  "sampleManagement.addTests.submit": "Ajouter des tests",
  "sampleManagement.addTests.success": "{compter} test(s) ajouté(s) avec succès",
  "sampleManagement.addTests.title": "Ajouter des tests aux échantillons",
  "sampleManagement.aliquot.button": "Créer une aliquote",
  "sampleManagement.aliquot.cancel": "Annuler",
  "sampleManagement.aliquot.error": "Erreur lors de la création de l'aliquote",
  "sampleManagement.aliquot.error.concurrentModification": "Cet exemple a été modifié par un autre utilisateur. Veuillez actualiser la page et réessayer.",
  "sampleManagement.aliquot.error.insufficientQuantity": "Impossible de répartir : la quantité demandée {requested} dépasse la quantité restante {remaining}.",
  "sampleManagement.aliquot.error.noRemainingQuantity": "Volume total distribué : aucune quantité restante disponible pour le fractionnement.",
  "sampleManagement.aliquot.notes": "Notes (facultatives)",
  "sampleManagement.aliquot.notesPlaceholder": "Ajouter des notes concernant cette aliquote...",
  "sampleManagement.aliquot.parentExternalId": "ID externe du parent",
  "sampleManagement.aliquot.parentLabel": "Échantillon parenta",
  "sampleManagement.aliquot.quantityPlaceholder": "Entrez la quantité...",
  "sampleManagement.aliquot.quantityToTransfer": "Quantité à transférer",
  "sampleManagement.aliquot.remainingQuantity": "Quantité restante",
  "sampleManagement.aliquot.submit": "Ajouter des notes concernant cette aliquote...",
  "sampleManagement.aliquot.success": "Aliquot {externalId} créé avec succès",
  "sampleManagement.aliquot.title": "Créer une aliquote",
  "sampleManagement.aliquot.unit": "Unité",
  "sampleManagement.aliquot.validation.exceeds": "la quantité dépasse la quantité restante",
  "sampleManagement.aliquot.validation.min": "La quantité doit être d'au moins 0,001",
  "sampleManagement.aliquot.validation.required": "Quantité à transférer requise",
  "sampleManagement.clearSelection": "Effacer la sélection",
  "sampleManagement.hierarchy.children": "Aliquotes:",
  "sampleManagement.hierarchy.collapse": "Réduire la hiérarchie",
  "sampleManagement.hierarchy.expand": "Développer la hiérarchie",
  "sampleManagement.hierarchy.level": "Niveau {niveau}",
  "sampleManagement.hierarchy.parent": "Parent:",
  "sampleManagement.notification.refreshResults": "Les résultats ont été mis à jour.",
  "sampleManagement.results.children": "Aliquotes",
  "sampleManagement.results.collectionDate": "Date de collecte",
  "sampleManagement.results.count": "{compter} échantillon(s) trouvé(s)",
  "sampleManagement.results.externalId": "Identifiant externe",
  "sampleManagement.results.originalQuantity": "Quantité originale",
  "sampleManagement.results.parent": "Parent",
  "sampleManagement.results.remainingQuantity": "Quantité restante",
  "sampleManagement.results.sampleType": "Type d'échantillon",
  "sampleManagement.results.status": "Statut",
  "sampleManagement.results.tests": "Tests",
  "sampleManagement.results.title": "Résultats de la recherche",
  "sampleManagement.search.button": "Recherche",
  "sampleManagement.search.error": "Erreur lors de la recherche d'échantillons",
  "sampleManagement.search.label": "Recherche par numéro de laboratoire",
  "sampleManagement.search.loading": "Recherche...",
  "sampleManagement.search.noResults": "Aucun échantillon trouvé avec ce numéro de laboratoire",
  "sampleManagement.search.placeholder": "Saisissez le numéro de laboratoire",
  "sampleManagement.selectSamples": "Sélectionner un ou plusieurs échantillons",
  "sampleManagement.selectedCount": "{compter} sélectionné",
  "sampleManagement.test.name": "Nom du Test",
  "sampleManagement.test.orderedDate": "Date de commande",
  "sampleManagement.test.status": "Statut",
  "sampleManagement.test.status.CANCELLED": "Annuler",
  "sampleManagement.test.status.COMPLETED": "Terminer ",
  "sampleManagement.test.status.IN_PROGRESS": "En cours",
  "sampleManagement.test.status.ORDERED": "Ordonné",
  "sampleManagement.title": "Gestion des échantillons",
  "sampleManagement.validation.accessionNumberRequired": "Un numéro de laboratoire est requis.",
  "sampleManagement.validation.parentSampleRequired": "L'élément parent de référence est requis.",
  "sampleManagement.validation.samplesRequired": "Au moins un échantillon doit être sélectionné",
  "sampleManagement.validation.testsRequired": "Au moins un test doit être sélectionné",
  "sampleType.existing": "Sortir des types d'échantillon",
  "sampleType.existing.inactive": "Type d'échantillons inactif. Attribuer des tests pour l'activer.",
  "sampleType.new": "Nouveau type d'échantillon",
  "sampleType.typeName": "Nom du type d'échantillon",
  "save.aliquot.changes": "Enregistrer les modifications de l’Aliquote",
  "save.config.success.msg": "Configuration mise à jour avec succès",
  "save.order.success.msg": "La commande a été enregistrée avec succès",
  "save.success": "Enregistrement réussi",
  "saving": "Enregistrer ",
  "search.by.dictionary.entry": "Rechercher une entrée du dictionnaire",
  "search.label": "Rechercher",
  "search.label.accession": "Saisissez le numéro d'accès",
  "search.label.analysis": "Sélectionnez l'état de l'analyse",
  "search.label.collectiondate": "Saisissez la date de collecte",
  "search.label.fromaccession": "Du numéro d'accès",
  "search.label.loadnext": "Charger les 99 enregistrements suivants à partir du numéro de laboratoire",
  "search.label.receiveddate": "Saisir la date de réception",
  "search.label.sample": "Sélectionnez l'état de l'échantillon",
  "search.label.test": "Sélectionnez le nom du test",
  "search.label.testdate": "Saisissez la date du test",
  "search.label.testunit": "Sélectionnez l'unité de test",
  "search.label.toaccession": "Au numéro d'accès",
  "search.patient.label": "Rechercher un patient",
  "search.placeholder": "Rechercher...",
  "searchTests.label": "Rechercher les tests disponibles",
  "searchTests.legend": "Recherchez parmi les tests disponibles",
  "searchindexmanagement.description": "L'index de recherche se met à jour automatiquement lorsque des données sont ajoutées ou modifiées. Si vous devez mettre à jour manuellement l'index de recherche, cliquez sur le bouton Démarrer la réindexation. Cela peut prendre un certain temps.",
  "searchindexmanagement.label": "Gestion de l'index de recherche",
  "searchindexmanagement.reindex": "Réindexer",
  "searchindexmanagement.reindex.error": "Erreur de réindexation",
  "searchindexmanagement.reindex.success": "Réindexation réussie",
  "select.aliquot": "Sélectionner l’aliquote",
  "select.datarange.label": "Sélectionner la plage de données",
  "select.dateRange": "Sélectionnez la plage de dates pour le résumé du rapport de test",
  "select.default.option.label": "Choisis une option",
  "select.end.date.referredTests": "Sélectionner la date de fin des tests référés",
  "select.labUnits": "Sélectionnez l'unité ou les unités de laboratoire pour lesquelles vous souhaitez créer le test. Vous pouvez en sélectionner autant que vous le souhaitez.",
  "select.label.analyser": "Choisir l'automate",
  "select.priority.tests": "Sélectionnez la priorité des tests que vous souhaitez afficher",
  "select.program": "Programme",
  "select.referral.centre": "Sélectionner le centre de référence",
  "select.referral.centre.is.required": "Le centre de référence est requis",
  "select.start.date.referredTests": "Sélectionner la date de début des tests référés",
  "select.timeFrame": "Sélectionnez les plages horaires pour lesquelles vous souhaitez générer les rapports",
  "select.timeFrame.Note": "NOTE : toutes les dates et heures sont basées sur l'heure de réception. Par exemple : un test reçu le 31 janvier à 23h59 et dont le résultat est obtenu le 1er février à 9h30 apparaîtrait comme étant hors des heures normales en janvier.",
  "select.year.report": "Sélectionnez l'année pour laquelle vous souhaitez générer les rapports",
  "selectListRenameEntry.selectList": "Renommer une entrée de liste de sélection",
  "selectListRenameEntry.selectListEdit": "Renommer une entrée de liste de sélection",
  "selectReportValues.title": "Sélectionner les valeurs du rapport",
  "selectResult.title": "Sélectionner le résultat",
  "serial.config.active.label": "Active",
  "serial.config.baudRate.label": "Baud Rate",
  "serial.config.connect.button": "Connect",
  "serial.config.connect.error": "Error connecting serial port",
  "serial.config.connect.success": "Serial port connected successfully",
  "serial.config.create.title": "Create Serial Port Configuration",
  "serial.config.dataBits.label": "Data Bits",
  "serial.config.disconnect.button": "Disconnect",
  "serial.config.disconnect.error": "Error disconnecting serial port",
  "serial.config.disconnect.success": "Serial port disconnected successfully",
  "serial.config.edit.title": "Edit Serial Port Configuration",
  "serial.config.flowControl.label": "Flow Control",
  "serial.config.flowControl.none": "None",
  "serial.config.form.legend": "Serial Port Settings",
  "serial.config.parity.even": "Even",
  "serial.config.parity.label": "Parity",
  "serial.config.parity.mark": "Mark",
  "serial.config.parity.none": "None",
  "serial.config.parity.odd": "Odd",
  "serial.config.parity.space": "Space",
  "serial.config.portName.label": "Port Name",
  "serial.config.save.error": "Error saving serial port configuration",
  "serial.config.save.success": "Serial port configuration saved successfully",
  "serial.config.status.label": "Connection Status",
  "serial.config.stopBits.label": "Stop Bits",
  "serial.config.validation.analyzerId.required": "Analyzer ID is required",
  "serial.config.validation.baudRate.invalid": "Baud rate must be between 9600 and 115200",
  "serial.config.validation.dataBits.invalid": "Data bits must be 7 or 8",
  "serial.config.validation.portName.required": "Port name is required",
  "server.error.msg": "Oups, erreur de serveur, veuillez contacter l'administrateur",
  "show.aliquoting": "Afficher l’aliquotage",
  "showing": "Affichage",
  "sidenav.label.addorder": "Ajouter une commande",
  "sidenav.label.admin": "Administration",
  "sidenav.label.admin.analyzerTest": "Nom du test de l'automate",
  "sidenav.label.admin.backToMainMenu": "Retour au menu principal",
  "sidenav.label.admin.labelPresets": "Label Presets",
  "sidenav.label.admin.commonproperties": "Propriétés de l'application",
  "sidenav.label.admin.eqaProgram": "Gestion des programmes d’EEQ",
  "sidenav.label.admin.formEntry.menustatementconfig": "Configuration de MenuStatement",
  "sidenav.label.admin.formEntry.nonconformityconfig": "Configuration de Non-Conformité",
  "sidenav.label.admin.formEntry.patientconfig": "Configuration de saisie du patient",
  "sidenav.label.admin.formEntry.PrintedReportsconfig": "Configuration des rapports imprimés",
  "sidenav.label.admin.formEntry.resultConfig": "Configuration de saisie de résultat",
  "sidenav.label.admin.formEntry.sampleEntryconfig": "Configuration de saisie de commande",
  "sidenav.label.admin.formEntry.siteBranding": "Site Branding",
  "sidenav.label.admin.formEntry.siteInfoconfig": "Informations sur le site",
  "sidenav.label.admin.formEntry.validationconfig": "Configuration de validation",
  "sidenav.label.admin.formEntry.Workplanconfig": "Configuration du plan de travail",
  "sidenav.label.admin.labNumber": "Gestion des numéros de laboratoire",
  "sidenav.label.admin.Listplugin": "Liste des plugins",
  "sidenav.label.admin.localization": "Localisation",
  "sidenav.label.admin.menu": "Configuration du menu",
  "sidenav.label.admin.menu.billing": "Configuration du menu de facturation",
  "sidenav.label.admin.menu.global": "Menu global",
  "sidenav.label.admin.menu.nonconform": "Configuration du menu des non-conformités",
  "sidenav.label.admin.menu.patient": "Configuration du menu des patients",
  "sidenav.label.admin.menu.study": "Configuration du menu d'étude",
  "sidenav.label.admin.organizationmgt": "Gestion de l'Organisation",
  "sidenav.label.admin.pluginFile": "Fichiers de plugin",
  "sidenav.label.admin.program": "Entrée du Programme",
  "sidenav.label.admin.testmgt": "Configuration des tests réflexes",
  "sidenav.label.admin.testmgt.calculated": "Gestion des tests de valeur calculée",
  "sidenav.label.admin.testmgt.testCatalogEditor": "Test Catalog Editor",
  "sidenav.label.admin.testCatalog": "Test Catalog Management",
  "sidenav.label.admin.testCatalog.backToList": "← All Tests",
  "sidenav.label.admin.testCatalog.sectionsHelper": "Select a test to edit its sections",
  "sidenav.label.admin.testCatalog.editing": "Editing: {name}",
  "sidenav.label.admin.testCatalog.editingGeneric": "Editing test",
  "label.testCatalog.editor": "Test Catalog Editor",
  "label.testCatalog.editor.empty": "No test selected",
  "label.testCatalog.editor.empty.helper": "Open a test from the Test Catalog list to edit it.",
  "label.testCatalog.editor.loadError": "Unable to load this test. Please try again.",
  "label.testCatalog.editor.saveAsNew": "Save as new test…",
  "label.testCatalog.editor.save.pending": "Saving is available once the section editors ship.",
  "label.testCatalog.editor.clone.pending": "Save as new test is available once the editor sections ship.",
  "label.testCatalog.section.pending": "This section's editor ships in a later milestone.",
  "label.testCatalog.section.basic-info": "Basic Info",
  "label.testCatalog.section.sample-results": "Sample & Results",
  "label.testCatalog.section.methods": "Methods",
  "label.testCatalog.section.ranges": "Ranges",
  "label.testCatalog.section.storage": "Sample Storage",
  "label.testCatalog.section.panels": "Panels",
  "label.testCatalog.section.terminology": "Terminology",
  "label.testCatalog.section.analyzers": "Analyzers",
  "label.testCatalog.section.display-order": "Display Order",
  "label.testCatalog.basicInfo.name": "Name",
  "label.testCatalog.basicInfo.name.helper": "Editing name, code and description is part of a later milestone.",
  "label.testCatalog.basicInfo.code": "Code",
  "label.testCatalog.basicInfo.description": "Description",
  "label.testCatalog.basicInfo.domain": "Domain",
  "label.testCatalog.basicInfo.domain.CLINICAL": "Clinical",
  "label.testCatalog.basicInfo.domain.ENVIRONMENTAL": "Environmental",
  "label.testCatalog.basicInfo.domain.VECTOR": "Vector",
  "label.testCatalog.basicInfo.domainModal.title": "Change test domain?",
  "label.testCatalog.basicInfo.domainModal.body": "Change this test's domain to {domain}? This affects how the test is categorized in the catalog.",
  "label.testCatalog.basicInfo.amr": "AMR surveillance test",
  "label.testCatalog.basicInfo.active": "Active",
  "label.testCatalog.basicInfo.orderable": "Orderable",
  "label.testCatalog.basicInfo.saved": "Basic info saved.",
  "label.testCatalog.sampleResults.saved": "Sample & results saved.",
  "label.testCatalog.sampleResults.empty": "No result components yet. Add one to define how this test's results are captured.",
  "label.testCatalog.sampleResults.newComponent": "(new component)",
  "label.testCatalog.sampleResults.code": "Component code",
  "label.testCatalog.sampleResults.label": "Component label",
  "label.testCatalog.sampleResults.resultType": "Result type",
  "label.testCatalog.sampleResults.resultType.N": "Numeric",
  "label.testCatalog.sampleResults.resultType.D": "Select list (dictionary)",
  "label.testCatalog.sampleResults.resultType.R": "Free text",
  "label.testCatalog.sampleResults.displayOrder": "Display order",
  "label.testCatalog.sampleResults.uom": "Unit of measure",
  "label.testCatalog.sampleResults.uom.none": "(none)",
  "label.testCatalog.sampleResults.significantDigits": "Significant digits",
  "label.testCatalog.sampleResults.defaultResult": "Default result",
  "label.testCatalog.sampleResults.allowMultiple": "Allow multiple readings",
  "label.testCatalog.sampleResults.options": "Select-list options",
  "label.testCatalog.sampleResults.option.value": "Value",
  "label.testCatalog.sampleResults.option.sortOrder": "Sort order",
  "label.testCatalog.sampleResults.option.normal": "Normal",
  "label.testCatalog.sampleResults.addOption": "Add option",
  "label.testCatalog.sampleResults.removeOption": "Remove option",
  "label.testCatalog.sampleResults.interpretations": "Interpretations",
  "label.testCatalog.sampleResults.interp.valueMatch": "Value match",
  "label.testCatalog.sampleResults.interp.text": "Interpretation",
  "label.testCatalog.sampleResults.interp.severity": "Severity",
  "label.testCatalog.sampleResults.addInterpretation": "Add interpretation",
  "label.testCatalog.sampleResults.removeInterpretation": "Remove interpretation",
  "label.testCatalog.sampleResults.severity.NORMAL": "Normal",
  "label.testCatalog.sampleResults.severity.ABNORMAL": "Abnormal",
  "label.testCatalog.sampleResults.severity.CRITICAL": "Critical",
  "label.testCatalog.sampleResults.actions": "Actions",
  "label.testCatalog.sampleResults.addComponent": "Add component",
  "label.testCatalog.sampleResults.removeComponent": "Remove component",
  "label.testCatalog.sampleResults.moveUp": "Move component up",
  "label.testCatalog.sampleResults.moveDown": "Move component down",
  "label.testCatalog.sampleResults.copyFrom": "Copy configuration from test",
  "label.testCatalog.sampleResults.copyFrom.placeholder": "Select a test…",
  "label.testCatalog.sampleResults.copyFromButton": "Copy from test",
  "label.testCatalog.sampleResults.copied": "Configuration copied.",
  "label.testCatalog.ranges.activated": "Test activated.",
  "label.testCatalog.ranges.ackModal.title": "Activate with coverage gaps?",
  "label.testCatalog.ranges.ackModal.confirm": "Acknowledge and activate",
  "label.testCatalog.ranges.ackModal.warning": "This test has reference-range coverage gaps.",
  "label.testCatalog.ranges.ackModal.body": "The following age windows have no reference range — results there cannot be flagged against a range. Acknowledge to activate anyway.",
  "label.testCatalog.ranges.male": "Male",
  "label.testCatalog.ranges.female": "Female",
  "label.testCatalog.ranges.gapRange": "{from} – {to}",
  "label.testCatalog.ranges.days": "days",
  "label.testCatalog.ranges.months": "months",
  "label.testCatalog.ranges.years": "years",
  "label.testCatalog.ranges.both": "Both",
  "label.testCatalog.ranges.add": "Add range",
  "label.testCatalog.ranges.empty": "No reference ranges defined yet.",
  "label.testCatalog.ranges.saved": "Reference ranges saved.",
  "label.testCatalog.ranges.loadError": "Could not load reference ranges.",
  "label.testCatalog.ranges.col.sex": "Sex",
  "label.testCatalog.ranges.col.age": "Age range",
  "label.testCatalog.ranges.col.normal": "Normal",
  "label.testCatalog.ranges.col.critical": "Critical",
  "label.testCatalog.ranges.col.actions": "Actions",
  "label.testCatalog.ranges.anyAge": "Any age",
  "label.testCatalog.ranges.coverage.title": "Coverage validation",
  "label.testCatalog.ranges.coverage.gapsHeading": "Uncovered age windows:",
  "label.testCatalog.ranges.coverage.status.COMPLETE": "Fully covered",
  "label.testCatalog.ranges.coverage.status.GAP": "Has gaps",
  "label.testCatalog.ranges.coverage.status.OVERLAP": "Has overlaps",
  "label.testCatalog.ranges.coverage.status.EMPTY": "No ranges",
  "label.testCatalog.ranges.modal.titleAdd": "Add reference range",
  "label.testCatalog.ranges.modal.titleEdit": "Edit reference range",
  "label.testCatalog.ranges.modal.sex": "Applies to",
  "label.testCatalog.ranges.modal.ageUnit": "Age unit",
  "label.testCatalog.ranges.modal.minAge": "From age",
  "label.testCatalog.ranges.modal.maxAge": "To age (blank = no upper bound)",
  "label.testCatalog.ranges.modal.lowNormal": "Normal low",
  "label.testCatalog.ranges.modal.highNormal": "Normal high",
  "label.testCatalog.ranges.modal.lowCritical": "Critical low",
  "label.testCatalog.ranges.modal.highCritical": "Critical high",
  "label.testCatalog.ranges.modal.ageError": "“To age” must be greater than “From age”.",
  "label.testCatalog.storage.saved": "Sample storage saved.",
  "label.testCatalog.storage.loadError": "Could not load sample storage settings.",
  "label.testCatalog.storage.storageHeading": "Storage",
  "label.testCatalog.storage.disposalHeading": "Disposal",
  "label.testCatalog.storage.handlingHeading": "Special handling",
  "label.testCatalog.storage.condition": "Storage condition",
  "label.testCatalog.storage.conditionCustom": "Custom condition",
  "label.testCatalog.storage.duration": "Maximum storage duration",
  "label.testCatalog.storage.durationUnit": "Duration unit",
  "label.testCatalog.storage.stabilityNotes": "Stability notes",
  "label.testCatalog.storage.protectFromLight": "Protect from light",
  "label.testCatalog.storage.doNotFreeze": "Do not freeze",
  "label.testCatalog.storage.doNotRefrigerate": "Do not refrigerate",
  "label.testCatalog.storage.disposalMethod": "Disposal method",
  "label.testCatalog.storage.disposalTimeframe": "Disposal timeframe",
  "label.testCatalog.storage.disposalUnit": "Timeframe unit",
  "label.testCatalog.storage.specialInstructions": "Special instructions",
  "label.testCatalog.storage.overrideRestricted": "Restrict storage-duration override",
  "label.testCatalog.storage.none": "— none —",
  "label.testCatalog.storage.condition.REFRIGERATED": "Refrigerated (2–8°C)",
  "label.testCatalog.storage.condition.FROZEN": "Frozen (−20°C)",
  "label.testCatalog.storage.condition.DEEP_FROZEN": "Deep frozen (−70°C)",
  "label.testCatalog.storage.condition.AMBIENT": "Ambient / room temperature",
  "label.testCatalog.storage.disposal.INCINERATION": "Incineration",
  "label.testCatalog.storage.disposal.AUTOCLAVE": "Autoclave",
  "label.testCatalog.storage.disposal.BIOHAZARD": "Biohazard waste",
  "label.testCatalog.storage.disposal.STANDARD": "Standard waste",
  "label.testCatalog.storage.unit.hours": "hours",
  "label.testCatalog.storage.unit.days": "days",
  "label.testCatalog.storage.unit.weeks": "weeks",
  "label.testCatalog.storage.unit.months": "months",
  "label.testCatalog.analyzers.infoCard": "Analyzers are linked to this test on the analyzer configuration screen. This list is read-only.",
  "label.testCatalog.analyzers.empty": "No analyzers are mapped to this test yet.",
  "label.testCatalog.analyzers.loadError": "Could not load analyzers for this test.",
  "label.testCatalog.analyzers.col.analyzer": "Analyzer",
  "label.testCatalog.analyzers.col.testName": "Analyzer test name",
  "label.testCatalog.displayOrder.pickSampleType": "Sample type",
  "label.testCatalog.displayOrder.intro": "Reorder how tests appear within a sample type. Order is saved automatically.",
  "label.testCatalog.displayOrder.empty": "No tests are assigned to this sample type.",
  "label.testCatalog.displayOrder.loadError": "Could not load the display order.",
  "label.testCatalog.displayOrder.saved": "Display order saved.",
  "label.testCatalog.displayOrder.moveUp": "Move up",
  "label.testCatalog.displayOrder.moveDown": "Move down",
  "label.testCatalog.displayOrder.col.position": "Position",
  "label.testCatalog.displayOrder.col.test": "Test",
  "label.testCatalog.displayOrder.dragHandle": "Drag to reorder",
  "label.testCatalog.terminology.intro": "Map this test to standard terminology codes for interoperability.",
  "label.testCatalog.terminology.col.source": "Source",
  "label.testCatalog.terminology.col.code": "Code",
  "label.testCatalog.terminology.col.relationship": "Relationship",
  "label.testCatalog.terminology.col.actions": "Actions",
  "label.testCatalog.terminology.source": "Terminology source",
  "label.testCatalog.terminology.code": "Code",
  "label.testCatalog.terminology.relationship": "Relationship",
  "label.testCatalog.terminology.addMapping": "Add mapping",
  "label.testCatalog.terminology.remove": "Remove mapping",
  "label.testCatalog.terminology.empty": "No terminology mappings yet.",
  "label.testCatalog.terminology.loadError": "Could not load terminology mappings.",
  "label.testCatalog.terminology.saved": "Terminology mappings saved.",
  "label.testCatalog.terminology.rel.none": "— none —",
  "label.testCatalog.terminology.rel.SAME_AS": "Same as",
  "label.testCatalog.terminology.rel.BROADER_THAN": "Broader than",
  "label.testCatalog.terminology.rel.NARROWER_THAN": "Narrower than",
  "label.testCatalog.panels.intro": "Manage which panels this test belongs to, and its position within each.",
  "label.testCatalog.panels.addToPanel": "Add to panel",
  "label.testCatalog.panels.col.panel": "Panel",
  "label.testCatalog.panels.col.position": "Position",
  "label.testCatalog.panels.col.actions": "Actions",
  "label.testCatalog.panels.position": "Position",
  "label.testCatalog.panels.remove": "Remove from panel",
  "label.testCatalog.panels.empty": "This test is not in any panel yet.",
  "label.testCatalog.panels.loadError": "Could not load panel memberships.",
  "label.testCatalog.panels.saved": "Panel memberships saved.",
  "label.testCatalog.panels.createPanel": "Create new panel",
  "label.testCatalog.panels.createPanelHint": "New panels are created in Master Lists → Panel Management, where their sample type and ordering modules are configured.",
  "label.search": "Search",
  "label.testCatalog.list": "Test Catalog",
  "label.testCatalog.list.search": "Search by test name",
  "label.testCatalog.list.col.status": "Status",
  "label.testCatalog.list.filter.allDomains": "All domains",
  "label.testCatalog.list.filter.allStatus": "All statuses",
  "label.testCatalog.list.filter.inactive": "Inactive",
  "label.testCatalog.list.coverageIncomplete": "Coverage incomplete",
  "label.testCatalog.list.filter.amr": "AMR",
  "label.testCatalog.list.filter.anyAmr": "Any",
  "label.testCatalog.list.filter.amrOnly": "AMR only",
  "label.testCatalog.list.filter.nonAmr": "Non-AMR",
  "label.testCatalog.list.amrTag": "AMR",
  "label.testCatalog.list.error": "Couldn't load the test catalog. Adjust the filters or reload to try again.",
  "label.testCatalog.list.empty": "No tests match the current filters.",
  "sidenav.label.admin.testmgt.ManageMethod": "Gérer la méthode",
  "sidenav.label.admin.testmgt.reflex": "Gestion des tests de réflexes",
  "sidenav.label.admin.testmgt.ViewtestCatalog": "Voir le catalogue des tests",
  "sidenav.label.admin.usermgt": "Gestion des Utilisateurs",
  "sideNav.label.arvfollowup1": "Suivi ARV version 1",
  "sideNav.label.arvfollowup2": "Suivi ARV version 2",
  "sideNav.label.arvreports1": "ARV version initiale 1",
  "sideNav.label.arvreports2": "ARV version initiale 2",
  "sideNav.label.arvversion1": "ARV-Version 1",
  "sideNav.label.associatedpatientreport": "Rapport de patient associé",
  "sideNav.label.audittrail": "Piste d'audit",
  "sidenav.label.barcode": "Code-barres",
  "sidenav.label.batchorder": "Saisie d'ordonnances en lot",
  "sideNav.label.bypaneltype": "Par type de panneau",
  "sideNav.label.bytesttype": "Par type de test",
  "sideNav.label.byunit": "Par unité",
  "sideNav.label.collectedarvpatientreports": "Rapport de patient ARV collecté",
  "sidenav.label.cytology": "Cytologie",
  "sidenav.label.cytology.dashboard": "Tableau de bord",
  "sideNav.label.delayedvalidation": "Validation retardée",
  "sidenav.label.editorder": "Modifier la commande",
  "sideNav.label.eidreports1": "EID version 1",
  "sideNav.label.eidreports2": "EID version 2",
  "sideNav.label.exportcsvfile": "Exporter le fichier CSV de routine",
  "sideNav.label.followuprequired": "Suivi requis",
  "sideNav.label.generalreport": "Rapport général",
  "sideNav.label.hivtestsummary": "Synthèse des tests VIH",
  "sidenav.label.immunochem": "Immuno-Histochimie",
  "sidenav.label.immunochem.dashboard": "Tableau de bord",
  "sidenav.label.incomingorder": "Statistiques journalières. ",
  "sideNav.label.intermediatebyservice": "Intermédiaire par service",
  "sideNav.label.intermediatereport1": "Version intermédiaire 1",
  "sideNav.label.intermediatereport2": "Version intermédiaire 2",
  "sidenav.label.inventory": "Inventaire",
  "sidenav.label.inventory.management": "Gestion des stocks",
  "sidenav.label.inventory.management.tooltip": "Gérer les articles, les lots et les niveaux de stock.",
  "sidenav.label.inventory.tooltip": "Gestion des stocks de réactifs, de kits et de fournitures",
  "sideNav.label.noncomformitynotification": "Notification de non-conformité",
  "sideNav.label.noncomformityreportsbydate": "Par date",
  "sideNav.label.noncomformityreportsbylabno": "Par numéro de laboratoire",
  "sideNav.label.noncomformityreportsbyunit": "Par unité et raison",
  "sidenav.label.notebook": "Carnet de notes",
  "sidenav.label.add.order": "Add Order",
  "sidenav.label.clinical.order": "Add Clinical Order",
  "sidenav.label.environmental.order": "Add Environmental Order",
  "sidenav.label.vector.order": "Add Vector Order",
  "sidenav.label.order": "Commande",
  "sidenav.label.order.collect": "Prélever un échantillon",
  "sidenav.label.order.dashboard": "Tableau de bord",
  "sidenav.label.order.enter": "Saisir la demande d’examen",
  "sidenav.label.order.label": " Étiqueter et stocker",
  "sidenav.label.order.qa": "Revue Assurance Qualité",
  "sidenav.label.pathology": "Pathologie",
  "sidenav.label.pathology.dashboard": "Tableau de Bord",
  "sideNav.label.referredtestreport": "Rapport de tests référencés",
  "sideNav.label.rejectionreport": "Rapport de rejet",
  "sidenav.label.reports": "Rapports",
  "sidenav.label.reports.routine": "Routine",
  "sidenav.label.reports.study": "Étude",
  "sidenav.label.results": "Résultats",
  "sidenav.label.results.byrange": "Par plage de numéros de commande",
  "sidenav.label.results.order": "Recherche par ordonnance",
  "sidenav.label.results.patient": "Par Patient",
  "sidenav.label.results.testdate": "Par Date de Test",
  "sidenav.label.results.unit": "Par Unité",
  "sideNav.label.sectionperformance": "Performances de la section",
  "sideNav.label.specialrequest": "Demande spéciale ",
  "sidenav.label.statisticsreport": "Rapport Statistiques",
  "sidenav.label.statusreport": "Rapport sur l'état du patient",
  "sidenav.label.storage.coldstorage": "Surveillance des entrepôts frigorifiques",
  "sidenav.label.storage.coldstorage.tooltip": "Surveiller la température et l'humidité des congélateurs et des réfrigérateurs.",
  "sidenav.label.storage.management": "Gestion du stockage",
  "sidenav.label.storage.management.tooltip": "Gérer les emplacements de stockage et les appareils",
  "sidenav.label.testsummary": "Résumé de tous les tests",
  "sidenav.label.validation": "Validation",
  "sidenav.label.validation.order": "Recherche Par Commande",
  "sidenav.label.validation.routine": "Routine",
  "sidenav.label.validation.study": "Étude",
  "sidenav.label.validation.testdate": "Recherche Par Date de Test",
  "sideNav.label.viralloaddataexport": "Exportation des données de charge virale",
  "sideNav.label.vlversionnational": "VL version Nationale",
  "sidenav.label.workplan": "Plan de Travail",
  "sidenav.label.workplan.panel": "Par Type de Panel",
  "sidenav.label.workplan.priority": "Par Priorité",
  "sidenav.label.workplan.test": "Par Type de Test",
  "sidenav.label.workplan.unit": "Par Unité",
  "sideNav.title.activityreport": "Rapport d'activité",
  "sidenav.title.aggregatereport": "Rapports globaux",
  "sideNav.title.arvreports": "Rapports ARV",
  "sideNav.title.associatedpatientreport": "Rapport de patient associé",
  "sideNav.title.audittrail": "Piste d'audit",
  "sideNav.title.collectedarvpatientreports": "Rapport de patient ARV collecté",
  "sideNav.title.delayedvalidation": "Validation retardée",
  "sideNav.title.eidreports": "Rapports EID",
  "sideNav.title.exportbydate": "Exporter par date",
  "sideNav.title.exportcsvfile": "Exporter le fichier CSV de routine",
  "sideNav.title.indicator": "Indicateur",
  "sideNav.title.intermediatereport": "Rapport intermédiaire",
  "sideNav.title.noncomformityreports": "Rapports de non-conformité",
  "sideNav.title.referredtestreport": "Rapport de tests référencés",
  "sideNav.title.rejectionreport": "Rapport de rejet",
  "sideNav.title.specialrequest": "Demande spéciale ",
  "sideNav.title.tatreport": "Délai de traitement",
  "sideNav.title.vlreport": "Rapport VL",
  "sideNav.label.audittrail.orderEvents": "Événements de la demande d’examen",
  "sideNav.label.audittrail.systemEvents": "Événements système",
  "sidenav.title.statusreport": "Rapport sur l'état du patient",
  "systemAudit.filter.startDate": "Date de début",
  "systemAudit.filter.endDate": "Date de fin",
  "systemAudit.filter.entityType": "Type d’entité ",
  "systemAudit.filter.action": "Action",
  "systemAudit.filter.search": "Rechercher",
  "systemAudit.filter.export": "Exporter en CSV",
  "systemAudit.table.heading.time": "Heure",
  "systemAudit.table.heading.entityType": "Type d’entité",
  "systemAudit.table.heading.entityId": "ID de l’entité ",
  "systemAudit.table.heading.action": "Action",
  "systemAudit.table.heading.user": "Utilisateur",
  "systemAudit.table.heading.changes": "Modifications",
  "systemAudit.noResults": "Aucun événement système trouvé pour les filtres donnés.",
  "systemAudit.filter.all": "Tous",
  "systemAudit.filter.user": "Utilisateur",
  "systemAudit.filter.searchText": "Rechercher",
  "systemAudit.filter.searchText.placeholder": "Rechercher par ID d’entité… ",
  "systemAudit.filter.exportPdf": "Exporter en PDF",
  "systemAudit.filter.selectedPatient": "Selected Patient",
  "systemAudit.filter.selectedPatient.none": "None",
  "systemAudit.filter.selectPatient": "Select Patient",
  "systemAudit.filter.selectAnotherPatient": "Select Another Patient",
  "systemAudit.action.insert": "Insérer",
  "systemAudit.action.update": "Mettre à jour ",
  "systemAudit.action.delete": "Supprimer",
  "site.branding.cancel": "Cancel",
  "site.branding.color.format.error": "Invalid color format. Please use a valid CSS color (e.g., #0f62fe)",
  "site.branding.color.hex.label": "Hex Color Code",
  "site.branding.colorPicker.helperText": "Enter any CSS color (e.g., #0f62fe, blue, rgb(15, 98, 254))",
  "site.branding.colorPicker.placeholder": "#0f62fe or blue",
  "site.branding.confirm.remove": "Remove Logo",
  "site.branding.confirm.remove.message": "Are you sure you want to remove this logo and revert to the default OpenELIS logo?",
  "site.branding.current.logo": "Current Logo",
  "site.branding.description": "Gestion de l’identité visuelle (logos et couleurs)",
  "site.branding.error.remove": "Error removing logo file.",
  "site.branding.favicon": "Favicon",
  "site.branding.favicon.description": "Icon displayed in browser tabs and bookmarks",
  "site.branding.file.format.error": "Unsupported file format. Please use PNG, SVG, or JPG/JPEG",
  "site.branding.file.pending": "File selected - click Save Changes to upload",
  "site.branding.file.size.error": "File size exceeds 2MB limit",
  "site.branding.formats": "Formats : PNG, SVG, JPG (max 2 Mo)",
  "site.branding.header.color": "Header Color",
  "site.branding.header.color.description": "Background color for the application header bar",
  "site.branding.header.logo": "Header Logo",
  "site.branding.header.logo.description": "Logo displayed in the top-left of the application header",
  "site.branding.login.logo": "Login Page Logo",
  "site.branding.login.logo.description": "Logo de la page de connexion",
  "site.branding.login.using.header.logo": "Using header logo for login page",
  "site.branding.logo.upload.success": "Logo uploaded successfully",
  "site.branding.no.logo": "No custom logo (using default)",
  "site.branding.preview": "Preview",
  "site.branding.primary.color": "Primary Color",
  "site.branding.primary.color.description": "Color for primary buttons, active menu items, and links",
  "site.branding.remove.favicon": "Remove Favicon",
  "site.branding.remove.header.logo": "Remove Header Logo",
  "site.branding.remove.login.logo": "Remove Login Logo",
  "site.branding.remove.logo": "Remove Logo",
  "site.branding.reset.confirmation": "Are you sure you want to reset all branding to OpenELIS defaults? This will remove all custom logos and colors.",
  "site.branding.reset.error": "Error resetting branding to defaults.",
  "site.branding.reset.success": "Branding reset to default values successfully.",
  "site.branding.reset.to.defaults": "Reset to Default Branding",
  "site.branding.save": "Save Changes",
  "site.branding.save.error": "Error saving branding configuration",
  "site.branding.save.success": "Branding configuration saved successfully",
  "site.branding.secondary.color": "Secondary Color",
  "site.branding.secondary.color.description": "Color for secondary buttons, borders, and inactive states",
  "site.branding.section.colors": "Colors",
  "site.branding.section.logos": "Logos",
  "site.branding.title": "Site Branding",
  "site.branding.unsaved.changes": "You have unsaved changes. Do you want to save, discard, or cancel?",
  "site.branding.unsaved.changes.warning": "You have unsaved changes. Click Save to apply them.",
  "site.branding.upload.favicon": "Upload Favicon",
  "site.branding.upload.header.logo": "Upload Header Logo",
  "site.branding.upload.login.logo": "Upload Login Logo",
  "site.branding.upload.logo": "Upload Logo",
  "site.branding.use.header.logo.for.login": "Use same logo as header",
  "siteInfo.description.default.barcode": "Indiquez le nombre par défaut d'étiquettes de code-barres qui doivent être imprimées avec chaque commande et spécimen.",
  "siteInfo.description.dimensions": "Indiquez les dimensions auxquelles les étiquettes de code-barres doivent se conformer lors de l'impression.",
  "siteInfo.description.elements": "Cochez la case à côté des éléments optionnels qui doivent apparaître sur les étiquettes de code-barres de commande et d'échantillon.",
  "siteInfo.description.max.barcode": "Indiquez le nombre maximum d'étiquettes de code-barres pouvant être imprimées pour chaque commande ou spécimen. Une fois le maximum atteint, un utilisateur ne pourra plus imprimer d'étiquettes supplémentaires.",
  "siteInfo.elements.mandatory": "Éléments Obligatoires",
  "siteInfo.elements.optional": "Éléments Optionnels",
  "siteInfo.section.altAccession": "Numéro d'accès au code-barres pré-imprimé",
  "siteInfo.section.elements": "Éléments de l'étiquette de code-barres",
  "siteInfo.section.number": "Nombre d'étiquettes de code-barres",
  "siteInfo.section.size": "Dimensions de l'étiquette de code-barres",
  "siteInfo.title.default.barcode": "Étiquettes de code-barres par défaut",
  "siteInfo.title.default.barcode.block": "Bloc",
  "siteInfo.title.default.barcode.height": "Hauteur",
  "siteInfo.title.default.barcode.order": "Commande",
  "siteInfo.title.default.barcode.order.none": "Aucune",
  "siteInfo.title.default.barcode.slide": "Lame",
  "siteInfo.title.default.barcode.specimen": "Échantillon",
  "siteInfo.title.default.barcode.freezer": "Congélateur",
  "siteInfo.title.default.barcode.width": "Largeur",
  "siteInfo.title.max.barcode": "Nombre maximum d'étiquettes de code-barres",
  "started.date": "Date de début",
  "status": "Statuts",
  "status.in.progress": "En Cours",
  "status.unknown": "Inconnue",
  "stillThere.message": "la session utilisateur est sur le point d'expirer. Cliquez pour rester connecté",
  "stillThere.title": "Toujours là?",
  "stock.available": "Disponible",
  "stock.level": "Niveau de stock",
  "stock.status": "État des stocks",
  "stock.status.expired": "Expiré",
  "stock.status.expiring": "Expiration",
  "stock.status.inStock": "En stock",
  "stock.status.lowStock": "Stock faible",
  "stock.status.outOfStock": "En rupture de stock",
  "storage.active": "Actif",
  "storage.add.device": "Ajouter un appareil",
  "storage.add.location": "Emplacement",
  "storage.add.location.option": "Ajouter Emplacement",
  "storage.add.new.device": "Ajouter un nouvel appareil",
  "storage.add.rack": "Ajouter un support",
  "storage.add.box": "Ajouter une boîte",
  "storage.add.room": "Ajouter une pièce",
  "storage.add.shelf": "Ajouter une étagère",
  "storage.allAssigned.title": "Tous les échantillons assignés",
  "storage.assign.button": "Attribuer un chemin ",
  "storage.assign.title": "Assigner un emplacement de stockage",
  "storage.assigned": "Assigné",
  "storage.assigned.by": "Attribué par",
  "storage.assigned.date": "Date d’attribution",
  "storage.barcode.scan.placeholder": "Scannez le code-barres ou saisissez manuellement.",
  "storage.bulk.move.auto.assigned": "Positions attribuées automatiquement (modifiables)",
  "storage.bulk.move.preview": "Aperçu de la suppression groupé",
  "storage.cannotDelete.hasAssignments": "Impossible de supprimer {entityType} '{name}': contient{count}type d'echantillon",
  "storage.cannotDelete.hasChildren": "Impossible de supprimer {entityType} '{name}' : contient {count} {childType}(s)",
  "storage.capacity.calculated": "Calculé",
  "storage.capacity.manual": "Limite manuelle",
  "storage.capacity.undetermined.tooltip": "La capacité ne peut pas être calculée : certains emplacements enfants n’ont pas de capacités définies",
  "storage.capacity.warning": "{location} est rempli à {percentage} %. Envisagez d’utiliser un autre emplacement de stockage.",
  "storage.code.change.acknowledge": "Je comprends et souhaite procéder à la modification du code.",
  "storage.code.change.warning": "Avertissement",
  "storage.code.change.warning.message": "La modification du code invalidera toutes les étiquettes imprimées précédemment pour cet emplacement.",
  "storage.confirm.add.device": "Voulez-vous créer un nouvel appareil '{name}' ?",
  "storage.conditionNotes": "Notes sur les conditions",
  "storage.conditionNotes.placeholder": "Saisissez des notes sur les conditions de stockage…",
  "storage.confirm.delete": "Confirmer la suppression",
  "storage.create.room.error": "Failed to create room: {error}",
  "storage.create.room.success": "Room \\",
  "storage.current.location": "Emplacement actuel",
  "storage.currentLocation": "Emplacement actuel ",
  "storage.delete.admin.only": "Seuls les administrateurs globaux peuvent supprimer des emplacements",
  "storage.delete.are.you.sure": "Êtes-vous sûr de vouloir supprimer",
  "storage.delete.cannot.be.undone": "Cette action est irréversible.",
  "storage.delete.cascade.confirm": "Confirmer la suppression en cascade",
  "storage.delete.cascade.confirmation.checkbox": "Je confirme vouloir supprimer cet emplacement et tous ses sous-emplacements. Tous les échantillons seront désattribués. Cette action est irréversible.",
  "storage.delete.cascade.summary": "Cela supprimera {childCount} {childType}(s) et désassignera {sampleCount} échantillon(s). Êtes-vous sûr de vouloir continuer ?",
  "storage.delete.cascade.warning": "Avertissement de suppression en cascade",
  "storage.delete.checking": "Vérification des contraintes…",
  "storage.delete.confirmation.checkbox": "Je confirme que je souhaite supprimer cet emplacement. Cette action est irréversible.",
  "storage.delete.constraints.title": "Suppression impossible",
  "storage.delete.device": "Supprimer l'appareil",
  "storage.delete.error": "Échec de la suppression de l’emplacement",
  "storage.delete.location": "Supprimer l'emplacement",
  "storage.delete.rack": "Supprimer le support",
  "storage.delete.room": "Supprimer la pièce",
  "storage.delete.shelf": "Supprimer l'étagère",
  "storage.device.code": "Code",
  "storage.device.communicationProtocol": "Protocole de communication",
  "storage.device.communicationProtocol.helper": "Protocole utilisé pour la communication entre les appareils (par exemple, BACnet)",
  "storage.device.ipAddress": "Adresse IP",
  "storage.device.ipAddress.helper": "Adresse IPv4 ou IPv6 pour les équipements connectés au réseau",
  "storage.device.label": "Appareil",
  "storage.device.name": "Nom",
  "storage.device.placeholder": "Sélectionnez ou saisissez pour créer un appareil…",
  "storage.device.port": "Port",
  "storage.device.port.helper": "Numéro de port (1-65535) pour la communication",
  "storage.device.room": "Chambre",
  "storage.device.type": "Type",
  "storage.edit.device": "Modifier l'appareil",
  "storage.edit.error.loadLocation": "Échec du chargement de l'emplacement",
  "storage.edit.error.saveFailed": "Échec de l'enregistrement",
  "storage.edit.error.saveHttp": "Échec de l'enregistrement (HTTP {status})",
  "storage.edit.rack": "Modifier le support",
  "storage.edit.room": "Modifier la salle",
  "storage.edit.shelf": "Modifier l'étagère",
  "storage.edit.selectParent": "Sélectionner {parent}",
  "storage.editbox.error.loadBox": "Échec du chargement de la boîte",
  "storage.editbox.selectRack": "Sélectionner le portoir",
  "storage.box.capacity": "Capacité",
  "storage.box.rows": "Lignes",
  "storage.box.columns": "Colonnes",
  "storage.box.preset": "Préréglage de dimensions",
  "storage.box.preset.select": "Sélectionner les dimensions",
  "storage.error.location.inactive": "Impossible d'affecter à un emplacement inactif",
  "storage.error.name.duplicate": "Une entité de  type {entityType} portant ce nom existe déjà dans l'emplacement parent sélectionné.",
  "storage.error.position.occupied": "Le poste est déjà occupé",
  "storage.expanded.capacityLimit": "Limite de capacité",
  "storage.expanded.createdBy": "Créé par",
  "storage.expanded.createdDate": "Date de création",
  "storage.expanded.description": "Description",
  "storage.expanded.lastModifiedBy": "Dernière modification par",
  "storage.expanded.lastModifiedDate": "Date de dernière modification",
  "storage.expanded.notAvailable": "N/A",
  "storage.expanded.positionSchemaHint": "Indication du schéma de position",
  "storage.expanded.temperatureSetting": "Réglage de la température",
  "storage.filter.by.locations": "Filtrer par emplacements",
  "storage.filter.by.locations.placeholder": "Filtrer par emplacements",
  "storage.filter.device": "Filtrer par appareil",
  "storage.filter.room": "Filtrer par Chambre",
  "storage.filter.status": "Filtrer par statut",
  "storage.hierarchical.path": "Chemin d'accès",
  "storage.inline.add.device": "Ajouter un nouvel appareil",
  "storage.inline.add.rack": "Ajouter un nouveau support ",
  "storage.inline.add.room": "Ajouter une nouvelle pièce",
  "storage.inline.add.shelf": "Ajouter une nouvelle étagère",
  "storage.location": "Emplacement",
  "storage.location.active": "Active",
  "storage.location.current": "Lieu de stockage",
  "storage.location.code": "Code Emplacement",
  "storage.location.code.helper": "10 caractères maximum, alphanumériques avec tirets/traits de soulignement",
  "storage.location.description": "Description",
  "storage.location.label": "Emplacement de stockage",
  "storage.location.name": "Nom de l'emplacement",
  "storage.location.unassigned": "Non attribué",
  "storage.manageLocation.error.saveFailed": "Échec de l'enregistrement",
  "storage.manageLocation.error.selectTarget": "Sélectionnez un appareil, une étagère, un portoir ou une boîte avant d'enregistrer",
  "storage.nav.device": "Appareil",
  "storage.nav.room": "Pièce",
  "storage.nav.shelf": "Étagère",
  "storage.picker.backToSearch": "Retour à la recherche",
  "storage.picker.createNewLocation": "Créer un nouvel emplacement",
  "storage.picker.currentLocation": "Emplacement actuel",
  "storage.picker.heading.assignLocation": "Attribuer un lieu de stockage",
  "storage.picker.heading.moveSample": "Déplacer l'échantillon",
  "storage.picker.newLocation": "Nouvel emplacement",
  "storage.picker.notes": "Notes",
  "storage.picker.position.optional": "Position (facultatif)",
  "storage.picker.select": "Sélectionner {level}",
  "storage.picker.addNewLevel": "Ajouter un nouveau {level}",
  "storage.picker.inlineCreate.heading": "Créer un nouveau {level}",
  "storage.picker.inlineCreate.error.title": "Impossible de créer l'emplacement",
  "storage.picker.inlineCreate.error": "Échec de la création de l'emplacement",
  "storage.picker.sample.accession": "Accession",
  "storage.picker.sample.heading": "Échantillon",
  "storage.picker.sample.status": "Statut",
  "storage.picker.sample.type": "Type",
  "storage.picker.storageLocation": "Lieu de stockage",
  "storage.metrics.active": "Active",
  "storage.metrics.disposed": "Rejeté",
  "storage.metrics.storage.locations": "Emplacements de stockage",
  "storage.metrics.total.samples": "Total des échantillons",
  "storage.mode.autocomplete": "Recherche à saisie semi-automatique",
  "storage.mode.barcode": "Numérisation des codes à barres",
  "storage.mode.cascading": "Menus déroulants en cascade",
  "storage.move.button": "Supprimer un échantillon",
  "storage.move.reason.label": "Raison de la suppression",
  "storage.nav.boxes": "Boxes",
  "storage.nav.boxes.tooltip": "Manage storage boxes",
  "storage.nav.dashboard": "Storage Dashboard",
  "storage.nav.devices": "Devices",
  "storage.nav.devices.tooltip": "Manage storage devices",
  "storage.nav.locations": "Locations",
  "storage.nav.locations.tooltip": "Manage storage locations",
  "storage.nav.racks": "Racks",
  "storage.nav.racks.tooltip": "Manage storage racks",
  "storage.nav.rooms": "Rooms",
  "storage.nav.rooms.tooltip": "Manage storage rooms",
  "storage.nav.sample.items": "Sample Items",
  "storage.nav.sample.items.tooltip": "View and manage stored samples",
  "storage.nav.samples": "Sample Items",
  "storage.nav.samples.tooltip": "View and manage stored samples",
  "storage.nav.shelves": "Shelves",
  "storage.nav.shelves.tooltip": "Manage storage shelves",
  "storage.no.data": "Aucune donnée disponible",
  "storage.occupancy": "Occupation",
  "storage.position.label": "Position",
  "storage.rack.device": "Appareil",
  "storage.rack.dimensions": "Dimensions",
  "storage.rack.label": "Support",
  "storage.rack.placeholder": "Sélectionnez ou saisissez pour créer un support…",
  "storage.rack.room": "Chambre",
  "storage.rack.shelf": "Étagère",
  "storage.room.code": "Code",
  "storage.room.devices": "Appareils",
  "storage.room.label": "Chambre",
  "storage.room.name": "Nom",
  "storage.room.placeholder": "Sélectionnez ou saisissez pour créer une chambre...",
  "storage.room.samples": "Echantillons",
  "storage.sampleitem.id": "ID d'élément d'échantillon",
  "storage.search.devices.placeholder": "Rechercher par nom ou code de l’appareil…",
  "storage.search.placeholder": "Recherche par identifiant d'échantillon ou par emplacement...",
  "storage.search.racks.placeholder": "Rechercher par étiquette de support d'echantillons…",
  "storage.search.rooms.placeholder": "Recherche par nom ou code de chambre...",
  "storage.search.samples.placeholder": "Recherche par identifiant d'échantillon ou par emplacement...",
  "storage.search.shelves.placeholder": "Rechercher par étiquette d’étagère…",
  "storage.select.location": "Sélectionner un emplacement",
  "storage.selectSample": "Sélectionner un échantillon ",
  "storage.shelf.device": "Appareil",
  "storage.shelf.label": "Étagère",
  "storage.shelf.placeholder": "Sélectionnez ou saisissez pour créer une étagère…",
  "storage.shelf.room": "Chambre",
  "storage.status": "Statut",
  "storage.status.disposed": "Rejeté",
  "storage.success.assigned": "Échantillon affecté avec succès à l'emplacement de stockage",
  "storage.success.moved": "L'échantillon a été déplacé avec succès vers son nouvel emplacement.",
  "storage.tab.devices": "Appareils",
  "storage.tab.racks": "Supports",
  "storage.tab.rooms": "Chambres",
  "storage.tab.samples": "éléments d’échantillon",
  "storage.tab.shelves": "Étagères",
  "storage.target.location": "Emplacement cible",
  "storage.unassigned.title": "Échantillons non assignés ",
  "storage.skipAssignment": "Aucun stockage requis – les échantillons seront traités immédiatement",
  "success.add.edited.msg": "Ajouté/Modifié avec succès",
  "success.delete.msg": "Supprimé avec succès",
  "success.import.patient": "Patient importé avec succès",
  "success.report.status": "Rapport généré avec succès",
  "success.save.msg": "Enregistré avec succès",
  "success.save.patient": "Patient enregistré avec succès",
  "systemuser.firstName": "Prénom de l'utilisateur",
  "systemuser.isActive": "Est actif",
  "systemuser.lastName": "Nom de l'utilisateur",
  "systemuser.loginName": "Nom d'utilisateur",
  "systemuser.role": "Rôles",
  "systemuserrole.apply": "Appliquer",
  "systemuserrole.copypermissions": "Copier les permissions de l'utilisateur",
  "systemuserrole.copypermissions.placeholder": "Copier les permissions d'un utilisateur",
  "systemuserrole.instruction.1": "Il existe deux types de rôles. Les rôles globaux qui sont définis pour l'ensemble de l'application et les rôles des unités de laboratoire qui peuvent être définis pour toutes les unités de laboratoire ou des unités spécifiques.",
  "systemuserrole.instruction.2": "Les rôles globaux disponibles sont : Administrateur global (accès à toutes les fonctions d'administration), Audit Trail (accès à tous les audits), Administrateur de comptes utilisateur (accès à toutes les fonctionnalités d'administration des comptes utilisateur, mais pas à d'autres fonctions d'administration).",
  "systemuserrole.instruction.3": "Les rôles des unités de laboratoire sont : Réception (accès aux onglets Commande, Patient et Non-conformité), Résultats (accès aux onglets Plan de travail, Non-conformité et Résultats), Validation (accès aux onglets Validation et Non-conformité), Rapports (accès à l'onglet Rapports sauf export CSV uniquement disponible pour les administrateurs globaux).",
  "systemuserrole.instruction.4": "Pour attribuer des rôles d'unités de laboratoire, sélectionnez toutes les unités de laboratoire ou l'unité spécifique dans le menu déroulant et sélectionnez les rôles que vous souhaitez définir.",
  "systemuserrole.instruction.5": "Vous pouvez également utiliser la fonctionnalité de copie des autorisations pour copier les autorisations d'un utilisateur existant. Assurez-vous d'avoir rempli toutes les informations ci-dessus et entrez le nom d'utilisateur dont vous souhaitez copier les autorisations dans la case et cliquez sur appliquer.",
  "systemuserrole.newpermissions": "Ajouter une nouvelle permission",
  "systemuserrole.rmpermissions": "Supprimer la permission",
  "systemuserrole.roles.global": "Rôles globaux",
  "systemuserrole.roles.labunit": "Rôles Unité de Laboratoire",
  "test.add.copy.name": "Copier depuis le nom du test",
  "test.antimicrobialResistance": "Résistance aux antimicrobiens",
  "test.description.active": "Si le test est actif, il peut être sélectionné sur le bulletin d'analyse ou dans le cadre d'un algorithme de test. S'il n'est pas actif, il ne peut pas être sélectionné ou faire partie d'un algorithme de test",
  "test.description.name": "Le nom du test tel qu'il apparaîtra dans openELIS. L'anglais et le français sont requis.",
  "test.description.orderable": "Si un test est actif et sélectionnable, il peut être sélectionné via un bulletin d'analyse. S'il est actif mais non sélectionnable, il ne sera actif que s'il est lié à un autre test.",
  "test.description.panel": "Si ce test fait partie d'un panel de tests, le panel peut être ajouté ici. Il est possible, mais pas habituel, qu'un test soit dans plus d'un panel",
  "test.description.reportName": "Nom du test tel qu'il apparaîtra dans les rapports. L'anglais et le français sont requis. Si le nom et le nom sur le rapport sont identiques, cliquez sur le bouton pour copier le nom.",
  "test.description.testSection": "La section de test dans laquelle le test sera effectué",
  "test.description.uom": "Unité de mesure du test. Cela ne s'applique généralement qu'aux résultats numériques ou alphanumériques",
  "test.field.active": "Actif",
  "test.field.orderable": "Sélectionnable",
  "test.inLabOnly": "Uniquement en laboratoire",
  "test.modify.en": "An",
  "test.modify.fr": "Fr",
  "test.modify.header.modify": "Sélectionner le test à modifier",
  "test.modify.header.test": "Test",
  "test.name": "Nom du test ",
  "test.notifyResults": "Notifier le patient des résultats",
  "test.section": "Section de test",
  "test.section.label": "Section d'essais",
  "test.show.guide": "Consulter l'aide",
  "testcalculation.label.calculation": "Calcul",
  "testcalculation.label.finalresult": "Résultat final",
  "testcalculation.label.insertOperation": "Insérer une opération",
  "testcalculation.label.integer": "Entier",
  "testcalculation.label.mathFucntion": "Fonction mathématique",
  "testcalculation.label.name": "Nom du calcul",
  "testcalculation.label.patientAttribute": "Attribut du patient",
  "testcalculation.label.searchNumericTest": "Rechercher un test numérique",
  "testcalculation.label.selectDictionaryValue": "Sélectionnez la valeur du dictionnaire",
  "testcalculation.label.testResult": "Résultat du test",
  "testcalculation.label.textValue": "Valeur de texte",
  "testCatalog.header.ageRange": "Tranche d’âge",
  "testCatalog.header.criticalRange": "Plage critique",
  "testCatalog.header.field": "Champ",
  "testCatalog.header.gender": "Sexe",
  "testCatalog.header.normalRange": "Valeurs normales ",
  "testCatalog.header.reportingRange": "Plage de rendu ",
  "testCatalog.header.validRange": "Plage valide",
  "testCatalog.header.value": "Valeur",
  "admin.testCatalog.methods.title": "Methods",
  "admin.testCatalog.methods.column.name": "Method Name",
  "admin.testCatalog.methods.column.code": "Code",
  "admin.testCatalog.methods.column.default": "Default",
  "admin.testCatalog.methods.column.effectiveDate": "Effective Date",
  "admin.testCatalog.methods.column.actions": "Actions",
  "admin.testCatalog.methods.action.edit": "Edit",
  "admin.testCatalog.methods.action.remove": "Remove",
  "admin.testCatalog.methods.btn.linkMethod": "+ Link Method",
  "admin.testCatalog.methods.btn.createMethod": "+ Create New Method",
  "admin.testCatalog.methods.btn.copyFromTest": "Copy from Test",
  "admin.testCatalog.methods.modal.link.title": "Link Method",
  "admin.testCatalog.methods.modal.link.selectPlaceholder": "Select a method to link",
  "admin.testCatalog.methods.modal.link.noAvailable": "All active methods are already linked",
  "admin.testCatalog.methods.inline.nameEnglish": "Method Name (English)",
  "admin.testCatalog.methods.inline.nameFrench": "Method Name (French)",
  "admin.testCatalog.methods.inline.code": "Shortcode",
  "admin.testCatalog.methods.inline.codeHint": "3–10 uppercase alphanumeric characters, no spaces",
  "admin.testCatalog.methods.inline.createAndLink": "Create & Link",
  "admin.testCatalog.methods.copyFromTest.label": "Copy methods from test",
  "admin.testCatalog.methods.copyFromTest.placeholder": "Select source test",
  "admin.testCatalog.methods.effectiveDate.label": "Effective Date",
  "admin.testCatalog.methods.default.label": "Set as default",
  "admin.testCatalog.methods.error.duplicateLink": "This method is already linked to the test",
  "admin.testCatalog.methods.error.codeFormat": "Code must be 3–10 uppercase alphanumeric characters with no spaces",
  "admin.testCatalog.methods.error.effectiveDateRequired": "Effective date is required",
  "admin.testCatalog.methods.empty": "No methods linked. Use '+ Link Method' or '+ Create New Method' to add one.",
  "testnotification.bcc": "BCC",
  "testnotification.instructionis.variables.body": "[testName] : Nom du test pour lequel cela est",
  "testnotification.instructionis.variables.body.0": "[testResult] : Résultat du test",
  "testnotification.instructionis.variables.body.1": "[patientFirstName] : Prénom du patient",
  "testnotification.instructionis.variables.body.2": "[patientLastNameInitial] : Initiale du nom de famille du patient",
  "testnotification.instructionis.variables.header": "Liste des variables :",
  "testnotification.instructions.body": "Lorsqu'une notification est créée, elle vérifiera d'abord si un modèle de message est défini pour le destinataire/type de message.",
  "testnotification.instructions.body.0": "S'il n'en existe pas, elle utilisera le message par défaut du test.",
  "testnotification.instructions.body.1": "Si cela n'existe pas, elle utilisera le message par défaut du système.",
  "testnotification.instructions.body.2": "Les variables seront remplacées par leurs valeurs correspondantes dans le corps du message et l'objet.",
  "testnotification.instructions.body.3": "Les variables doivent toujours être entre crochets et ne doivent pas contenir d'espaces.",
  "testnotification.instructions.header": "Instructions :",
  "testnotification.messagetemplate": "Message",
  "testnotification.options": "Messages individuels",
  "testnotification.patient.email": "E-mail du patient",
  "testnotification.patient.sms": "SMS du patient",
  "testnotification.patiententry.header": "Rapport de résultats",
  "testnotification.patiententry.info": "Si OpenELIS n'est pas en mesure de se connecter au destinataire des résultats transmis, il les mettra en file d'attente. Une file d'attente grande et croissante est un signe qu'il faut entreprendre des actions correctives, y compris contacter la partie réceptrice.",
  "testnotification.provider.email": "E-mail du prestataire",
  "testnotification.provider.sms": "SMS du prestataire",
  "testnotification.subjecttemplate": "Objet",
  "testnotification.systemdefault.template": "Message par défaut du système",
  "testnotification.testdefault.editIcon": "Modifier la notification de test",
  "testnotification.testdefault.template": "Message par défaut pour le test",
  "testnotificationconfig.browse.title": "Configuration des notifications de test",
  "tests.not.assigned": "Tests non assignés",
  "testsection.testSectionName": "Nom de la section de test",
  "testUnit.existing": "Unités de test existantes",
  "testUnit.existing.inactive": "Unités de test inactives. Attribuer des tests pour les activer",
  "testUnit.new": "Nouvelle unité de tests",
  "text.length.max": "La longueur du texte ne doit pas dépasser 200",
  "title.notestfoundmatching": "Aucun test trouvé correspondant",
  "to.title": "À",
  "tooltip.banner.menu.generic.sample.results": "Saisir les résultats des tests pour les échantillons génériques",
  "total.quantity": "Quantité totale",
  "transaction.date": "Date",
  "transaction.quantity": "Quantité",
  "transaction.type": "Type",
  "transaction.user": "Utilisateur",
  "true.label": "Vrai",
  "unifiedSystemUser.add.user": "Ajouter un utilisateur",
  "unifiedSystemUser.browser.button.add": "Ajouter un nouvel utilisateur",
  "unifiedSystemUser.browser.search": "Recherche par noms d'utilisateurs",
  "unifiedSystemUser.browser.search.placeholder": "Recherche par noms d'utilisateurs...",
  "unifiedSystemUser.browser.title": "Gestion des utilisateurs",
  "unifiedSystemUser.edit.user": "Modifier l'utilisateur",
  "unifiedSystemUser.select": "Sélectionner",
  "unknown.section": "Section inconnue",
  "unknown.test": "Test inconnu",
  "uom.browse.title": "Unité de mesure",
  "uom.create.heading.confirmation": "Confirmation",
  "uom.existing": "Unité de mesure actuelle",
  "uom.existing.inactive": "Unité de mesure inactive. Assignez des tests à cette unité de mesure pour l’activer.",
  "uom.new": "Créer une nouvelle unité de mesure",
  "uom.new.added": "Une nouvelle unité de mesure sera ajoutée",
  "uom.notification.duplicate": "L’unité de mesure existe déjà",
  "uom.notification.save": "La nouvelle unité de mesure a été enregistrée.",
  "uom.uomName": "Nom de l'unité de mesure",
  "training.installation.message": "Environnement de formation ",
  "translation.edit.title": "Modifier les traductions",
  "translation.export": "Exporter en CSV",
  "translation.export.success": " Traductions exportées avec succès",
  "translation.fallback": "Valeur de repli (anglais) ",
  "translation.management.description": "Voir et modifier les traductions des métadonnées",
  "translation.management.title": "Gestion des traductions",
  "translation.missing": "Manquant",
  "translation.search": "Rechercher des traductions…",
  "translation.selectLocale": "Sélectionner la langue ",
  "translation.showMissing": "Afficher uniquement les éléments manquants",
  "translation.stats.title": "Progression des traductions",
  "translation.stats.total": "Nombre total d’entrées : {count}",
  "translation.update.error": "Échec de la mise à jour de la traduction",
  "translation.update.success": "Traduction mise à jour avec succès",
  "translation.value": "Traduction",
  "usage.analysisId": "Identifiant de l'analyse",
  "usage.date": "Date d’utilisation",
  "usage.notes": "Notes",
  "usage.notes.placeholder": "Ajoutez toute note concernant cette utilisation",
  "usage.quantityUsed": "Quantité utilisée",
  "usage.quantityUsed.helper": "Saisissez le nombre d'unités utilisées ",
  "usage.record.button": "Enregistrement en cours",
  "usage.record.success": "Enregistrée avec succès",
  "usage.record.title": "Enregistrement le matériels utilisé  ",
  "usage.testResultId": "ID du résultat du test (facultatif)",
  "usage.testResultId.placeholder": "Lien vers le résultat du test pour la traçabilité",
  "user.select.instruction": "Sélectionnez un utilisateur à modifier ou à désactiver. Vous pouvez définir un filtre, rechercher des utilisateurs ou ajouter un utilisateur à l'aide des contrôles en haut.",
  "validation.accept.all": "Enregistrer tous les résultats",
  "validation.accept.normal": "Enregistrer tous les normals",
  "validation.field.required": "Ce champ est requis",
  "validation.ignore.all": "Ignorer tous les résultats",
  "validation.label.nonconform": "= L'échantillon ou la commande est non conforme ou le test a été rejeté",
  "validation.password.match": "Les mots de passe doivent correspondre",
  "validation.password.minLength": "Le mot de passe doit contenir au moins 7 caractères ",
  "validation.password.notSameAsOld": "Le nouveau mot de passe ne doit pas être identique à l’ancien",
  "validation.password.specialChar": "Le mot de passe doit contenir au moins un caractère spécial (*$#!) et une lettre majuscule ",
  "validation.no.records.display": "Aucun enregistrement a afficher",
  "validation.reject.all": "Rejeter tous les résultats",
  "validation.save.error": "Erreur lors de l'enregistrement de la validation",
  "validation.save.success": "Validation enregistrée avec succès",
  "validation.search.noresult": "Aucun résultat trouvé pour la validation",
  "validation.search.noresult.analyser": "Aucun résultat trouvé à partir de :",
  "vl.arvRegimen": "Régime ARV",
  "vl.durationOnARV": "Durée sous ARV (mois) ",
  "vl.durationOnARV.placeholder": "Saisir le nombre de mois de traitement",
  "vl.indication": "Indication du test de charge virale ",
  "vl.lastVLDate": "Date du dernier résultat de charge virale",
  "vl.lastVLResult": "Dernier résultat de charge virale (copies/mL) ",
  "vl.lastVLResult.placeholder": "ex. 150",
  "vl.pregnancyStatus": "Statut grossesse / allaitement ",
  "workplan.page.title": "Plan de Travail {0}",
  "workplan.panel.selection.error.msg": "Sélection du panneau invalide.",
  "workplan.panel.title": "Plan de Travail par Panel",
  "workplan.panel.types": "Panel",
  "workplan.print": "Imprimer Plan de Travail",
  "workplan.priority.list": "Priorité",
  "workplan.priority.title": "Plan de travail par priorité",
  "workplan.run": "Rechercher",
  "workplan.test.title": "Plan de Travail par Test",
  "workplan.test.types": "Test",
  "workplan.title": "Plan de Travail",
  "workplan.unit.title": "Plan de travail par unité",
  "workplan.unit.types": "Unité",
  "yes.option": "Oui",
  "shipment.module.title": "Gestion des expéditions",
  "shipment.breadcrumb": "Expédition d'échantillons",
  "shipment.nav.dashboard": "Tableau de bord",
  "shipment.nav.createBox": "Créer une boîte",
  "shipment.nav.receiveBox": "Recevoir une boîte",
  "shipment.dashboard.title": "Tableau de bord des expéditions",
  "shipment.dashboard.description": "Gérer les boîtes d'expédition et suivre les échantillons référés",
  "shipment.dashboard.tabs.shipments": "Expéditions",
  "shipment.dashboard.tabs.unassigned": "Analyses non assignées",
  "shipment.tab.boxes": "Boîtes d'expédition",
  "shipment.tab.unassignedSamples": "Échantillons non assignés",
  "shipment.label.boxId": "ID de la boîte",
  "shipment.label.createdDate": "Date de création",
  "shipment.label.daysUnassigned": "Jours non assignés",
  "shipment.label.destination": "Destination",
  "shipment.label.priority": "Priorité",
  "shipment.label.referralTest": "Analyse référée",
  "shipment.label.sampleCount": "Nombre d'échantillons",
  "shipment.label.state": "État",
  "shipment.label.tests": "Analyses",
  "shipment.filter.state": "Filtrer par état",
  "shipment.filter.facility": "Filtrer par établissement",
  "shipment.action.addToBox": "Ajouter à la boîte",
  "shipment.action.cancelReferral": "Annuler la référence",
  "shipment.action.confirmRejection": "Confirmer le rejet",
  "shipment.action.createBox": "Créer une nouvelle boîte",
  "shipment.action.markAsLost": "Marquer comme perdu",
  "shipment.action.printManifest": "Imprimer le bordereau",
  "shipment.action.rejectSample": "Rejeter l'échantillon",
  "shipment.action.saveAndMarkReady": "Enregistrer et marquer prêt à envoyer",
  "shipment.action.saveBox": "Enregistrer la boîte",
  "shipment.action.saveDraft": "Enregistrer comme brouillon",
  "shipment.action.scanSample": "Scanner l'échantillon",
  "shipment.box.addSample": "Ajouter un échantillon",
  "shipment.box.addSampleDescription": "Sélectionner les échantillons à ajouter à cette boîte d'expédition",
  "shipment.box.addSamples": "Ajouter des échantillons",
  "shipment.box.autoGenerate": "Générer automatiquement",
  "shipment.box.capacity": "Capacité",
  "shipment.box.capacityValue": "{capacity} échantillons",
  "shipment.box.create": "Créer une boîte",
  "shipment.box.createDescription": "Créer une nouvelle boîte d'expédition pour les échantillons référés",
  "shipment.box.created": "Date de création :",
  "shipment.box.createdBy": "Créé par :",
  "shipment.box.createdDate": "Date de création",
  "shipment.box.destination": "Destination",
  "shipment.box.downloadLabel": "Télécharger l'étiquette",
  "shipment.box.downloadManifest": "Télécharger le bordereau",
  "shipment.box.generateLabel": "Générer l'étiquette",
  "shipment.box.generateManifest": "Générer le bordereau",
  "shipment.box.id": "ID de boîte :",
  "shipment.box.labelDownloaded": "Étiquette téléchargée avec succès",
  "shipment.box.labelPrefix": "Préfixe d'étiquette",
  "shipment.box.labelPrefixHelper": "Configuré par l'administrateur dans les paramètres du site",
  "shipment.box.manifest": "Bordereau",
  "shipment.box.manifestDownloaded": "Bordereau téléchargé avec succès",
  "shipment.box.noSamples": "Cette boîte ne contient pas encore d'échantillons",
  "shipment.box.noUnassignedSamples": "Aucun échantillon non assigné trouvé pour cet établissement",
  "shipment.box.notes": "Notes",
  "shipment.box.notesPlaceholder": "Saisir les instructions spéciales de manipulation ou les notes...",
  "shipment.box.number": "Numéro de boîte",
  "shipment.box.readyConfirmation": "Êtes-vous sûr de vouloir marquer cette boîte comme prête à envoyer ?",
  "shipment.box.readySampleCount": "Cette boîte contient {count} échantillon(s)",
  "shipment.box.readyToSend": "Marquer prêt à envoyer",
  "shipment.box.reconcile": "Rapprocher",
  "shipment.box.removeSample": "Retirer l'échantillon",
  "shipment.box.removeSampleConfirmation": "Êtes-vous sûr de vouloir retirer cet échantillon de la boîte ?",
  "shipment.box.resendManifest": "Renvoyer le bordereau",
  "shipment.box.sampleCount": "Nombre d'échantillons",
  "shipment.box.sampleProgress": "{added} / {capacity} ({remaining} restant(s))",
  "shipment.box.samplesAdded": "Échantillons ajoutés",
  "shipment.box.samplesSelected": "{count} échantillon(s) sélectionné(s)",
  "shipment.box.scanExisting": "Scanner un existant",
  "shipment.box.scanExistingId": "Scanner ou saisir l'ID de boîte existant",
  "shipment.box.scanExistingIdPlaceholder": "Scanner le code-barres ou saisir l'ID de boîte",
  "shipment.box.sendBox": "Envoyer la boîte",
  "shipment.box.sendConfirmation": "Êtes-vous sûr de vouloir envoyer cette boîte ?",
  "shipment.box.sendSampleCount": "Cette boîte contient {count} échantillon(s) qui seront marqué(s) comme envoyé(s)",
  "shipment.box.state": "État",
  "shipment.box.summary": "Résumé",
  "shipment.box.temperature": "Exigence de température",
  "shipment.box.title": "Boîte {boxId}",
  "shipment.box.useExistingId": "Mode ID de boîte",
  "shipment.dashboard.boxNotFound": "Aucune boîte trouvée avec l'ID \"{boxId}\". Essayez de filtrer la liste à la place.",
  "shipment.dashboard.scanBoxPlaceholder": "Rechercher ou scanner l'ID de boîte (appuyez sur Entrée pour naviguer)",
  "shipment.error.addSample": "Échec de l'ajout de l'échantillon à la boîte",
  "shipment.error.assignToBox": "Échec de l'assignation de l'échantillon à la boîte",
  "shipment.error.boxFull": "La boîte est pleine. Impossible d'ajouter plus d'échantillons.",
  "shipment.error.boxNotEmpty": "La boîte doit contenir au moins un échantillon",
  "shipment.error.boxNotFound": "Boîte introuvable",
  "shipment.error.cancelReferral": "Échec de l'annulation de la référence",
  "shipment.error.confirmReception": "Échec de la confirmation de réception",
  "shipment.error.createBox": "Échec de la création de la boîte d'expédition",
  "shipment.error.exceedsCapacity": "Impossible d'ajouter {requested} échantillon(s). Seulement {available} emplacement(s) disponible(s).",
  "shipment.error.fetchBox": "Échec de la récupération des informations de la boîte",
  "shipment.error.fetchBoxes": "Échec de la récupération des boîtes disponibles",
  "shipment.error.generateLabel": "Erreur lors de la génération de l'étiquette d'expédition",
  "shipment.error.generateManifest": "Erreur lors de la génération du bordereau",
  "shipment.error.invalidState": "État de boîte invalide pour cette opération",
  "shipment.error.markAsLost": "Échec du marquage de l'échantillon comme perdu",
  "shipment.error.markReady": "Échec du marquage de la boîte comme prête à envoyer",
  "shipment.error.noDestinationFacility": "Aucun établissement de destination spécifié pour cet échantillon",
  "shipment.error.noReferralId": "Aucun ID de référence disponible pour cet échantillon",
  "shipment.error.noSampleSelected": "Veuillez sélectionner au moins un échantillon",
  "shipment.error.partialReception": "Certaines mises à jour de statut d'échantillons ont échoué. Veuillez réessayer SVP.",
  "shipment.error.reasonRequired": "Veuillez fournir un motif SVP",
  "shipment.error.reconcile": "Erreur lors du rapprochement de la boîte",
  "shipment.error.removeSample": "Échec du retrait de l'échantillon de la boîte",
  "shipment.error.sampleAlreadyAssigned": "Cet échantillon est déjà assigné à une boîte",
  "shipment.error.sampleAlreadyInBox": "Échantillon déjà dans la boîte",
  "shipment.error.sampleNotFound": "Échantillon introuvable",
  "shipment.error.saveFailed": "Échec de l'enregistrement",
  "shipment.error.searchFailed": "Échec de la recherche de l'échantillon. Veuillez réessayer SVP.",
  "shipment.error.selectBox": "Veuillez sélectionner une boîte SVP",
  "shipment.error.sendBox": "Échec de l'envoi de la boîte",
  "shipment.filter.clear": "Effacer les filtres",
  "shipment.filter.dateFrom": "Date de début",
  "shipment.filter.dateTo": "Date de fin",
  "shipment.filter.referenceLab": "Laboratoire de référence",
  "shipment.label.addedDate": "Date d'ajout",
  "shipment.label.position": "Position",
  "shipment.label.samples": "Échantillons",
  "shipment.label.shippingLabel": "ÉTIQUETTE D'EXPÉDITION",
  "shipment.manifest.generated": "Généré le :",
  "shipment.manifest.number": "N°",
  "shipment.manifest.recallExpired": "Le rappel du bordereau n'est plus disponible (délai de 7 jours dépassé depuis l'envoi)",
  "shipment.manifest.regenerationExpired": "La régénération du bordereau n'est plus disponible (délai de 24 heures dépassé depuis l'envoi)",
  "shipment.manifest.serviceLocation": "Lieu de service :",
  "shipment.manifest.specimenBarcodes": "Codes-barres des spécimens",
  "shipment.manifest.title": "Bordereau d'expédition",
  "shipment.manifest.totalSamples": "Total des échantillons :",
  "shipment.modal.addToBox.existingBox": "Ajouter à une boîte existante",
  "shipment.modal.addToBox.mode": "Sélectionner une option",
  "shipment.modal.addToBox.newBox": "Créer une nouvelle boîte",
  "shipment.modal.addToBox.newBoxInfo.message": "Vous serez redirigé pour créer une nouvelle boîte pour cet échantillon",
  "shipment.modal.addToBox.newBoxInfo.title": "Créer une nouvelle boîte",
  "shipment.modal.addToBox.noDraftBoxes.message": "Aucune boîte brouillon trouvée pour cette destination. Une nouvelle boîte sera créée.",
  "shipment.modal.addToBox.noDraftBoxes.title": "Aucune boîte brouillon disponible",
  "shipment.modal.addToBox.selectBox": "Sélectionner une boîte",
  "shipment.modal.addToBox.title": "Ajouter un échantillon à la boîte",
  "shipment.modal.cancelReferral.reason": "Motif de l'annulation",
  "shipment.modal.cancelReferral.reasonPlaceholder": "Veuillez expliquer pourquoi cette référence est annulée...",
  "shipment.modal.cancelReferral.title": "Annuler la référence",
  "shipment.modal.cancelReferral.warning.message": "Cette action annulera définitivement la référence et ne peut pas être annulée.",
  "shipment.modal.cancelReferral.warning.title": "Avertissement",
  "shipment.modal.createBox.cancel": "Annuler",
  "shipment.modal.createBox.submit": "Créer",
  "shipment.modal.createBox.title": "Créer une nouvelle boîte",
  "shipment.modal.markAsLost.reason": "Motif du marquage comme perdu",
  "shipment.modal.markAsLost.reasonPlaceholder": "Veuillez expliquer pourquoi cet échantillon est marqué comme perdu...",
  "shipment.modal.markAsLost.title": "Marquer l'échantillon comme perdu",
  "shipment.modal.markAsLost.warning.message": "Cette action marquera définitivement l'échantillon comme perdu et ne peut pas être annulée.",
  "shipment.modal.markAsLost.warning.title": "Avertissement",
  "shipment.modal.rejectSample": "Rejeter l'échantillon",
  "shipment.modal.rejectSampleMessage": "Êtes-vous sûr de vouloir rejeter l'échantillon {accession} ?",
  "shipment.nav.reports": "Rapports",
  "shipment.nav.settings": "Paramètres",
  "shipment.notification.boxCreated": "Boîte créée avec succès",
  "shipment.notification.boxReadyToSend": "Boîte marquée comme prête à envoyer",
  "shipment.notification.boxReconciled": "La boîte a été rapprochée avec succès",
  "shipment.notification.boxSent": "Boîte envoyée avec succès",
  "shipment.notification.error": "Une erreur est survenue : {message}",
  "shipment.notification.partialSamplesAdded": "Seulement {added} sur {total} échantillons ajoutés. Capacité de la boîte atteinte ({notAdded} non ajouté(s)).",
  "shipment.notification.receptionComplete": "Expédition reçue avec succès",
  "shipment.notification.referralCancelled": "Référence annulée avec succès",
  "shipment.notification.sampleAdded": "Échantillon {accessionNumber} ajouté avec {testCount, plural, one {# analyse} other {# analyses}}",
  "shipment.notification.sampleAssignedToBox": "Échantillon assigné à la boîte avec succès",
  "shipment.notification.sampleMarkedAsLost": "Échantillon marqué comme perdu",
  "shipment.notification.sampleRejected": "Échantillon {accession} rejeté : {reason}",
  "shipment.notification.sampleRemoved": "Échantillon retiré de la boîte",
  "shipment.notification.samplesAdded": "{count, plural, one {# sample added to box} many {# samples added to box} other {# échantillons ajoutés à la boîte}}",
  "shipment.notification.samplesRemovedDueToCapacity": "{removed} échantillon(s) retiré(s) en raison de la réduction de capacité.",
  "shipment.reception.applyToAll": "Appliquer le statut à tous...",
  "shipment.reception.confirmMessage": "Confirmer la réception de {count} échantillon(s) ?",
  "shipment.reception.confirmReception": "Confirmer la réception",
  "shipment.reception.damaged": "Endommagé",
  "shipment.reception.description": "Scanner le code-barres de la boîte pour recevoir et vérifier les échantillons",
  "shipment.reception.enterBoxId": "Veuillez saisir un ID de boîte",
  "shipment.reception.generalNotes": "Notes générales",
  "shipment.reception.generalNotesPlaceholder": "Saisir les notes de réception générales",
  "shipment.reception.importError": "Erreur lors de l'importation des expéditions depuis le serveur distant",
  "shipment.reception.importFromFhir": "Importer depuis FHIR",
  "shipment.reception.importResult": "{count, plural, =0 {Aucune nouvelle expédition trouvée} one {1 expédition importée} other {{count} expéditions importées}}",
  "shipment.reception.leaked": "Fuité",
  "shipment.reception.markAllMissing": "Tout marquer comme manquant",
  "shipment.reception.markAllReceived": "Tout marquer comme reçu",
  "shipment.reception.missing": "Manquant",
  "shipment.reception.notes": "Notes",
  "shipment.reception.notesPlaceholder": "Saisir les notes si nécessaire",
  "shipment.reception.notesRequired": "Les notes sont obligatoires pour les échantillons non reçus en bon état",
  "shipment.reception.notesRequiredPlaceholder": "Obligatoire : décrivez le problème",
  "shipment.reception.pending": "En attente",
  "shipment.reception.received": "Reçu",
  "shipment.reception.rejected": "Rejeté",
  "shipment.reception.sampleNotFound": "Échantillon {accessionNumber} introuvable dans cette boîte",
  "shipment.reception.sampleScanned": "Échantillon {accessionNumber} enregistré comme reçu",
  "shipment.reception.sampleVerification": "Vérification des échantillons",
  "shipment.reception.scanBox": "ID de boîte / Code-barres",
  "shipment.reception.scanBoxPlaceholder": "Scanner ou saisir le code-barres de la boîte",
  "shipment.reception.scanButton": "Scanner la boîte",
  "shipment.reception.scanSample": "Scanner l'ID de l'échantillon",
  "shipment.reception.scanSampleButton": "Enregistrer l'échantillon",
  "shipment.reception.scanSamplePlaceholder": "Scanner ou saisir le numéro d'enregistrement de l'échantillon",
  "shipment.reception.status": "Statut de réception",
  "shipment.reception.title": "Recevoir l'expédition",
  "shipment.rejection.damaged": "Endommagé",
  "shipment.rejection.expired": "Expiré",
  "shipment.rejection.insufficientVolume": "Volume insuffisant",
  "shipment.rejection.other": "Autre",
  "shipment.rejection.reason": "Motif du rejet",
  "shipment.rejection.wrongType": "Mauvais type d'échantillon",
  "shipment.report.contents": "Contenu",
  "shipment.report.description": "Générer et exporter des rapports d'expédition par boîte, date, destination ou laboratoire de référence",
  "shipment.report.export.excel": "Exporter en Excel",
  "shipment.report.export.pdf": "Exporter en PDF",
  "shipment.report.generate": "Générer le rapport",
  "shipment.report.noResults": "Aucun enregistrement d'expédition trouvé pour les filtres sélectionnés",
  "shipment.report.receivedDate": "Date de réception",
  "shipment.report.receivedStatus": "Statut de réception",
  "shipment.report.receiver": "Destinataire",
  "shipment.report.receivingUser": "Utilisateur récepteur",
  "shipment.report.sender": "Expéditeur",
  "shipment.report.sentDate": "Date d'envoi",
  "shipment.report.title": "Rapports d'expédition",
  "shipment.report.totalBoxes": "Total des boîtes",
  "shipment.report.totalSamples": "Total des échantillons",
  "shipment.sample.accessionNumber": "Numéro d'enregistrement",
  "shipment.sample.remove": "Retirer",
  "shipment.sample.search": "Rechercher un échantillon par numéro d'enregistrement",
  "shipment.sample.searchPlaceholder": "Scanner ou saisir le numéro d'enregistrement",
  "shipment.sample.status": "Statut",
  "shipment.sample.type": "Type d'échantillon",
  "shipment.settings.administration": "Administration",
  "shipment.settings.boxLabelSection": "Configuration des étiquettes de boîte",
  "shipment.settings.description": "Configurer les paramètres du module d'expédition",
  "shipment.settings.fhirConfig": "Options de mappage FHIR",
  "shipment.settings.fhirConfigDesc": "Configurer le mappage SupplyDelivery et les types de conteneurs de spécimens pour l'interopérabilité FHIR",
  "shipment.settings.fhirConfigNote": "Le mappage FHIR est configuré via les propriétés de l'application. Contactez votre administrateur système pour les modifications.",
  "shipment.settings.fhirConfigSaveError": "Erreur lors de l'enregistrement de la configuration du mappage FHIR",
  "shipment.settings.fhirConfigSaved": "Configuration du mappage FHIR enregistrée",
  "shipment.settings.fhirContainerType": "Type de conteneur de spécimen (SNOMED CT)",
  "shipment.settings.fhirDisplayName": "Nom d'affichage",
  "shipment.settings.fhirNonConformity": "Codes de non-conformité (SNOMED CT)",
  "shipment.settings.fhirSnomedCode": "Code SNOMED CT",
  "shipment.settings.manageFacilities": "Gérer le registre des établissements",
  "shipment.settings.manageFacilitiesDesc": "Ajouter, modifier ou supprimer des destinations de laboratoires de référence",
  "shipment.settings.manageUsers": "Gérer les utilisateurs",
  "shipment.settings.manageUsersDesc": "Configurer les comptes utilisateurs et les rôles pour le module d'expédition",
  "shipment.settings.prefixHelperText": "Préfixe utilisé lors de la génération de nouveaux ID de boîte (ex. : BOX, SHIP, LAB)",
  "shipment.settings.prefixPlaceholder": "BOX",
  "shipment.settings.prefixPreview": "Aperçu : {preview}",
  "shipment.settings.prefixRequired": "Le préfixe d'étiquette de boîte est obligatoire",
  "shipment.settings.prefixSaveError": "Erreur lors de l'enregistrement du préfixe d'étiquette de boîte",
  "shipment.settings.prefixSaved": "Préfixe d'étiquette de boîte enregistré avec succès",
  "shipment.settings.siteOrgDescription": "Sélectionnez l'organisation qui représente ce laboratoire. Seules les expéditions destinées à cette organisation seront importées depuis les serveurs FHIR distants.",
  "shipment.settings.siteOrgLabel": "Ce laboratoire",
  "shipment.settings.siteOrgSaveError": "Erreur lors de l'enregistrement de l'organisation du site",
  "workflow.clinical": "Clinique",
  "workflow.environmental": "Environnemental / Autre",
  "provider.name": "Nom du prescripteur",
  "provider.name.placeholder": "Saisir le nom du prescripteur",
  "provider.phone": "Téléphone du prescripteur",
  "provider.search.helper": "Saisir le nom ou le numéro de téléphone du prescripteur et appuyer sur Rechercher.",
  "site.search": "Recherche de site",
  "site.name": "Nom du site",
  "site.name.placeholder": "Saisir le nom du site",
  "site.location": "Localisation",
  "site.type": "Type",
  "site.department": "Département / Service / Unité",
  "site.department.selectFirst": "Sélectionner d'abord un établissement...",
  "site.department.none": "Aucune sous-unité disponible",
  "sample.filterByLabUnit": "Filtrer par unité de laboratoire",
  "sample.allLabUnits": "Toutes les unités de laboratoire",
  "sample.orderPanels": "Panels de demande d'examen",
  "sample.orderTests": "Analyses de la demande d'examen",
  "sample.referToReferenceLab": "Référer l'analyse à un laboratoire de référence",
  "sample.optional.info": "La sélection de l'échantillon et de l'analyse est facultative à cette étape. Les analyses et le type d'échantillon peuvent être spécifiés ultérieurement lors de la collecte.",
  "panel.search.placeholder": "Choisir un panel disponible",
  "test.search.placeholder": "Choisir une analyse disponible",
  "select.regimen": "Sélectionner un régime...",
  "select": "Sélectionner...",
  "generating": "Génération en cours...",
  "label.order": "Étiquette de la demande d'examen",
  "label.sample": "Étiquette d'échantillon",
  "label.slide": "Étiquette de lame",
  "label.block": "Étiquette de bloc",
  "label.freezer": "Étiquette de congélateur",
  "environmental.coming.soon": "Flux de travail environnemental",
  "environmental.location.info": "Les champs de hiérarchie de localisation (Région/District/Ville-Village) et la capture GPS seront disponibles ici.",
  "env.collectionConditions.title": "Default Collection Conditions",
  "env.collectionConditions.subtitle": "Defaults applied to all samples in this batch.",
  "env.collectionMethod": "Collection Method",
  "env.waterTemp": "Water Temp (°C)",
  "env.ambientTemp": "Ambient Temp (°C)",
  "env.weather": "Weather",
  "env.preservationMethod": "Preservation Method",
  "env.preservationMethod.placeholder": "e.g., HNO3 acidification, 4°C cooler",
  "env.fieldNotes": "Field Notes",
  "env.fieldNotes.placeholder": "Enter field observations...",
  "env.sample.manifest.title": "Per-Sample Manifest",
  "env.sample.manifest.subtitle": "one row = one physical sample",
  "env.sample.container": "Container",
  "env.sample.gpsLat": "GPS Lat",
  "env.sample.gpsLat.placeholder": "e.g. -6.2088",
  "env.sample.gpsLng": "GPS Lng",
  "env.sample.gpsLng.placeholder": "e.g. 106.8456",
  "env.sample.locationDetails": "Location Details",
  "env.sample.locationDetails.placeholder": "e.g., Inlet, Bank...",
  "env.sample.collected": "Collected",
  "env.sample.duplicate": "Duplicate sample",
  "env.sample.addRow": "+ Add sample row",
  "env.sample.total": "Total: {count} {count, plural, one {sample} other {samples}} in this batch",
  "env.sample.testsAndPanels": "Tests & Panels",
  "env.sample.tests.required": "required",
  "env.complianceStandards.title": "Applicable Compliance Standards",
  "env.complianceStandards.subtitle": "Select the regulatory standards that apply to this order.",
  "env.complianceStandards.label": "Compliance Standards",
  "env.complianceStandards.placeholder": "Select standards...",
  "env.complianceStandards.empty": "No active compliance standards configured. Add them in Administration → Compliance Standards.",
  "order.dashboard.samplingSite": "Sampling Site",
  "order.search.placeholder.env": "Search by site name or lab number...",
  "order.filter.dateFrom": "From",
  "order.filter.dateTo": "To",
  "program.placeholder": "Saisir pour filtrer ou sélectionner dans la liste",
  "program.helper": "Saisir pour filtrer ou sélectionner dans la liste. La sélection d'un programme affiche ses champs d'informations de demande spécifiques ci-dessous.",
  "patient.externalSearch": "Recherche externe",
  "patient.results": "Résultats du patient",
  "patient.id.placeholder": "Saisir l'ID du patient",
  "patient.lastName.placeholder": "Saisir le nom de famille du patient",
  "patient.firstName.placeholder": "Saisir le prénom du patient",
  "patient.natId": "Identifiant de santé unique",
  "patient.dataSource": "Source de données",
  "patient.noResults": "0-0 sur 0 éléments",
  "patient.new.info": "Saisir les informations du nouveau patient ci-dessous. Le patient sera créé lors de l'enregistrement de la demande.",
  "pagination.showing": "Affichage de {start}-{end} sur {total} analyses",
  "results.found.for": "résultats trouvés pour \"{term}\"",
  "selected": "Sélectionné",
  "shipment.settings.siteOrgSaved": "Organisation du site enregistrée (UUID FHIR : {uuid})",
  "shipment.settings.siteOrgSection": "Organisation du site (FHIR)",
  "shipment.settings.title": "Paramètres d'expédition",
  "shipment.state.cancelled": "Annulé",
  "shipment.state.draft": "Brouillon",
  "shipment.state.inTransit": "En transit",
  "shipment.state.lostInTransit": "Perdu en transit",
  "shipment.state.partiallyReceived": "Partiellement reçu",
  "shipment.state.readyToSend": "Prêt à envoyer",
  "shipment.state.received": "Reçu",
  "shipment.state.reconciled": "Rapproché",
  "shipment.state.sent": "Envoyé",
  "shipment.stats.delivered": "Livré",
  "shipment.stats.inTransit": "En transit",
  "shipment.stats.reconciled": "Rapproché",
  "shipment.stats.totalSamples": "Total des échantillons",
  "shipment.temperature.ambient": "Ambiant (température ambiante)",
  "shipment.temperature.deepFrozen": "Ultra-congelé (-80°C)",
  "shipment.temperature.dryIce": "Glace carbonique",
  "shipment.temperature.frozen": "Congelé (-20°C)",
  "shipment.temperature.refrigerated": "Réfrigéré (2-8°C)",
  "shipment.validation.addSample": "Ajouter au moins un échantillon",
  "shipment.validation.selectDestination": "Sélectionner un établissement de destination",
  "qc.dashboard.title": "Tableau de bord du contrôle qualité",
  "qc.dashboard.lastUpdate": "Dernière mise à jour",
  "qc.dashboard.complianceStatus": "État de conformité",
  "qc.dashboard.compliant": "Conforme",
  "qc.dashboard.warning": "Avertissement",
  "qc.dashboard.nonCompliant": "Non conforme",
  "qc.dashboard.violationsCount": "{count} violations",
  "qc.dashboard.lastResult": "Dernier résultat",
  "qc.dashboard.noInstruments": "Aucun instrument configuré",
  "qc.dashboard.subtitle": "Surveiller l'état CQ et les alertes des instruments",
  "qc.dashboard.loading": "Chargement des données du tableau de bord...",
  "qc.dashboard.refresh": "Actualiser",
  "qc.dashboard.lastUpdated": "Dernière mise à jour",
  "qc.dashboard.error.title": "Erreur",
  "qc.dashboard.error.loadFailed": "Échec du chargement des données. Veuillez réessayer.",
  "qc.dashboard.tab.instruments": "Instruments",
  "qc.dashboard.tab.alerts": "Alertes",
  "qc.dashboard.summary.inControl": "Instruments sous contrôle",
  "qc.dashboard.summary.warningStatus": "État d'avertissement",
  "qc.dashboard.summary.outOfControl": "Hors contrôle",
  "qc.dashboard.summary.passRate": "Taux global de réussite CQ",
  "qc.dashboard.summary.ofTotal": "{percentage} % du total des instruments",
  "qc.dashboard.instruments.title": "État du contrôle qualité des instruments",
  "qc.dashboard.instruments.subtitle": "Surveiller la conformité et la performance CQ de tous les instruments de laboratoire",
  "qc.dashboard.instruments.search": "Rechercher des instruments...",
  "qc.dashboard.instruments.col.id": "ID de l'instrument",
  "qc.dashboard.instruments.col.name": "Nom de l'instrument",
  "qc.dashboard.instruments.col.type": "Type",
  "qc.dashboard.instruments.col.location": "Emplacement",
  "qc.dashboard.instruments.col.status": "Statut",
  "qc.dashboard.instruments.col.analytes": "Analytes",
  "qc.dashboard.instruments.col.violations": "Violations récentes",
  "qc.dashboard.instruments.col.lastUpdate": "Dernière mise à jour",
  "qc.dashboard.instruments.col.actions": "Actions",
  "qc.dashboard.instruments.view": "Voir",
  "qc.dashboard.instruments.status.green": "Sous contrôle",
  "qc.dashboard.instruments.status.yellow": "Avertissement",
  "qc.dashboard.instruments.status.red": "Hors contrôle",
  "qc.dashboard.instruments.noViolations": "Aucune violation",
  "qc.dashboard.instruments.empty": "Aucun instrument trouvé",
  "qc.dashboard.alerts.title": "Violations et alertes CQ",
  "qc.dashboard.alerts.subtitle": "Violations des {period} dernières",
  "qc.dashboard.alerts.timePeriod": "Période",
  "qc.dashboard.alerts.timePeriod.24h": "Dernières 24 heures",
  "qc.dashboard.alerts.timePeriod.72h": "Dernières 72 heures",
  "qc.dashboard.alerts.timePeriod.7d": "7 derniers jours",
  "qc.dashboard.alerts.timePeriod.30d": "30 derniers jours",
  "qc.dashboard.alerts.timePeriod.all": "Depuis toujours",
  "qc.dashboard.alerts.active": "Violations CQ actives",
  "qc.dashboard.alerts.active.count": "{count} violation(s) sans accusé de réception nécessitant une attention",
  "qc.dashboard.alerts.active.empty": "Aucune violation active",
  "qc.dashboard.alerts.acknowledge": "Accuser réception",
  "qc.dashboard.alerts.acknowledged": "Violations avec accusé de réception",
  "qc.dashboard.alerts.acknowledged.count": "{count} violation(s) ont reçu un accusé de réception",
  "qc.dashboard.alerts.acknowledged.empty": "Aucune violation avec accusé de réception",
  "qc.dashboard.alerts.col.severity": "Gravité",
  "qc.dashboard.alerts.col.time": "Heure",
  "qc.dashboard.alerts.col.instrument": "Instrument",
  "qc.dashboard.alerts.col.analyte": "Analyte",
  "qc.dashboard.alerts.col.rule": "Règle",
  "qc.dashboard.alerts.col.acknowledgedBy": "Accusé de réception par",
  "qc.dashboard.alerts.col.acknowledgedDate": "Date d'accusé de réception",
  "qc.chart.axis.date": "Date/Heure",
  "qc.chart.axis.value": "Écarts-types (σ)",
  "qc.chart.legend.normal": "Normal",
  "qc.chart.legend.violation": "Violation",
  "qc.chart.mean": "Moyenne",
  "qc.chart.noData": "Aucune donnée CQ disponible",
  "qc.chart.tooltip.date": "Date",
  "qc.chart.tooltip.value": "Valeur",
  "qc.chart.tooltip.violations": "Violations",
  "qc.chart.tooltip.zScore": "Score Z",
  "qc.charts.title": "Graphiques de contrôle",
  "qc.charts.leveyJennings": "Diagramme de Levey-Jennings",
  "qc.charts.dateRange": "Plage de dates",
  "qc.charts.controlLevel": "Niveau de contrôle",
  "qc.charts.export": "Exporter le graphique",
  "qc.charts.noData": "Aucune donnée CQ disponible",
  "qc.violations.title": "Violations CQ",
  "qc.violations.severity": "Gravité",
  "qc.violations.rule": "Règle",
  "qc.violations.date": "Date",
  "qc.violations.status": "Statut",
  "qc.violations.unresolved": "Non résolu",
  "qc.violations.resolved": "Résolu",
  "qc.violations.acknowledged": "Accusé de réception",
  "qc.correctiveActions.title": "Actions correctives",
  "qc.correctiveActions.create": "Créer une action corrective",
  "qc.correctiveActions.type": "Type d'action",
  "qc.correctiveActions.description": "Description",
  "qc.correctiveActions.assignedTo": "Assigné à",
  "qc.correctiveActions.status": "Statut",
  "qc.correctiveActions.pending": "En attente",
  "qc.correctiveActions.inProgress": "En cours",
  "qc.correctiveActions.completed": "Terminé",
  "qc.correctiveActions.resolutionNotes": "Notes de résolution",
  "qc.alerts.title": "Alertes CQ",
  "qc.alerts.markAsRead": "Marquer comme lu",
  "qc.alerts.viewDetails": "Voir les détails",
  "qc.rules.title": "Configuration des règles de Westgard",
  "qc.rules.enable": "Activer",
  "qc.rules.disable": "Désactiver",
  "qc.rules.preset": "Configuration prédéfinie",
  "qc.rules.basic": "De base",
  "qc.rules.standard": "Standard",
  "qc.rules.comprehensive": "Complet",
  "qc.rules.1₂ₛ.description": "Un contrôle dépasse ±2 ET",
  "qc.rules.1₃ₛ.description": "Un contrôle dépasse ±3 ET",
  "qc.rules.2₂ₛ.description": "Deux contrôles consécutifs dépassent ±2 ET dans la même direction",
  "qc.rules.R₄ₛ.description": "L'écart entre deux contrôles dépasse 4 ET",
  "qc.rules.4₁ₛ.description": "Quatre contrôles consécutifs dépassent ±1 ET dans la même direction",
  "qc.rules.10ₓ.description": "Dix contrôles consécutifs du même côté de la moyenne",
  "qc.rules.3₁ₛ.description": "Trois contrôles consécutifs dépassent ±1 ET dans la même direction",
  "qc.rules.7ₜ.description": "Sept contrôles consécutifs évoluant dans la même direction",
  "qc.ruleConfig.title": "Configuration des règles",
  "qc.ruleConfig.subtitle": "Configurer les règles de Westgard par combinaison analyseur/test",
  "qc.ruleConfig.field.analyzer": "Analyseur",
  "qc.ruleConfig.field.selectAnalyzer": "Sélectionner un analyseur",
  "qc.ruleConfig.field.test": "Test",
  "qc.ruleConfig.field.selectTest": "Sélectionner un test",
  "qc.ruleConfig.field.severity": "Gravité",
  "qc.ruleConfig.severity.warning": "Avertissement",
  "qc.ruleConfig.severity.rejection": "Rejet",
  "qc.ruleConfig.category.rejection": "Règles de rejet",
  "qc.ruleConfig.category.warning": "Règles d'avertissement",
  "qc.ruleConfig.action.reset": "Réinitialiser aux valeurs par défaut",
  "qc.ruleConfig.loading": "Chargement de la configuration des règles...",
  "qc.ruleConfig.prompt.selectAnalyzerTest": "Sélectionnez un analyseur et un test pour configurer les règles de Westgard.",
  "qc.ruleConfig.error.title": "Erreur",
  "qc.ruleConfig.error.selectAnalyzerTest": "Veuillez sélectionner à la fois un analyseur et un test.",
  "qc.ruleConfig.error.saveFailed": "Échec de l'enregistrement de la configuration des règles.",
  "qc.ruleConfig.success.title": "Succès",
  "qc.ruleConfig.success.saved": "Configuration des règles enregistrée avec succès.",
  "qc.ruleConfig.table.title": "Ensembles de règles configurés",
  "qc.ruleConfig.table.empty": "Aucune configuration de règle trouvée.",
  "qc.ruleConfig.field.enabledRules": "Règles activées",
  "qc.ruleConfig.unconfigured.title": "Mappages de contrôle non configurés",
  "qc.ruleConfig.unconfigured.subtitle": "Lots de contrôle sans configuration de règles de Westgard",
  "qc.ruleConfig.unconfigured.configure": "Configurer",
  "qc.ruleConfig.unconfigured.activeLots": "Lots actifs",
  "qc.ruleConfig.modal.title.edit": "Modifier la configuration des règles",
  "qc.ruleConfig.modal.title.create": "Créer une configuration de règles",
  "button.saving": "Enregistrement...",
  "qc.controlLots.title": "Lots de contrôle",
  "qc.controlLots.create": "Créer un lot de contrôle",
  "qc.controlLots.productName": "Nom du produit",
  "qc.controlLots.lotNumber": "Numéro de lot",
  "qc.controlLots.level": "Niveau de contrôle",
  "qc.controlLots.statisticsMethod": "Méthode de calcul des statistiques",
  "qc.controlLots.initialRuns": "Exécutions initiales",
  "qc.controlLots.rolling": "Fenêtre glissante",
  "qc.controlLots.manufacturerFixed": "Valeurs fixes du fabricant",
  "qc.controlLots.activationDate": "Date d'activation",
  "qc.controlLots.expirationDate": "Date d'expiration",
  "qc.controlLots.status.active": "Actif",
  "qc.controlLots.status.establishment": "Établissement",
  "qc.controlLots.status.expired": "Expiré",
  "qc.controlLots.subtitle": "Gérer les lots de contrôle CQ pour l'évaluation des règles de Westgard",
  "qc.controlLots.empty": "Aucun lot de contrôle trouvé",
  "qc.controlLot.filter.allStatuses": "Tous les statuts",
  "qc.controlLot.status.establishment": "Établissement",
  "qc.controlLot.status.active": "Actif",
  "qc.controlLot.status.expired": "Expiré",
  "qc.controlLot.field.lotNumber": "Numéro de lot",
  "qc.controlLot.field.lotNumberPlaceholder": "Saisir le numéro de lot",
  "qc.controlLot.field.material": "Matériau de contrôle",
  "qc.controlLot.field.materialPlaceholder": "Saisir le nom du matériau",
  "qc.controlLot.field.manufacturer": "Fabricant",
  "qc.controlLot.field.level": "Niveau de contrôle",
  "qc.controlLot.field.selectLevel": "Sélectionner le niveau",
  "qc.controlLot.field.expiration": "Date d'expiration",
  "qc.controlLot.field.analyzer": "Analyseur",
  "qc.controlLot.field.selectAnalyzer": "Sélectionner l'analyseur",
  "qc.controlLot.field.test": "Test",
  "qc.controlLot.field.selectTest": "Sélectionner le test",
  "qc.controlLot.field.isActive": "Statut",
  "qc.controlLot.field.inactive": "Inactif",
  "qc.controlLot.field.active": "Actif",
  "qc.controlLot.field.status": "Statut",
  "qc.controlLot.loading": "Chargement...",
  "qc.controlLot.error.title": "Erreur",
  "qc.controlLot.error.saveFailed": "Échec de l'enregistrement du lot de contrôle",
  "qc.controlLot.new.title": "Nouveau lot de contrôle",
  "qc.controlLot.new.subtitle": "Créer un nouveau lot de contrôle CQ",
  "qc.controlLot.edit.title": "Modifier le lot de contrôle",
  "qc.controlLot.edit.subtitle": "Mettre à jour la configuration du lot de contrôle",
  "qc.controlLot.validation.lotNumberRequired": "Le numéro de lot est obligatoire",
  "qc.controlLot.validation.materialRequired": "Le matériau est obligatoire",
  "qc.controlLot.validation.levelRequired": "Le niveau de contrôle est obligatoire",
  "qc.controlLot.validation.expirationRequired": "La date d'expiration est obligatoire",
  "qc.controlLot.validation.analyzerRequired": "L'analyseur est obligatoire",
  "qc.controlLot.validation.testRequired": "Le test est obligatoire",
  "qc.controlLot.level.low": "Bas",
  "qc.controlLot.level.normal": "Normal",
  "qc.controlLot.level.high": "Haut",
  "qc.controlLot.statistics.title": "Configuration des statistiques",
  "qc.controlLot.statistics.configure": "Configurer",
  "qc.controlLot.statistics.method": "Méthode de calcul",
  "qc.controlLot.statistics.mean": "Moyenne",
  "qc.controlLot.statistics.sd": "Écart-type",
  "qc.controlLot.statistics.config.title": "Configuration des statistiques",
  "qc.controlLot.statistics.config.label": "Configurer la méthode statistique",
  "qc.controlLot.statistics.method.manufacturer_fixed": "Valeurs fixes du fabricant",
  "qc.controlLot.statistics.method.manufacturer_fixed.description": "Utiliser les valeurs de moyenne et d'écart-type fournies par le fabricant",
  "qc.controlLot.statistics.method.rolling": "Fenêtre glissante",
  "qc.controlLot.statistics.method.rolling.description": "Recalculer à partir des N résultats les plus récents",
  "qc.controlLot.statistics.method.initial_runs": "Exécutions initiales",
  "qc.controlLot.statistics.method.initial_runs.description": "Calculer une fois à partir des N premières exécutions d'établissement",
  "qc.controlLot.statistics.manufacturerValues": "Valeurs du fabricant",
  "qc.controlLot.statistics.rollingConfig": "Configuration de la fenêtre glissante",
  "qc.controlLot.statistics.windowSize": "Taille de la fenêtre",
  "qc.controlLot.statistics.windowSize.helper": "Nombre de résultats récents à inclure dans le calcul",
  "qc.controlLot.statistics.initialRunsConfig": "Configuration des exécutions initiales",
  "qc.controlLot.statistics.initialRunsRequired": "Exécutions requises",
  "qc.controlLot.statistics.initialRunsRequired.helper": "Nombre d'exécutions d'établissement avant le calcul des statistiques",
  "qc.instrumentDetail.analytesMonitored": "Analytes surveillés",
  "qc.instrumentDetail.analyte.cv": "CV : {value} %",
  "qc.instrumentDetail.analyte.violations": "{count, plural, one {Nombre de violations} many {Nombre de violations} other {Nombre de violations}}",
  "qc.instrumentDetail.tab.activityTimeline": "Chronologie d'activité",
  "qc.instrumentDetail.tab.controlChart": "Graphique de contrôle",
  "qc.instrumentDetail.timeline.empty": "Aucune alerte ou action corrective enregistrée pour la période sélectionnée",
  "qc.instrumentDetail.timeline.violation": "Violation",
  "qc.instrumentDetail.timeline.correctiveAction": "Action corrective",
  "qc.instrumentDetail.timeline.loading": "Chargement de la chronologie...",
  "qc.instrumentDetail.chart.selectAnalyte": "Sélectionner l'analyte",
  "qc.instrumentDetail.chart.loading": "Chargement de la carte de contrôle...",
  "qc.instrumentDetail.chart.noData": "Aucune donnée CQ disponible pour cet analyte",
  "qc.instrumentDetail.chart.activeRules": "Règles CQ actives",
  "qc.instrumentDetail.chart.noRules": "Aucune règle active configurée",
  "qc.instrumentDetail.chart.stats.cv": "CV %",
  "qc.instrumentDetail.chart.stats.mean": "Moyenne (x̄)",
  "qc.instrumentDetail.chart.stats.n": "N",
  "qc.instrumentDetail.chart.stats.sd": "Écart-type (s)",
  "qc.instrumentDetail.error.loadFailed": "Échec du chargement des détails de l'instrument",
  "question.text.required": "Le texte de la question est requis",
  "compliance.legend.limitTypes": "LIMIT TYPES:",
  "compliance.limitType.borderlineShort": "Borderline ⚑",
  "compliance.limitType.descriptiveShort": "Qualitative",
  "compliance.limitType.MAXIMUM": "High Limit ≤",
  "compliance.limitType.MINIMUM": "Low Limit ≥",
  "compliance.limitType.RANGE": "Normal Range",
  "compliance.limitType.BORDERLINE": "Borderline 🚩",
  "compliance.limitType.DESCRIPTIVE": "Qualitative",
  "compliance.limitType.EXACT": "Exact",
  "compliance.limitType.SELECT_MAP": "Value Mapping",
  "compliance.status.ACTIVE": "Active",
  "compliance.status.DRAFT": "Draft",
  "compliance.status.SUPERSEDED": "Superseded",
  "compliance.status.ARCHIVED": "Archived",
  "compliance.standard.placeholder.name": "e.g., PP No. 22/2021 — Water Quality",
  "compliance.standard.placeholder.issuingBody": "e.g., Government of Indonesia",
  "compliance.standard.placeholder.regulationNumber": "e.g., PP 22/2021",
  "compliance.standard.placeholder.version": "e.g., 2021",
  "compliance.standard.placeholder.countryRegion": "e.g., Indonesia",
  "compliance.standard.placeholder.description": "Optional. Full description of the standard's scope.",
  "compliance.standard.placeholder.date": "yyyy-mm-dd",
  "compliance.threshold.placeholder.lower": "Lower / Min",
  "compliance.threshold.placeholder.upper": "Upper / Max",
  "compliance.threshold.placeholder.unit": "Unit",
  "compliance.standard.archive": "Archive",
  "compliance.standard.archiveHeading": "Archive Compliance Standard",
  "compliance.standard.archivePrompt": "Archive this standard? Existing evaluated results stay linked to it for audit, but the standard will be hidden from active selection lists. This action can be reverted by editing the standard's status back to Active.",
  "compliance.standard.archived": "Compliance standard archived.",
  "compliance.standard.archiveError": "Could not archive this standard.",
  "button.complianceStandard.copy": "Copy Standard",
  "compliance.standard.copied": "Compliance standard copied as a new Draft.",
  "compliance.standard.copyError": "Could not copy this standard.",
  "compliance.standard.viewLinkedTests": "View Linked Tests",
  "compliance.testEditor.groupBy": "Group by",
  "compliance.testEditor.section.configuration": "Configuration",
  "compliance.testEditor.section.organization": "Organization",
  "compliance.testEditor.section.resources": "Resources",
  "compliance.testEditor.section.automation": "Automation",
  "compliance.testEditor.section.compliance": "Compliance",
  "compliance.testEditor.tab.compliance": "Compliance",
  "compliance.testEditor.tabPlaceholder": "Coming with the Test Editor surface — manage this from the Modify Test page for now.",
  "compliance.parameterGroup.editBtn": "Edit",
  "compliance.parameterGroup.moveUp": "Move up",
  "compliance.parameterGroup.moveDown": "Move down",
  "compliance.parameterGroup.updateError": "Could not update parameter group.",
  "compliance.testEditor.standardInactiveBanner": "This test has thresholds linked to {name} which is now {status}. Results will no longer be evaluated against this standard.",
  "compliance.standard.viewLinkedTests.heading": "Linked Tests — {name}",
  "compliance.standard.viewLinkedTests.empty": "No tests are currently linked to this standard.",
  "compliance.filter.status": "Status",
  "compliance.filter.region": "Region",
  "compliance.filter.allStatuses": "All Statuses",
  "compliance.filter.allRegions": "All Regions",
  "compliance.filter.sampleType": "Sample Type",
  "compliance.filter.allSampleTypes": "All Sample Types",
  "compliance.sampleTypes.addLabel": "Add sample type",
  "compliance.sampleTypes.noneConfigured": "None configured",
  "compliance.sampleTypes.noneTitle": "No sample types configured yet.",
  "compliance.sampleTypes.noneSubtitle": "Add at least one sample type before linking tests.",
  "compliance.sampleTypes.counter": "{count, plural, one {# sample type configured} other {# sample types configured}}",
  "compliance.standard.default": "Default",
  "compliance.standard.groups": "Groups",
  "compliance.standard.tests": "Tests",
  "compliance.standard.expiryDate": "Expiry Date",
  "compliance.parameterGroups.heading": "Parameter Groups & Linked Tests",
  "compliance.parameterGroups.requireSampleTypes": "Configure the standard's fields and sample types first, then link tests.",
  "compliance.button.save": "Save",
  "compliance.button.saving": "Saving…",
  "compliance.parameterGroup.createError": "Could not add parameter group.",
  "compliance.parameterGroup.deleteHeading": "Delete Parameter Group",
  "compliance.parameterGroup.deletePrompt": "Delete the parameter group {name} and all of its thresholds? This cannot be undone.",
  "compliance.parameterGroup.deleteWarning": "{count, plural, one {# test is} other {# tests are}} currently linked. All linked thresholds will be removed.",
  "compliance.threshold.saveError": "Could not save this row.",
  "compliance.threshold.deleteError": "Could not remove this row.",
  "compliance.validation.required": "This field is required.",
  "compliance.validation.expiryAfterEffective": "Expiry date must be on or after the effective date.",
  "compliance.validation.missingUpper": "Upper limit is required.",
  "compliance.validation.missingLower": "Lower limit is required.",
  "compliance.validation.missingBounds": "Both lower and upper bounds are required.",
  "compliance.validation.lowerGtUpper": "Lower bound must be less than or equal to upper bound.",
  "compliance.validation.missingDescriptive": "Qualitative value is required.",
  "compliance.linkTest.selectNoOptions": "This test is select-list but has no options configured in the test catalog. Add result options in test management before linking it to a compliance standard.",
  "compliance.linkTest.resultTypeLegend": "Result type",
  "compliance.linkTest.resultType.numeric": "Numeric (use limit values)",
  "compliance.linkTest.resultType.select": "Select list (map options to status)",
  "compliance.linkTest.optionsHint": "Add the result options for this test (e.g. 'Absent', 'Present'). The next step lets you map each one to a compliance status.",
  "compliance.linkTest.optionLabel": "Option value",
  "compliance.linkTest.optionPlaceholder": "e.g. Absent",
  "compliance.linkTest.optionsRequired": "Add at least one option above before mapping statuses.",
  "compliance.admin.title": "Compliance Standards Administration",
  "compliance.admin.tile.explain": "Manage compliance standards, parameter groups, and per-test thresholds (e.g. PP 22/2021, WHO Drinking Water).",
  "compliance.tabs.standardsAdmin": "Compliance Standards List",
  "compliance.tabs.testThresholds": "Compliance Tab (Test Editor)",
  "compliance.testEditor.back": "Back",
  "compliance.testEditor.editTest": "Edit Test:",
  "compliance.testEditor.loinc": "LOINC:",
  "compliance.testEditor.sampleType": "Sample Type:",
  "compliance.testEditor.resultType": "Result Type:",
  "compliance.testEditor.saveTest": "Save Test",
  "compliance.testEditor.saveDisabledHint": "Other test-editor tabs are not yet wired in this iteration.",
  "compliance.testEditor.thresholdsHeading": "Compliance Thresholds for",
  "compliance.testEditor.addThreshold": "Add Threshold",
  "compliance.testEditor.addThresholdHeading": "Link {name} to a compliance standard",
  "compliance.testEditor.pickStandard": "Compliance standard",
  "compliance.testEditor.pickStandardPlaceholder": "-- Select a standard --",
  "compliance.testEditor.pickGroup": "Parameter group",
  "compliance.testEditor.pickGroupPlaceholder": "-- Select a parameter group --",
  "compliance.testEditor.pickGroupHint": "Pick a standard and parameter group above to configure the threshold.",
  "compliance.testEditor.unlink": "Unlink",
  "compliance.testEditor.unlinkHeading": "Unlink Threshold",
  "compliance.testEditor.unlinkPrompt": "Remove this threshold from {test}? The threshold itself stays on the standard's parameter group; only the link to this specific test is removed.",
  "compliance.testEditor.linkedBanner": "This test is linked to {count, plural, one {# compliance standard} other {# compliance standards}}. Thresholds are evaluated at validation time.",
  "compliance.testEditor.expandRow": "Expand row",
  "compliance.testEditor.col.standard": "Standard",
  "compliance.testEditor.col.parameterGroup": "Parameter Group",
  "compliance.testEditor.col.limitType": "Limit Type",
  "compliance.testEditor.col.thresholdRange": "Threshold / Range",
  "compliance.testEditor.col.unit": "Unit",
  "compliance.testEditor.col.effective": "Effective",
  "compliance.testEditor.col.status": "Status",
  "compliance.testThresholds.selectHint": "Select a test to view its compliance thresholds linked across standards.",
  "compliance.testThresholds.overviewHeading": "Tests linked to compliance standards",
  "compliance.testThresholds.overviewCount": "{filtered} of {total} test{total, plural, one {} other {s}}",
  "compliance.testThresholds.overviewEmpty": "No tests are linked to compliance standards yet.",
  "compliance.testThresholds.overviewEmptyHint": "CSV-seeded thresholds at parameter-group level appear in Tab 1 (Compliance Standards Admin), not here. Search above to pick a test from the catalog and link it to a standard.",
  "compliance.testThresholds.noLinkedMatches": "No linked tests match \"{q}\".",
  "compliance.testThresholds.addSection": "Add a test to compliance",
  "compliance.testThresholds.col.test": "Test",
  "compliance.testThresholds.col.code": "Code",
  "compliance.testThresholds.col.loinc": "LOINC",
  "compliance.testThresholds.col.sampleTypes": "Sample Types",
  "compliance.testThresholds.col.thresholdCount": "# Thresholds",
  "compliance.testThresholds.col.standardCount": "# Standards",
  "compliance.testThresholds.openEditor": "Open",
  "compliance.testThresholds.title": "Test Compliance Thresholds",
  "compliance.testThresholds.tile.explain": "View compliance thresholds linked to a specific test, grouped by standard and parameter group.",
  "compliance.testThresholds.searchLabel": "Search test",
  "compliance.testThresholds.searchPlaceholder": "Filter test list…",
  "compliance.testThresholds.test": "Test",
  "compliance.testThresholds.selectPlaceholder": "-- Select a test --",
  "compliance.testThresholds.empty": "No compliance thresholds are linked to this test yet. Click + Add Threshold above to link it to a compliance standard's parameter group.",
  "compliance.testThresholds.parameter": "Parameter",
  "compliance.testThresholds.type": "Limit Type",
  "compliance.testThresholds.value": "Value",
  "compliance.testThresholds.note": "Note",
  "compliance.testThresholds.unknownStandard": "Unknown standard",
  "compliance.button.openAdmin": "Open Compliance Standards Admin",
  "compliance.button.addStandard": "Add Standard",
  "compliance.button.saveStandard": "Save Standard",
  "compliance.button.linkTest": "Link Test to Group",
  "compliance.button.saveLimits": "Save Limits",
  "compliance.button.saveMapping": "Save Mapping",
  "compliance.search": "Search standards",
  "compliance.search.placeholder": "Search by name, issuing body, regulation, country…",
  "compliance.list.empty": "No compliance standards yet.",
  "compliance.standard.name": "Standard Name",
  "compliance.standard.issuingBody": "Issuing Body",
  "compliance.standard.regulationNumber": "Regulation Number",
  "compliance.standard.version": "Version",
  "compliance.standard.countryRegion": "Country / Region",
  "compliance.standard.status": "Status",
  "compliance.standard.effectiveDate": "Effective Date",
  "compliance.standard.description": "Description",
  "compliance.standard.addNew": "Add New Compliance Standard",
  "compliance.standard.edit": "Edit Compliance Standard",
  "compliance.standard.preSeeded": "Pre-seeded",
  "compliance.standard.saved": "Compliance standard saved.",
  "compliance.standard.saveError": "Could not save standard.",
  "compliance.standard.saveBeforeGroups": "Save the standard before adding parameter groups.",
  "compliance.standard.deleted": "Compliance standard deleted.",
  "compliance.standard.deleteError": "Could not delete standard (it may be pre-seeded or have linked thresholds).",
  "compliance.standard.deleteHeading": "Delete Compliance Standard",
  "compliance.standard.deletePrompt": "Are you sure you want to delete this standard? Pre-seeded standards and standards with linked thresholds cannot be deleted.",
  "compliance.sampleTypes.heading": "Applicable Sample Types",
  "compliance.sampleTypes.explicitHint": "Declare which sample type categories this standard applies to. These selections drive the test filter when linking tests.",
  "compliance.sampleTypes.empty": "No sample types declared yet.",
  "compliance.sampleTypes.selectPlaceholder": "Select sample type...",
  "compliance.sampleTypes.addBtn": "Add Sample Type",
  "compliance.sampleTypes.remove": "Remove",
  "compliance.parameterGroups": "Parameter Groups",
  "compliance.parameterGroups.empty": "No parameter groups defined yet.",
  "compliance.parameterGroups.add": "Add Parameter Group",
  "compliance.parameterGroup.name": "Group name",
  "compliance.parameterGroup.description": "Description",
  "compliance.parameterGroup.deleteBtn": "Delete",
  "compliance.label.tests": "tests",
  "compliance.linkedTest.name": "Test",
  "compliance.linkedTest.sampleTypes": "Sample Types",
  "compliance.linkedTest.limits": "Limits Configured",
  "compliance.linkedTest.editLimits": "Edit limits",
  "compliance.linkedTest.unlink": "Remove from group",
  "compliance.linkedTest.unlinkHeading": "Remove Test from Group",
  "compliance.linkedTest.unlinkConfirm": "Remove",
  "compliance.linkedTest.unlinkPrompt": "Remove this test from the group? All threshold definitions for this test in this group will be deleted.",
  "compliance.group.noTests": "No tests linked to this group yet. Link tests to define compliance thresholds for evaluation.",
  "compliance.linkTest.heading": "Link Test to Group",
  "compliance.linkTest.step1": "Step 1 — Filter by Sample Type",
  "compliance.linkTest.step2": "Step 2 — Search & Select Test",
  "compliance.linkTest.step3Numeric": "Step 3 — Configure Limits",
  "compliance.linkTest.step3Select": "Step 3 — Compliance Value Mapping",
  "compliance.linkTest.filterByST": "Filter by sample type:",
  "compliance.linkTest.searchTest": "Search test catalog",
  "compliance.linkTest.searchPlaceholder": "Type to search by name or code...",
  "compliance.linkTest.noResults": "No matching tests found.",
  "compliance.linkTest.selectListBadge": "Select List",
  "compliance.linkTest.clearSelection": "Clear selection",
  "compliance.multiLimit.editHeading": "Configure Limits",
  "compliance.multiLimit.hint": "Enable one or more limit types for this test. At least one limit type must be enabled.",
  "compliance.multiLimit.type": "Limit Type",
  "compliance.multiLimit.lower": "Lower",
  "compliance.multiLimit.upper": "Upper",
  "compliance.multiLimit.unit": "Unit",
  "compliance.multiLimit.note": "Note / Advisory",
  "compliance.multiLimit.descriptive.placeholder": "e.g., No odor, Absent, Clear",
  "compliance.multiLimit.note.placeholder": "Optional note",
  "compliance.limitType.high": "High Limit ≤",
  "compliance.limitType.high.hint": "Non-compliant if result exceeds upper limit",
  "compliance.limitType.low": "Low Limit ≥",
  "compliance.limitType.low.hint": "Non-compliant if result is below lower limit",
  "compliance.limitType.range": "Normal Range",
  "compliance.limitType.range.hint": "Compliant within lower–upper range",
  "compliance.limitType.borderline": "Borderline (Advisory)",
  "compliance.limitType.borderline.hint": "Advisory zone — triggers review flag, not fail",
  "compliance.limitType.descriptive": "Qualitative / Descriptive",
  "compliance.limitType.descriptive.hint": "Text value evaluated by analyst",
  "compliance.selectMap.editHeading": "Compliance Mapping",
  "compliance.selectMap.hint": "Map each result option to its compliance status. Options come from the test catalog.",
  "compliance.selectMap.option": "Result Option",
  "compliance.selectMap.status": "Compliance Status",
  "compliance.selectMap.preview": "Preview",
  "compliance.selectMap.badge": "Value Mapping",
  "compliance.selectMap.optionsLabel": "options mapped",
  "compliance.selectMap.statusForOption": "Compliance status for {option}",
  "compliance.status.compliant": "Compliant",
  "compliance.status.borderline": "Borderline",
  "compliance.status.nonCompliant": "Non-Compliant",
  "compliance.status.compliantWithIcon": "Compliant ✓",
  "compliance.status.borderlineWithIcon": "Borderline ⚑",
  "compliance.status.nonCompliantWithIcon": "Non-Compliant ✗",
  "compliance.linkedTest.noLimits": "No limits configured",
  "compliance.threshold.savedThresholds": "Compliance thresholds linked to the test.",
  "compliance.threshold.savedValueMap": "Value-mapping threshold saved.",
  "compliance.threshold.savedPartialError": "Some thresholds could not be saved. Review the highlighted rows.",
  "compliance.threshold.unlinked": "Threshold unlinked from the test.",
  "compliance.threshold.unlinkError": "Could not unlink this threshold.",
  "notification.title.success": "Success",
  "notification.title.error": "Error",
  "sidenav.label.admin.vectorSurveillance": "Vector Surveillance",
  "vector.admin.title": "Vector Surveillance Setup",
  "vector.admin.groups": "Organism Groups",
  "vector.admin.group.code": "Code",
  "vector.admin.group.label": "Label",
  "vector.admin.group.colorTag": "Color Tag",
  "vector.admin.group.description": "Description",
  "vector.admin.active": "Active",
  "vector.admin.system": "System",
  "vector.admin.trapTypes": "Trap Types",
  "vector.admin.trapType.name": "Name",
  "vector.admin.trapType.description": "Description",
  "vector.admin.species": "Species",
  "vector.admin.selectGroup": "Select a group on the left to manage its trap types and species.",
  "vector.admin.newGroup": "New group (unsaved)",
  "vector.admin.newTrapType": "New trap type",
  "vector.admin.newSpecies": "New species",
  "vector.admin.saveGroup": "Save group",
  "vector.admin.saveTrap": "Save trap",
  "vector.admin.saveSpecies": "Save species",
  "vector.admin.addGroup": "+ Add group",
  "vector.admin.addTrapType": "+ Add trap type",
  "vector.admin.addSpecies": "+ Add species",
  "vector.admin.locked": "locked",
  "vector.admin.systemGroup": "System-protected group",
  "vector.admin.systemGroup.desc": "The code is locked because this group is referenced by core reports and seed data. You may still edit the label, color, and description.",
  "vector.admin.usedBy": "Used by",
  "vector.admin.status": "Status",
  "vector.admin.status.active": "Active",
  "vector.admin.status.inactive": "Inactive",
  "vector.admin.group": "Organism group",
  "vector.admin.trapType.group": "Target organism group",
  "vector.admin.trapType.groups": "Organism groups",
  "vector.admin.trapType.sampleTypes": "Sample types",
  "vector.admin.sampleType": "Sample type",
  "vector.admin.search.groups": "Search by code or label...",
  "vector.admin.search.traps": "Search trap name or description...",
  "vector.admin.search.species": "Search genus or species...",
  "vector.admin.samplingSites": "Sampling Sites",
  "vector.admin.samplingSite.newSite": "New site",
  "vector.admin.samplingSite.allSites": "All Sites",
  "vector.admin.samplingSite.code": "Code",
  "vector.admin.samplingSite.name": "Site Name",
  "vector.admin.samplingSite.type": "Site Type",
  "vector.admin.samplingSite.region": "Region",
  "vector.admin.samplingSite.district": "District",
  "vector.admin.samplingSite.contactName": "Contact Person",
  "vector.admin.samplingSite.contactPhone": "Contact Phone",
  "vector.admin.samplingSite.gpsLatitude": "GPS Latitude",
  "vector.admin.samplingSite.gpsLongitude": "GPS Longitude",
  "vector.admin.samplingSite.environmentalZone": "Environmental Zone",
  "vector.admin.samplingSite.address": "Address",
  "vector.admin.samplingSite.description": "Description",
  "vector.admin.samplingSite.source": "Source",
  "vector.admin.samplingSite.source.local": "LOCAL",
  "vector.admin.samplingSite.source.hub": "HUB",
  "vector.admin.samplingSite.lastCollection": "Last Collection",
  "vector.admin.samplingSite.search": "Search by code, name, region...",
  "vector.admin.samplingSite.saveSite": "Save site",
  "vector.admin.samplingSites.registry": "Sampling Site Registry",
  "vector.admin.samplingSite.deactivate": "Deactivate",
  "vector.admin.samplingSite.activate": "Activate",
  "vector.admin.samplingSite.location": "Location",
  "vector.admin.samplingSite.allTypes": "All types",
  "vector.admin.samplingSite.subtype": "Subtype",
  "vector.admin.samplingSite.subtype.placeholder": "e.g. River, Well, BG-Sentinel, Fixed Station",
  "vector.admin.samplingSite.city": "City",
  "vector.admin.samplingSite.addressLocation": "Address Location",
  "vector.admin.samplingSite.addressSearch.placeholder": "Search location to auto-fill dropdowns...",
  "vector.admin.samplingSite.gpsCoordinates": "GPS Coordinates",
  "vector.admin.samplingSite.lastModified": "Last Modified",
  "label.noResults": "No results found",
  "vector.admin.addSite": "+ New Site",
  "vector.order.title": "New Vector Order",
  "vector.order.subtitle": "Lab unit: Vector Surveillance Lab — Vector domain active.",
  "vector.order.samplingSite": "Sampling Site",
  "vector.order.site.placeholder": "Search by site name or code...",
  "vector.order.specimen": "Specimen",
  "vector.order.organism": "Animal / Organism",
  "vector.order.organism.hint": "Common name — e.g., Mosquito, Tick, Rodent, Sandfly.",
  "vector.order.organism.placeholder": "Search organism or species...",
  "vector.order.quantity": "Quantity",
  "vector.order.quantity.hint": "Number of organisms in this pool.",
  "vector.order.requester.section": "Requester / Ordering Programme",
  "vector.order.requester": "Requester",
  "vector.order.requester.placeholder": "Search by organisation name or code...",
  "vector.order.panels": "Order Panels",
  "vector.order.panels.search": "Choose available panel",
  "vector.order.tests": "Order Tests",
  "vector.order.tests.search": "Choose available test",
  "vector.order.collectionContext": "Collection Context (optional — bionomics capture)",
  "vector.order.timeOfDay": "Time of Day",
  "vector.order.timeOfDay.dawn": "Dawn",
  "vector.order.timeOfDay.day": "Day",
  "vector.order.timeOfDay.dusk": "Dusk",
  "vector.order.timeOfDay.night": "Night",
  "vector.order.restingContext": "Resting Context",
  "vector.order.restingContext.outdoor": "Outdoor (exophilic)",
  "vector.order.restingContext.indoor": "Indoor (endophilic)",
  "vector.order.restingContext.peridomestic": "Peridomestic",
  "vector.order.humanBitingCatch": "Human-Biting Catch",
  "vector.order.humanBitingCatch.hint": "specimen came from a human-landing collection",
  "vector.order.collectionNotes": "Collection Notes",
  "vector.order.collectionNotes.placeholder": "Weather, trap conditions, anomalies...",
  "vector.admin.group.code.placeholder": "e.g., SANDFLY",
  "vector.admin.group.label.placeholder": "e.g., Sandfly",
  "vector.species.genus.placeholder": "e.g., Mansonia",
  "vector.species.species.placeholder": "e.g., uniformis",
  "vector.species.subspecies.placeholder": "e.g., diardii",
  "vector.species.genus": "Genus",
  "vector.species.species": "Species",
  "vector.species.subspecies": "Subspecies",
  "vector.species.pathogensOfInterest": "Pathogens of Interest",
  "vector.species.lifecycleStages": "Lifecycle Stages",
  "vector.species.pathogenCategory": "Pathogen category",
  "vector.species.lifecycleCategory": "Lifecycle category",
  "workflow.vector": "Vector Surveillance",
  "vector.sampleType": "Sample Type",
  "vector.organismGroup": "Organism Group",
  "vector.species": "Species",
  "vector.animalOrganism": "Animal/Organism",
  "vector.animalOrganism.add": "Add Animal/Organism",
  "vector.animalOrganism.remove": "Remove Animal/Organism",
  "vector.collectedVolume": "Quantity in Pool",
  "vector.lifecycleStage": "Lifecycle Stage",
  "vector.trapType": "Trap Type",
  "vector.poolingMethod": "Pooling Method",
  "vector.poolCount": "Number of Pools",
  "vector.samplesPerPool": "Specimens per Pool",
  "vector.totalSpecimens": "Total Specimens",
  "vector.pathogensOfInterest": "Pathogens of Interest",
  "vector.homogeneous": "Homogeneous",
  "vector.random": "Random",
  "vector.collectionSite": "Collection Site",
  "vector.collectionSiteName": "Collection Site Name",
  "vector.gpsLatitude": "GPS Latitude",
  "vector.gpsLongitude": "GPS Longitude",
  "patient.search.merged.tag": "Merged",
  "patient.merged.banner.title": "This patient record was merged",
  "patient.merged.banner.subtitle": "Active records are kept on Patient {target}.",
  "patient.merged.banner.subtitle.noTarget": "This record has been merged into another patient.",
  "admin.testCatalog.tabs.ariaLabel": "Test details tabs",
  "admin.testCatalog.tabs.details": "Details",
  "admin.testCatalog.tabs.labels": "Labels",
  "admin.testCatalog.labels.masterOverride.label": "Allow Order Entry Override",
  "admin.testCatalog.labels.masterOverride.on": "On",
  "admin.testCatalog.labels.masterOverride.off": "Off",
  "admin.testCatalog.labels.linkedPresets.title": "Linked Label Presets",
  "admin.testCatalog.labels.linkedPresets.empty": "No label presets linked. Use the dropdown below to add one.",
  "admin.testCatalog.labels.col.presetName": "Preset Name",
  "admin.testCatalog.labels.col.defaultQty": "Default Qty",
  "admin.testCatalog.labels.col.maxQty": "Max Qty",
  "admin.testCatalog.labels.col.allowOverride": "Allow Override",
  "admin.testCatalog.labels.col.actions": "Actions",
  "admin.testCatalog.labels.action.remove": "Remove preset link",
  "admin.testCatalog.labels.addPreset.label": "Add Label Type",
  "admin.testCatalog.labels.addPreset.placeholder": "Select a label preset",
  "admin.testCatalog.labels.preview.title": "Order Entry Preview",
  "admin.testCatalog.labels.preview.col.locked": "Locked",
  "admin.testCatalog.labels.preview.locked": "Locked",
  "admin.testCatalog.labels.preview.unlocked": "Editable",
  "admin.testCatalog.labels.save.success": "Label configuration saved.",
  "admin.testCatalog.labels.save.error": "Failed to save label configuration.",
  "orderEntry.labels.orderTable.title": "Order Labels",
  "orderEntry.labels.sampleTable.title": "Sample Labels",
  "orderEntry.labels.col.row": "Row",
  "orderEntry.labels.col.sample": "Sample",
  "orderEntry.labels.col.quantity": "Quantity",
  "orderEntry.labels.orderRow.header": "Order",
  "orderEntry.labels.sampleRow.header": "Sample {number}",
  "orderEntry.labels.input.sample": "Sample {number} {column} quantity",
  "orderEntry.labels.source.test": "From test",
  "orderEntry.labels.source.presetDefault": "Preset default",
  "orderEntry.labels.locked.tooltipFor": "{label} is locked by the test configuration and cannot be changed.",
  "orderEntry.labels.total": "Total labels: {total}",
  "orderEntry.labels.heading": "LABELS"
}
